import './style.css';
var $C = Object.defineProperty;
var IC = (e, t, n) => t in e ? $C(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Se = (e, t, n) => IC(e, typeof t != "symbol" ? t + "" : t, n);
import * as w from "react";
import vt, { forwardRef as In, useState as rt, useEffect as Ht, createContext as h1, useContext as Xa, useCallback as kt, useLayoutEffect as Qa, useRef as Dt, useId as AC, memo as yu, useMemo as kn } from "react";
import * as m1 from "react-dom";
import { createPortal as PC } from "react-dom";
const NC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
let ml;
const DC = new Uint8Array(16);
function MC() {
  if (!ml && (ml = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !ml))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return ml(DC);
}
const Xt = [];
for (let e = 0; e < 256; ++e)
  Xt.push((e + 256).toString(16).slice(1));
function jC(e, t = 0) {
  return Xt[e[t + 0]] + Xt[e[t + 1]] + Xt[e[t + 2]] + Xt[e[t + 3]] + "-" + Xt[e[t + 4]] + Xt[e[t + 5]] + "-" + Xt[e[t + 6]] + Xt[e[t + 7]] + "-" + Xt[e[t + 8]] + Xt[e[t + 9]] + "-" + Xt[e[t + 10]] + Xt[e[t + 11]] + Xt[e[t + 12]] + Xt[e[t + 13]] + Xt[e[t + 14]] + Xt[e[t + 15]];
}
const LC = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), ky = {
  randomUUID: LC
};
function v1(e, t, n) {
  if (ky.randomUUID && !t && !e)
    return ky.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || MC)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, jC(r);
}
const Ps = (e) => ({
  block: e,
  type: "bubble"
}), y1 = (e) => {
  const t = e.title, n = e.subtitle, r = e.imageUrl, i = e.actions.map((o) => {
    switch (o.action) {
      case "postback":
        return {
          type: "button",
          variant: "action",
          text: o.label,
          buttonValue: o.value,
          reusable: !0
        };
      case "url":
        return {
          type: "button",
          variant: "link",
          text: o.label,
          buttonValue: o.value,
          reusable: !0
        };
      case "say":
        return {
          type: "button",
          variant: "action",
          text: o.label,
          buttonValue: o.value,
          reusable: !0
        };
      default:
        throw new Error(`Unknown action type ${o.action}`);
    }
  }), a = [];
  return r && a.push({
    type: "image",
    url: r
  }), t && a.push({
    type: "text",
    text: `## ${t}`
  }), n && a.push({
    type: "text",
    text: n
  }), i.length > 0 && a.push({
    type: "row",
    blocks: i
  }), {
    type: "column",
    horizontalAlignment: "center",
    blocks: [...a]
  };
}, g1 = (e) => ({
  payload: { type: "audio", url: e.audioUrl }
}), FC = (e) => ({
  payload: Ps(y1(e))
}), BC = (e) => ({
  payload: {
    type: "carousel",
    blocks: e.items.map((t) => y1(t))
  }
}), UC = (e) => {
  const t = e.options.map((a) => ({ title: a.label, value: a.value })), n = e.text, r = v1(), i = Ps({
    type: "text",
    text: n
  });
  return t.length === 0 ? {
    disableInput: e.disableFreeText,
    payload: i
  } : {
    disableInput: e.disableFreeText,
    payload: {
      type: "column",
      horizontalAlignment: "left",
      blocks: [
        i,
        {
          type: "row",
          blocks: t.map(({ title: a, value: o }) => ({
            type: "button",
            variant: "action",
            text: a,
            buttonValue: o,
            groupId: r
          }))
        }
      ]
    }
  };
}, zC = (e) => {
  const t = e.options.map((i) => ({ label: i.label, value: i.value })), n = e.text, r = [
    {
      type: "dropdown",
      label: n ?? "Select an option",
      options: t
    }
  ];
  return n && r.unshift({
    type: "text",
    text: n
  }), {
    disableInput: !0,
    payload: Ps({
      type: "column",
      blocks: r
    })
  };
}, b1 = (e) => ({
  payload: {
    type: "file",
    url: e.fileUrl,
    title: e.title
  }
}), x1 = (e) => ({
  payload: { type: "image", url: e.imageUrl }
}), w1 = (e) => ({
  payload: {
    type: "location",
    latitude: e.latitude,
    longitude: e.longitude,
    title: e.title ?? e.address ?? "View on map"
  }
}), S1 = (e) => ({
  payload: Ps({ type: "text", text: e.markdown })
}), _1 = (e) => ({
  payload: Ps({ type: "text", text: e.text, value: e.value })
}), E1 = (e) => ({
  payload: { type: "video", url: e.videoUrl }
}), VC = (e) => ({ payload: {
  type: "column",
  blocks: e.items.map((n) => {
    switch (n.type) {
      case "audio":
        return g1({ ...n.payload, type: n.type }).payload;
      case "file":
        return b1({ ...n.payload, type: n.type }).payload;
      case "image":
        return x1({ ...n.payload, type: n.type }).payload;
      case "location":
        return w1({ ...n.payload, type: n.type }).payload;
      case "markdown":
        return S1({ ...n.payload, type: n.type }).payload;
      case "text":
        return _1({ ...n.payload, type: n.type }).payload;
      case "video":
        return E1({ ...n.payload, type: n.type }).payload;
      default:
        throw new Error("Unsuported message type");
    }
  })
} }), nm = (e) => {
  switch (e.type) {
    case "audio":
      return g1(e);
    case "card":
      return FC(e);
    case "carousel":
      return BC(e);
    case "choice":
      return UC(e);
    case "dropdown":
      return zC(e);
    case "file":
      return b1(e);
    case "image":
      return x1(e);
    case "location":
      return w1(e);
    case "markdown":
      return S1(e);
    case "text":
      return _1(e);
    case "video":
      return E1(e);
    case "bloc":
      return VC(e);
    case "custom":
      return { payload: e };
    default:
      throw new Error("Unsuported message type");
  }
}, HC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messageAdapter: nm
}, Symbol.toStringTag, { value: "Module" })), _le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  target: NC,
  webchatToTarget: HC
}, Symbol.toStringTag, { value: "Module" }));
var pt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ke(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function qC(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var kp = { exports: {} }, ho = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Oy;
function WC() {
  if (Oy) return ho;
  Oy = 1;
  var e = vt, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, c, l) {
    var u, f = {}, d = null, p = null;
    l !== void 0 && (d = "" + l), c.key !== void 0 && (d = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (u in c) r.call(c, u) && !a.hasOwnProperty(u) && (f[u] = c[u]);
    if (s && s.defaultProps) for (u in c = s.defaultProps, c) f[u] === void 0 && (f[u] = c[u]);
    return { $$typeof: t, type: s, key: d, ref: p, props: f, _owner: i.current };
  }
  return ho.Fragment = n, ho.jsx = o, ho.jsxs = o, ho;
}
var mo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Cy;
function ZC() {
  return Cy || (Cy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = vt, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = Symbol.iterator, h = "@@iterator";
    function y(C) {
      if (C === null || typeof C != "object")
        return null;
      var ee = m && C[m] || C[h];
      return typeof ee == "function" ? ee : null;
    }
    var v = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(C) {
      {
        for (var ee = arguments.length, ve = new Array(ee > 1 ? ee - 1 : 0), De = 1; De < ee; De++)
          ve[De - 1] = arguments[De];
        b("error", C, ve);
      }
    }
    function b(C, ee, ve) {
      {
        var De = v.ReactDebugCurrentFrame, lt = De.getStackAddendum();
        lt !== "" && (ee += "%s", ve = ve.concat([lt]));
        var mt = ve.map(function(Je) {
          return String(Je);
        });
        mt.unshift("Warning: " + ee), Function.prototype.apply.call(console[C], console, mt);
      }
    }
    var T = !1, S = !1, E = !1, O = !1, j = !1, D;
    D = Symbol.for("react.module.reference");
    function k(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === r || C === a || j || C === i || C === l || C === u || O || C === p || T || S || E || typeof C == "object" && C !== null && (C.$$typeof === d || C.$$typeof === f || C.$$typeof === o || C.$$typeof === s || C.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === D || C.getModuleId !== void 0));
    }
    function A(C, ee, ve) {
      var De = C.displayName;
      if (De)
        return De;
      var lt = ee.displayName || ee.name || "";
      return lt !== "" ? ve + "(" + lt + ")" : ve;
    }
    function V(C) {
      return C.displayName || "Context";
    }
    function $(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case i:
          return "StrictMode";
        case l:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case s:
            var ee = C;
            return V(ee) + ".Consumer";
          case o:
            var ve = C;
            return V(ve._context) + ".Provider";
          case c:
            return A(C, C.render, "ForwardRef");
          case f:
            var De = C.displayName || null;
            return De !== null ? De : $(C.type) || "Memo";
          case d: {
            var lt = C, mt = lt._payload, Je = lt._init;
            try {
              return $(Je(mt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var L = Object.assign, M = 0, F, q, B, N, x, z, Z;
    function _() {
    }
    _.__reactDisabledLog = !0;
    function G() {
      {
        if (M === 0) {
          F = console.log, q = console.info, B = console.warn, N = console.error, x = console.group, z = console.groupCollapsed, Z = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: _,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        M++;
      }
    }
    function ae() {
      {
        if (M--, M === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: L({}, C, {
              value: F
            }),
            info: L({}, C, {
              value: q
            }),
            warn: L({}, C, {
              value: B
            }),
            error: L({}, C, {
              value: N
            }),
            group: L({}, C, {
              value: x
            }),
            groupCollapsed: L({}, C, {
              value: z
            }),
            groupEnd: L({}, C, {
              value: Z
            })
          });
        }
        M < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var te = v.ReactCurrentDispatcher, se;
    function de(C, ee, ve) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (lt) {
            var De = lt.stack.trim().match(/\n( *(at )?)/);
            se = De && De[1] || "";
          }
        return `
` + se + C;
      }
    }
    var pe = !1, le;
    {
      var X = typeof WeakMap == "function" ? WeakMap : Map;
      le = new X();
    }
    function W(C, ee) {
      if (!C || pe)
        return "";
      {
        var ve = le.get(C);
        if (ve !== void 0)
          return ve;
      }
      var De;
      pe = !0;
      var lt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var mt;
      mt = te.current, te.current = null, G();
      try {
        if (ee) {
          var Je = function() {
            throw Error();
          };
          if (Object.defineProperty(Je.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Je, []);
            } catch (vn) {
              De = vn;
            }
            Reflect.construct(C, [], Je);
          } else {
            try {
              Je.call();
            } catch (vn) {
              De = vn;
            }
            C.call(Je.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (vn) {
            De = vn;
          }
          C();
        }
      } catch (vn) {
        if (vn && De && typeof vn.stack == "string") {
          for (var We = vn.stack.split(`
`), un = De.stack.split(`
`), $t = We.length - 1, It = un.length - 1; $t >= 1 && It >= 0 && We[$t] !== un[It]; )
            It--;
          for (; $t >= 1 && It >= 0; $t--, It--)
            if (We[$t] !== un[It]) {
              if ($t !== 1 || It !== 1)
                do
                  if ($t--, It--, It < 0 || We[$t] !== un[It]) {
                    var Mn = `
` + We[$t].replace(" at new ", " at ");
                    return C.displayName && Mn.includes("<anonymous>") && (Mn = Mn.replace("<anonymous>", C.displayName)), typeof C == "function" && le.set(C, Mn), Mn;
                  }
                while ($t >= 1 && It >= 0);
              break;
            }
        }
      } finally {
        pe = !1, te.current = mt, ae(), Error.prepareStackTrace = lt;
      }
      var ra = C ? C.displayName || C.name : "", $i = ra ? de(ra) : "";
      return typeof C == "function" && le.set(C, $i), $i;
    }
    function fe(C, ee, ve) {
      return W(C, !1);
    }
    function me(C) {
      var ee = C.prototype;
      return !!(ee && ee.isReactComponent);
    }
    function Oe(C, ee, ve) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return W(C, me(C));
      if (typeof C == "string")
        return de(C);
      switch (C) {
        case l:
          return de("Suspense");
        case u:
          return de("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case c:
            return fe(C.render);
          case f:
            return Oe(C.type, ee, ve);
          case d: {
            var De = C, lt = De._payload, mt = De._init;
            try {
              return Oe(mt(lt), ee, ve);
            } catch {
            }
          }
        }
      return "";
    }
    var I = Object.prototype.hasOwnProperty, Y = {}, re = v.ReactDebugCurrentFrame;
    function Q(C) {
      if (C) {
        var ee = C._owner, ve = Oe(C.type, C._source, ee ? ee.type : null);
        re.setExtraStackFrame(ve);
      } else
        re.setExtraStackFrame(null);
    }
    function Ee(C, ee, ve, De, lt) {
      {
        var mt = Function.call.bind(I);
        for (var Je in C)
          if (mt(C, Je)) {
            var We = void 0;
            try {
              if (typeof C[Je] != "function") {
                var un = Error((De || "React class") + ": " + ve + " type `" + Je + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[Je] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw un.name = "Invariant Violation", un;
              }
              We = C[Je](ee, Je, De, ve, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch ($t) {
              We = $t;
            }
            We && !(We instanceof Error) && (Q(lt), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", De || "React class", ve, Je, typeof We), Q(null)), We instanceof Error && !(We.message in Y) && (Y[We.message] = !0, Q(lt), g("Failed %s type: %s", ve, We.message), Q(null));
          }
      }
    }
    var xe = Array.isArray;
    function Re(C) {
      return xe(C);
    }
    function Ve(C) {
      {
        var ee = typeof Symbol == "function" && Symbol.toStringTag, ve = ee && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return ve;
      }
    }
    function Ie(C) {
      try {
        return Me(C), !1;
      } catch {
        return !0;
      }
    }
    function Me(C) {
      return "" + C;
    }
    function U(C) {
      if (Ie(C))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Ve(C)), Me(C);
    }
    var P = v.ReactCurrentOwner, J = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ce, _e, ke;
    ke = {};
    function Ge(C) {
      if (I.call(C, "ref")) {
        var ee = Object.getOwnPropertyDescriptor(C, "ref").get;
        if (ee && ee.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function at(C) {
      if (I.call(C, "key")) {
        var ee = Object.getOwnPropertyDescriptor(C, "key").get;
        if (ee && ee.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function Lt(C, ee) {
      if (typeof C.ref == "string" && P.current && ee && P.current.stateNode !== ee) {
        var ve = $(P.current.type);
        ke[ve] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(P.current.type), C.ref), ke[ve] = !0);
      }
    }
    function Ct(C, ee) {
      {
        var ve = function() {
          ce || (ce = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ee));
        };
        ve.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: ve,
          configurable: !0
        });
      }
    }
    function He(C, ee) {
      {
        var ve = function() {
          _e || (_e = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ee));
        };
        ve.isReactWarning = !0, Object.defineProperty(C, "ref", {
          get: ve,
          configurable: !0
        });
      }
    }
    var Rt = function(C, ee, ve, De, lt, mt, Je) {
      var We = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: C,
        key: ee,
        ref: ve,
        props: Je,
        // Record the component responsible for creating this element.
        _owner: mt
      };
      return We._store = {}, Object.defineProperty(We._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(We, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: De
      }), Object.defineProperty(We, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: lt
      }), Object.freeze && (Object.freeze(We.props), Object.freeze(We)), We;
    };
    function Ye(C, ee, ve, De, lt) {
      {
        var mt, Je = {}, We = null, un = null;
        ve !== void 0 && (U(ve), We = "" + ve), at(ee) && (U(ee.key), We = "" + ee.key), Ge(ee) && (un = ee.ref, Lt(ee, lt));
        for (mt in ee)
          I.call(ee, mt) && !J.hasOwnProperty(mt) && (Je[mt] = ee[mt]);
        if (C && C.defaultProps) {
          var $t = C.defaultProps;
          for (mt in $t)
            Je[mt] === void 0 && (Je[mt] = $t[mt]);
        }
        if (We || un) {
          var It = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
          We && Ct(Je, It), un && He(Je, It);
        }
        return Rt(C, We, un, lt, De, P.current, Je);
      }
    }
    var mn = v.ReactCurrentOwner, En = v.ReactDebugCurrentFrame;
    function Wn(C) {
      if (C) {
        var ee = C._owner, ve = Oe(C.type, C._source, ee ? ee.type : null);
        En.setExtraStackFrame(ve);
      } else
        En.setExtraStackFrame(null);
    }
    var Nr;
    Nr = !1;
    function ur(C) {
      return typeof C == "object" && C !== null && C.$$typeof === t;
    }
    function Zn() {
      {
        if (mn.current) {
          var C = $(mn.current.type);
          if (C)
            return `

Check the render method of \`` + C + "`.";
        }
        return "";
      }
    }
    function Dr(C) {
      return "";
    }
    var ft = {};
    function wt(C) {
      {
        var ee = Zn();
        if (!ee) {
          var ve = typeof C == "string" ? C : C.displayName || C.name;
          ve && (ee = `

Check the top-level render call using <` + ve + ">.");
        }
        return ee;
      }
    }
    function Ft(C, ee) {
      {
        if (!C._store || C._store.validated || C.key != null)
          return;
        C._store.validated = !0;
        var ve = wt(ee);
        if (ft[ve])
          return;
        ft[ve] = !0;
        var De = "";
        C && C._owner && C._owner !== mn.current && (De = " It was passed a child from " + $(C._owner.type) + "."), Wn(C), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ve, De), Wn(null);
      }
    }
    function Bt(C, ee) {
      {
        if (typeof C != "object")
          return;
        if (Re(C))
          for (var ve = 0; ve < C.length; ve++) {
            var De = C[ve];
            ur(De) && Ft(De, ee);
          }
        else if (ur(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var lt = y(C);
          if (typeof lt == "function" && lt !== C.entries)
            for (var mt = lt.call(C), Je; !(Je = mt.next()).done; )
              ur(Je.value) && Ft(Je.value, ee);
        }
      }
    }
    function Jt(C) {
      {
        var ee = C.type;
        if (ee == null || typeof ee == "string")
          return;
        var ve;
        if (typeof ee == "function")
          ve = ee.propTypes;
        else if (typeof ee == "object" && (ee.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ee.$$typeof === f))
          ve = ee.propTypes;
        else
          return;
        if (ve) {
          var De = $(ee);
          Ee(ve, C.props, "prop", De, C);
        } else if (ee.PropTypes !== void 0 && !Nr) {
          Nr = !0;
          var lt = $(ee);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", lt || "Unknown");
        }
        typeof ee.getDefaultProps == "function" && !ee.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ut(C) {
      {
        for (var ee = Object.keys(C.props), ve = 0; ve < ee.length; ve++) {
          var De = ee[ve];
          if (De !== "children" && De !== "key") {
            Wn(C), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", De), Wn(null);
            break;
          }
        }
        C.ref !== null && (Wn(C), g("Invalid attribute `ref` supplied to `React.Fragment`."), Wn(null));
      }
    }
    var Nn = {};
    function Dn(C, ee, ve, De, lt, mt) {
      {
        var Je = k(C);
        if (!Je) {
          var We = "";
          (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var un = Dr();
          un ? We += un : We += Zn();
          var $t;
          C === null ? $t = "null" : Re(C) ? $t = "array" : C !== void 0 && C.$$typeof === t ? ($t = "<" + ($(C.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : $t = typeof C, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", $t, We);
        }
        var It = Ye(C, ee, ve, lt, mt);
        if (It == null)
          return It;
        if (Je) {
          var Mn = ee.children;
          if (Mn !== void 0)
            if (De)
              if (Re(Mn)) {
                for (var ra = 0; ra < Mn.length; ra++)
                  Bt(Mn[ra], C);
                Object.freeze && Object.freeze(Mn);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Bt(Mn, C);
        }
        if (I.call(ee, "key")) {
          var $i = $(C), vn = Object.keys(ee).filter(function(RC) {
            return RC !== "key";
          }), yf = vn.length > 0 ? "{key: someKey, " + vn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Nn[$i + yf]) {
            var CC = vn.length > 0 ? "{" + vn.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, yf, $i, CC, $i), Nn[$i + yf] = !0;
          }
        }
        return C === r ? Ut(It) : Jt(It), It;
      }
    }
    function Xr(C, ee, ve) {
      return Dn(C, ee, ve, !0);
    }
    function TC(C, ee, ve) {
      return Dn(C, ee, ve, !1);
    }
    var kC = TC, OC = Xr;
    mo.Fragment = r, mo.jsx = kC, mo.jsxs = OC;
  }()), mo;
}
process.env.NODE_ENV === "production" ? kp.exports = WC() : kp.exports = ZC();
var R = kp.exports;
function KC(e, t = []) {
  let n = [];
  function r(a, o) {
    const s = w.createContext(o), c = n.length;
    n = [...n, o];
    function l(f) {
      const { scope: d, children: p, ...m } = f, h = (d == null ? void 0 : d[e][c]) || s, y = w.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ R.jsx(h.Provider, { value: y, children: p });
    }
    function u(f, d) {
      const p = (d == null ? void 0 : d[e][c]) || s, m = w.useContext(p);
      if (m) return m;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return l.displayName = a + "Provider", [l, u];
  }
  const i = () => {
    const a = n.map((o) => w.createContext(o));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return w.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, GC(i, ...t)];
}
function GC(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const o = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return w.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function mi(e) {
  const t = w.useRef(e);
  return w.useEffect(() => {
    t.current = e;
  }), w.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
var Aa = globalThis != null && globalThis.document ? w.useLayoutEffect : () => {
};
function YC(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function JC(...e) {
  return (t) => e.forEach((n) => YC(n, t));
}
var T1 = w.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = w.Children.toArray(n), a = i.find(QC);
  if (a) {
    const o = a.props.children, s = i.map((c) => c === a ? w.Children.count(o) > 1 ? w.Children.only(null) : w.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ R.jsx(Op, { ...r, ref: t, children: w.isValidElement(o) ? w.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(Op, { ...r, ref: t, children: n });
});
T1.displayName = "Slot";
var Op = w.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (w.isValidElement(n)) {
    const i = tR(n);
    return w.cloneElement(n, {
      ...eR(r, n.props),
      // @ts-ignore
      ref: t ? JC(t, i) : i
    });
  }
  return w.Children.count(n) > 1 ? w.Children.only(null) : null;
});
Op.displayName = "SlotClone";
var XC = ({ children: e }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: e });
function QC(e) {
  return w.isValidElement(e) && e.type === XC;
}
function eR(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...s) => {
      a(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function tR(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var nR = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], rm = nR.reduce((e, t) => {
  const n = w.forwardRef((r, i) => {
    const { asChild: a, ...o } = r, s = a ? T1 : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(s, { ...o, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), im = "Avatar", [rR, Ele] = KC(im), [iR, k1] = rR(im), am = w.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, ...r } = e, [i, a] = w.useState("idle");
    return /* @__PURE__ */ R.jsx(
      iR,
      {
        scope: n,
        imageLoadingStatus: i,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ R.jsx(rm.span, { ...r, ref: t })
      }
    );
  }
);
am.displayName = im;
var O1 = "AvatarImage", om = w.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, src: r, onLoadingStatusChange: i = () => {
    }, ...a } = e, o = k1(O1, n), s = aR(r), c = mi((l) => {
      i(l), o.onImageLoadingStatusChange(l);
    });
    return Aa(() => {
      s !== "idle" && c(s);
    }, [s, c]), s === "loaded" ? /* @__PURE__ */ R.jsx(rm.img, { ...a, ref: t, src: r }) : null;
  }
);
om.displayName = O1;
var C1 = "AvatarFallback", sm = w.forwardRef(
  (e, t) => {
    const { __scopeAvatar: n, delayMs: r, ...i } = e, a = k1(C1, n), [o, s] = w.useState(r === void 0);
    return w.useEffect(() => {
      if (r !== void 0) {
        const c = window.setTimeout(() => s(!0), r);
        return () => window.clearTimeout(c);
      }
    }, [r]), o && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ R.jsx(rm.span, { ...i, ref: t }) : null;
  }
);
sm.displayName = C1;
function aR(e) {
  const [t, n] = w.useState("idle");
  return Aa(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const i = new window.Image(), a = (o) => () => {
      r && n(o);
    };
    return n("loading"), i.onload = a("loaded"), i.onerror = a("error"), i.src = e, () => {
      r = !1;
    };
  }, [e]), t;
}
function Cp(e) {
  if (!/^#?([a-fA-F\d]{6}|[a-fA-F\d]{3})$/.test(e))
    return { r: 0, g: 0, b: 0 };
  const n = e.replace(/^#/, "");
  let r = n;
  n.length === 3 && (r = n.split("").map((c) => c + c).join(""));
  const i = parseInt(r, 16), a = i >> 16 & 255, o = i >> 8 & 255, s = i & 255;
  return { r: a, g: o, b: s };
}
function oR(e) {
  return `#${((1 << 24) + (e.r << 16) + (e.g << 8) + e.b).toString(16).slice(1)}`;
}
const sR = (e, t = 30) => {
  const n = Math.min(e.r, e.g, e.b), r = Math.max(e.r, e.g, e.b, n + 1);
  return {
    r: Math.floor((e.r - n) / (r - n) * t * (1 - 0.299) + 120 - t / 2),
    g: Math.floor((e.g - n) / (r - n) * t * (1 - 0.587) + 120 - t / 2),
    b: Math.floor((e.b - n) / (r - n) * t * (1 - 0.114) + 120 - t / 2)
  };
};
function Ry(e) {
  return Object.entries(e).reduce((t, [n, r]) => {
    const i = n.replace(/(\d+)/, (a) => (1e3 - parseInt(a)).toString());
    return { ...t, [i]: r };
  }, {});
}
const lR = 2.4, cR = 0.2126729, uR = 0.7151522, fR = 0.072175, dR = 0.56, pR = 0.57, hR = 0.62, mR = 0.65, vl = 0.022, $y = 1.414, vR = 1.14, yR = 1.14, gR = 0.035991, bR = 0.035991, xR = 27.7847239587675, wR = 27.7847239587675, Iy = 0.027, Ay = 0.027, Py = 1e-3, SR = 5e-4;
function Ny(e) {
  const { r: t, g: n, b: r } = e, i = (a) => (a / 255) ** lR;
  return cR * i(t) + uR * i(n) + fR * i(r);
}
function Dy(e, t) {
  if (!e || !t)
    return 0;
  let n = Ny(Cp(e)), r = Ny(Cp(t)), i = 0, a = 0;
  return n = n > vl ? n : n + (vl - n) ** $y, r = r > vl ? r : r + (vl - r) ** $y, Math.abs(r - n) < SR ? 0 : (r > n ? (i = (r ** dR - n ** pR) * vR, a = i < Py ? 0 : i < gR ? i - i * xR * Iy : i - Iy) : (i = (r ** mR - n ** hR) * yR, a = i > -Py ? 0 : i > -bR ? i - i * wR * Ay : i + Ay), Math.abs(a * 100));
}
let lm = class {
  constructor() {
    Se(this, "eventMap");
    this.eventMap = {};
  }
  on(t, n) {
    var r;
    return this.eventMap[t] || (this.eventMap[t] = /* @__PURE__ */ new Set()), (r = this.eventMap[t]) == null || r.add(n), () => {
      var i;
      (i = this.eventMap[t]) == null || i.delete(n);
    };
  }
  emit(t, n) {
    var r, i;
    (r = this.eventMap[t]) == null || r.forEach((a) => {
      a(n);
    }), (i = this.eventMap["*"]) == null || i.forEach((a) => {
      a({ type: t, payload: n });
    });
  }
};
const _R = new lm();
function My(e, t) {
  let n = `${e} {`;
  for (const [r, i] of Object.entries(t))
    n += `${r}: ${i}; `;
  return n += "}", n;
}
function R1(e, t) {
  let n = 0;
  if (e.length == 0)
    return n;
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    n = (n << 5) - n + i, n = n & n;
  }
  return Math.abs(n) % t;
}
var $1 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(pt, function() {
    var n = 1e3, r = 6e4, i = 36e5, a = "millisecond", o = "second", s = "minute", c = "hour", l = "day", u = "week", f = "month", d = "quarter", p = "year", m = "date", h = "Invalid Date", y = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(L) {
      var M = ["th", "st", "nd", "rd"], F = L % 100;
      return "[" + L + (M[(F - 20) % 10] || M[F] || M[0]) + "]";
    } }, b = function(L, M, F) {
      var q = String(L);
      return !q || q.length >= M ? L : "" + Array(M + 1 - q.length).join(F) + L;
    }, T = { s: b, z: function(L) {
      var M = -L.utcOffset(), F = Math.abs(M), q = Math.floor(F / 60), B = F % 60;
      return (M <= 0 ? "+" : "-") + b(q, 2, "0") + ":" + b(B, 2, "0");
    }, m: function L(M, F) {
      if (M.date() < F.date()) return -L(F, M);
      var q = 12 * (F.year() - M.year()) + (F.month() - M.month()), B = M.clone().add(q, f), N = F - B < 0, x = M.clone().add(q + (N ? -1 : 1), f);
      return +(-(q + (F - B) / (N ? B - x : x - B)) || 0);
    }, a: function(L) {
      return L < 0 ? Math.ceil(L) || 0 : Math.floor(L);
    }, p: function(L) {
      return { M: f, y: p, w: u, d: l, D: m, h: c, m: s, s: o, ms: a, Q: d }[L] || String(L || "").toLowerCase().replace(/s$/, "");
    }, u: function(L) {
      return L === void 0;
    } }, S = "en", E = {};
    E[S] = g;
    var O = "$isDayjsObject", j = function(L) {
      return L instanceof V || !(!L || !L[O]);
    }, D = function L(M, F, q) {
      var B;
      if (!M) return S;
      if (typeof M == "string") {
        var N = M.toLowerCase();
        E[N] && (B = N), F && (E[N] = F, B = N);
        var x = M.split("-");
        if (!B && x.length > 1) return L(x[0]);
      } else {
        var z = M.name;
        E[z] = M, B = z;
      }
      return !q && B && (S = B), B || !q && S;
    }, k = function(L, M) {
      if (j(L)) return L.clone();
      var F = typeof M == "object" ? M : {};
      return F.date = L, F.args = arguments, new V(F);
    }, A = T;
    A.l = D, A.i = j, A.w = function(L, M) {
      return k(L, { locale: M.$L, utc: M.$u, x: M.$x, $offset: M.$offset });
    };
    var V = function() {
      function L(F) {
        this.$L = D(F.locale, null, !0), this.parse(F), this.$x = this.$x || F.x || {}, this[O] = !0;
      }
      var M = L.prototype;
      return M.parse = function(F) {
        this.$d = function(q) {
          var B = q.date, N = q.utc;
          if (B === null) return /* @__PURE__ */ new Date(NaN);
          if (A.u(B)) return /* @__PURE__ */ new Date();
          if (B instanceof Date) return new Date(B);
          if (typeof B == "string" && !/Z$/i.test(B)) {
            var x = B.match(y);
            if (x) {
              var z = x[2] - 1 || 0, Z = (x[7] || "0").substring(0, 3);
              return N ? new Date(Date.UTC(x[1], z, x[3] || 1, x[4] || 0, x[5] || 0, x[6] || 0, Z)) : new Date(x[1], z, x[3] || 1, x[4] || 0, x[5] || 0, x[6] || 0, Z);
            }
          }
          return new Date(B);
        }(F), this.init();
      }, M.init = function() {
        var F = this.$d;
        this.$y = F.getFullYear(), this.$M = F.getMonth(), this.$D = F.getDate(), this.$W = F.getDay(), this.$H = F.getHours(), this.$m = F.getMinutes(), this.$s = F.getSeconds(), this.$ms = F.getMilliseconds();
      }, M.$utils = function() {
        return A;
      }, M.isValid = function() {
        return this.$d.toString() !== h;
      }, M.isSame = function(F, q) {
        var B = k(F);
        return this.startOf(q) <= B && B <= this.endOf(q);
      }, M.isAfter = function(F, q) {
        return k(F) < this.startOf(q);
      }, M.isBefore = function(F, q) {
        return this.endOf(q) < k(F);
      }, M.$g = function(F, q, B) {
        return A.u(F) ? this[q] : this.set(B, F);
      }, M.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, M.valueOf = function() {
        return this.$d.getTime();
      }, M.startOf = function(F, q) {
        var B = this, N = !!A.u(q) || q, x = A.p(F), z = function(pe, le) {
          var X = A.w(B.$u ? Date.UTC(B.$y, le, pe) : new Date(B.$y, le, pe), B);
          return N ? X : X.endOf(l);
        }, Z = function(pe, le) {
          return A.w(B.toDate()[pe].apply(B.toDate("s"), (N ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(le)), B);
        }, _ = this.$W, G = this.$M, ae = this.$D, te = "set" + (this.$u ? "UTC" : "");
        switch (x) {
          case p:
            return N ? z(1, 0) : z(31, 11);
          case f:
            return N ? z(1, G) : z(0, G + 1);
          case u:
            var se = this.$locale().weekStart || 0, de = (_ < se ? _ + 7 : _) - se;
            return z(N ? ae - de : ae + (6 - de), G);
          case l:
          case m:
            return Z(te + "Hours", 0);
          case c:
            return Z(te + "Minutes", 1);
          case s:
            return Z(te + "Seconds", 2);
          case o:
            return Z(te + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, M.endOf = function(F) {
        return this.startOf(F, !1);
      }, M.$set = function(F, q) {
        var B, N = A.p(F), x = "set" + (this.$u ? "UTC" : ""), z = (B = {}, B[l] = x + "Date", B[m] = x + "Date", B[f] = x + "Month", B[p] = x + "FullYear", B[c] = x + "Hours", B[s] = x + "Minutes", B[o] = x + "Seconds", B[a] = x + "Milliseconds", B)[N], Z = N === l ? this.$D + (q - this.$W) : q;
        if (N === f || N === p) {
          var _ = this.clone().set(m, 1);
          _.$d[z](Z), _.init(), this.$d = _.set(m, Math.min(this.$D, _.daysInMonth())).$d;
        } else z && this.$d[z](Z);
        return this.init(), this;
      }, M.set = function(F, q) {
        return this.clone().$set(F, q);
      }, M.get = function(F) {
        return this[A.p(F)]();
      }, M.add = function(F, q) {
        var B, N = this;
        F = Number(F);
        var x = A.p(q), z = function(G) {
          var ae = k(N);
          return A.w(ae.date(ae.date() + Math.round(G * F)), N);
        };
        if (x === f) return this.set(f, this.$M + F);
        if (x === p) return this.set(p, this.$y + F);
        if (x === l) return z(1);
        if (x === u) return z(7);
        var Z = (B = {}, B[s] = r, B[c] = i, B[o] = n, B)[x] || 1, _ = this.$d.getTime() + F * Z;
        return A.w(_, this);
      }, M.subtract = function(F, q) {
        return this.add(-1 * F, q);
      }, M.format = function(F) {
        var q = this, B = this.$locale();
        if (!this.isValid()) return B.invalidDate || h;
        var N = F || "YYYY-MM-DDTHH:mm:ssZ", x = A.z(this), z = this.$H, Z = this.$m, _ = this.$M, G = B.weekdays, ae = B.months, te = B.meridiem, se = function(le, X, W, fe) {
          return le && (le[X] || le(q, N)) || W[X].slice(0, fe);
        }, de = function(le) {
          return A.s(z % 12 || 12, le, "0");
        }, pe = te || function(le, X, W) {
          var fe = le < 12 ? "AM" : "PM";
          return W ? fe.toLowerCase() : fe;
        };
        return N.replace(v, function(le, X) {
          return X || function(W) {
            switch (W) {
              case "YY":
                return String(q.$y).slice(-2);
              case "YYYY":
                return A.s(q.$y, 4, "0");
              case "M":
                return _ + 1;
              case "MM":
                return A.s(_ + 1, 2, "0");
              case "MMM":
                return se(B.monthsShort, _, ae, 3);
              case "MMMM":
                return se(ae, _);
              case "D":
                return q.$D;
              case "DD":
                return A.s(q.$D, 2, "0");
              case "d":
                return String(q.$W);
              case "dd":
                return se(B.weekdaysMin, q.$W, G, 2);
              case "ddd":
                return se(B.weekdaysShort, q.$W, G, 3);
              case "dddd":
                return G[q.$W];
              case "H":
                return String(z);
              case "HH":
                return A.s(z, 2, "0");
              case "h":
                return de(1);
              case "hh":
                return de(2);
              case "a":
                return pe(z, Z, !0);
              case "A":
                return pe(z, Z, !1);
              case "m":
                return String(Z);
              case "mm":
                return A.s(Z, 2, "0");
              case "s":
                return String(q.$s);
              case "ss":
                return A.s(q.$s, 2, "0");
              case "SSS":
                return A.s(q.$ms, 3, "0");
              case "Z":
                return x;
            }
            return null;
          }(le) || x.replace(":", "");
        });
      }, M.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, M.diff = function(F, q, B) {
        var N, x = this, z = A.p(q), Z = k(F), _ = (Z.utcOffset() - this.utcOffset()) * r, G = this - Z, ae = function() {
          return A.m(x, Z);
        };
        switch (z) {
          case p:
            N = ae() / 12;
            break;
          case f:
            N = ae();
            break;
          case d:
            N = ae() / 3;
            break;
          case u:
            N = (G - _) / 6048e5;
            break;
          case l:
            N = (G - _) / 864e5;
            break;
          case c:
            N = G / i;
            break;
          case s:
            N = G / r;
            break;
          case o:
            N = G / n;
            break;
          default:
            N = G;
        }
        return B ? N : A.a(N);
      }, M.daysInMonth = function() {
        return this.endOf(f).$D;
      }, M.$locale = function() {
        return E[this.$L];
      }, M.locale = function(F, q) {
        if (!F) return this.$L;
        var B = this.clone(), N = D(F, q, !0);
        return N && (B.$L = N), B;
      }, M.clone = function() {
        return A.w(this.$d, this);
      }, M.toDate = function() {
        return new Date(this.valueOf());
      }, M.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, M.toISOString = function() {
        return this.$d.toISOString();
      }, M.toString = function() {
        return this.$d.toUTCString();
      }, L;
    }(), $ = V.prototype;
    return k.prototype = $, [["$ms", a], ["$s", o], ["$m", s], ["$H", c], ["$W", l], ["$M", f], ["$y", p], ["$D", m]].forEach(function(L) {
      $[L[1]] = function(M) {
        return this.$g(M, L[0], L[1]);
      };
    }), k.extend = function(L, M) {
      return L.$i || (L(M, V, k), L.$i = !0), k;
    }, k.locale = D, k.isDayjs = j, k.unix = function(L) {
      return k(1e3 * L);
    }, k.en = E[S], k.Ls = E, k.p = {}, k;
  });
})($1);
var ER = $1.exports;
const gu = /* @__PURE__ */ Ke(ER);
var I1 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(pt, function() {
    return function(n, r, i) {
      r.prototype.isToday = function() {
        var a = "YYYY-MM-DD", o = i();
        return this.format(a) === o.format(a);
      };
    };
  });
})(I1);
var TR = I1.exports;
const kR = /* @__PURE__ */ Ke(TR);
var A1 = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(pt, function() {
    return function(n, r, i) {
      r.prototype.isYesterday = function() {
        var a = "YYYY-MM-DD", o = i().subtract(1, "day");
        return this.format(a) === o.format(a);
      };
    };
  });
})(A1);
var OR = A1.exports;
const CR = /* @__PURE__ */ Ke(OR);
gu.extend(kR);
gu.extend(CR);
function RR(e, t = "day") {
  var r, i, a;
  if (!e || e.length === 0) return [];
  const n = [];
  (r = e[0]) != null && r.timestamp && n.push(jy(e[0].timestamp));
  for (let o = 0; o < e.length; o++)
    if (e[o] && n.push(e[o]), o + 1 < e.length) {
      const s = (i = e[o]) == null ? void 0 : i.timestamp, c = (a = e[o + 1]) == null ? void 0 : a.timestamp;
      !gu(s).isSame(c, t) && c && n.push(jy(c));
    }
  return n;
}
function jy(e) {
  return {
    id: v1(),
    direction: "system",
    sender: { name: "system" },
    timestamp: e,
    block: {
      type: "text",
      text: $R(e)
    }
  };
}
function $R(e, t = !1) {
  const n = gu(e), r = "h:mma";
  return n.isToday() ? t ? `Today • ${n.format(r)}` : "Today" : n.isYesterday() ? t ? `Yesterday • ${n.format(r)}` : "Yesterday" : t ? n.format(`YYYY-MM-DD • ${r}`) : n.format("YYYY-MM-DD");
}
function IR(e = "") {
  if (typeof e != "string")
    throw new TypeError("Color should be string!");
  const t = /^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i.exec(e);
  if (t)
    return t.splice(1).map((r) => Number.parseInt(r, 16));
  const n = /^#?([\da-f])([\da-f])([\da-f])$/i.exec(e);
  if (n)
    return n.splice(1).map((r) => Number.parseInt(r + r, 16));
  if (e.includes(","))
    return e.split(",").map((r) => Number.parseInt(r));
  throw new Error("Invalid color format! Use #ABC or #AABBCC or r,g,b");
}
function AR(e) {
  return "#" + e.map((t) => `0${t.toString(16).toUpperCase()}`.slice(-2)).join("");
}
function PR(e, t) {
  return e.map((n) => Math.round(n + (255 - n) * t));
}
function NR(e, t) {
  return e.map((n) => Math.round(n * t));
}
const vo = (e) => (t) => PR(t, e), yo = (e) => (t) => NR(t, e), DR = {
  50: vo(0.95),
  100: vo(0.9),
  200: vo(0.75),
  300: vo(0.6),
  400: vo(0.3),
  500: (e) => e,
  600: yo(0.9),
  700: yo(0.6),
  800: yo(0.45),
  900: yo(0.3),
  950: yo(0.2)
};
function Ly(e, t = DR) {
  const n = {}, r = IR(e);
  for (const [i, a] of Object.entries(t))
    n[i] = AR(a(r));
  return n;
}
var it;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function n(i) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(it || (it = {}));
var Rp;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Rp || (Rp = {}));
const ye = it.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), ii = (e) => {
  switch (typeof e) {
    case "undefined":
      return ye.undefined;
    case "string":
      return ye.string;
    case "number":
      return isNaN(e) ? ye.nan : ye.number;
    case "boolean":
      return ye.boolean;
    case "function":
      return ye.function;
    case "bigint":
      return ye.bigint;
    case "symbol":
      return ye.symbol;
    case "object":
      return Array.isArray(e) ? ye.array : e === null ? ye.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? ye.promise : typeof Map < "u" && e instanceof Map ? ye.map : typeof Set < "u" && e instanceof Set ? ye.set : typeof Date < "u" && e instanceof Date ? ye.date : ye.object;
    default:
      return ye.unknown;
  }
}, oe = it.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), MR = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
let er = class extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(a) {
      return a.message;
    }, r = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let s = r, c = 0;
          for (; c < o.path.length; ) {
            const l = o.path[c];
            c === o.path.length - 1 ? (s[l] = s[l] || { _errors: [] }, s[l]._errors.push(n(o))) : s[l] = s[l] || { _errors: [] }, s = s[l], c++;
          }
        }
    };
    return i(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, it.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
};
er.create = (e) => new er(e);
const Ho = (e, t) => {
  let n;
  switch (e.code) {
    case oe.invalid_type:
      e.received === ye.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case oe.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, it.jsonStringifyReplacer)}`;
      break;
    case oe.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${it.joinValues(e.keys, ", ")}`;
      break;
    case oe.invalid_union:
      n = "Invalid input";
      break;
    case oe.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${it.joinValues(e.options)}`;
      break;
    case oe.invalid_enum_value:
      n = `Invalid enum value. Expected ${it.joinValues(e.options)}, received '${e.received}'`;
      break;
    case oe.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case oe.invalid_return_type:
      n = "Invalid function return type";
      break;
    case oe.invalid_date:
      n = "Invalid date";
      break;
    case oe.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : it.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case oe.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case oe.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case oe.custom:
      n = "Invalid input";
      break;
    case oe.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case oe.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case oe.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, it.assertNever(e);
  }
  return { message: n };
};
let P1 = Ho;
function jR(e) {
  P1 = e;
}
function Sc() {
  return P1;
}
const _c = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
    ...i,
    path: a
  };
  let s = "";
  const c = r.filter((l) => !!l).slice().reverse();
  for (const l of c)
    s = l(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: i.message || s
  };
}, LR = [];
function be(e, t) {
  const n = _c({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      Sc(),
      Ho
      // then global default map
    ].filter((r) => !!r)
  });
  e.common.issues.push(n);
}
let wn = class N1 {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return je;
      i.status === "dirty" && t.dirty(), r.push(i.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const i of n)
      r.push({
        key: await i.key,
        value: await i.value
      });
    return N1.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const i of n) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return je;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (r[a.value] = o.value);
    }
    return { status: t.value, value: r };
  }
};
const je = Object.freeze({
  status: "aborted"
}), D1 = (e) => ({ status: "dirty", value: e }), pn = (e) => ({ status: "valid", value: e }), $p = (e) => e.status === "aborted", Ip = (e) => e.status === "dirty", qo = (e) => e.status === "valid", Ec = (e) => typeof Promise < "u" && e instanceof Promise;
var Ce;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Ce || (Ce = {}));
let Er = class {
  constructor(t, n, r, i) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
};
const Fy = (e, t) => {
  if (qo(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new er(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Fe(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (o, s) => o.code !== "invalid_type" ? { message: s.defaultError } : typeof s.data > "u" ? { message: r ?? s.defaultError } : { message: n ?? s.defaultError }, description: i };
}
let Ue = class {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return ii(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: ii(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new wn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: ii(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (Ec(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ii(t)
    }, a = this._parseSync({ data: t, path: i.path, parent: i });
    return Fy(i, a);
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: ii(t)
    }, i = this._parse({ data: t, path: r.path, parent: r }), a = await (Ec(i) ? i : Promise.resolve(i));
    return Fy(r, a);
  }
  refine(t, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: oe.custom,
        ...r(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((c) => c ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, i) => t(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(t) {
    return new rr({
      schema: this,
      typeName: Ae.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return Fr.create(this, this._def);
  }
  nullable() {
    return zi.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Ui.create(this, this._def);
  }
  promise() {
    return Da.create(this, this._def);
  }
  or(t) {
    return Xo.create([this, t], this._def);
  }
  and(t) {
    return Qo.create(this, t, this._def);
  }
  transform(t) {
    return new rr({
      ...Fe(this._def),
      schema: this,
      typeName: Ae.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new rs({
      ...Fe(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Ae.ZodDefault
    });
  }
  brand() {
    return new V1({
      typeName: Ae.ZodBranded,
      type: this,
      ...Fe(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Rc({
      ...Fe(this._def),
      innerType: this,
      catchValue: n,
      typeName: Ae.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return cm.create(this, t);
  }
  readonly() {
    return Ic.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
const FR = /^c[^\s-]{8,}$/i, BR = /^[a-z][a-z0-9]*$/, UR = /^[0-9A-HJKMNP-TV-Z]{26}$/, zR = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, VR = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, HR = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let gf;
const qR = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, WR = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, ZR = (e) => e.precision ? e.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${e.precision}}Z$`) : e.precision === 0 ? e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : e.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function KR(e, t) {
  return !!((t === "v4" || !t) && qR.test(e) || (t === "v6" || !t) && WR.test(e));
}
let Pa = class Ao extends Ue {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== ye.string) {
      const a = this._getOrReturnCtx(t);
      return be(
        a,
        {
          code: oe.invalid_type,
          expected: ye.string,
          received: a.parsedType
        }
        //
      ), je;
    }
    const r = new wn();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        t.data.length < a.value && (i = this._getOrReturnCtx(t, i), be(i, {
          code: oe.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        t.data.length > a.value && (i = this._getOrReturnCtx(t, i), be(i, {
          code: oe.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const o = t.data.length > a.value, s = t.data.length < a.value;
        (o || s) && (i = this._getOrReturnCtx(t, i), o ? be(i, {
          code: oe.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : s && be(i, {
          code: oe.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        VR.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "email",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        gf || (gf = new RegExp(HR, "u")), gf.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "emoji",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        zR.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "uuid",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        FR.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "cuid",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        BR.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "cuid2",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        UR.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
          validation: "ulid",
          code: oe.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(t.data);
        } catch {
          i = this._getOrReturnCtx(t, i), be(i, {
            validation: "url",
            code: oe.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
        validation: "regex",
        code: oe.invalid_string,
        message: a.message
      }), r.dirty())) : a.kind === "trim" ? t.data = t.data.trim() : a.kind === "includes" ? t.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), r.dirty()) : a.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : a.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : a.kind === "startsWith" ? t.data.startsWith(a.value) || (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "endsWith" ? t.data.endsWith(a.value) || (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "datetime" ? ZR(a).test(t.data) || (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.invalid_string,
        validation: "datetime",
        message: a.message
      }), r.dirty()) : a.kind === "ip" ? KR(t.data, a.version) || (i = this._getOrReturnCtx(t, i), be(i, {
        validation: "ip",
        code: oe.invalid_string,
        message: a.message
      }), r.dirty()) : it.assertNever(a);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((i) => t.test(i), {
      validation: n,
      code: oe.invalid_string,
      ...Ce.errToObj(r)
    });
  }
  _addCheck(t) {
    return new Ao({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Ce.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Ce.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Ce.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Ce.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Ce.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Ce.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Ce.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Ce.errToObj(t) });
  }
  datetime(t) {
    var n;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      ...Ce.errToObj(t == null ? void 0 : t.message)
    });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Ce.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Ce.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Ce.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Ce.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Ce.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Ce.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Ce.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, Ce.errToObj(t));
  }
  trim() {
    return new Ao({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Ao({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Ao({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
};
Pa.create = (e) => {
  var t;
  return new Pa({
    checks: [],
    typeName: Ae.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Fe(e)
  });
};
function GR(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r, a = parseInt(e.toFixed(i).replace(".", "")), o = parseInt(t.toFixed(i).replace(".", ""));
  return a % o / Math.pow(10, i);
}
let Wo = class Ap extends Ue {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== ye.number) {
      const a = this._getOrReturnCtx(t);
      return be(a, {
        code: oe.invalid_type,
        expected: ye.number,
        received: a.parsedType
      }), je;
    }
    let r;
    const i = new wn();
    for (const a of this._def.checks)
      a.kind === "int" ? it.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? GR(t.data, a.value) !== 0 && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.not_finite,
        message: a.message
      }), i.dirty()) : it.assertNever(a);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ce.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ce.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ce.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ce.toString(n));
  }
  setLimit(t, n, r, i) {
    return new Ap({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ce.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Ap({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Ce.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Ce.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Ce.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Ce.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Ce.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ce.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Ce.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Ce.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Ce.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && it.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
};
Wo.create = (e) => new Wo({
  checks: [],
  typeName: Ae.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Fe(e)
});
let Zo = class Pp extends Ue {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== ye.bigint) {
      const a = this._getOrReturnCtx(t);
      return be(a, {
        code: oe.invalid_type,
        expected: ye.bigint,
        received: a.parsedType
      }), je;
    }
    let r;
    const i = new wn();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? t.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), be(r, {
        code: oe.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : it.assertNever(a);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Ce.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Ce.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Ce.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Ce.toString(n));
  }
  setLimit(t, n, r, i) {
    return new Pp({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Ce.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new Pp({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Ce.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Ce.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Ce.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Ce.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Ce.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
};
Zo.create = (e) => {
  var t;
  return new Zo({
    checks: [],
    typeName: Ae.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Fe(e)
  });
};
let Ko = class extends Ue {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== ye.boolean) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.boolean,
        received: r.parsedType
      }), je;
    }
    return pn(t.data);
  }
};
Ko.create = (e) => new Ko({
  typeName: Ae.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Fe(e)
});
let Go = class M1 extends Ue {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== ye.date) {
      const a = this._getOrReturnCtx(t);
      return be(a, {
        code: oe.invalid_type,
        expected: ye.date,
        received: a.parsedType
      }), je;
    }
    if (isNaN(t.data.getTime())) {
      const a = this._getOrReturnCtx(t);
      return be(a, {
        code: oe.invalid_date
      }), je;
    }
    const r = new wn();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? t.data.getTime() < a.value && (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? t.data.getTime() > a.value && (i = this._getOrReturnCtx(t, i), be(i, {
        code: oe.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : it.assertNever(a);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new M1({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Ce.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Ce.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
};
Go.create = (e) => new Go({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Ae.ZodDate,
  ...Fe(e)
});
let Tc = class extends Ue {
  _parse(t) {
    if (this._getType(t) !== ye.symbol) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.symbol,
        received: r.parsedType
      }), je;
    }
    return pn(t.data);
  }
};
Tc.create = (e) => new Tc({
  typeName: Ae.ZodSymbol,
  ...Fe(e)
});
let Yo = class extends Ue {
  _parse(t) {
    if (this._getType(t) !== ye.undefined) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.undefined,
        received: r.parsedType
      }), je;
    }
    return pn(t.data);
  }
};
Yo.create = (e) => new Yo({
  typeName: Ae.ZodUndefined,
  ...Fe(e)
});
let Jo = class extends Ue {
  _parse(t) {
    if (this._getType(t) !== ye.null) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.null,
        received: r.parsedType
      }), je;
    }
    return pn(t.data);
  }
};
Jo.create = (e) => new Jo({
  typeName: Ae.ZodNull,
  ...Fe(e)
});
let Na = class extends Ue {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return pn(t.data);
  }
};
Na.create = (e) => new Na({
  typeName: Ae.ZodAny,
  ...Fe(e)
});
let Di = class extends Ue {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return pn(t.data);
  }
};
Di.create = (e) => new Di({
  typeName: Ae.ZodUnknown,
  ...Fe(e)
});
let Vr = class extends Ue {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return be(n, {
      code: oe.invalid_type,
      expected: ye.never,
      received: n.parsedType
    }), je;
  }
};
Vr.create = (e) => new Vr({
  typeName: Ae.ZodNever,
  ...Fe(e)
});
let kc = class extends Ue {
  _parse(t) {
    if (this._getType(t) !== ye.undefined) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.void,
        received: r.parsedType
      }), je;
    }
    return pn(t.data);
  }
};
kc.create = (e) => new kc({
  typeName: Ae.ZodVoid,
  ...Fe(e)
});
let Ui = class Kl extends Ue {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), i = this._def;
    if (n.parsedType !== ye.array)
      return be(n, {
        code: oe.invalid_type,
        expected: ye.array,
        received: n.parsedType
      }), je;
    if (i.exactLength !== null) {
      const o = n.data.length > i.exactLength.value, s = n.data.length < i.exactLength.value;
      (o || s) && (be(n, {
        code: o ? oe.too_big : oe.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (be(n, {
      code: oe.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (be(n, {
      code: oe.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, s) => i.type._parseAsync(new Er(n, o, n.path, s)))).then((o) => wn.mergeArray(r, o));
    const a = [...n.data].map((o, s) => i.type._parseSync(new Er(n, o, n.path, s)));
    return wn.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new Kl({
      ...this._def,
      minLength: { value: t, message: Ce.toString(n) }
    });
  }
  max(t, n) {
    return new Kl({
      ...this._def,
      maxLength: { value: t, message: Ce.toString(n) }
    });
  }
  length(t, n) {
    return new Kl({
      ...this._def,
      exactLength: { value: t, message: Ce.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
};
Ui.create = (e, t) => new Ui({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Ae.ZodArray,
  ...Fe(t)
});
function va(e) {
  if (e instanceof Vn) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = Fr.create(va(r));
    }
    return new Vn({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof Ui ? new Ui({
    ...e._def,
    type: va(e.element)
  }) : e instanceof Fr ? Fr.create(va(e.unwrap())) : e instanceof zi ? zi.create(va(e.unwrap())) : e instanceof vi ? vi.create(e.items.map((t) => va(t))) : e;
}
let Vn = class Kn extends Ue {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = it.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== ye.object) {
      const l = this._getOrReturnCtx(t);
      return be(l, {
        code: oe.invalid_type,
        expected: ye.object,
        received: l.parsedType
      }), je;
    }
    const { status: r, ctx: i } = this._processInputParams(t), { shape: a, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Vr && this._def.unknownKeys === "strip"))
      for (const l in i.data)
        o.includes(l) || s.push(l);
    const c = [];
    for (const l of o) {
      const u = a[l], f = i.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new Er(i, f, i.path, l)),
        alwaysSet: l in i.data
      });
    }
    if (this._def.catchall instanceof Vr) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of s)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: i.data[u] }
          });
      else if (l === "strict")
        s.length > 0 && (be(i, {
          code: oe.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of s) {
        const f = i.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new Er(i, f, i.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const f = await u.key;
        l.push({
          key: f,
          value: await u.value,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => wn.mergeObjectSync(r, l)) : wn.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Ce.errToObj, new Kn({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var i, a, o, s;
          const c = (o = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = Ce.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new Kn({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new Kn({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new Kn({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new Kn({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Ae.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new Kn({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return it.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new Kn({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return it.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new Kn({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return va(this);
  }
  partial(t) {
    const n = {};
    return it.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      t && !t[r] ? n[r] = i : n[r] = i.optional();
    }), new Kn({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return it.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof Fr; )
          a = a._def.innerType;
        n[r] = a;
      }
    }), new Kn({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return z1(it.objectKeys(this.shape));
  }
};
Vn.create = (e, t) => new Vn({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Vr.create(),
  typeName: Ae.ZodObject,
  ...Fe(t)
});
Vn.strictCreate = (e, t) => new Vn({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Vr.create(),
  typeName: Ae.ZodObject,
  ...Fe(t)
});
Vn.lazycreate = (e, t) => new Vn({
  shape: e,
  unknownKeys: "strip",
  catchall: Vr.create(),
  typeName: Ae.ZodObject,
  ...Fe(t)
});
let Xo = class extends Ue {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new er(s.ctx.common.issues));
      return be(n, {
        code: oe.invalid_union,
        unionErrors: o
      }), je;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const c of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !a && (a = { result: u, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((c) => new er(c));
      return be(n, {
        code: oe.invalid_union,
        unionErrors: s
      }), je;
    }
  }
  get options() {
    return this._def.options;
  }
};
Xo.create = (e, t) => new Xo({
  options: e,
  typeName: Ae.ZodUnion,
  ...Fe(t)
});
const Gl = (e) => e instanceof es ? Gl(e.schema) : e instanceof rr ? Gl(e.innerType()) : e instanceof ts ? [e.value] : e instanceof Ns ? e.options : e instanceof ns ? Object.keys(e.enum) : e instanceof rs ? Gl(e._def.innerType) : e instanceof Yo ? [void 0] : e instanceof Jo ? [null] : null;
let j1 = class L1 extends Ue {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ye.object)
      return be(n, {
        code: oe.invalid_type,
        expected: ye.object,
        received: n.parsedType
      }), je;
    const r = this.discriminator, i = n.data[r], a = this.optionsMap.get(i);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (be(n, {
      code: oe.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), je);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const a of n) {
      const o = Gl(a.shape[t]);
      if (!o)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (i.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        i.set(s, a);
      }
    }
    return new L1({
      typeName: Ae.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...Fe(r)
    });
  }
};
function Np(e, t) {
  const n = ii(e), r = ii(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === ye.object && r === ye.object) {
    const i = it.objectKeys(t), a = it.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const c = Np(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      o[s] = c.data;
    }
    return { valid: !0, data: o };
  } else if (n === ye.array && r === ye.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], c = Np(o, s);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else return n === ye.date && r === ye.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
let Qo = class extends Ue {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = (a, o) => {
      if ($p(a) || $p(o))
        return je;
      const s = Np(a.value, o.value);
      return s.valid ? ((Ip(a) || Ip(o)) && n.dirty(), { status: n.value, value: s.data }) : (be(r, {
        code: oe.invalid_intersection_types
      }), je);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
};
Qo.create = (e, t, n) => new Qo({
  left: e,
  right: t,
  typeName: Ae.ZodIntersection,
  ...Fe(n)
});
let vi = class F1 extends Ue {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ye.array)
      return be(r, {
        code: oe.invalid_type,
        expected: ye.array,
        received: r.parsedType
      }), je;
    if (r.data.length < this._def.items.length)
      return be(r, {
        code: oe.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), je;
    !this._def.rest && r.data.length > this._def.items.length && (be(r, {
      code: oe.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((o, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new Er(r, o, r.path, s)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(a).then((o) => wn.mergeArray(n, o)) : wn.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new F1({
      ...this._def,
      rest: t
    });
  }
};
vi.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new vi({
    items: e,
    typeName: Ae.ZodTuple,
    rest: null,
    ...Fe(t)
  });
};
let B1 = class Dp extends Ue {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ye.object)
      return be(r, {
        code: oe.invalid_type,
        expected: ye.object,
        received: r.parsedType
      }), je;
    const i = [], a = this._def.keyType, o = this._def.valueType;
    for (const s in r.data)
      i.push({
        key: a._parse(new Er(r, s, r.path, s)),
        value: o._parse(new Er(r, r.data[s], r.path, s))
      });
    return r.common.async ? wn.mergeObjectAsync(n, i) : wn.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof Ue ? new Dp({
      keyType: t,
      valueType: n,
      typeName: Ae.ZodRecord,
      ...Fe(r)
    }) : new Dp({
      keyType: Pa.create(),
      valueType: t,
      typeName: Ae.ZodRecord,
      ...Fe(n)
    });
  }
}, Oc = class extends Ue {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ye.map)
      return be(r, {
        code: oe.invalid_type,
        expected: ye.map,
        received: r.parsedType
      }), je;
    const i = this._def.keyType, a = this._def.valueType, o = [...r.data.entries()].map(([s, c], l) => ({
      key: i._parse(new Er(r, s, r.path, [l, "key"])),
      value: a._parse(new Er(r, c, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of o) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return je;
          (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of o) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return je;
        (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
      }
      return { status: n.value, value: s };
    }
  }
};
Oc.create = (e, t, n) => new Oc({
  valueType: t,
  keyType: e,
  typeName: Ae.ZodMap,
  ...Fe(n)
});
let Cc = class Mp extends Ue {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ye.set)
      return be(r, {
        code: oe.invalid_type,
        expected: ye.set,
        received: r.parsedType
      }), je;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (be(r, {
      code: oe.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (be(r, {
      code: oe.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function o(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return je;
        u.status === "dirty" && n.dirty(), l.add(u.value);
      }
      return { status: n.value, value: l };
    }
    const s = [...r.data.values()].map((c, l) => a._parse(new Er(r, c, r.path, l)));
    return r.common.async ? Promise.all(s).then((c) => o(c)) : o(s);
  }
  min(t, n) {
    return new Mp({
      ...this._def,
      minSize: { value: t, message: Ce.toString(n) }
    });
  }
  max(t, n) {
    return new Mp({
      ...this._def,
      maxSize: { value: t, message: Ce.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
};
Cc.create = (e, t) => new Cc({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Ae.ZodSet,
  ...Fe(t)
});
let U1 = class Yl extends Ue {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ye.function)
      return be(n, {
        code: oe.invalid_type,
        expected: ye.function,
        received: n.parsedType
      }), je;
    function r(s, c) {
      return _c({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Sc(),
          Ho
        ].filter((l) => !!l),
        issueData: {
          code: oe.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(s, c) {
      return _c({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          Sc(),
          Ho
        ].filter((l) => !!l),
        issueData: {
          code: oe.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof Da) {
      const s = this;
      return pn(async function(...c) {
        const l = new er([]), u = await s._def.args.parseAsync(c, a).catch((p) => {
          throw l.addIssue(r(c, p)), l;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, a).catch((p) => {
          throw l.addIssue(i(f, p)), l;
        });
      });
    } else {
      const s = this;
      return pn(function(...c) {
        const l = s._def.args.safeParse(c, a);
        if (!l.success)
          throw new er([r(c, l.error)]);
        const u = Reflect.apply(o, this, l.data), f = s._def.returns.safeParse(u, a);
        if (!f.success)
          throw new er([i(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Yl({
      ...this._def,
      args: vi.create(t).rest(Di.create())
    });
  }
  returns(t) {
    return new Yl({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Yl({
      args: t || vi.create([]).rest(Di.create()),
      returns: n || Di.create(),
      typeName: Ae.ZodFunction,
      ...Fe(r)
    });
  }
}, es = class extends Ue {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
};
es.create = (e, t) => new es({
  getter: e,
  typeName: Ae.ZodLazy,
  ...Fe(t)
});
let ts = class extends Ue {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return be(n, {
        received: n.data,
        code: oe.invalid_literal,
        expected: this._def.value
      }), je;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
};
ts.create = (e, t) => new ts({
  value: e,
  typeName: Ae.ZodLiteral,
  ...Fe(t)
});
function z1(e, t) {
  return new Ns({
    values: e,
    typeName: Ae.ZodEnum,
    ...Fe(t)
  });
}
let Ns = class jp extends Ue {
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return be(n, {
        expected: it.joinValues(r),
        received: n.parsedType,
        code: oe.invalid_type
      }), je;
    }
    if (this._def.values.indexOf(t.data) === -1) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return be(n, {
        received: n.data,
        code: oe.invalid_enum_value,
        options: r
      }), je;
    }
    return pn(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t) {
    return jp.create(t);
  }
  exclude(t) {
    return jp.create(this.options.filter((n) => !t.includes(n)));
  }
};
Ns.create = z1;
let ns = class extends Ue {
  _parse(t) {
    const n = it.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== ye.string && r.parsedType !== ye.number) {
      const i = it.objectValues(n);
      return be(r, {
        expected: it.joinValues(i),
        received: r.parsedType,
        code: oe.invalid_type
      }), je;
    }
    if (n.indexOf(t.data) === -1) {
      const i = it.objectValues(n);
      return be(r, {
        received: r.data,
        code: oe.invalid_enum_value,
        options: i
      }), je;
    }
    return pn(t.data);
  }
  get enum() {
    return this._def.values;
  }
};
ns.create = (e, t) => new ns({
  values: e,
  typeName: Ae.ZodNativeEnum,
  ...Fe(t)
});
let Da = class extends Ue {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ye.promise && n.common.async === !1)
      return be(n, {
        code: oe.invalid_type,
        expected: ye.promise,
        received: n.parsedType
      }), je;
    const r = n.parsedType === ye.promise ? n.data : Promise.resolve(n.data);
    return pn(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
};
Da.create = (e, t) => new Da({
  type: e,
  typeName: Ae.ZodPromise,
  ...Fe(t)
});
let rr = class extends Ue {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Ae.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        be(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(r.data, a);
      return r.common.issues.length ? {
        status: "dirty",
        value: r.data
      } : r.common.async ? Promise.resolve(o).then((s) => this._def.schema._parseAsync({
        data: s,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: o,
        path: r.path,
        parent: r
      });
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const c = i.refinement(s, a);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? je : (s.status === "dirty" && n.dirty(), o(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => s.status === "aborted" ? je : (s.status === "dirty" && n.dirty(), o(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!qo(o))
          return o;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => qo(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({ status: n.value, value: s })) : o);
    it.assertNever(i);
  }
};
rr.create = (e, t, n) => new rr({
  schema: e,
  typeName: Ae.ZodEffects,
  effect: t,
  ...Fe(n)
});
rr.createWithPreprocess = (e, t, n) => new rr({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Ae.ZodEffects,
  ...Fe(n)
});
let Fr = class extends Ue {
  _parse(t) {
    return this._getType(t) === ye.undefined ? pn(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
};
Fr.create = (e, t) => new Fr({
  innerType: e,
  typeName: Ae.ZodOptional,
  ...Fe(t)
});
let zi = class extends Ue {
  _parse(t) {
    return this._getType(t) === ye.null ? pn(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
};
zi.create = (e, t) => new zi({
  innerType: e,
  typeName: Ae.ZodNullable,
  ...Fe(t)
});
let rs = class extends Ue {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === ye.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
rs.create = (e, t) => new rs({
  innerType: e,
  typeName: Ae.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Fe(t)
});
let Rc = class extends Ue {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return Ec(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new er(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new er(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
};
Rc.create = (e, t) => new Rc({
  innerType: e,
  typeName: Ae.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Fe(t)
});
let $c = class extends Ue {
  _parse(t) {
    if (this._getType(t) !== ye.nan) {
      const r = this._getOrReturnCtx(t);
      return be(r, {
        code: oe.invalid_type,
        expected: ye.nan,
        received: r.parsedType
      }), je;
    }
    return { status: "valid", value: t.data };
  }
};
$c.create = (e) => new $c({
  typeName: Ae.ZodNaN,
  ...Fe(e)
});
const YR = Symbol("zod_brand");
let V1 = class extends Ue {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}, cm = class H1 extends Ue {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? je : a.status === "dirty" ? (n.dirty(), D1(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? je : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new H1({
      in: t,
      out: n,
      typeName: Ae.ZodPipeline
    });
  }
}, Ic = class extends Ue {
  _parse(t) {
    const n = this._def.innerType._parse(t);
    return qo(n) && (n.value = Object.freeze(n.value)), n;
  }
};
Ic.create = (e, t) => new Ic({
  innerType: e,
  typeName: Ae.ZodReadonly,
  ...Fe(t)
});
const q1 = (e, t = {}, n) => e ? Na.create().superRefine((r, i) => {
  var a, o;
  if (!e(r)) {
    const s = typeof t == "function" ? t(r) : typeof t == "string" ? { message: t } : t, c = (o = (a = s.fatal) !== null && a !== void 0 ? a : n) !== null && o !== void 0 ? o : !0, l = typeof s == "string" ? { message: s } : s;
    i.addIssue({ code: "custom", ...l, fatal: c });
  }
}) : Na.create(), JR = {
  object: Vn.lazycreate
};
var Ae;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Ae || (Ae = {}));
const XR = (e, t = {
  message: `Input not instance of ${e.name}`
}) => q1((n) => n instanceof e, t), W1 = Pa.create, Z1 = Wo.create, QR = $c.create, e$ = Zo.create, K1 = Ko.create, t$ = Go.create, n$ = Tc.create, r$ = Yo.create, i$ = Jo.create, a$ = Na.create, o$ = Di.create, s$ = Vr.create, l$ = kc.create, c$ = Ui.create, u$ = Vn.create, f$ = Vn.strictCreate, d$ = Xo.create, p$ = j1.create, h$ = Qo.create, m$ = vi.create, v$ = B1.create, y$ = Oc.create, g$ = Cc.create, b$ = U1.create, x$ = es.create, w$ = ts.create, S$ = Ns.create, _$ = ns.create, E$ = Da.create, By = rr.create, T$ = Fr.create, k$ = zi.create, O$ = rr.createWithPreprocess, C$ = cm.create, R$ = () => W1().optional(), $$ = () => Z1().optional(), I$ = () => K1().optional(), A$ = {
  string: (e) => Pa.create({ ...e, coerce: !0 }),
  number: (e) => Wo.create({ ...e, coerce: !0 }),
  boolean: (e) => Ko.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => Zo.create({ ...e, coerce: !0 }),
  date: (e) => Go.create({ ...e, coerce: !0 })
}, P$ = je;
var we = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Ho,
  setErrorMap: jR,
  getErrorMap: Sc,
  makeIssue: _c,
  EMPTY_PATH: LR,
  addIssueToContext: be,
  ParseStatus: wn,
  INVALID: je,
  DIRTY: D1,
  OK: pn,
  isAborted: $p,
  isDirty: Ip,
  isValid: qo,
  isAsync: Ec,
  get util() {
    return it;
  },
  get objectUtil() {
    return Rp;
  },
  ZodParsedType: ye,
  getParsedType: ii,
  ZodType: Ue,
  ZodString: Pa,
  ZodNumber: Wo,
  ZodBigInt: Zo,
  ZodBoolean: Ko,
  ZodDate: Go,
  ZodSymbol: Tc,
  ZodUndefined: Yo,
  ZodNull: Jo,
  ZodAny: Na,
  ZodUnknown: Di,
  ZodNever: Vr,
  ZodVoid: kc,
  ZodArray: Ui,
  ZodObject: Vn,
  ZodUnion: Xo,
  ZodDiscriminatedUnion: j1,
  ZodIntersection: Qo,
  ZodTuple: vi,
  ZodRecord: B1,
  ZodMap: Oc,
  ZodSet: Cc,
  ZodFunction: U1,
  ZodLazy: es,
  ZodLiteral: ts,
  ZodEnum: Ns,
  ZodNativeEnum: ns,
  ZodPromise: Da,
  ZodEffects: rr,
  ZodTransformer: rr,
  ZodOptional: Fr,
  ZodNullable: zi,
  ZodDefault: rs,
  ZodCatch: Rc,
  ZodNaN: $c,
  BRAND: YR,
  ZodBranded: V1,
  ZodPipeline: cm,
  ZodReadonly: Ic,
  custom: q1,
  Schema: Ue,
  ZodSchema: Ue,
  late: JR,
  get ZodFirstPartyTypeKind() {
    return Ae;
  },
  coerce: A$,
  any: a$,
  array: c$,
  bigint: e$,
  boolean: K1,
  date: t$,
  discriminatedUnion: p$,
  effect: By,
  enum: S$,
  function: b$,
  instanceof: XR,
  intersection: h$,
  lazy: x$,
  literal: w$,
  map: y$,
  nan: QR,
  nativeEnum: _$,
  never: s$,
  null: i$,
  nullable: k$,
  number: Z1,
  object: u$,
  oboolean: I$,
  onumber: $$,
  optional: T$,
  ostring: R$,
  pipeline: C$,
  preprocess: O$,
  promise: E$,
  record: v$,
  set: g$,
  strictObject: f$,
  string: W1,
  symbol: n$,
  transformer: By,
  tuple: m$,
  undefined: r$,
  union: d$,
  unknown: o$,
  void: l$,
  NEVER: P$,
  ZodIssueCode: oe,
  quotelessJson: MR,
  ZodError: er
});
const go = we.object({
  title: we.string().optional(),
  link: we.string().optional()
}), G1 = we.object({
  color: we.string().optional(),
  variant: we.enum(["soft", "solid"]).optional(),
  themeMode: we.enum(["light", "dark"]).optional(),
  fontFamily: we.enum(["rubik", "inter", "ibm", "fira"]).optional(),
  radius: we.number().min(0.5).max(4).optional()
}), N$ = we.object({
  composerPlaceholder: we.string().optional(),
  botName: we.string().optional(),
  botAvatar: we.string().optional(),
  botDescription: we.string().optional(),
  website: go.optional(),
  email: go.optional(),
  phone: go.optional(),
  privacyPolicy: go.optional(),
  termsOfService: go.optional(),
  showPoweredBy: we.boolean().optional()
}).merge(G1), D$ = we.enum([
  "heading1",
  "heading2",
  "heading3",
  "text",
  "horizontalRule",
  "link",
  "italic",
  "bold",
  "orderedList",
  "unorderedList",
  "listItem",
  "lineBreak",
  "pre"
]), M$ = we.object({}).passthrough().transform((e) => e), ue = we.object({
  className: we.string().optional(),
  style: M$.optional()
}), bf = we.object({
  container: ue.optional(),
  image: ue.optional(),
  fallback: ue.optional()
}), j$ = we.object({
  button: ue.optional(),
  text: we.record(D$, ue.optional()),
  image: we.object({
    image: ue.optional(),
    placeholder: ue.optional()
  }).optional(),
  audio: ue.optional(),
  video: ue.optional(),
  file: we.object({
    container: ue.optional(),
    title: ue.optional(),
    icon: ue.optional()
  }).optional(),
  location: we.object({
    container: ue.optional(),
    title: ue.optional(),
    icon: ue.optional()
  }).optional(),
  column: ue.optional(),
  row: ue.optional(),
  bubble: ue.optional(),
  carousel: we.object({
    container: ue.optional(),
    slidesContainer: ue.optional(),
    backButton: ue.optional(),
    nextButton: ue.optional()
  }).optional(),
  dropdown: we.object({
    button: we.object({
      container: ue.optional(),
      icon: ue.optional(),
      text: ue.optional()
    }).optional(),
    content: we.object({
      container: ue.optional(),
      item: ue.optional()
    }).optional()
  }).optional()
}), L$ = we.object({
  container: ue.optional(),
  modal: we.object({
    overlay: ue.optional(),
    container: ue.optional(),
    dialog: we.object({
      container: ue.optional(),
      title: we.object({
        container: ue.optional(),
        text: ue.optional(),
        closeIcon: ue.optional()
      }).optional(),
      content: ue.optional(),
      newConversation: we.object({
        text: ue.optional(),
        button: ue.optional()
      }).optional()
    }).optional()
  }).optional(),
  notification: we.object({
    container: ue.optional(),
    title: ue.optional(),
    description: ue.optional(),
    icon: ue.optional(),
    closeIcon: ue.optional()
  }).optional(),
  header: we.object({
    container: ue.optional(),
    content: we.object({
      container: ue.optional(),
      title: ue.optional(),
      description: ue.optional(),
      avatar: bf.optional(),
      actions: we.object({
        container: ue.optional(),
        icons: ue.optional()
      }).optional()
    }),
    expandedContent: we.object({
      container: ue.optional(),
      group: ue.optional(),
      descriptionItems: we.object({
        container: ue.optional(),
        icon: ue.optional(),
        text: ue.optional(),
        link: ue.optional(),
        poweredBy: ue.optional()
      }).optional()
    }).optional(),
    description: we.object({
      container: ue.optional(),
      title: ue.optional(),
      subtitle: ue.optional()
    }).optional(),
    newConversationIcon: ue.optional()
  }).optional(),
  composer: we.object({
    container: ue.optional(),
    input: ue.optional(),
    uploadButton: we.object({
      container: ue.optional(),
      icon: ue.optional()
    }).optional(),
    button: we.object({
      container: ue.optional(),
      icon: ue.optional()
    }).optional()
  }).optional(),
  fab: we.object({
    icon: ue.optional(),
    container: ue.optional()
  }).optional(),
  messageList: we.object({
    scrollbar: we.object({
      container: ue.optional(),
      viewport: ue.optional(),
      thumb: ue.optional(),
      corner: ue.optional(),
      background: ue.optional()
    }).optional(),
    container: ue.optional(),
    marquee: we.object({
      content: ue.optional(),
      title: ue.optional(),
      description: ue.optional(),
      avatar: bf.optional(),
      container: ue.optional()
    }).optional(),
    scrollDownButton: we.object({
      container: ue.optional(),
      button: ue.optional(),
      icon: ue.optional()
    }).optional()
  }).optional(),
  message: we.object({
    container: ue.optional(),
    avatar: bf.optional(),
    blocks: j$.optional()
  }).optional(),
  loadingIndicator: we.object({
    container: ue.optional(),
    loader: ue.optional()
  }).optional()
}), F$ = we.enum(["opened", "closed", "initial"]), B$ = we.object({
  name: we.string().optional(),
  pictureUrl: we.string().optional(),
  data: we.record(we.unknown()).optional(),
  userKey: we.string().optional()
}), U$ = we.object({
  configuration: N$.optional().catch(void 0),
  theme: L$.optional().catch(void 0),
  style: we.string().optional().catch(void 0),
  user: B$.optional().catch(void 0)
}), Xle = U$.extend({
  clientId: we.string(),
  botId: we.string(),
  selector: we.string().optional().catch(void 0),
  webchatScriptUrl: we.string().optional().catch(void 0),
  fabScriptUrl: we.string().optional().catch(void 0),
  pushpinUrl: we.string().optional().catch(void 0),
  defaultState: F$.optional().catch(void 0)
});
function z$(e) {
  const { fontFamily: t, radius: n, themeMode: r, variant: i, color: a } = G1.parse(e);
  let o = {}, s = {};
  if (a) {
    const u = Ly(a), f = r === "dark" ? Ry(u) : u, d = Ly(oR(sR(Cp(a)))), p = r === "dark" ? Ry(d) : d, m = r === "dark" ? "#101010" : "#fdfdfd";
    s = Object.entries({ ...f, 1: m }).reduce(
      (y, [v, g]) => ({ ...y, [`--bpPrimary-${v}`]: g }),
      {}
    );
    const h = Object.entries({ ...p, 1: m }).reduce(
      (y, [v, g]) => ({ ...y, [`--bpGray-${v}`]: g }),
      {}
    );
    o = {
      ...s,
      ...h
    };
  }
  n && (o = {
    ...o,
    "--bpRadius-scale": n.toString()
  });
  const c = s ? Dy(s["--bpPrimary-600"], s["--bpPrimary-50"]) > 40 ? "var(--bpPrimary-50)" : "var(--bpPrimary-900)" : "var(--bpPrimary-50)", l = i === "solid" ? {
    "--header-bg": "var(--bpPrimary-600)",
    "--header-bg-hover": "var(--bpPrimary-700)",
    "--header-hover-dark": "var(--bpPrimary-800)",
    "--header-title": c,
    "--header-description": c,
    "--header-description-icon": c,
    "--header-description-link": c,
    "--header-avatar-bg": "var(--bpPrimary-300)",
    "--header-avatar-text": "var(--bpPrimary-700)",
    "--message-bg": "var(--bpPrimary-600)",
    "--message-bg-hover": "var(--bpPrimary-700)",
    "--message-text": c,
    "--send-button-bg": "var(--bpPrimary-600)",
    "--send-button-bg-hover": "var(--bpPrimary-700)",
    "--send-button-text": "var(--bpPrimary-50)",
    "--button-bg": "var(--bpPrimary-50)",
    "--button-bg-hover": "var(--bpPrimary-100)",
    "--button-text": "var(--bpPrimary-800)",
    "--fab-bg": "var(--bpPrimary-600)",
    "--fab-bg-hover": "var(--bpPrimary-700)",
    "--fab-icon": c
  } : {
    "--header-bg": "var(--bpGray-50)",
    "--header-bg-hover": "var(--bpGray-100)",
    "--header-hover-dark": "var(--bpGray-200)",
    "--header-title": "var(--bpGray-900)",
    "--header-description": "var(--bpGray-800)",
    "--header-description-icon": "var(--bpPrimary-700)",
    "--header-description-link": "var(--bpPrimary-800)",
    "--header-avatar-bg": "var(--bpPrimary-600)",
    "--header-avatar-text": "var(--bpPrimary-50)",
    "--message-bg": "var(--bpPrimary-100)",
    "--message-bg-hover": "var(--bpPrimary-200)",
    "--message-text": "var(--bpPrimary-900)",
    "--send-button-bg": "var(--bpPrimary-600)",
    "--send-button-bg-hover": "var(--bpPrimary-700)",
    "--send-button-text": "var(--bpPrimary-50)",
    "--button-bg": "var(--bpPrimary-500)",
    "--button-bg-hover": "var(--bpPrimary-600)",
    "--button-text": s ? Dy(s["--bpPrimary-500"], s["--bpPrimary-50"]) > 40 ? "var(--bpPrimary-50)" : "var(--bpPrimary-900)" : "var(--bpPrimary-50)",
    "--fab-bg": "var(--bpPrimary-100)",
    "--fab-bg-hover": "var(--bpPrimary-200)",
    "--fab-icon": "var(--bpPrimary-700)"
  };
  return o = {
    ...o,
    ...l
  }, My(":root", o) + (t ? My(".bpFont", { "font-family": `var(--${t}-font)` }) : "");
}
const um = In(
  ({ userId: e, src: t, container: n, image: r, fallback: i, ...a }, o) => {
    const s = R1(e ?? "", 15);
    return /* @__PURE__ */ R.jsxs(am, { ref: o, "data-color": s, ...n, ...a, children: [
      /* @__PURE__ */ R.jsx(om, { src: t, ...r }),
      /* @__PURE__ */ R.jsx(sm, { ...i, children: typeof a.children == "string" ? a.children[0] : a.children })
    ] });
  }
);
um.displayName = "Avatar";
function V$(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const H$ = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, q$ = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, W$ = {};
function Uy(e, t) {
  return (W$.jsx ? q$ : H$).test(e);
}
const Z$ = /[ \t\n\f\r]/g;
function K$(e) {
  return typeof e == "object" ? e.type === "text" ? zy(e.value) : !1 : zy(e);
}
function zy(e) {
  return e.replace(Z$, "") === "";
}
class Ds {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Ds.prototype.property = {};
Ds.prototype.normal = {};
Ds.prototype.space = null;
function Y1(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Ds(n, r, t);
}
function Lp(e) {
  return e.toLowerCase();
}
class Hn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Hn.prototype.space = null;
Hn.prototype.boolean = !1;
Hn.prototype.booleanish = !1;
Hn.prototype.overloadedBoolean = !1;
Hn.prototype.number = !1;
Hn.prototype.commaSeparated = !1;
Hn.prototype.spaceSeparated = !1;
Hn.prototype.commaOrSpaceSeparated = !1;
Hn.prototype.mustUseProperty = !1;
Hn.prototype.defined = !1;
let G$ = 0;
const Le = Yi(), Nt = Yi(), J1 = Yi(), ie = Yi(), gt = Yi(), Ta = Yi(), Tn = Yi();
function Yi() {
  return 2 ** ++G$;
}
const Fp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Le,
  booleanish: Nt,
  commaOrSpaceSeparated: Tn,
  commaSeparated: Ta,
  number: ie,
  overloadedBoolean: J1,
  spaceSeparated: gt
}, Symbol.toStringTag, { value: "Module" })), xf = Object.keys(Fp);
class fm extends Hn {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let a = -1;
    if (super(t, n), Vy(this, "space", i), typeof r == "number")
      for (; ++a < xf.length; ) {
        const o = xf[a];
        Vy(this, xf[a], (r & Fp[o]) === Fp[o]);
      }
  }
}
fm.prototype.defined = !0;
function Vy(e, t, n) {
  n && (e[t] = n);
}
const Y$ = {}.hasOwnProperty;
function eo(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Y$.call(e.properties, r)) {
      const i = e.properties[r], a = new fm(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (a.mustUseProperty = !0), t[r] = a, n[Lp(r)] = r, n[Lp(a.attribute)] = r;
    }
  return new Ds(t, n, e.space);
}
const X1 = eo({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Q1 = eo({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function eS(e, t) {
  return t in e ? e[t] : t;
}
function tS(e, t) {
  return eS(e, t.toLowerCase());
}
const nS = eo({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: tS,
  properties: { xmlns: null, xmlnsXLink: null }
}), rS = eo({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Nt,
    ariaAutoComplete: null,
    ariaBusy: Nt,
    ariaChecked: Nt,
    ariaColCount: ie,
    ariaColIndex: ie,
    ariaColSpan: ie,
    ariaControls: gt,
    ariaCurrent: null,
    ariaDescribedBy: gt,
    ariaDetails: null,
    ariaDisabled: Nt,
    ariaDropEffect: gt,
    ariaErrorMessage: null,
    ariaExpanded: Nt,
    ariaFlowTo: gt,
    ariaGrabbed: Nt,
    ariaHasPopup: null,
    ariaHidden: Nt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: gt,
    ariaLevel: ie,
    ariaLive: null,
    ariaModal: Nt,
    ariaMultiLine: Nt,
    ariaMultiSelectable: Nt,
    ariaOrientation: null,
    ariaOwns: gt,
    ariaPlaceholder: null,
    ariaPosInSet: ie,
    ariaPressed: Nt,
    ariaReadOnly: Nt,
    ariaRelevant: null,
    ariaRequired: Nt,
    ariaRoleDescription: gt,
    ariaRowCount: ie,
    ariaRowIndex: ie,
    ariaRowSpan: ie,
    ariaSelected: Nt,
    ariaSetSize: ie,
    ariaSort: null,
    ariaValueMax: ie,
    ariaValueMin: ie,
    ariaValueNow: ie,
    ariaValueText: null,
    role: null
  }
}), J$ = eo({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: tS,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ta,
    acceptCharset: gt,
    accessKey: gt,
    action: null,
    allow: null,
    allowFullScreen: Le,
    allowPaymentRequest: Le,
    allowUserMedia: Le,
    alt: null,
    as: null,
    async: Le,
    autoCapitalize: null,
    autoComplete: gt,
    autoFocus: Le,
    autoPlay: Le,
    blocking: gt,
    capture: null,
    charSet: null,
    checked: Le,
    cite: null,
    className: gt,
    cols: ie,
    colSpan: null,
    content: null,
    contentEditable: Nt,
    controls: Le,
    controlsList: gt,
    coords: ie | Ta,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Le,
    defer: Le,
    dir: null,
    dirName: null,
    disabled: Le,
    download: J1,
    draggable: Nt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Le,
    formTarget: null,
    headers: gt,
    height: ie,
    hidden: Le,
    high: ie,
    href: null,
    hrefLang: null,
    htmlFor: gt,
    httpEquiv: gt,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Le,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Le,
    itemId: null,
    itemProp: gt,
    itemRef: gt,
    itemScope: Le,
    itemType: gt,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Le,
    low: ie,
    manifest: null,
    max: null,
    maxLength: ie,
    media: null,
    method: null,
    min: null,
    minLength: ie,
    multiple: Le,
    muted: Le,
    name: null,
    nonce: null,
    noModule: Le,
    noValidate: Le,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Le,
    optimum: ie,
    pattern: null,
    ping: gt,
    placeholder: null,
    playsInline: Le,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Le,
    referrerPolicy: null,
    rel: gt,
    required: Le,
    reversed: Le,
    rows: ie,
    rowSpan: ie,
    sandbox: gt,
    scope: null,
    scoped: Le,
    seamless: Le,
    selected: Le,
    shadowRootClonable: Le,
    shadowRootDelegatesFocus: Le,
    shadowRootMode: null,
    shape: null,
    size: ie,
    sizes: null,
    slot: null,
    span: ie,
    spellCheck: Nt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ie,
    step: null,
    style: null,
    tabIndex: ie,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Le,
    useMap: null,
    value: Nt,
    width: ie,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: gt,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ie,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ie,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Le,
    // Lists. Use CSS to reduce space between items instead
    declare: Le,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ie,
    // `<img>` and `<object>`
    leftMargin: ie,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ie,
    // `<body>`
    marginWidth: ie,
    // `<body>`
    noResize: Le,
    // `<frame>`
    noHref: Le,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Le,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Le,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ie,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Nt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ie,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ie,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Le,
    disableRemotePlayback: Le,
    prefix: null,
    property: null,
    results: ie,
    security: null,
    unselectable: null
  }
}), X$ = eo({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: eS,
  properties: {
    about: Tn,
    accentHeight: ie,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ie,
    amplitude: ie,
    arabicForm: null,
    ascent: ie,
    attributeName: null,
    attributeType: null,
    azimuth: ie,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ie,
    by: null,
    calcMode: null,
    capHeight: ie,
    className: gt,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ie,
    diffuseConstant: ie,
    direction: null,
    display: null,
    dur: null,
    divisor: ie,
    dominantBaseline: null,
    download: Le,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ie,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ie,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ie,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ta,
    g2: Ta,
    glyphName: Ta,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ie,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ie,
    horizOriginX: ie,
    horizOriginY: ie,
    id: null,
    ideographic: ie,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ie,
    k: ie,
    k1: ie,
    k2: ie,
    k3: ie,
    k4: ie,
    kernelMatrix: Tn,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ie,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ie,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ie,
    overlineThickness: ie,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ie,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: gt,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ie,
    pointsAtY: ie,
    pointsAtZ: ie,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Tn,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Tn,
    rev: Tn,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Tn,
    requiredFeatures: Tn,
    requiredFonts: Tn,
    requiredFormats: Tn,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ie,
    specularExponent: ie,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ie,
    strikethroughThickness: ie,
    string: null,
    stroke: null,
    strokeDashArray: Tn,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ie,
    strokeOpacity: ie,
    strokeWidth: null,
    style: null,
    surfaceScale: ie,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Tn,
    tabIndex: ie,
    tableValues: null,
    target: null,
    targetX: ie,
    targetY: ie,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Tn,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ie,
    underlineThickness: ie,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ie,
    values: null,
    vAlphabetic: ie,
    vMathematical: ie,
    vectorEffect: null,
    vHanging: ie,
    vIdeographic: ie,
    version: null,
    vertAdvY: ie,
    vertOriginX: ie,
    vertOriginY: ie,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ie,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Q$ = /^data[-\w.:]+$/i, Hy = /-[a-z]/g, eI = /[A-Z]/g;
function tI(e, t) {
  const n = Lp(t);
  let r = t, i = Hn;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Q$.test(t)) {
    if (t.charAt(4) === "-") {
      const a = t.slice(5).replace(Hy, rI);
      r = "data" + a.charAt(0).toUpperCase() + a.slice(1);
    } else {
      const a = t.slice(4);
      if (!Hy.test(a)) {
        let o = a.replace(eI, nI);
        o.charAt(0) !== "-" && (o = "-" + o), t = "data" + o;
      }
    }
    i = fm;
  }
  return new i(r, t);
}
function nI(e) {
  return "-" + e.toLowerCase();
}
function rI(e) {
  return e.charAt(1).toUpperCase();
}
const iI = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, aI = Y1([Q1, X1, nS, rS, J$], "html"), dm = Y1([Q1, X1, nS, rS, X$], "svg");
function oI(e) {
  return e.join(" ").trim();
}
var iS = {}, qy = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, sI = /\n/g, lI = /^\s*/, cI = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, uI = /^:\s*/, fI = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, dI = /^[;\s]*/, pI = /^\s+|\s+$/g, hI = `
`, Wy = "/", Zy = "*", Pi = "", mI = "comment", vI = "declaration", yI = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(m) {
    var h = m.match(sI);
    h && (n += h.length);
    var y = m.lastIndexOf(hI);
    r = ~y ? m.length - y : r + m.length;
  }
  function a() {
    var m = { line: n, column: r };
    return function(h) {
      return h.position = new o(m), l(), h;
    };
  }
  function o(m) {
    this.start = m, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function s(m) {
    var h = new Error(
      t.source + ":" + n + ":" + r + ": " + m
    );
    if (h.reason = m, h.filename = t.source, h.line = n, h.column = r, h.source = e, !t.silent) throw h;
  }
  function c(m) {
    var h = m.exec(e);
    if (h) {
      var y = h[0];
      return i(y), e = e.slice(y.length), h;
    }
  }
  function l() {
    c(lI);
  }
  function u(m) {
    var h;
    for (m = m || []; h = f(); )
      h !== !1 && m.push(h);
    return m;
  }
  function f() {
    var m = a();
    if (!(Wy != e.charAt(0) || Zy != e.charAt(1))) {
      for (var h = 2; Pi != e.charAt(h) && (Zy != e.charAt(h) || Wy != e.charAt(h + 1)); )
        ++h;
      if (h += 2, Pi === e.charAt(h - 1))
        return s("End of comment missing");
      var y = e.slice(2, h - 2);
      return r += 2, i(y), e = e.slice(h), r += 2, m({
        type: mI,
        comment: y
      });
    }
  }
  function d() {
    var m = a(), h = c(cI);
    if (h) {
      if (f(), !c(uI)) return s("property missing ':'");
      var y = c(fI), v = m({
        type: vI,
        property: Ky(h[0].replace(qy, Pi)),
        value: y ? Ky(y[0].replace(qy, Pi)) : Pi
      });
      return c(dI), v;
    }
  }
  function p() {
    var m = [];
    u(m);
    for (var h; h = d(); )
      h !== !1 && (m.push(h), u(m));
    return m;
  }
  return l(), p();
};
function Ky(e) {
  return e ? e.replace(pI, Pi) : Pi;
}
var gI = pt && pt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(iS, "__esModule", { value: !0 });
var Gy = iS.default = xI, bI = gI(yI);
function xI(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, bI.default)(e), i = typeof t == "function";
  return r.forEach(function(a) {
    if (a.type === "declaration") {
      var o = a.property, s = a.value;
      i ? t(o, s, a) : s && (n = n || {}, n[o] = s);
    }
  }), n;
}
const wI = Gy.default || Gy, aS = oS("end"), pm = oS("start");
function oS(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function SI(e) {
  const t = pm(e), n = aS(e);
  if (t && n)
    return { start: t, end: n };
}
function Mo(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Yy(e.position) : "start" in e || "end" in e ? Yy(e) : "line" in e || "column" in e ? Bp(e) : "";
}
function Bp(e) {
  return Jy(e && e.line) + ":" + Jy(e && e.column);
}
function Yy(e) {
  return Bp(e && e.start) + "-" + Bp(e && e.end);
}
function Jy(e) {
  return e && typeof e == "number" ? e : 1;
}
class ln extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", a = {}, o = !1;
    if (n && ("line" in n && "column" in n ? a = { place: n } : "start" in n && "end" in n ? a = { place: n } : "type" in n ? a = {
      ancestors: [n],
      place: n.position
    } : a = { ...n }), typeof t == "string" ? i = t : !a.cause && t && (o = !0, i = t.message, a.cause = t), !a.ruleId && !a.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? a.ruleId = r : (a.source = r.slice(0, c), a.ruleId = r.slice(c + 1));
    }
    if (!a.place && a.ancestors && a.ancestors) {
      const c = a.ancestors[a.ancestors.length - 1];
      c && (a.place = c.position);
    }
    const s = a.place && "start" in a.place ? a.place.start : a.place;
    this.ancestors = a.ancestors || void 0, this.cause = a.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = s ? s.line : void 0, this.name = Mo(a.place) || "1:1", this.place = a.place || void 0, this.reason = this.message, this.ruleId = a.ruleId || void 0, this.source = a.source || void 0, this.stack = o && a.cause && typeof a.cause.stack == "string" ? a.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
ln.prototype.file = "";
ln.prototype.name = "";
ln.prototype.reason = "";
ln.prototype.message = "";
ln.prototype.stack = "";
ln.prototype.column = void 0;
ln.prototype.line = void 0;
ln.prototype.ancestors = void 0;
ln.prototype.cause = void 0;
ln.prototype.fatal = void 0;
ln.prototype.place = void 0;
ln.prototype.ruleId = void 0;
ln.prototype.source = void 0;
const hm = {}.hasOwnProperty, _I = /* @__PURE__ */ new Map(), EI = /[A-Z]/g, TI = /-([a-z])/g, kI = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), OI = /* @__PURE__ */ new Set(["td", "th"]), sS = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function CI(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = MI(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = DI(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? dm : aI,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, a = lS(i, e, void 0);
  return a && typeof a != "string" ? a : i.create(
    e,
    i.Fragment,
    { children: a || void 0 },
    void 0
  );
}
function lS(e, t, n) {
  if (t.type === "element")
    return RI(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return $I(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return AI(e, t, n);
  if (t.type === "mdxjsEsm")
    return II(e, t);
  if (t.type === "root")
    return PI(e, t, n);
  if (t.type === "text")
    return NI(e, t);
}
function RI(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = dm, e.schema = i), e.ancestors.push(t);
  const a = uS(e, t.tagName, !1), o = jI(e, t);
  let s = vm(e, t);
  return kI.has(t.tagName) && (s = s.filter(function(c) {
    return typeof c == "string" ? !K$(c) : !0;
  })), cS(e, o, a, t), mm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function $I(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  is(e, t.position);
}
function II(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  is(e, t.position);
}
function AI(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = dm, e.schema = i), e.ancestors.push(t);
  const a = t.name === null ? e.Fragment : uS(e, t.name, !0), o = LI(e, t), s = vm(e, t);
  return cS(e, o, a, t), mm(o, s), e.ancestors.pop(), e.schema = r, e.create(t, a, o, n);
}
function PI(e, t, n) {
  const r = {};
  return mm(r, vm(e, t)), e.create(t, e.Fragment, r, n);
}
function NI(e, t) {
  return t.value;
}
function cS(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function mm(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function DI(e, t, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children) ? n : t;
    return s ? l(a, o, s) : l(a, o);
  }
}
function MI(e, t) {
  return n;
  function n(r, i, a, o) {
    const s = Array.isArray(a.children), c = pm(r);
    return t(
      i,
      a,
      o,
      s,
      {
        columnNumber: c ? c.column - 1 : void 0,
        fileName: e,
        lineNumber: c ? c.line : void 0
      },
      void 0
    );
  }
}
function jI(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && hm.call(t.properties, i)) {
      const a = FI(e, i, t.properties[i]);
      if (a) {
        const [o, s] = a;
        e.tableCellAlignToStyle && o === "align" && typeof s == "string" && OI.has(t.tagName) ? r = s : n[o] = s;
      }
    }
  if (r) {
    const a = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    a[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function LI(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const a = r.data.estree.body[0];
        a.type;
        const o = a.expression;
        o.type;
        const s = o.properties[0];
        s.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(s.argument)
        );
      } else
        is(e, t.position);
    else {
      const i = r.name;
      let a;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const s = r.value.data.estree.body[0];
          s.type, a = e.evaluater.evaluateExpression(s.expression);
        } else
          is(e, t.position);
      else
        a = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      a;
    }
  return n;
}
function vm(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : _I;
  for (; ++r < t.children.length; ) {
    const a = t.children[r];
    let o;
    if (e.passKeys) {
      const c = a.type === "element" ? a.tagName : a.type === "mdxJsxFlowElement" || a.type === "mdxJsxTextElement" ? a.name : void 0;
      if (c) {
        const l = i.get(c) || 0;
        o = c + "-" + l, i.set(c, l + 1);
      }
    }
    const s = lS(e, a, o);
    s !== void 0 && n.push(s);
  }
  return n;
}
function FI(e, t, n) {
  const r = tI(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? V$(n) : oI(n)), r.property === "style") {
      let i = typeof n == "object" ? n : BI(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = UI(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? iI[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function BI(e, t) {
  const n = {};
  try {
    wI(t, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const a = (
        /** @type {Error} */
        i
      ), o = new ln("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: a,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw o.file = e.filePath || void 0, o.url = sS + "#cannot-parse-style-attribute", o;
    }
  }
  return n;
  function r(i, a) {
    let o = i;
    o.slice(0, 2) !== "--" && (o.slice(0, 4) === "-ms-" && (o = "ms-" + o.slice(4)), o = o.replace(TI, VI)), n[o] = a;
  }
}
function uS(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let a = -1, o;
    for (; ++a < i.length; ) {
      const s = Uy(i[a]) ? { type: "Identifier", name: i[a] } : { type: "Literal", value: i[a] };
      o = o ? {
        type: "MemberExpression",
        object: o,
        property: s,
        computed: !!(a && s.type === "Literal"),
        optional: !1
      } : s;
    }
    r = o;
  } else
    r = Uy(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return hm.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  is(e);
}
function is(e, t) {
  const n = new ln(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = sS + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function UI(e) {
  const t = {};
  let n;
  for (n in e)
    hm.call(e, n) && (t[zI(n)] = e[n]);
  return t;
}
function zI(e) {
  let t = e.replace(EI, HI);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function VI(e, t) {
  return t.toUpperCase();
}
function HI(e) {
  return "-" + e.toLowerCase();
}
const wf = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, qI = {};
function ym(e, t) {
  const n = qI, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return fS(e, r, i);
}
function fS(e, t, n) {
  if (WI(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Xy(e.children, t, n);
  }
  return Array.isArray(e) ? Xy(e, t, n) : "";
}
function Xy(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = fS(e[i], t, n);
  return r.join("");
}
function WI(e) {
  return !!(e && typeof e == "object");
}
const Qy = document.createElement("i");
function gm(e) {
  const t = "&" + e + ";";
  Qy.innerHTML = t;
  const n = Qy.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function Un(e, t, n, r) {
  const i = e.length;
  let a = 0, o;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); a < r.length; )
      o = r.slice(a, a + 1e4), o.unshift(t, 0), e.splice(...o), a += 1e4, t += 1e4;
}
function jn(e, t) {
  return e.length > 0 ? (Un(e, e.length, 0, t), e) : t;
}
const eg = {}.hasOwnProperty;
function dS(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    ZI(t, e[n]);
  return t;
}
function ZI(e, t) {
  let n;
  for (n in t) {
    const i = (eg.call(e, n) ? e[n] : void 0) || (e[n] = {}), a = t[n];
    let o;
    if (a)
      for (o in a) {
        eg.call(i, o) || (i[o] = []);
        const s = a[o];
        KI(
          // @ts-expect-error Looks like a list.
          i[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function KI(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  Un(e, 0, 0, r);
}
function pS(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function tr(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const dn = Ei(/[A-Za-z]/), an = Ei(/[\dA-Za-z]/), GI = Ei(/[#-'*+\--9=?A-Z^-~]/);
function Ac(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Up = Ei(/\d/), YI = Ei(/[\dA-Fa-f]/), JI = Ei(/[!-/:-@[-`{-~]/);
function $e(e) {
  return e !== null && e < -2;
}
function yt(e) {
  return e !== null && (e < 0 || e === 32);
}
function qe(e) {
  return e === -2 || e === -1 || e === 32;
}
const bu = Ei(new RegExp("\\p{P}|\\p{S}", "u")), Vi = Ei(/\s/);
function Ei(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function to(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const a = e.charCodeAt(n);
    let o = "";
    if (a === 37 && an(e.charCodeAt(n + 1)) && an(e.charCodeAt(n + 2)))
      i = 2;
    else if (a < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(a)) || (o = String.fromCharCode(a));
    else if (a > 55295 && a < 57344) {
      const s = e.charCodeAt(n + 1);
      a < 56320 && s > 56319 && s < 57344 ? (o = String.fromCharCode(a, s), i = 1) : o = "�";
    } else
      o = String.fromCharCode(a);
    o && (t.push(e.slice(r, n), encodeURIComponent(o)), r = n + i + 1, o = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function et(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let a = 0;
  return o;
  function o(c) {
    return qe(c) ? (e.enter(n), s(c)) : t(c);
  }
  function s(c) {
    return qe(c) && a++ < i ? (e.consume(c), s) : (e.exit(n), t(c));
  }
}
const XI = {
  tokenize: QI
};
function QI(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), et(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), a(s);
  }
  function a(s) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return $e(s) ? (e.consume(s), e.exit("chunkText"), a) : (e.consume(s), o);
  }
}
const eA = {
  tokenize: tA
}, tg = {
  tokenize: nA
};
function tA(e) {
  const t = this, n = [];
  let r = 0, i, a, o;
  return s;
  function s(b) {
    if (r < n.length) {
      const T = n[r];
      return t.containerState = T[1], e.attempt(
        T[0].continuation,
        c,
        l
      )(b);
    }
    return l(b);
  }
  function c(b) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && g();
      const T = t.events.length;
      let S = T, E;
      for (; S--; )
        if (t.events[S][0] === "exit" && t.events[S][1].type === "chunkFlow") {
          E = t.events[S][1].end;
          break;
        }
      v(r);
      let O = T;
      for (; O < t.events.length; )
        t.events[O][1].end = Object.assign({}, E), O++;
      return Un(
        t.events,
        S + 1,
        0,
        t.events.slice(T)
      ), t.events.length = O, l(b);
    }
    return s(b);
  }
  function l(b) {
    if (r === n.length) {
      if (!i)
        return d(b);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return m(b);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      tg,
      u,
      f
    )(b);
  }
  function u(b) {
    return i && g(), v(r), d(b);
  }
  function f(b) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, m(b);
  }
  function d(b) {
    return t.containerState = {}, e.attempt(
      tg,
      p,
      m
    )(b);
  }
  function p(b) {
    return r++, n.push([t.currentConstruct, t.containerState]), d(b);
  }
  function m(b) {
    if (b === null) {
      i && g(), v(0), e.consume(b);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: a,
      _tokenizer: i
    }), h(b);
  }
  function h(b) {
    if (b === null) {
      y(e.exit("chunkFlow"), !0), v(0), e.consume(b);
      return;
    }
    return $e(b) ? (e.consume(b), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(b), h);
  }
  function y(b, T) {
    const S = t.sliceStream(b);
    if (T && S.push(null), b.previous = a, a && (a.next = b), a = b, i.defineSkip(b.start), i.write(S), t.parser.lazy[b.start.line]) {
      let E = i.events.length;
      for (; E--; )
        if (
          // The token starts before the line ending…
          i.events[E][1].start.offset < o && // …and either is not ended yet…
          (!i.events[E][1].end || // …or ends after it.
          i.events[E][1].end.offset > o)
        )
          return;
      const O = t.events.length;
      let j = O, D, k;
      for (; j--; )
        if (t.events[j][0] === "exit" && t.events[j][1].type === "chunkFlow") {
          if (D) {
            k = t.events[j][1].end;
            break;
          }
          D = !0;
        }
      for (v(r), E = O; E < t.events.length; )
        t.events[E][1].end = Object.assign({}, k), E++;
      Un(
        t.events,
        j + 1,
        0,
        t.events.slice(O)
      ), t.events.length = E;
    }
  }
  function v(b) {
    let T = n.length;
    for (; T-- > b; ) {
      const S = n[T];
      t.containerState = S[1], S[0].exit.call(t, e);
    }
    n.length = b;
  }
  function g() {
    i.write([null]), a = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function nA(e, t, n) {
  return et(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Pc(e) {
  if (e === null || yt(e) || Vi(e))
    return 1;
  if (bu(e))
    return 2;
}
function xu(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const a = e[i].resolveAll;
    a && !r.includes(a) && (t = a(t, n), r.push(a));
  }
  return t;
}
const zp = {
  name: "attention",
  tokenize: iA,
  resolveAll: rA
};
function rA(e, t) {
  let n = -1, r, i, a, o, s, c, l, u;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = Object.assign({}, e[r][1].end), d = Object.assign({}, e[n][1].start);
          ng(f, -c), ng(d, c), o = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: Object.assign({}, e[r][1].end)
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: d
          }, a = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: c > 1 ? "strong" : "emphasis",
            start: Object.assign({}, o.start),
            end: Object.assign({}, s.end)
          }, e[r][1].end = Object.assign({}, o.start), e[n][1].start = Object.assign({}, s.end), l = [], e[r][1].end.offset - e[r][1].start.offset && (l = jn(l, [["enter", e[r][1], t], ["exit", e[r][1], t]])), l = jn(l, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["enter", a, t]]), l = jn(l, xu(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = jn(l, [["exit", a, t], ["enter", s, t], ["exit", s, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (u = 2, l = jn(l, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : u = 0, Un(e, r - 1, n - r + 3, l), n = r + l.length - u - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function iA(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Pc(r);
  let a;
  return o;
  function o(c) {
    return a = c, e.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === a)
      return e.consume(c), s;
    const l = e.exit("attentionSequence"), u = Pc(c), f = !u || u === 2 && i || n.includes(c), d = !i || i === 2 && u || n.includes(r);
    return l._open = !!(a === 42 ? f : f && (i || !d)), l._close = !!(a === 42 ? d : d && (u || !f)), t(c);
  }
}
function ng(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const aA = {
  name: "autolink",
  tokenize: oA
};
function oA(e, t, n) {
  let r = 0;
  return i;
  function i(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), a;
  }
  function a(p) {
    return dn(p) ? (e.consume(p), o) : p === 64 ? n(p) : l(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || an(p) ? (r = 1, s(p)) : l(p);
  }
  function s(p) {
    return p === 58 ? (e.consume(p), r = 0, c) : (p === 43 || p === 45 || p === 46 || an(p)) && r++ < 32 ? (e.consume(p), s) : (r = 0, l(p));
  }
  function c(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || Ac(p) ? n(p) : (e.consume(p), c);
  }
  function l(p) {
    return p === 64 ? (e.consume(p), u) : GI(p) ? (e.consume(p), l) : n(p);
  }
  function u(p) {
    return an(p) ? f(p) : n(p);
  }
  function f(p) {
    return p === 46 ? (e.consume(p), r = 0, u) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : d(p);
  }
  function d(p) {
    if ((p === 45 || an(p)) && r++ < 63) {
      const m = p === 45 ? d : f;
      return e.consume(p), m;
    }
    return n(p);
  }
}
const Ms = {
  tokenize: sA,
  partial: !0
};
function sA(e, t, n) {
  return r;
  function r(a) {
    return qe(a) ? et(e, i, "linePrefix")(a) : i(a);
  }
  function i(a) {
    return a === null || $e(a) ? t(a) : n(a);
  }
}
const hS = {
  name: "blockQuote",
  tokenize: lA,
  continuation: {
    tokenize: cA
  },
  exit: uA
};
function lA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), a;
    }
    return n(o);
  }
  function a(o) {
    return qe(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function cA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return qe(o) ? et(e, a, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : a(o);
  }
  function a(o) {
    return e.attempt(hS, t, n)(o);
  }
}
function uA(e) {
  e.exit("blockQuote");
}
const mS = {
  name: "characterEscape",
  tokenize: fA
};
function fA(e, t, n) {
  return r;
  function r(a) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(a), e.exit("escapeMarker"), i;
  }
  function i(a) {
    return JI(a) ? (e.enter("characterEscapeValue"), e.consume(a), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(a);
  }
}
const vS = {
  name: "characterReference",
  tokenize: dA
};
function dA(e, t, n) {
  const r = this;
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), a = 31, o = an, u(f));
  }
  function l(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), a = 6, o = YI, u) : (e.enter("characterReferenceValue"), a = 7, o = Up, u(f));
  }
  function u(f) {
    if (f === 59 && i) {
      const d = e.exit("characterReferenceValue");
      return o === an && !gm(r.sliceSerialize(d)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(f) && i++ < a ? (e.consume(f), u) : n(f);
  }
}
const rg = {
  tokenize: hA,
  partial: !0
}, ig = {
  name: "codeFenced",
  tokenize: pA,
  concrete: !0
};
function pA(e, t, n) {
  const r = this, i = {
    tokenize: S,
    partial: !0
  };
  let a = 0, o = 0, s;
  return c;
  function c(E) {
    return l(E);
  }
  function l(E) {
    const O = r.events[r.events.length - 1];
    return a = O && O[1].type === "linePrefix" ? O[2].sliceSerialize(O[1], !0).length : 0, s = E, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(E);
  }
  function u(E) {
    return E === s ? (o++, e.consume(E), u) : o < 3 ? n(E) : (e.exit("codeFencedFenceSequence"), qe(E) ? et(e, f, "whitespace")(E) : f(E));
  }
  function f(E) {
    return E === null || $e(E) ? (e.exit("codeFencedFence"), r.interrupt ? t(E) : e.check(rg, h, T)(E)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), d(E));
  }
  function d(E) {
    return E === null || $e(E) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(E)) : qe(E) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), et(e, p, "whitespace")(E)) : E === 96 && E === s ? n(E) : (e.consume(E), d);
  }
  function p(E) {
    return E === null || $e(E) ? f(E) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), m(E));
  }
  function m(E) {
    return E === null || $e(E) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(E)) : E === 96 && E === s ? n(E) : (e.consume(E), m);
  }
  function h(E) {
    return e.attempt(i, T, y)(E);
  }
  function y(E) {
    return e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), v;
  }
  function v(E) {
    return a > 0 && qe(E) ? et(e, g, "linePrefix", a + 1)(E) : g(E);
  }
  function g(E) {
    return E === null || $e(E) ? e.check(rg, h, T)(E) : (e.enter("codeFlowValue"), b(E));
  }
  function b(E) {
    return E === null || $e(E) ? (e.exit("codeFlowValue"), g(E)) : (e.consume(E), b);
  }
  function T(E) {
    return e.exit("codeFenced"), t(E);
  }
  function S(E, O, j) {
    let D = 0;
    return k;
    function k(M) {
      return E.enter("lineEnding"), E.consume(M), E.exit("lineEnding"), A;
    }
    function A(M) {
      return E.enter("codeFencedFence"), qe(M) ? et(E, V, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(M) : V(M);
    }
    function V(M) {
      return M === s ? (E.enter("codeFencedFenceSequence"), $(M)) : j(M);
    }
    function $(M) {
      return M === s ? (D++, E.consume(M), $) : D >= o ? (E.exit("codeFencedFenceSequence"), qe(M) ? et(E, L, "whitespace")(M) : L(M)) : j(M);
    }
    function L(M) {
      return M === null || $e(M) ? (E.exit("codeFencedFence"), O(M)) : j(M);
    }
  }
}
function hA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const Sf = {
  name: "codeIndented",
  tokenize: vA
}, mA = {
  tokenize: yA,
  partial: !0
};
function vA(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return e.enter("codeIndented"), et(e, a, "linePrefix", 5)(l);
  }
  function a(l) {
    const u = r.events[r.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? c(l) : $e(l) ? e.attempt(mA, o, c)(l) : (e.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || $e(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), s);
  }
  function c(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function yA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : $e(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : et(e, a, "linePrefix", 5)(o);
  }
  function a(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : $e(o) ? i(o) : n(o);
  }
}
const gA = {
  name: "codeText",
  tokenize: wA,
  resolve: bA,
  previous: xA
};
function bA(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function xA(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function wA(e, t, n) {
  let r = 0, i, a;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), r++, s) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (a = e.enter("codeTextSequence"), i = 0, u(f)) : $e(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(f));
  }
  function l(f) {
    return f === null || f === 32 || f === 96 || $e(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), l);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), i++, u) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (a.type = "codeTextData", l(f));
  }
}
class SA {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const a = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && bo(this.left, r), a.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), bo(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), bo(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        bo(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        bo(this.left, n.reverse());
      }
  }
}
function bo(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function yS(e) {
  const t = {};
  let n = -1, r, i, a, o, s, c, l;
  const u = new SA(e);
  for (; ++n < u.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = u.get(n), n && r[1].type === "chunkFlow" && u.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, a = 0, a < c.length && c[a][1].type === "lineEndingBlank" && (a += 2), a < c.length && c[a][1].type === "content"))
      for (; ++a < c.length && c[a][1].type !== "content"; )
        c[a][1].type === "chunkText" && (c[a][1]._isInFirstContentOfListItem = !0, a++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, _A(u, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (a = n, i = void 0; a-- && (o = u.get(a), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (i && (u.get(i)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", i = a);
      i && (r[1].end = Object.assign({}, u.get(i)[1].start), s = u.slice(i, n), s.unshift(r), u.splice(i, n - i + 1, s));
    }
  }
  return Un(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !l;
}
function _A(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const a = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, c = [], l = {};
  let u, f, d = -1, p = n, m = 0, h = 0;
  const y = [h];
  for (; p; ) {
    for (; e.get(++i)[1] !== p; )
      ;
    a.push(i), p._tokenizer || (u = r.sliceStream(p), p.next || u.push(null), f && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(u), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = n; ++d < s.length; )
    // Find a void token that includes a break.
    s[d][0] === "exit" && s[d - 1][0] === "enter" && s[d][1].type === s[d - 1][1].type && s[d][1].start.line !== s[d][1].end.line && (h = d + 1, y.push(h), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : y.pop(), d = y.length; d--; ) {
    const v = s.slice(y[d], y[d + 1]), g = a.pop();
    c.push([g, g + v.length - 1]), e.splice(g, 2, v);
  }
  for (c.reverse(), d = -1; ++d < c.length; )
    l[m + c[d][0]] = m + c[d][1], m += c[d][1] - c[d][0] - 1;
  return l;
}
const EA = {
  tokenize: OA,
  resolve: kA
}, TA = {
  tokenize: CA,
  partial: !0
};
function kA(e) {
  return yS(e), e;
}
function OA(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? a(s) : $e(s) ? e.check(TA, o, a)(s) : (e.consume(s), i);
  }
  function a(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function CA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), et(e, a, "linePrefix");
  }
  function a(o) {
    if (o === null || $e(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function gS(e, t, n, r, i, a, o, s, c) {
  const l = c || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(v) {
    return v === 60 ? (e.enter(r), e.enter(i), e.enter(a), e.consume(v), e.exit(a), d) : v === null || v === 32 || v === 41 || Ac(v) ? n(v) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), h(v));
  }
  function d(v) {
    return v === 62 ? (e.enter(a), e.consume(v), e.exit(a), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), p(v));
  }
  function p(v) {
    return v === 62 ? (e.exit("chunkString"), e.exit(s), d(v)) : v === null || v === 60 || $e(v) ? n(v) : (e.consume(v), v === 92 ? m : p);
  }
  function m(v) {
    return v === 60 || v === 62 || v === 92 ? (e.consume(v), p) : p(v);
  }
  function h(v) {
    return !u && (v === null || v === 41 || yt(v)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(v)) : u < l && v === 40 ? (e.consume(v), u++, h) : v === 41 ? (e.consume(v), u--, h) : v === null || v === 32 || v === 40 || Ac(v) ? n(v) : (e.consume(v), v === 92 ? y : h);
  }
  function y(v) {
    return v === 40 || v === 41 || v === 92 ? (e.consume(v), h) : h(v);
  }
}
function bS(e, t, n, r, i, a) {
  const o = this;
  let s = 0, c;
  return l;
  function l(p) {
    return e.enter(r), e.enter(i), e.consume(p), e.exit(i), e.enter(a), u;
  }
  function u(p) {
    return s > 999 || p === null || p === 91 || p === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(p) : p === 93 ? (e.exit(a), e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : $e(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || $e(p) || s++ > 999 ? (e.exit("chunkString"), u(p)) : (e.consume(p), c || (c = !qe(p)), p === 92 ? d : f);
  }
  function d(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), s++, f) : f(p);
  }
}
function xS(e, t, n, r, i, a) {
  let o;
  return s;
  function s(d) {
    return d === 34 || d === 39 || d === 40 ? (e.enter(r), e.enter(i), e.consume(d), e.exit(i), o = d === 40 ? 41 : d, c) : n(d);
  }
  function c(d) {
    return d === o ? (e.enter(i), e.consume(d), e.exit(i), e.exit(r), t) : (e.enter(a), l(d));
  }
  function l(d) {
    return d === o ? (e.exit(a), c(o)) : d === null ? n(d) : $e(d) ? (e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), et(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(d));
  }
  function u(d) {
    return d === o || d === null || $e(d) ? (e.exit("chunkString"), l(d)) : (e.consume(d), d === 92 ? f : u);
  }
  function f(d) {
    return d === o || d === 92 ? (e.consume(d), u) : u(d);
  }
}
function jo(e, t) {
  let n;
  return r;
  function r(i) {
    return $e(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : qe(i) ? et(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const RA = {
  name: "definition",
  tokenize: IA
}, $A = {
  tokenize: AA,
  partial: !0
};
function IA(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(p) {
    return e.enter("definition"), o(p);
  }
  function o(p) {
    return bS.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function s(p) {
    return i = tr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), c) : n(p);
  }
  function c(p) {
    return yt(p) ? jo(e, l)(p) : l(p);
  }
  function l(p) {
    return gS(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function u(p) {
    return e.attempt($A, f, f)(p);
  }
  function f(p) {
    return qe(p) ? et(e, d, "whitespace")(p) : d(p);
  }
  function d(p) {
    return p === null || $e(p) ? (e.exit("definition"), r.parser.defined.push(i), t(p)) : n(p);
  }
}
function AA(e, t, n) {
  return r;
  function r(s) {
    return yt(s) ? jo(e, i)(s) : n(s);
  }
  function i(s) {
    return xS(e, a, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function a(s) {
    return qe(s) ? et(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || $e(s) ? t(s) : n(s);
  }
}
const PA = {
  name: "hardBreakEscape",
  tokenize: NA
};
function NA(e, t, n) {
  return r;
  function r(a) {
    return e.enter("hardBreakEscape"), e.consume(a), i;
  }
  function i(a) {
    return $e(a) ? (e.exit("hardBreakEscape"), t(a)) : n(a);
  }
}
const DA = {
  name: "headingAtx",
  tokenize: jA,
  resolve: MA
};
function MA(e, t) {
  let n = e.length - 2, r = 3, i, a;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, a = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, Un(e, r, n - r + 1, [["enter", i, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]])), e;
}
function jA(e, t, n) {
  let r = 0;
  return i;
  function i(u) {
    return e.enter("atxHeading"), a(u);
  }
  function a(u) {
    return e.enter("atxHeadingSequence"), o(u);
  }
  function o(u) {
    return u === 35 && r++ < 6 ? (e.consume(u), o) : u === null || yt(u) ? (e.exit("atxHeadingSequence"), s(u)) : n(u);
  }
  function s(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), c(u)) : u === null || $e(u) ? (e.exit("atxHeading"), t(u)) : qe(u) ? et(e, s, "whitespace")(u) : (e.enter("atxHeadingText"), l(u));
  }
  function c(u) {
    return u === 35 ? (e.consume(u), c) : (e.exit("atxHeadingSequence"), s(u));
  }
  function l(u) {
    return u === null || u === 35 || yt(u) ? (e.exit("atxHeadingText"), s(u)) : (e.consume(u), l);
  }
}
const LA = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], ag = ["pre", "script", "style", "textarea"], FA = {
  name: "htmlFlow",
  tokenize: VA,
  resolveTo: zA,
  concrete: !0
}, BA = {
  tokenize: qA,
  partial: !0
}, UA = {
  tokenize: HA,
  partial: !0
};
function zA(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function VA(e, t, n) {
  const r = this;
  let i, a, o, s, c;
  return l;
  function l(_) {
    return u(_);
  }
  function u(_) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(_), f;
  }
  function f(_) {
    return _ === 33 ? (e.consume(_), d) : _ === 47 ? (e.consume(_), a = !0, h) : _ === 63 ? (e.consume(_), i = 3, r.interrupt ? t : x) : dn(_) ? (e.consume(_), o = String.fromCharCode(_), y) : n(_);
  }
  function d(_) {
    return _ === 45 ? (e.consume(_), i = 2, p) : _ === 91 ? (e.consume(_), i = 5, s = 0, m) : dn(_) ? (e.consume(_), i = 4, r.interrupt ? t : x) : n(_);
  }
  function p(_) {
    return _ === 45 ? (e.consume(_), r.interrupt ? t : x) : n(_);
  }
  function m(_) {
    const G = "CDATA[";
    return _ === G.charCodeAt(s++) ? (e.consume(_), s === G.length ? r.interrupt ? t : V : m) : n(_);
  }
  function h(_) {
    return dn(_) ? (e.consume(_), o = String.fromCharCode(_), y) : n(_);
  }
  function y(_) {
    if (_ === null || _ === 47 || _ === 62 || yt(_)) {
      const G = _ === 47, ae = o.toLowerCase();
      return !G && !a && ag.includes(ae) ? (i = 1, r.interrupt ? t(_) : V(_)) : LA.includes(o.toLowerCase()) ? (i = 6, G ? (e.consume(_), v) : r.interrupt ? t(_) : V(_)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(_) : a ? g(_) : b(_));
    }
    return _ === 45 || an(_) ? (e.consume(_), o += String.fromCharCode(_), y) : n(_);
  }
  function v(_) {
    return _ === 62 ? (e.consume(_), r.interrupt ? t : V) : n(_);
  }
  function g(_) {
    return qe(_) ? (e.consume(_), g) : k(_);
  }
  function b(_) {
    return _ === 47 ? (e.consume(_), k) : _ === 58 || _ === 95 || dn(_) ? (e.consume(_), T) : qe(_) ? (e.consume(_), b) : k(_);
  }
  function T(_) {
    return _ === 45 || _ === 46 || _ === 58 || _ === 95 || an(_) ? (e.consume(_), T) : S(_);
  }
  function S(_) {
    return _ === 61 ? (e.consume(_), E) : qe(_) ? (e.consume(_), S) : b(_);
  }
  function E(_) {
    return _ === null || _ === 60 || _ === 61 || _ === 62 || _ === 96 ? n(_) : _ === 34 || _ === 39 ? (e.consume(_), c = _, O) : qe(_) ? (e.consume(_), E) : j(_);
  }
  function O(_) {
    return _ === c ? (e.consume(_), c = null, D) : _ === null || $e(_) ? n(_) : (e.consume(_), O);
  }
  function j(_) {
    return _ === null || _ === 34 || _ === 39 || _ === 47 || _ === 60 || _ === 61 || _ === 62 || _ === 96 || yt(_) ? S(_) : (e.consume(_), j);
  }
  function D(_) {
    return _ === 47 || _ === 62 || qe(_) ? b(_) : n(_);
  }
  function k(_) {
    return _ === 62 ? (e.consume(_), A) : n(_);
  }
  function A(_) {
    return _ === null || $e(_) ? V(_) : qe(_) ? (e.consume(_), A) : n(_);
  }
  function V(_) {
    return _ === 45 && i === 2 ? (e.consume(_), F) : _ === 60 && i === 1 ? (e.consume(_), q) : _ === 62 && i === 4 ? (e.consume(_), z) : _ === 63 && i === 3 ? (e.consume(_), x) : _ === 93 && i === 5 ? (e.consume(_), N) : $e(_) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(BA, Z, $)(_)) : _ === null || $e(_) ? (e.exit("htmlFlowData"), $(_)) : (e.consume(_), V);
  }
  function $(_) {
    return e.check(UA, L, Z)(_);
  }
  function L(_) {
    return e.enter("lineEnding"), e.consume(_), e.exit("lineEnding"), M;
  }
  function M(_) {
    return _ === null || $e(_) ? $(_) : (e.enter("htmlFlowData"), V(_));
  }
  function F(_) {
    return _ === 45 ? (e.consume(_), x) : V(_);
  }
  function q(_) {
    return _ === 47 ? (e.consume(_), o = "", B) : V(_);
  }
  function B(_) {
    if (_ === 62) {
      const G = o.toLowerCase();
      return ag.includes(G) ? (e.consume(_), z) : V(_);
    }
    return dn(_) && o.length < 8 ? (e.consume(_), o += String.fromCharCode(_), B) : V(_);
  }
  function N(_) {
    return _ === 93 ? (e.consume(_), x) : V(_);
  }
  function x(_) {
    return _ === 62 ? (e.consume(_), z) : _ === 45 && i === 2 ? (e.consume(_), x) : V(_);
  }
  function z(_) {
    return _ === null || $e(_) ? (e.exit("htmlFlowData"), Z(_)) : (e.consume(_), z);
  }
  function Z(_) {
    return e.exit("htmlFlow"), t(_);
  }
}
function HA(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return $e(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : n(o);
  }
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function qA(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Ms, t, n);
  }
}
const WA = {
  name: "htmlText",
  tokenize: ZA
};
function ZA(e, t, n) {
  const r = this;
  let i, a, o;
  return s;
  function s(x) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(x), c;
  }
  function c(x) {
    return x === 33 ? (e.consume(x), l) : x === 47 ? (e.consume(x), S) : x === 63 ? (e.consume(x), b) : dn(x) ? (e.consume(x), j) : n(x);
  }
  function l(x) {
    return x === 45 ? (e.consume(x), u) : x === 91 ? (e.consume(x), a = 0, m) : dn(x) ? (e.consume(x), g) : n(x);
  }
  function u(x) {
    return x === 45 ? (e.consume(x), p) : n(x);
  }
  function f(x) {
    return x === null ? n(x) : x === 45 ? (e.consume(x), d) : $e(x) ? (o = f, q(x)) : (e.consume(x), f);
  }
  function d(x) {
    return x === 45 ? (e.consume(x), p) : f(x);
  }
  function p(x) {
    return x === 62 ? F(x) : x === 45 ? d(x) : f(x);
  }
  function m(x) {
    const z = "CDATA[";
    return x === z.charCodeAt(a++) ? (e.consume(x), a === z.length ? h : m) : n(x);
  }
  function h(x) {
    return x === null ? n(x) : x === 93 ? (e.consume(x), y) : $e(x) ? (o = h, q(x)) : (e.consume(x), h);
  }
  function y(x) {
    return x === 93 ? (e.consume(x), v) : h(x);
  }
  function v(x) {
    return x === 62 ? F(x) : x === 93 ? (e.consume(x), v) : h(x);
  }
  function g(x) {
    return x === null || x === 62 ? F(x) : $e(x) ? (o = g, q(x)) : (e.consume(x), g);
  }
  function b(x) {
    return x === null ? n(x) : x === 63 ? (e.consume(x), T) : $e(x) ? (o = b, q(x)) : (e.consume(x), b);
  }
  function T(x) {
    return x === 62 ? F(x) : b(x);
  }
  function S(x) {
    return dn(x) ? (e.consume(x), E) : n(x);
  }
  function E(x) {
    return x === 45 || an(x) ? (e.consume(x), E) : O(x);
  }
  function O(x) {
    return $e(x) ? (o = O, q(x)) : qe(x) ? (e.consume(x), O) : F(x);
  }
  function j(x) {
    return x === 45 || an(x) ? (e.consume(x), j) : x === 47 || x === 62 || yt(x) ? D(x) : n(x);
  }
  function D(x) {
    return x === 47 ? (e.consume(x), F) : x === 58 || x === 95 || dn(x) ? (e.consume(x), k) : $e(x) ? (o = D, q(x)) : qe(x) ? (e.consume(x), D) : F(x);
  }
  function k(x) {
    return x === 45 || x === 46 || x === 58 || x === 95 || an(x) ? (e.consume(x), k) : A(x);
  }
  function A(x) {
    return x === 61 ? (e.consume(x), V) : $e(x) ? (o = A, q(x)) : qe(x) ? (e.consume(x), A) : D(x);
  }
  function V(x) {
    return x === null || x === 60 || x === 61 || x === 62 || x === 96 ? n(x) : x === 34 || x === 39 ? (e.consume(x), i = x, $) : $e(x) ? (o = V, q(x)) : qe(x) ? (e.consume(x), V) : (e.consume(x), L);
  }
  function $(x) {
    return x === i ? (e.consume(x), i = void 0, M) : x === null ? n(x) : $e(x) ? (o = $, q(x)) : (e.consume(x), $);
  }
  function L(x) {
    return x === null || x === 34 || x === 39 || x === 60 || x === 61 || x === 96 ? n(x) : x === 47 || x === 62 || yt(x) ? D(x) : (e.consume(x), L);
  }
  function M(x) {
    return x === 47 || x === 62 || yt(x) ? D(x) : n(x);
  }
  function F(x) {
    return x === 62 ? (e.consume(x), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(x);
  }
  function q(x) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(x), e.exit("lineEnding"), B;
  }
  function B(x) {
    return qe(x) ? et(e, N, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(x) : N(x);
  }
  function N(x) {
    return e.enter("htmlTextData"), o(x);
  }
}
const bm = {
  name: "labelEnd",
  tokenize: QA,
  resolveTo: XA,
  resolveAll: JA
}, KA = {
  tokenize: eP
}, GA = {
  tokenize: tP
}, YA = {
  tokenize: nP
};
function JA(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function XA(e, t) {
  let n = e.length, r = 0, i, a, o, s;
  for (; n--; )
    if (i = e[n][1], a) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (a = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (o = n);
  const c = {
    type: e[a][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, l = {
    type: "label",
    start: Object.assign({}, e[a][1].start),
    end: Object.assign({}, e[o][1].end)
  }, u = {
    type: "labelText",
    start: Object.assign({}, e[a + r + 2][1].end),
    end: Object.assign({}, e[o - 2][1].start)
  };
  return s = [["enter", c, t], ["enter", l, t]], s = jn(s, e.slice(a + 1, a + r + 3)), s = jn(s, [["enter", u, t]]), s = jn(s, xu(t.parser.constructs.insideSpan.null, e.slice(a + r + 4, o - 3), t)), s = jn(s, [["exit", u, t], e[o - 2], e[o - 1], ["exit", l, t]]), s = jn(s, e.slice(o + 1)), s = jn(s, [["exit", c, t]]), Un(e, a, e.length, s), e;
}
function QA(e, t, n) {
  const r = this;
  let i = r.events.length, a, o;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      a = r.events[i][1];
      break;
    }
  return s;
  function s(d) {
    return a ? a._inactive ? f(d) : (o = r.parser.defined.includes(tr(r.sliceSerialize({
      start: a.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(d), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(d);
  }
  function c(d) {
    return d === 40 ? e.attempt(KA, u, o ? u : f)(d) : d === 91 ? e.attempt(GA, u, o ? l : f)(d) : o ? u(d) : f(d);
  }
  function l(d) {
    return e.attempt(YA, u, f)(d);
  }
  function u(d) {
    return t(d);
  }
  function f(d) {
    return a._balanced = !0, n(d);
  }
}
function eP(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return yt(f) ? jo(e, a)(f) : a(f);
  }
  function a(f) {
    return f === 41 ? u(f) : gS(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return yt(f) ? jo(e, c)(f) : u(f);
  }
  function s(f) {
    return n(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? xS(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function l(f) {
    return yt(f) ? jo(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function tP(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return bS.call(r, e, a, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function a(s) {
    return r.parser.defined.includes(tr(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function nP(e, t, n) {
  return r;
  function r(a) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), i;
  }
  function i(a) {
    return a === 93 ? (e.enter("referenceMarker"), e.consume(a), e.exit("referenceMarker"), e.exit("reference"), t) : n(a);
  }
}
const rP = {
  name: "labelStartImage",
  tokenize: iP,
  resolveAll: bm.resolveAll
};
function iP(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), a;
  }
  function a(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const aP = {
  name: "labelStartLink",
  tokenize: oP,
  resolveAll: bm.resolveAll
};
function oP(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), a;
  }
  function a(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const _f = {
  name: "lineEnding",
  tokenize: sP
};
function sP(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), et(e, t, "linePrefix");
  }
}
const Jl = {
  name: "thematicBreak",
  tokenize: lP
};
function lP(e, t, n) {
  let r = 0, i;
  return a;
  function a(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return i = l, s(l);
  }
  function s(l) {
    return l === i ? (e.enter("thematicBreakSequence"), c(l)) : r >= 3 && (l === null || $e(l)) ? (e.exit("thematicBreak"), t(l)) : n(l);
  }
  function c(l) {
    return l === i ? (e.consume(l), r++, c) : (e.exit("thematicBreakSequence"), qe(l) ? et(e, s, "whitespace")(l) : s(l));
  }
}
const gn = {
  name: "list",
  tokenize: fP,
  continuation: {
    tokenize: dP
  },
  exit: hP
}, cP = {
  tokenize: mP,
  partial: !0
}, uP = {
  tokenize: pP,
  partial: !0
};
function fP(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let a = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, o = 0;
  return s;
  function s(p) {
    const m = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (m === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : Up(p)) {
      if (r.containerState.type || (r.containerState.type = m, e.enter(m, {
        _container: !0
      })), m === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(Jl, n, l)(p) : l(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(p);
    }
    return n(p);
  }
  function c(p) {
    return Up(p) && ++o < 10 ? (e.consume(p), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), l(p)) : n(p);
  }
  function l(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      Ms,
      // Can’t be empty when interrupting.
      r.interrupt ? n : u,
      e.attempt(cP, d, f)
    );
  }
  function u(p) {
    return r.containerState.initialBlankLine = !0, a++, d(p);
  }
  function f(p) {
    return qe(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), d) : n(p);
  }
  function d(p) {
    return r.containerState.size = a + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function dP(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Ms, i, a);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, et(e, t, "listItemIndent", r.containerState.size + 1)(s);
  }
  function a(s) {
    return r.containerState.furtherBlankLines || !qe(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(uP, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, et(e, e.attempt(gn, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function pP(e, t, n) {
  const r = this;
  return et(e, i, "listItemIndent", r.containerState.size + 1);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(a) : n(a);
  }
}
function hP(e) {
  e.exit(this.containerState.type);
}
function mP(e, t, n) {
  const r = this;
  return et(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return !qe(a) && o && o[1].type === "listItemPrefixWhitespace" ? t(a) : n(a);
  }
}
const og = {
  name: "setextUnderline",
  tokenize: yP,
  resolveTo: vP
};
function vP(e, t) {
  let n = e.length, r, i, a;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !a && e[n][1].type === "definition" && (a = n);
  const o = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", a ? (e.splice(i, 0, ["enter", o, t]), e.splice(a + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[a][1].end)) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function yP(e, t, n) {
  const r = this;
  let i;
  return a;
  function a(l) {
    let u = r.events.length, f;
    for (; u--; )
      if (r.events[u][1].type !== "lineEnding" && r.events[u][1].type !== "linePrefix" && r.events[u][1].type !== "content") {
        f = r.events[u][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = l, o(l)) : n(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === i ? (e.consume(l), s) : (e.exit("setextHeadingLineSequence"), qe(l) ? et(e, c, "lineSuffix")(l) : c(l));
  }
  function c(l) {
    return l === null || $e(l) ? (e.exit("setextHeadingLine"), t(l)) : n(l);
  }
}
const gP = {
  tokenize: bP
};
function bP(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Ms,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      et(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(EA, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(a), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const xP = {
  resolveAll: SS()
}, wP = wS("string"), SP = wS("text");
function wS(e) {
  return {
    tokenize: t,
    resolveAll: SS(
      e === "text" ? _P : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], a = n.attempt(i, o, s);
    return o;
    function o(u) {
      return l(u) ? a(u) : s(u);
    }
    function s(u) {
      if (u === null) {
        n.consume(u);
        return;
      }
      return n.enter("data"), n.consume(u), c;
    }
    function c(u) {
      return l(u) ? (n.exit("data"), a(u)) : (n.consume(u), c);
    }
    function l(u) {
      if (u === null)
        return !0;
      const f = i[u];
      let d = -1;
      if (f)
        for (; ++d < f.length; ) {
          const p = f[d];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function SS(e) {
  return t;
  function t(n, r) {
    let i = -1, a;
    for (; ++i <= n.length; )
      a === void 0 ? n[i] && n[i][1].type === "data" && (a = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== a + 2 && (n[a][1].end = n[i - 1][1].end, n.splice(a + 2, i - a - 2), i = a + 2), a = void 0);
    return e ? e(n, r) : n;
  }
}
function _P(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let a = i.length, o = -1, s = 0, c;
      for (; a--; ) {
        const l = i[a];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          c = !0, s++;
        else if (l !== -1) {
          a++;
          break;
        }
      }
      if (s) {
        const l = {
          type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + a,
            _bufferIndex: a ? o : r.start._bufferIndex + o
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, l.start), r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(
          n,
          0,
          ["enter", l, t],
          ["exit", l, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function EP(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, a = [];
  let o = [], s = [];
  const c = {
    consume: g,
    enter: b,
    exit: T,
    attempt: O(S),
    check: O(E),
    interrupt: O(E, {
      interrupt: !0
    })
  }, l = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: p,
    sliceSerialize: d,
    now: m,
    defineSkip: h,
    write: f
  };
  let u = t.tokenize.call(l, c);
  return t.resolveAll && a.push(t), l;
  function f(A) {
    return o = jn(o, A), y(), o[o.length - 1] !== null ? [] : (j(t, 0), l.events = xu(a, l.events, l), l.events);
  }
  function d(A, V) {
    return kP(p(A), V);
  }
  function p(A) {
    return TP(o, A);
  }
  function m() {
    const { line: A, column: V, offset: $, _index: L, _bufferIndex: M } = r;
    return {
      line: A,
      column: V,
      offset: $,
      _index: L,
      _bufferIndex: M
    };
  }
  function h(A) {
    i[A.line] = A.column, k();
  }
  function y() {
    let A;
    for (; r._index < o.length; ) {
      const V = o[r._index];
      if (typeof V == "string")
        for (A = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === A && r._bufferIndex < V.length; )
          v(V.charCodeAt(r._bufferIndex));
      else
        v(V);
    }
  }
  function v(A) {
    u = u(A);
  }
  function g(A) {
    $e(A) ? (r.line++, r.column = 1, r.offset += A === -3 ? 2 : 1, k()) : A !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = A;
  }
  function b(A, V) {
    const $ = V || {};
    return $.type = A, $.start = m(), l.events.push(["enter", $, l]), s.push($), $;
  }
  function T(A) {
    const V = s.pop();
    return V.end = m(), l.events.push(["exit", V, l]), V;
  }
  function S(A, V) {
    j(A, V.from);
  }
  function E(A, V) {
    V.restore();
  }
  function O(A, V) {
    return $;
    function $(L, M, F) {
      let q, B, N, x;
      return Array.isArray(L) ? Z(L) : "tokenize" in L ? (
        // @ts-expect-error Looks like a construct.
        Z([L])
      ) : z(L);
      function z(te) {
        return se;
        function se(de) {
          const pe = de !== null && te[de], le = de !== null && te.null, X = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(pe) ? pe : pe ? [pe] : [],
            ...Array.isArray(le) ? le : le ? [le] : []
          ];
          return Z(X)(de);
        }
      }
      function Z(te) {
        return q = te, B = 0, te.length === 0 ? F : _(te[B]);
      }
      function _(te) {
        return se;
        function se(de) {
          return x = D(), N = te, te.partial || (l.currentConstruct = te), te.name && l.parser.constructs.disable.null.includes(te.name) ? ae() : te.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            V ? Object.assign(Object.create(l), V) : l,
            c,
            G,
            ae
          )(de);
        }
      }
      function G(te) {
        return A(N, x), M;
      }
      function ae(te) {
        return x.restore(), ++B < q.length ? _(q[B]) : F;
      }
    }
  }
  function j(A, V) {
    A.resolveAll && !a.includes(A) && a.push(A), A.resolve && Un(
      l.events,
      V,
      l.events.length - V,
      A.resolve(l.events.slice(V), l)
    ), A.resolveTo && (l.events = A.resolveTo(l.events, l));
  }
  function D() {
    const A = m(), V = l.previous, $ = l.currentConstruct, L = l.events.length, M = Array.from(s);
    return {
      restore: F,
      from: L
    };
    function F() {
      r = A, l.previous = V, l.currentConstruct = $, l.events.length = L, s = M, k();
    }
  }
  function k() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function TP(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, a = t.end._bufferIndex;
  let o;
  if (n === i)
    o = [e[n].slice(r, a)];
  else {
    if (o = e.slice(n, i), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    a > 0 && o.push(e[i].slice(0, a));
  }
  return o;
}
function kP(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const a = e[n];
    let o;
    if (typeof a == "string")
      o = a;
    else
      switch (a) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i) continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(a);
      }
    i = a === -2, r.push(o);
  }
  return r.join("");
}
const OP = {
  42: gn,
  43: gn,
  45: gn,
  48: gn,
  49: gn,
  50: gn,
  51: gn,
  52: gn,
  53: gn,
  54: gn,
  55: gn,
  56: gn,
  57: gn,
  62: hS
}, CP = {
  91: RA
}, RP = {
  [-2]: Sf,
  [-1]: Sf,
  32: Sf
}, $P = {
  35: DA,
  42: Jl,
  45: [og, Jl],
  60: FA,
  61: og,
  95: Jl,
  96: ig,
  126: ig
}, IP = {
  38: vS,
  92: mS
}, AP = {
  [-5]: _f,
  [-4]: _f,
  [-3]: _f,
  33: rP,
  38: vS,
  42: zp,
  60: [aA, WA],
  91: aP,
  92: [PA, mS],
  93: bm,
  95: zp,
  96: gA
}, PP = {
  null: [zp, xP]
}, NP = {
  null: [42, 95]
}, DP = {
  null: []
}, MP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: NP,
  contentInitial: CP,
  disable: DP,
  document: OP,
  flow: $P,
  flowInitial: RP,
  insideSpan: PP,
  string: IP,
  text: AP
}, Symbol.toStringTag, { value: "Module" }));
function jP(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    dS([MP, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(XI),
    document: i(eA),
    flow: i(gP),
    string: i(wP),
    text: i(SP)
  };
  return r;
  function i(a) {
    return o;
    function o(s) {
      return EP(r, a, s);
    }
  }
}
function LP(e) {
  for (; !yS(e); )
    ;
  return e;
}
const sg = /[\0\t\n\r]/g;
function FP() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(a, o, s) {
    const c = [];
    let l, u, f, d, p;
    for (a = t + (typeof a == "string" ? a.toString() : new TextDecoder(o || void 0).decode(a)), f = 0, t = "", n && (a.charCodeAt(0) === 65279 && f++, n = void 0); f < a.length; ) {
      if (sg.lastIndex = f, l = sg.exec(a), d = l && l.index !== void 0 ? l.index : a.length, p = a.charCodeAt(d), !l) {
        t = a.slice(f);
        break;
      }
      if (p === 10 && f === d && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), f < d && (c.push(a.slice(f, d)), e += d - f), p) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, c.push(-2); e++ < u; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = d + 1;
    }
    return s && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const BP = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function UP(e) {
  return e.replace(BP, zP);
}
function zP(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), a = i === 120 || i === 88;
    return pS(n.slice(a ? 2 : 1), a ? 16 : 10);
  }
  return gm(n) || e;
}
const _S = {}.hasOwnProperty;
function VP(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), HP(n)(LP(jP(n).document().write(FP()(e, t, !0))));
}
function HP(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: a(Q),
      autolinkProtocol: D,
      autolinkEmail: D,
      atxHeading: a(Oe),
      blockQuote: a(le),
      characterEscape: D,
      characterReference: D,
      codeFenced: a(X),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: a(X, o),
      codeText: a(W, o),
      codeTextData: D,
      data: D,
      codeFlowValue: D,
      definition: a(fe),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: a(me),
      hardBreakEscape: a(I),
      hardBreakTrailing: a(I),
      htmlFlow: a(Y, o),
      htmlFlowData: D,
      htmlText: a(Y, o),
      htmlTextData: D,
      image: a(re),
      label: o,
      link: a(Q),
      listItem: a(xe),
      listItemValue: d,
      listOrdered: a(Ee, f),
      listUnordered: a(Ee),
      paragraph: a(Re),
      reference: _,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: a(Oe),
      strong: a(Ve),
      thematicBreak: a(Me)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: S,
      autolink: c(),
      autolinkEmail: pe,
      autolinkProtocol: de,
      blockQuote: c(),
      characterEscapeValue: k,
      characterReferenceMarkerHexadecimal: ae,
      characterReferenceMarkerNumeric: ae,
      characterReferenceValue: te,
      characterReference: se,
      codeFenced: c(y),
      codeFencedFence: h,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: m,
      codeFlowValue: k,
      codeIndented: c(v),
      codeText: c(M),
      codeTextData: k,
      data: k,
      definition: c(),
      definitionDestinationString: T,
      definitionLabelString: g,
      definitionTitleString: b,
      emphasis: c(),
      hardBreakEscape: c(V),
      hardBreakTrailing: c(V),
      htmlFlow: c($),
      htmlFlowData: k,
      htmlText: c(L),
      htmlTextData: k,
      image: c(q),
      label: N,
      labelText: B,
      lineEnding: A,
      link: c(F),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: G,
      resourceDestinationString: x,
      resourceTitleString: z,
      resource: Z,
      setextHeading: c(j),
      setextHeadingLineSequence: O,
      setextHeadingText: E,
      strong: c(),
      thematicBreak: c()
    }
  };
  ES(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(U) {
    let P = {
      type: "root",
      children: []
    };
    const J = {
      stack: [P],
      tokenStack: [],
      config: t,
      enter: s,
      exit: l,
      buffer: o,
      resume: u,
      data: n
    }, ce = [];
    let _e = -1;
    for (; ++_e < U.length; )
      if (U[_e][1].type === "listOrdered" || U[_e][1].type === "listUnordered")
        if (U[_e][0] === "enter")
          ce.push(_e);
        else {
          const ke = ce.pop();
          _e = i(U, ke, _e);
        }
    for (_e = -1; ++_e < U.length; ) {
      const ke = t[U[_e][0]];
      _S.call(ke, U[_e][1].type) && ke[U[_e][1].type].call(Object.assign({
        sliceSerialize: U[_e][2].sliceSerialize
      }, J), U[_e][1]);
    }
    if (J.tokenStack.length > 0) {
      const ke = J.tokenStack[J.tokenStack.length - 1];
      (ke[1] || lg).call(J, void 0, ke[0]);
    }
    for (P.position = {
      start: Qr(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Qr(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < t.transforms.length; )
      P = t.transforms[_e](P) || P;
    return P;
  }
  function i(U, P, J) {
    let ce = P - 1, _e = -1, ke = !1, Ge, at, Lt, Ct;
    for (; ++ce <= J; ) {
      const He = U[ce];
      switch (He[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          He[0] === "enter" ? _e++ : _e--, Ct = void 0;
          break;
        }
        case "lineEndingBlank": {
          He[0] === "enter" && (Ge && !Ct && !_e && !Lt && (Lt = ce), Ct = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          Ct = void 0;
      }
      if (!_e && He[0] === "enter" && He[1].type === "listItemPrefix" || _e === -1 && He[0] === "exit" && (He[1].type === "listUnordered" || He[1].type === "listOrdered")) {
        if (Ge) {
          let Rt = ce;
          for (at = void 0; Rt--; ) {
            const Ye = U[Rt];
            if (Ye[1].type === "lineEnding" || Ye[1].type === "lineEndingBlank") {
              if (Ye[0] === "exit") continue;
              at && (U[at][1].type = "lineEndingBlank", ke = !0), Ye[1].type = "lineEnding", at = Rt;
            } else if (!(Ye[1].type === "linePrefix" || Ye[1].type === "blockQuotePrefix" || Ye[1].type === "blockQuotePrefixWhitespace" || Ye[1].type === "blockQuoteMarker" || Ye[1].type === "listItemIndent")) break;
          }
          Lt && (!at || Lt < at) && (Ge._spread = !0), Ge.end = Object.assign({}, at ? U[at][1].start : He[1].end), U.splice(at || ce, 0, ["exit", Ge, He[2]]), ce++, J++;
        }
        if (He[1].type === "listItemPrefix") {
          const Rt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, He[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ge = Rt, U.splice(ce, 0, ["enter", Rt, He[2]]), ce++, J++, Lt = void 0, Ct = !0;
        }
      }
    }
    return U[P][1]._spread = ke, J;
  }
  function a(U, P) {
    return J;
    function J(ce) {
      s.call(this, U(ce), ce), P && P.call(this, ce);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(U, P, J) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([P, J]), U.position = {
      start: Qr(P.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(U) {
    return P;
    function P(J) {
      U && U.call(this, J), l.call(this, J);
    }
  }
  function l(U, P) {
    const J = this.stack.pop(), ce = this.tokenStack.pop();
    if (ce)
      ce[0].type !== U.type && (P ? P.call(this, U, ce[0]) : (ce[1] || lg).call(this, U, ce[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + Mo({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    J.position.end = Qr(U.end);
  }
  function u() {
    return ym(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function d(U) {
    if (this.data.expectingFirstListItemValue) {
      const P = this.stack[this.stack.length - 2];
      P.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.lang = U;
  }
  function m() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.meta = U;
  }
  function h() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function y() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function v() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function g(U) {
    const P = this.resume(), J = this.stack[this.stack.length - 1];
    J.label = P, J.identifier = tr(this.sliceSerialize(U)).toLowerCase();
  }
  function b() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.title = U;
  }
  function T() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.url = U;
  }
  function S(U) {
    const P = this.stack[this.stack.length - 1];
    if (!P.depth) {
      const J = this.sliceSerialize(U).length;
      P.depth = J;
    }
  }
  function E() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function O(U) {
    const P = this.stack[this.stack.length - 1];
    P.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function j() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function D(U) {
    const J = this.stack[this.stack.length - 1].children;
    let ce = J[J.length - 1];
    (!ce || ce.type !== "text") && (ce = Ie(), ce.position = {
      start: Qr(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, J.push(ce)), this.stack.push(ce);
  }
  function k(U) {
    const P = this.stack.pop();
    P.value += this.sliceSerialize(U), P.position.end = Qr(U.end);
  }
  function A(U) {
    const P = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const J = P.children[P.children.length - 1];
      J.position.end = Qr(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(P.type) && (D.call(this, U), k.call(this, U));
  }
  function V() {
    this.data.atHardBreak = !0;
  }
  function $() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = U;
  }
  function L() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = U;
  }
  function M() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.value = U;
  }
  function F() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const P = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = P, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function q() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const P = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = P, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function B(U) {
    const P = this.sliceSerialize(U), J = this.stack[this.stack.length - 2];
    J.label = UP(P), J.identifier = tr(P).toLowerCase();
  }
  function N() {
    const U = this.stack[this.stack.length - 1], P = this.resume(), J = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, J.type === "link") {
      const ce = U.children;
      J.children = ce;
    } else
      J.alt = P;
  }
  function x() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.url = U;
  }
  function z() {
    const U = this.resume(), P = this.stack[this.stack.length - 1];
    P.title = U;
  }
  function Z() {
    this.data.inReference = void 0;
  }
  function _() {
    this.data.referenceType = "collapsed";
  }
  function G(U) {
    const P = this.resume(), J = this.stack[this.stack.length - 1];
    J.label = P, J.identifier = tr(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function ae(U) {
    this.data.characterReferenceType = U.type;
  }
  function te(U) {
    const P = this.sliceSerialize(U), J = this.data.characterReferenceType;
    let ce;
    J ? (ce = pS(P, J === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : ce = gm(P);
    const _e = this.stack[this.stack.length - 1];
    _e.value += ce;
  }
  function se(U) {
    const P = this.stack.pop();
    P.position.end = Qr(U.end);
  }
  function de(U) {
    k.call(this, U);
    const P = this.stack[this.stack.length - 1];
    P.url = this.sliceSerialize(U);
  }
  function pe(U) {
    k.call(this, U);
    const P = this.stack[this.stack.length - 1];
    P.url = "mailto:" + this.sliceSerialize(U);
  }
  function le() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function X() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function W() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function fe() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function me() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Oe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function I() {
    return {
      type: "break"
    };
  }
  function Y() {
    return {
      type: "html",
      value: ""
    };
  }
  function re() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Q() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ee(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function xe(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function Re() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Ve() {
    return {
      type: "strong",
      children: []
    };
  }
  function Ie() {
    return {
      type: "text",
      value: ""
    };
  }
  function Me() {
    return {
      type: "thematicBreak"
    };
  }
}
function Qr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function ES(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? ES(e, r) : qP(e, r);
  }
}
function qP(e, t) {
  let n;
  for (n in t)
    if (_S.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function lg(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Mo({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + Mo({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + Mo({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function WP(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return VP(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function ZP(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function KP(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function GP(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function YP(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function JP(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function XP(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = to(r.toLowerCase()), a = e.footnoteOrder.indexOf(r);
  let o, s = e.footnoteCounts.get(r);
  s === void 0 ? (s = 0, e.footnoteOrder.push(r), o = e.footnoteOrder.length) : o = a + 1, s += 1, e.footnoteCounts.set(r, s);
  const c = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (s > 1 ? "-" + s : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, c);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [c]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function QP(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function eN(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function TS(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), a = i[0];
  a && a.type === "text" ? a.value = "[" + a.value : i.unshift({ type: "text", value: "[" });
  const o = i[i.length - 1];
  return o && o.type === "text" ? o.value += r : i.push({ type: "text", value: r }), i;
}
function tN(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return TS(e, t);
  const i = { src: to(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, a), e.applyData(t, a);
}
function nN(e, t) {
  const n = { src: to(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function rN(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function iN(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return TS(e, t);
  const i = { href: to(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const a = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function aN(e, t) {
  const n = { href: to(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function oN(e, t, n) {
  const r = e.all(t), i = n ? sN(n) : kS(t), a = {}, o = [];
  if (typeof t.checked == "boolean") {
    const u = r[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), a.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const u = r[s];
    (i || s !== 0 || u.type !== "element" || u.tagName !== "p") && o.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !i ? o.push(...u.children) : o.push(u);
  }
  const c = r[r.length - 1];
  c && (i || c.type !== "element" || c.tagName !== "p") && o.push({ type: "text", value: `
` });
  const l = { type: "element", tagName: "li", properties: a, children: o };
  return e.patch(t, l), e.applyData(t, l);
}
function sN(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = kS(n[r]);
  }
  return t;
}
function kS(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function lN(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const o = r[i];
    if (o.type === "element" && o.tagName === "li" && o.properties && Array.isArray(o.properties.className) && o.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const a = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function cN(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function uN(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function fN(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function dN(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const o = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], o), i.push(o);
  }
  if (n.length > 0) {
    const o = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = pm(t.children[1]), c = aS(t.children[t.children.length - 1]);
    s && c && (o.position = { start: s, end: c }), i.push(o);
  }
  const a = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, a), e.applyData(t, a);
}
function pN(e, t, n) {
  const r = n ? n.children : void 0, a = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", o = n && n.type === "table" ? n.align : void 0, s = o ? o.length : t.children.length;
  let c = -1;
  const l = [];
  for (; ++c < s; ) {
    const f = t.children[c], d = {}, p = o ? o[c] : void 0;
    p && (d.align = p);
    let m = { type: "element", tagName: a, properties: d, children: [] };
    f && (m.children = e.all(f), e.patch(f, m), m = e.applyData(f, m)), l.push(m);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(l, !0)
  };
  return e.patch(t, u), e.applyData(t, u);
}
function hN(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const cg = 9, ug = 32;
function mN(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const a = [];
  for (; r; )
    a.push(
      fg(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return a.push(fg(t.slice(i), i > 0, !1)), a.join("");
}
function fg(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let a = e.codePointAt(r);
    for (; a === cg || a === ug; )
      r++, a = e.codePointAt(r);
  }
  if (n) {
    let a = e.codePointAt(i - 1);
    for (; a === cg || a === ug; )
      i--, a = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function vN(e, t) {
  const n = { type: "text", value: mN(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function yN(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const gN = {
  blockquote: ZP,
  break: KP,
  code: GP,
  delete: YP,
  emphasis: JP,
  footnoteReference: XP,
  heading: QP,
  html: eN,
  imageReference: tN,
  image: nN,
  inlineCode: rN,
  linkReference: iN,
  link: aN,
  listItem: oN,
  list: lN,
  paragraph: cN,
  // @ts-expect-error: root is different, but hard to type.
  root: uN,
  strong: fN,
  table: dN,
  tableCell: hN,
  tableRow: pN,
  text: vN,
  thematicBreak: yN,
  toml: yl,
  yaml: yl,
  definition: yl,
  footnoteDefinition: yl
};
function yl() {
}
const OS = -1, wu = 0, Nc = 1, Dc = 2, xm = 3, wm = 4, Sm = 5, _m = 6, CS = 7, RS = 8, dg = typeof self == "object" ? self : globalThis, bN = (e, t) => {
  const n = (i, a) => (e.set(a, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [a, o] = t[i];
    switch (a) {
      case wu:
      case OS:
        return n(o, i);
      case Nc: {
        const s = n([], i);
        for (const c of o)
          s.push(r(c));
        return s;
      }
      case Dc: {
        const s = n({}, i);
        for (const [c, l] of o)
          s[r(c)] = r(l);
        return s;
      }
      case xm:
        return n(new Date(o), i);
      case wm: {
        const { source: s, flags: c } = o;
        return n(new RegExp(s, c), i);
      }
      case Sm: {
        const s = n(/* @__PURE__ */ new Map(), i);
        for (const [c, l] of o)
          s.set(r(c), r(l));
        return s;
      }
      case _m: {
        const s = n(/* @__PURE__ */ new Set(), i);
        for (const c of o)
          s.add(r(c));
        return s;
      }
      case CS: {
        const { name: s, message: c } = o;
        return n(new dg[s](c), i);
      }
      case RS:
        return n(BigInt(o), i);
      case "BigInt":
        return n(Object(BigInt(o)), i);
    }
    return n(new dg[a](o), i);
  };
  return r;
}, pg = (e) => bN(/* @__PURE__ */ new Map(), e)(0), ia = "", { toString: xN } = {}, { keys: wN } = Object, xo = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [wu, t];
  const n = xN.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [Nc, ia];
    case "Object":
      return [Dc, ia];
    case "Date":
      return [xm, ia];
    case "RegExp":
      return [wm, ia];
    case "Map":
      return [Sm, ia];
    case "Set":
      return [_m, ia];
  }
  return n.includes("Array") ? [Nc, n] : n.includes("Error") ? [CS, n] : [Dc, n];
}, gl = ([e, t]) => e === wu && (t === "function" || t === "symbol"), SN = (e, t, n, r) => {
  const i = (o, s) => {
    const c = r.push(o) - 1;
    return n.set(s, c), c;
  }, a = (o) => {
    if (n.has(o))
      return n.get(o);
    let [s, c] = xo(o);
    switch (s) {
      case wu: {
        let u = o;
        switch (c) {
          case "bigint":
            s = RS, u = o.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + c);
            u = null;
            break;
          case "undefined":
            return i([OS], o);
        }
        return i([s, u], o);
      }
      case Nc: {
        if (c)
          return i([c, [...o]], o);
        const u = [], f = i([s, u], o);
        for (const d of o)
          u.push(a(d));
        return f;
      }
      case Dc: {
        if (c)
          switch (c) {
            case "BigInt":
              return i([c, o.toString()], o);
            case "Boolean":
            case "Number":
            case "String":
              return i([c, o.valueOf()], o);
          }
        if (t && "toJSON" in o)
          return a(o.toJSON());
        const u = [], f = i([s, u], o);
        for (const d of wN(o))
          (e || !gl(xo(o[d]))) && u.push([a(d), a(o[d])]);
        return f;
      }
      case xm:
        return i([s, o.toISOString()], o);
      case wm: {
        const { source: u, flags: f } = o;
        return i([s, { source: u, flags: f }], o);
      }
      case Sm: {
        const u = [], f = i([s, u], o);
        for (const [d, p] of o)
          (e || !(gl(xo(d)) || gl(xo(p)))) && u.push([a(d), a(p)]);
        return f;
      }
      case _m: {
        const u = [], f = i([s, u], o);
        for (const d of o)
          (e || !gl(xo(d))) && u.push(a(d));
        return f;
      }
    }
    const { message: l } = o;
    return i([s, { name: c, message: l }], o);
  };
  return a;
}, hg = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return SN(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, Mc = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? pg(hg(e, t)) : structuredClone(e)
) : (e, t) => pg(hg(e, t));
function _N(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function EN(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function TN(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || _N, r = e.options.footnoteBackLabel || EN, i = e.options.footnoteLabel || "Footnotes", a = e.options.footnoteLabelTagName || "h2", o = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, s = [];
  let c = -1;
  for (; ++c < e.footnoteOrder.length; ) {
    const l = e.footnoteById.get(
      e.footnoteOrder[c]
    );
    if (!l)
      continue;
    const u = e.all(l), f = String(l.identifier).toUpperCase(), d = to(f.toLowerCase());
    let p = 0;
    const m = [], h = e.footnoteCounts.get(f);
    for (; h !== void 0 && ++p <= h; ) {
      m.length > 0 && m.push({ type: "text", value: " " });
      let g = typeof n == "string" ? n : n(c, p);
      typeof g == "string" && (g = { type: "text", value: g }), m.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + d + (p > 1 ? "-" + p : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(c, p),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const y = u[u.length - 1];
    if (y && y.type === "element" && y.tagName === "p") {
      const g = y.children[y.children.length - 1];
      g && g.type === "text" ? g.value += " " : y.children.push({ type: "text", value: " " }), y.children.push(...m);
    } else
      u.push(...m);
    const v = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + d },
      children: e.wrap(u, !0)
    };
    e.patch(l, v), s.push(v);
  }
  if (s.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: a,
          properties: {
            ...Mc(o),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(s, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const Su = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return RN;
    if (typeof e == "function")
      return _u(e);
    if (typeof e == "object")
      return Array.isArray(e) ? kN(e) : ON(e);
    if (typeof e == "string")
      return CN(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function kN(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Su(e[n]);
  return _u(r);
  function r(...i) {
    let a = -1;
    for (; ++a < t.length; )
      if (t[a].apply(this, i)) return !0;
    return !1;
  }
}
function ON(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return _u(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let a;
    for (a in e)
      if (i[a] !== t[a]) return !1;
    return !0;
  }
}
function CN(e) {
  return _u(t);
  function t(n) {
    return n && n.type === e;
  }
}
function _u(e) {
  return t;
  function t(n, r, i) {
    return !!($N(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function RN() {
  return !0;
}
function $N(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const $S = [], IN = !0, Vp = !1, AN = "skip";
function IS(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const a = Su(i), o = r ? -1 : 1;
  s(e, void 0, [])();
  function s(c, l, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      c && typeof c == "object" ? c : {}
    );
    if (typeof f.type == "string") {
      const p = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(d, "name", {
        value: "node (" + (c.type + (p ? "<" + p + ">" : "")) + ")"
      });
    }
    return d;
    function d() {
      let p = $S, m, h, y;
      if ((!t || a(c, l, u[u.length - 1] || void 0)) && (p = PN(n(c, u)), p[0] === Vp))
        return p;
      if ("children" in c && c.children) {
        const v = (
          /** @type {UnistParent} */
          c
        );
        if (v.children && p[0] !== AN)
          for (h = (r ? v.children.length : -1) + o, y = u.concat(v); h > -1 && h < v.children.length; ) {
            const g = v.children[h];
            if (m = s(g, h, y)(), m[0] === Vp)
              return m;
            h = typeof m[1] == "number" ? m[1] : h + o;
          }
      }
      return p;
    }
  }
}
function PN(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [IN, e] : e == null ? $S : [e];
}
function Em(e, t, n, r) {
  let i, a, o;
  typeof t == "function" && typeof n != "function" ? (a = void 0, o = t, i = n) : (a = t, o = n, i = r), IS(e, a, s, i);
  function s(c, l) {
    const u = l[l.length - 1], f = u ? u.children.indexOf(c) : void 0;
    return o(c, f, u);
  }
}
const Hp = {}.hasOwnProperty, NN = {};
function DN(e, t) {
  const n = t || NN, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = { ...gN, ...n.handlers }, s = {
    all: l,
    applyData: jN,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: a,
    footnoteOrder: [],
    handlers: o,
    one: c,
    options: n,
    patch: MN,
    wrap: FN
  };
  return Em(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? r : i, d = String(u.identifier).toUpperCase();
      f.has(d) || f.set(d, u);
    }
  }), s;
  function c(u, f) {
    const d = u.type, p = s.handlers[d];
    if (Hp.call(s.handlers, d) && p)
      return p(s, u, f);
    if (s.options.passThrough && s.options.passThrough.includes(d)) {
      if ("children" in u) {
        const { children: h, ...y } = u, v = Mc(y);
        return v.children = s.all(u), v;
      }
      return Mc(u);
    }
    return (s.options.unknownHandler || LN)(s, u, f);
  }
  function l(u) {
    const f = [];
    if ("children" in u) {
      const d = u.children;
      let p = -1;
      for (; ++p < d.length; ) {
        const m = s.one(d[p], u);
        if (m) {
          if (p && d[p - 1].type === "break" && (!Array.isArray(m) && m.type === "text" && (m.value = mg(m.value)), !Array.isArray(m) && m.type === "element")) {
            const h = m.children[0];
            h && h.type === "text" && (h.value = mg(h.value));
          }
          Array.isArray(m) ? f.push(...m) : f.push(m);
        }
      }
    }
    return f;
  }
}
function MN(e, t) {
  e.position && (t.position = SI(e));
}
function jN(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, a = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const o = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: o };
      }
    n.type === "element" && a && Object.assign(n.properties, Mc(a)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function LN(e, t) {
  const n = t.data || {}, r = "value" in t && !(Hp.call(n, "hProperties") || Hp.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function FN(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function mg(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function vg(e, t) {
  const n = DN(e, t), r = n.one(e, void 0), i = TN(n), a = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && a.children.push({ type: "text", value: `
` }, i), a;
}
function BN(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      vg(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      vg(n, { file: r, ...e || t })
    );
  };
}
function yg(e) {
  if (e)
    throw e;
}
var Xl = Object.prototype.hasOwnProperty, AS = Object.prototype.toString, gg = Object.defineProperty, bg = Object.getOwnPropertyDescriptor, xg = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : AS.call(t) === "[object Array]";
}, wg = function(t) {
  if (!t || AS.call(t) !== "[object Object]")
    return !1;
  var n = Xl.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Xl.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Xl.call(t, i);
}, Sg = function(t, n) {
  gg && n.name === "__proto__" ? gg(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, _g = function(t, n) {
  if (n === "__proto__")
    if (Xl.call(t, n)) {
      if (bg)
        return bg(t, n).value;
    } else return;
  return t[n];
}, UN = function e() {
  var t, n, r, i, a, o, s = arguments[0], c = 1, l = arguments.length, u = !1;
  for (typeof s == "boolean" && (u = s, s = arguments[1] || {}, c = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); c < l; ++c)
    if (t = arguments[c], t != null)
      for (n in t)
        r = _g(s, n), i = _g(t, n), s !== i && (u && i && (wg(i) || (a = xg(i))) ? (a ? (a = !1, o = r && xg(r) ? r : []) : o = r && wg(r) ? r : {}, Sg(s, { name: n, newValue: e(u, o, i) })) : typeof i < "u" && Sg(s, { name: n, newValue: i }));
  return s;
};
const Ef = /* @__PURE__ */ Ke(UN);
function qp(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function zN() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let a = -1;
    const o = i.pop();
    if (typeof o != "function")
      throw new TypeError("Expected function as last argument, not " + o);
    s(null, ...i);
    function s(c, ...l) {
      const u = e[++a];
      let f = -1;
      if (c) {
        o(c);
        return;
      }
      for (; ++f < i.length; )
        (l[f] === null || l[f] === void 0) && (l[f] = i[f]);
      i = l, u ? VN(u, s)(...l) : o(null, ...l);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function VN(e, t) {
  let n;
  return r;
  function r(...o) {
    const s = e.length > o.length;
    let c;
    s && o.push(i);
    try {
      c = e.apply(this, o);
    } catch (l) {
      const u = (
        /** @type {Error} */
        l
      );
      if (s && n)
        throw u;
      return i(u);
    }
    s || (c && c.then && typeof c.then == "function" ? c.then(a, i) : c instanceof Error ? i(c) : a(c));
  }
  function i(o, ...s) {
    n || (n = !0, t(o, ...s));
  }
  function a(o) {
    i(null, o);
  }
}
const vr = { basename: HN, dirname: qN, extname: WN, join: ZN, sep: "/" };
function HN(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  js(e);
  let n = 0, r = -1, i = e.length, a;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (a) {
          n = i + 1;
          break;
        }
      } else r < 0 && (a = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let o = -1, s = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (a) {
        n = i + 1;
        break;
      }
    } else
      o < 0 && (a = !0, o = i + 1), s > -1 && (e.codePointAt(i) === t.codePointAt(s--) ? s < 0 && (r = i) : (s = -1, r = o));
  return n === r ? r = o : r < 0 && (r = e.length), e.slice(n, r);
}
function qN(e) {
  if (js(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function WN(e) {
  js(e);
  let t = e.length, n = -1, r = 0, i = -1, a = 0, o;
  for (; t--; ) {
    const s = e.codePointAt(t);
    if (s === 47) {
      if (o) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (o = !0, n = t + 1), s === 46 ? i < 0 ? i = t : a !== 1 && (a = 1) : i > -1 && (a = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  a === 0 || // The (right-most) trimmed path component is exactly `..`.
  a === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function ZN(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    js(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : KN(n);
}
function KN(e) {
  js(e);
  const t = e.codePointAt(0) === 47;
  let n = GN(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function GN(e, t) {
  let n = "", r = 0, i = -1, a = 0, o = -1, s, c;
  for (; ++o <= e.length; ) {
    if (o < e.length)
      s = e.codePointAt(o);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === o - 1 || a === 1)) if (i !== o - 1 && a === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (c = n.lastIndexOf("/"), c !== n.length - 1) {
              c < 0 ? (n = "", r = 0) : (n = n.slice(0, c), r = n.length - 1 - n.lastIndexOf("/")), i = o, a = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = o, a = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, o) : n = e.slice(i + 1, o), r = o - i - 1;
      i = o, a = 0;
    } else s === 46 && a > -1 ? a++ : a = -1;
  }
  return n;
}
function js(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const YN = { cwd: JN };
function JN() {
  return "/";
}
function Wp(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function XN(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Wp(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return QN(e);
}
function QN(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Tf = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class PS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? Wp(t) ? n = { path: t } : typeof t == "string" || eD(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : YN.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < Tf.length; ) {
      const a = Tf[r];
      a in n && n[a] !== void 0 && n[a] !== null && (this[a] = a === "history" ? [...n[a]] : n[a]);
    }
    let i;
    for (i in n)
      Tf.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    Of(t, "basename"), kf(t, "basename"), this.path = vr.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    Eg(this.basename, "dirname"), this.path = vr.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (kf(t, "extname"), Eg(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = vr.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    Wp(t) && (t = XN(t)), Of(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    Of(t, "stem"), kf(t, "stem"), this.path = vr.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new ln(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function kf(e, t) {
  if (e && e.includes(vr.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + vr.sep + "`"
    );
}
function Of(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function Eg(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function eD(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const tD = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], a = function() {
      return i.apply(a, arguments);
    };
    return Object.setPrototypeOf(a, r), a;
  }
), nD = {}.hasOwnProperty;
class Tm extends tD {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = zN();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Tm()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(Ef(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? ($f("data", this.frozen), this.namespace[t] = n, this) : nD.call(this.namespace, t) && this.namespace[t] || void 0 : t ? ($f("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = bl(t), r = this.parser || this.Parser;
    return Cf("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), Cf("process", this.parser || this.Parser), Rf("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(a, o) {
      const s = bl(t), c = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(s)
      );
      r.run(c, s, function(u, f, d) {
        if (u || !f || !d)
          return l(u);
        const p = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), m = r.stringify(p, d);
        aD(m) ? d.value = m : d.result = m, l(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          d
        );
      });
      function l(u, f) {
        u || !f ? o(u) : a ? a(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), Cf("processSync", this.parser || this.Parser), Rf("processSync", this.compiler || this.Compiler), this.process(t, i), kg("processSync", "process", n), r;
    function i(a, o) {
      n = !0, yg(a), r = o;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    Tg(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const c = bl(n);
      i.run(t, c, l);
      function l(u, f, d) {
        const p = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        u ? s(u) : o ? o(p) : r(void 0, p, d);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, a), kg("runSync", "run", r), i;
    function a(o, s) {
      yg(o), i = s, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = bl(n), i = this.compiler || this.Compiler;
    return Rf("stringify", i), Tg(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if ($f("use", this.frozen), t != null) if (typeof t == "function")
      c(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? s(t) : o(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function a(l) {
      if (typeof l == "function")
        c(l, []);
      else if (typeof l == "object")
        if (Array.isArray(l)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            l
          );
          c(u, f);
        } else
          o(l);
      else
        throw new TypeError("Expected usable value, not `" + l + "`");
    }
    function o(l) {
      if (!("plugins" in l) && !("settings" in l))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      s(l.plugins), l.settings && (i.settings = Ef(!0, i.settings, l.settings));
    }
    function s(l) {
      let u = -1;
      if (l != null) if (Array.isArray(l))
        for (; ++u < l.length; ) {
          const f = l[u];
          a(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + l + "`");
    }
    function c(l, u) {
      let f = -1, d = -1;
      for (; ++f < r.length; )
        if (r[f][0] === l) {
          d = f;
          break;
        }
      if (d === -1)
        r.push([l, ...u]);
      else if (u.length > 0) {
        let [p, ...m] = u;
        const h = r[d][1];
        qp(h) && qp(p) && (p = Ef(!0, h, p)), r[d] = [l, p, ...m];
      }
    }
  }
}
const rD = new Tm().freeze();
function Cf(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Rf(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function $f(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Tg(e) {
  if (!qp(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function kg(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function bl(e) {
  return iD(e) ? e : new PS(e);
}
function iD(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function aD(e) {
  return typeof e == "string" || oD(e);
}
function oD(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const sD = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Og = [], Cg = { allowDangerousHtml: !0 }, lD = /^(https?|ircs?|mailto|xmpp)$/i, cD = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function uD(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, a = e.components, o = e.disallowedElements, s = e.rehypePlugins || Og, c = e.remarkPlugins || Og, l = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Cg } : Cg, u = e.skipHtml, f = e.unwrapDisallowed, d = e.urlTransform || fD, p = rD().use(WP).use(c).use(BN, l).use(s), m = new PS();
  typeof r == "string" && (m.value = r);
  for (const g of cD)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + sD + g.id, void 0);
  const h = p.parse(m);
  let y = p.runSync(h, m);
  return i && (y = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      y.type === "root" ? y.children : [y]
    )
  }), Em(y, v), CI(y, {
    Fragment: R.Fragment,
    components: a,
    ignoreInvalidStyle: !0,
    jsx: R.jsx,
    jsxs: R.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function v(g, b, T) {
    if (g.type === "raw" && T && typeof b == "number")
      return u ? T.children.splice(b, 1) : T.children[b] = { type: "text", value: g.value }, b;
    if (g.type === "element") {
      let S;
      for (S in wf)
        if (Object.hasOwn(wf, S) && Object.hasOwn(g.properties, S)) {
          const E = g.properties[S], O = wf[S];
          (O === null || O.includes(g.tagName)) && (g.properties[S] = d(String(E || ""), S, g));
        }
    }
    if (g.type === "element") {
      let S = t ? !t.includes(g.tagName) : o ? o.includes(g.tagName) : !1;
      if (!S && n && typeof b == "number" && (S = !n(g, b, T)), S && T && typeof b == "number")
        return f && g.children ? T.children.splice(b, 1, ...g.children) : T.children.splice(b, 1), b;
    }
  }
}
function fD(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    lD.test(e.slice(0, t)) ? e : ""
  );
}
function dD(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function NS(e, t, n) {
  const i = Su((n || {}).ignore || []), a = pD(t);
  let o = -1;
  for (; ++o < a.length; )
    IS(e, "text", s);
  function s(l, u) {
    let f = -1, d;
    for (; ++f < u.length; ) {
      const p = u[f], m = d ? d.children : void 0;
      if (i(
        p,
        m ? m.indexOf(p) : void 0,
        d
      ))
        return;
      d = p;
    }
    if (d)
      return c(l, u);
  }
  function c(l, u) {
    const f = u[u.length - 1], d = a[o][0], p = a[o][1];
    let m = 0;
    const y = f.children.indexOf(l);
    let v = !1, g = [];
    d.lastIndex = 0;
    let b = d.exec(l.value);
    for (; b; ) {
      const T = b.index, S = {
        index: b.index,
        input: b.input,
        stack: [...u, l]
      };
      let E = p(...b, S);
      if (typeof E == "string" && (E = E.length > 0 ? { type: "text", value: E } : void 0), E === !1 ? d.lastIndex = T + 1 : (m !== T && g.push({
        type: "text",
        value: l.value.slice(m, T)
      }), Array.isArray(E) ? g.push(...E) : E && g.push(E), m = T + b[0].length, v = !0), !d.global)
        break;
      b = d.exec(l.value);
    }
    return v ? (m < l.value.length && g.push({ type: "text", value: l.value.slice(m) }), f.children.splice(y, 1, ...g)) : g = [l], y + g.length;
  }
}
function pD(e) {
  const t = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const n = !e[0] || Array.isArray(e[0]) ? e : [e];
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    t.push([hD(i[0]), mD(i[1])]);
  }
  return t;
}
function hD(e) {
  return typeof e == "string" ? new RegExp(dD(e), "g") : e;
}
function mD(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
function vD(e) {
  NS(e, [/\r?\n|\r/g, yD]);
}
function yD() {
  return { type: "break" };
}
function gD() {
  return function(e) {
    vD(e);
  };
}
function Rg(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
const If = "phrasing", Af = ["autolink", "link", "image", "label"];
function bD() {
  return {
    transforms: [kD],
    enter: {
      literalAutolink: wD,
      literalAutolinkEmail: Pf,
      literalAutolinkHttp: Pf,
      literalAutolinkWww: Pf
    },
    exit: {
      literalAutolink: TD,
      literalAutolinkEmail: ED,
      literalAutolinkHttp: SD,
      literalAutolinkWww: _D
    }
  };
}
function xD() {
  return {
    unsafe: [
      {
        character: "@",
        before: "[+\\-.\\w]",
        after: "[\\-.\\w]",
        inConstruct: If,
        notInConstruct: Af
      },
      {
        character: ".",
        before: "[Ww]",
        after: "[\\-.\\w]",
        inConstruct: If,
        notInConstruct: Af
      },
      {
        character: ":",
        before: "[ps]",
        after: "\\/",
        inConstruct: If,
        notInConstruct: Af
      }
    ]
  };
}
function wD(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Pf(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function SD(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function _D(e) {
  this.config.exit.data.call(this, e);
  const t = this.stack[this.stack.length - 1];
  t.type, t.url = "http://" + this.sliceSerialize(e);
}
function ED(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function TD(e) {
  this.exit(e);
}
function kD(e) {
  NS(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, OD],
      [new RegExp("(?<=^|\\s|\\p{P}|\\p{S})([-.\\w+]+)@([-\\w]+(?:\\.[-\\w]+)+)", "gu"), CD]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function OD(e, t, n, r, i) {
  let a = "";
  if (!DS(i) || (/^w/i.test(t) && (n = t + n, t = "", a = "http://"), !RD(n)))
    return !1;
  const o = $D(n + r);
  if (!o[0]) return !1;
  const s = {
    type: "link",
    title: null,
    url: a + t + o[0],
    children: [{ type: "text", value: t + o[0] }]
  };
  return o[1] ? [s, { type: "text", value: o[1] }] : s;
}
function CD(e, t, n, r) {
  return (
    // Not an expected previous character.
    !DS(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function RD(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function $D(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = Rg(e, "(");
  let a = Rg(e, ")");
  for (; r !== -1 && i > a; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), a++;
  return [e, n];
}
function DS(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Vi(n) || bu(n)) && // If it’s an email, the previous character should not be a slash.
  (!t || n !== 47);
}
MS.peek = UD;
function ID() {
  return {
    enter: {
      gfmFootnoteDefinition: PD,
      gfmFootnoteDefinitionLabelString: ND,
      gfmFootnoteCall: jD,
      gfmFootnoteCallString: LD
    },
    exit: {
      gfmFootnoteDefinition: MD,
      gfmFootnoteDefinitionLabelString: DD,
      gfmFootnoteCall: BD,
      gfmFootnoteCallString: FD
    }
  };
}
function AD() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: zD, footnoteReference: MS }
  };
}
function PD(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function ND() {
  this.buffer();
}
function DD(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = tr(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function MD(e) {
  this.exit(e);
}
function jD(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function LD() {
  this.buffer();
}
function FD(e) {
  const t = this.resume(), n = this.stack[this.stack.length - 1];
  n.type, n.label = t, n.identifier = tr(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function BD(e) {
  this.exit(e);
}
function MS(e, t, n, r) {
  const i = n.createTracker(r);
  let a = i.move("[^");
  const o = n.enter("footnoteReference"), s = n.enter("reference");
  return a += i.move(
    n.safe(n.associationId(e), {
      ...i.current(),
      before: a,
      after: "]"
    })
  ), s(), o(), a += i.move("]"), a;
}
function UD() {
  return "[";
}
function zD(e, t, n, r) {
  const i = n.createTracker(r);
  let a = i.move("[^");
  const o = n.enter("footnoteDefinition"), s = n.enter("label");
  return a += i.move(
    n.safe(n.associationId(e), {
      ...i.current(),
      before: a,
      after: "]"
    })
  ), s(), a += i.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), i.shift(4), a += i.move(
    n.indentLines(n.containerFlow(e, i.current()), VD)
  ), o(), a;
}
function VD(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
const HD = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
jS.peek = GD;
function qD() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: ZD },
    exit: { strikethrough: KD }
  };
}
function WD() {
  return {
    unsafe: [
      {
        character: "~",
        inConstruct: "phrasing",
        notInConstruct: HD
      }
    ],
    handlers: { delete: jS }
  };
}
function ZD(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function KD(e) {
  this.exit(e);
}
function jS(e, t, n, r) {
  const i = n.createTracker(r), a = n.enter("strikethrough");
  let o = i.move("~~");
  return o += n.containerPhrasing(e, {
    ...i.current(),
    before: o,
    after: "~"
  }), o += i.move("~~"), a(), o;
}
function GD() {
  return "~";
}
function YD(e) {
  return e.length;
}
function JD(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || YD, a = [], o = [], s = [], c = [];
  let l = 0, u = -1;
  for (; ++u < e.length; ) {
    const h = [], y = [];
    let v = -1;
    for (e[u].length > l && (l = e[u].length); ++v < e[u].length; ) {
      const g = XD(e[u][v]);
      if (n.alignDelimiters !== !1) {
        const b = i(g);
        y[v] = b, (c[v] === void 0 || b > c[v]) && (c[v] = b);
      }
      h.push(g);
    }
    o[u] = h, s[u] = y;
  }
  let f = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++f < l; )
      a[f] = $g(r[f]);
  else {
    const h = $g(r);
    for (; ++f < l; )
      a[f] = h;
  }
  f = -1;
  const d = [], p = [];
  for (; ++f < l; ) {
    const h = a[f];
    let y = "", v = "";
    h === 99 ? (y = ":", v = ":") : h === 108 ? y = ":" : h === 114 && (v = ":");
    let g = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      c[f] - y.length - v.length
    );
    const b = y + "-".repeat(g) + v;
    n.alignDelimiters !== !1 && (g = y.length + g + v.length, g > c[f] && (c[f] = g), p[f] = g), d[f] = b;
  }
  o.splice(1, 0, d), s.splice(1, 0, p), u = -1;
  const m = [];
  for (; ++u < o.length; ) {
    const h = o[u], y = s[u];
    f = -1;
    const v = [];
    for (; ++f < l; ) {
      const g = h[f] || "";
      let b = "", T = "";
      if (n.alignDelimiters !== !1) {
        const S = c[f] - (y[f] || 0), E = a[f];
        E === 114 ? b = " ".repeat(S) : E === 99 ? S % 2 ? (b = " ".repeat(S / 2 + 0.5), T = " ".repeat(S / 2 - 0.5)) : (b = " ".repeat(S / 2), T = b) : T = " ".repeat(S);
      }
      n.delimiterStart !== !1 && !f && v.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && g === "") && (n.delimiterStart !== !1 || f) && v.push(" "), n.alignDelimiters !== !1 && v.push(b), v.push(g), n.alignDelimiters !== !1 && v.push(T), n.padding !== !1 && v.push(" "), (n.delimiterEnd !== !1 || f !== l - 1) && v.push("|");
    }
    m.push(
      n.delimiterEnd === !1 ? v.join("").replace(/ +$/, "") : v.join("")
    );
  }
  return m.join(`
`);
}
function XD(e) {
  return e == null ? "" : String(e);
}
function $g(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
function QD(e, t, n, r) {
  const i = n.enter("blockquote"), a = n.createTracker(r);
  a.move("> "), a.shift(2);
  const o = n.indentLines(
    n.containerFlow(e, a.current()),
    eM
  );
  return i(), o;
}
function eM(e, t, n) {
  return ">" + (n ? "" : " ") + e;
}
function tM(e, t) {
  return Ig(e, t.inConstruct, !0) && !Ig(e, t.notInConstruct, !1);
}
function Ig(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function Ag(e, t, n, r) {
  let i = -1;
  for (; ++i < n.unsafe.length; )
    if (n.unsafe[i].character === `
` && tM(n.stack, n.unsafe[i]))
      return /[ \t]/.test(r.before) ? "" : " ";
  return `\\
`;
}
function nM(e, t) {
  const n = String(e);
  let r = n.indexOf(t), i = r, a = 0, o = 0;
  if (typeof t != "string")
    throw new TypeError("Expected substring");
  for (; r !== -1; )
    r === i ? ++a > o && (o = a) : a = 1, i = r + t.length, r = n.indexOf(t, i);
  return o;
}
function rM(e, t) {
  return !!(t.options.fences === !1 && e.value && // If there’s no info…
  !e.lang && // And there’s a non-whitespace character…
  /[^ \r\n]/.test(e.value) && // And the value doesn’t start or end in a blank…
  !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(e.value));
}
function iM(e) {
  const t = e.options.fence || "`";
  if (t !== "`" && t !== "~")
    throw new Error(
      "Cannot serialize code with `" + t + "` for `options.fence`, expected `` ` `` or `~`"
    );
  return t;
}
function aM(e, t, n, r) {
  const i = iM(n), a = e.value || "", o = i === "`" ? "GraveAccent" : "Tilde";
  if (rM(e, n)) {
    const f = n.enter("codeIndented"), d = n.indentLines(a, oM);
    return f(), d;
  }
  const s = n.createTracker(r), c = i.repeat(Math.max(nM(a, i) + 1, 3)), l = n.enter("codeFenced");
  let u = s.move(c);
  if (e.lang) {
    const f = n.enter(`codeFencedLang${o}`);
    u += s.move(
      n.safe(e.lang, {
        before: u,
        after: " ",
        encode: ["`"],
        ...s.current()
      })
    ), f();
  }
  if (e.lang && e.meta) {
    const f = n.enter(`codeFencedMeta${o}`);
    u += s.move(" "), u += s.move(
      n.safe(e.meta, {
        before: u,
        after: `
`,
        encode: ["`"],
        ...s.current()
      })
    ), f();
  }
  return u += s.move(`
`), a && (u += s.move(a + `
`)), u += s.move(c), l(), u;
}
function oM(e, t, n) {
  return (n ? "" : "    ") + e;
}
function km(e) {
  const t = e.options.quote || '"';
  if (t !== '"' && t !== "'")
    throw new Error(
      "Cannot serialize title with `" + t + "` for `options.quote`, expected `\"`, or `'`"
    );
  return t;
}
function sM(e, t, n, r) {
  const i = km(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("definition");
  let s = n.enter("label");
  const c = n.createTracker(r);
  let l = c.move("[");
  return l += c.move(
    n.safe(n.associationId(e), {
      before: l,
      after: "]",
      ...c.current()
    })
  ), l += c.move("]: "), s(), // If there’s no url, or…
  !e.url || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (s = n.enter("destinationLiteral"), l += c.move("<"), l += c.move(
    n.safe(e.url, { before: l, after: ">", ...c.current() })
  ), l += c.move(">")) : (s = n.enter("destinationRaw"), l += c.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : `
`,
      ...c.current()
    })
  )), s(), e.title && (s = n.enter(`title${a}`), l += c.move(" " + i), l += c.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...c.current()
    })
  ), l += c.move(i), s()), o(), l;
}
function lM(e) {
  const t = e.options.emphasis || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize emphasis with `" + t + "` for `options.emphasis`, expected `*`, or `_`"
    );
  return t;
}
LS.peek = cM;
function LS(e, t, n, r) {
  const i = lM(n), a = n.enter("emphasis"), o = n.createTracker(r);
  let s = o.move(i);
  return s += o.move(
    n.containerPhrasing(e, {
      before: s,
      after: i,
      ...o.current()
    })
  ), s += o.move(i), a(), s;
}
function cM(e, t, n) {
  return n.options.emphasis || "*";
}
function uM(e, t) {
  let n = !1;
  return Em(e, function(r) {
    if ("value" in r && /\r?\n|\r/.test(r.value) || r.type === "break")
      return n = !0, Vp;
  }), !!((!e.depth || e.depth < 3) && ym(e) && (t.options.setext || n));
}
function fM(e, t, n, r) {
  const i = Math.max(Math.min(6, e.depth || 1), 1), a = n.createTracker(r);
  if (uM(e, n)) {
    const u = n.enter("headingSetext"), f = n.enter("phrasing"), d = n.containerPhrasing(e, {
      ...a.current(),
      before: `
`,
      after: `
`
    });
    return f(), u(), d + `
` + (i === 1 ? "=" : "-").repeat(
      // The whole size…
      d.length - // Minus the position of the character after the last EOL (or
      // 0 if there is none)…
      (Math.max(d.lastIndexOf("\r"), d.lastIndexOf(`
`)) + 1)
    );
  }
  const o = "#".repeat(i), s = n.enter("headingAtx"), c = n.enter("phrasing");
  a.move(o + " ");
  let l = n.containerPhrasing(e, {
    before: "# ",
    after: `
`,
    ...a.current()
  });
  return /^[\t ]/.test(l) && (l = "&#x" + l.charCodeAt(0).toString(16).toUpperCase() + ";" + l.slice(1)), l = l ? o + " " + l : o, n.options.closeAtx && (l += " " + o), c(), s(), l;
}
FS.peek = dM;
function FS(e) {
  return e.value || "";
}
function dM() {
  return "<";
}
BS.peek = pM;
function BS(e, t, n, r) {
  const i = km(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.enter("image");
  let s = n.enter("label");
  const c = n.createTracker(r);
  let l = c.move("![");
  return l += c.move(
    n.safe(e.alt, { before: l, after: "]", ...c.current() })
  ), l += c.move("]("), s(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (s = n.enter("destinationLiteral"), l += c.move("<"), l += c.move(
    n.safe(e.url, { before: l, after: ">", ...c.current() })
  ), l += c.move(">")) : (s = n.enter("destinationRaw"), l += c.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...c.current()
    })
  )), s(), e.title && (s = n.enter(`title${a}`), l += c.move(" " + i), l += c.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...c.current()
    })
  ), l += c.move(i), s()), l += c.move(")"), o(), l;
}
function pM() {
  return "!";
}
US.peek = hM;
function US(e, t, n, r) {
  const i = e.referenceType, a = n.enter("imageReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let c = s.move("![");
  const l = n.safe(e.alt, {
    before: c,
    after: "]",
    ...s.current()
  });
  c += s.move(l + "]["), o();
  const u = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: c,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = u, a(), i === "full" || !l || l !== f ? c += s.move(f + "]") : i === "shortcut" ? c = c.slice(0, -1) : c += s.move("]"), c;
}
function hM() {
  return "!";
}
zS.peek = mM;
function zS(e, t, n) {
  let r = e.value || "", i = "`", a = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++a < n.unsafe.length; ) {
    const o = n.unsafe[a], s = n.compilePattern(o);
    let c;
    if (o.atBreak)
      for (; c = s.exec(r); ) {
        let l = c.index;
        r.charCodeAt(l) === 10 && r.charCodeAt(l - 1) === 13 && l--, r = r.slice(0, l) + " " + r.slice(c.index + 1);
      }
  }
  return i + r + i;
}
function mM() {
  return "`";
}
function VS(e, t) {
  const n = ym(e);
  return !!(!t.options.resourceLink && // If there’s a url…
  e.url && // And there’s a no title…
  !e.title && // And the content of `node` is a single text node…
  e.children && e.children.length === 1 && e.children[0].type === "text" && // And if the url is the same as the content…
  (n === e.url || "mailto:" + n === e.url) && // And that starts w/ a protocol…
  /^[a-z][a-z+.-]+:/i.test(e.url) && // And that doesn’t contain ASCII control codes (character escapes and
  // references don’t work), space, or angle brackets…
  !/[\0- <>\u007F]/.test(e.url));
}
HS.peek = vM;
function HS(e, t, n, r) {
  const i = km(n), a = i === '"' ? "Quote" : "Apostrophe", o = n.createTracker(r);
  let s, c;
  if (VS(e, n)) {
    const u = n.stack;
    n.stack = [], s = n.enter("autolink");
    let f = o.move("<");
    return f += o.move(
      n.containerPhrasing(e, {
        before: f,
        after: ">",
        ...o.current()
      })
    ), f += o.move(">"), s(), n.stack = u, f;
  }
  s = n.enter("link"), c = n.enter("label");
  let l = o.move("[");
  return l += o.move(
    n.containerPhrasing(e, {
      before: l,
      after: "](",
      ...o.current()
    })
  ), l += o.move("]("), c(), // If there’s no url but there is a title…
  !e.url && e.title || // If there are control characters or whitespace.
  /[\0- \u007F]/.test(e.url) ? (c = n.enter("destinationLiteral"), l += o.move("<"), l += o.move(
    n.safe(e.url, { before: l, after: ">", ...o.current() })
  ), l += o.move(">")) : (c = n.enter("destinationRaw"), l += o.move(
    n.safe(e.url, {
      before: l,
      after: e.title ? " " : ")",
      ...o.current()
    })
  )), c(), e.title && (c = n.enter(`title${a}`), l += o.move(" " + i), l += o.move(
    n.safe(e.title, {
      before: l,
      after: i,
      ...o.current()
    })
  ), l += o.move(i), c()), l += o.move(")"), s(), l;
}
function vM(e, t, n) {
  return VS(e, n) ? "<" : "[";
}
qS.peek = yM;
function qS(e, t, n, r) {
  const i = e.referenceType, a = n.enter("linkReference");
  let o = n.enter("label");
  const s = n.createTracker(r);
  let c = s.move("[");
  const l = n.containerPhrasing(e, {
    before: c,
    after: "]",
    ...s.current()
  });
  c += s.move(l + "]["), o();
  const u = n.stack;
  n.stack = [], o = n.enter("reference");
  const f = n.safe(n.associationId(e), {
    before: c,
    after: "]",
    ...s.current()
  });
  return o(), n.stack = u, a(), i === "full" || !l || l !== f ? c += s.move(f + "]") : i === "shortcut" ? c = c.slice(0, -1) : c += s.move("]"), c;
}
function yM() {
  return "[";
}
function Om(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function gM(e) {
  const t = Om(e), n = e.options.bulletOther;
  if (!n)
    return t === "*" ? "-" : "*";
  if (n !== "*" && n !== "+" && n !== "-")
    throw new Error(
      "Cannot serialize items with `" + n + "` for `options.bulletOther`, expected `*`, `+`, or `-`"
    );
  if (n === t)
    throw new Error(
      "Expected `bullet` (`" + t + "`) and `bulletOther` (`" + n + "`) to be different"
    );
  return n;
}
function bM(e) {
  const t = e.options.bulletOrdered || ".";
  if (t !== "." && t !== ")")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bulletOrdered`, expected `.` or `)`"
    );
  return t;
}
function WS(e) {
  const t = e.options.rule || "*";
  if (t !== "*" && t !== "-" && t !== "_")
    throw new Error(
      "Cannot serialize rules with `" + t + "` for `options.rule`, expected `*`, `-`, or `_`"
    );
  return t;
}
function xM(e, t, n, r) {
  const i = n.enter("list"), a = n.bulletCurrent;
  let o = e.ordered ? bM(n) : Om(n);
  const s = e.ordered ? o === "." ? ")" : "." : gM(n);
  let c = t && n.bulletLastUsed ? o === n.bulletLastUsed : !1;
  if (!e.ordered) {
    const u = e.children ? e.children[0] : void 0;
    if (
      // Bullet could be used as a thematic break marker:
      (o === "*" || o === "-") && // Empty first list item:
      u && (!u.children || !u.children[0]) && // Directly in two other list items:
      n.stack[n.stack.length - 1] === "list" && n.stack[n.stack.length - 2] === "listItem" && n.stack[n.stack.length - 3] === "list" && n.stack[n.stack.length - 4] === "listItem" && // That are each the first child.
      n.indexStack[n.indexStack.length - 1] === 0 && n.indexStack[n.indexStack.length - 2] === 0 && n.indexStack[n.indexStack.length - 3] === 0 && (c = !0), WS(n) === o && u
    ) {
      let f = -1;
      for (; ++f < e.children.length; ) {
        const d = e.children[f];
        if (d && d.type === "listItem" && d.children && d.children[0] && d.children[0].type === "thematicBreak") {
          c = !0;
          break;
        }
      }
    }
  }
  c && (o = s), n.bulletCurrent = o;
  const l = n.containerFlow(e, r);
  return n.bulletLastUsed = o, n.bulletCurrent = a, i(), l;
}
function wM(e) {
  const t = e.options.listItemIndent || "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function SM(e, t, n, r) {
  const i = wM(n);
  let a = n.bulletCurrent || Om(n);
  t && t.type === "list" && t.ordered && (a = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + a);
  let o = a.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (o = Math.ceil(o / 4) * 4);
  const s = n.createTracker(r);
  s.move(a + " ".repeat(o - a.length)), s.shift(o);
  const c = n.enter("listItem"), l = n.indentLines(
    n.containerFlow(e, s.current()),
    u
  );
  return c(), l;
  function u(f, d, p) {
    return d ? (p ? "" : " ".repeat(o)) + f : (p ? a : a + " ".repeat(o - a.length)) + f;
  }
}
function _M(e, t, n, r) {
  const i = n.enter("paragraph"), a = n.enter("phrasing"), o = n.containerPhrasing(e, r);
  return a(), i(), o;
}
const EM = (
  /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */
  Su([
    "break",
    "delete",
    "emphasis",
    // To do: next major: removed since footnotes were added to GFM.
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    // Enabled by `mdast-util-math`:
    "inlineMath",
    "link",
    "linkReference",
    // Enabled by `mdast-util-mdx`:
    "mdxJsxTextElement",
    // Enabled by `mdast-util-mdx`:
    "mdxTextExpression",
    "strong",
    "text",
    // Enabled by `mdast-util-directive`:
    "textDirective"
  ])
);
function TM(e, t, n, r) {
  return (e.children.some(function(o) {
    return EM(o);
  }) ? n.containerPhrasing : n.containerFlow).call(n, e, r);
}
function kM(e) {
  const t = e.options.strong || "*";
  if (t !== "*" && t !== "_")
    throw new Error(
      "Cannot serialize strong with `" + t + "` for `options.strong`, expected `*`, or `_`"
    );
  return t;
}
ZS.peek = OM;
function ZS(e, t, n, r) {
  const i = kM(n), a = n.enter("strong"), o = n.createTracker(r);
  let s = o.move(i + i);
  return s += o.move(
    n.containerPhrasing(e, {
      before: s,
      after: i,
      ...o.current()
    })
  ), s += o.move(i + i), a(), s;
}
function OM(e, t, n) {
  return n.options.strong || "*";
}
function CM(e, t, n, r) {
  return n.safe(e.value, r);
}
function RM(e) {
  const t = e.options.ruleRepetition || 3;
  if (t < 3)
    throw new Error(
      "Cannot serialize rules with repetition `" + t + "` for `options.ruleRepetition`, expected `3` or more"
    );
  return t;
}
function $M(e, t, n) {
  const r = (WS(n) + (n.options.ruleSpaces ? " " : "")).repeat(RM(n));
  return n.options.ruleSpaces ? r.slice(0, -1) : r;
}
const KS = {
  blockquote: QD,
  break: Ag,
  code: aM,
  definition: sM,
  emphasis: LS,
  hardBreak: Ag,
  heading: fM,
  html: FS,
  image: BS,
  imageReference: US,
  inlineCode: zS,
  link: HS,
  linkReference: qS,
  list: xM,
  listItem: SM,
  paragraph: _M,
  root: TM,
  strong: ZS,
  text: CM,
  thematicBreak: $M
};
function IM() {
  return {
    enter: {
      table: AM,
      tableData: Pg,
      tableHeader: Pg,
      tableRow: NM
    },
    exit: {
      codeText: DM,
      table: PM,
      tableData: Nf,
      tableHeader: Nf,
      tableRow: Nf
    }
  };
}
function AM(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map(function(n) {
        return n === "none" ? null : n;
      }),
      children: []
    },
    e
  ), this.data.inTable = !0;
}
function PM(e) {
  this.exit(e), this.data.inTable = void 0;
}
function NM(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Nf(e) {
  this.exit(e);
}
function Pg(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function DM(e) {
  let t = this.resume();
  this.data.inTable && (t = t.replace(/\\([\\|])/g, MM));
  const n = this.stack[this.stack.length - 1];
  n.type, n.value = t, this.exit(e);
}
function MM(e, t) {
  return t === "|" ? t : e;
}
function jM(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, a = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      inlineCode: d,
      table: o,
      tableCell: c,
      tableRow: s
    }
  };
  function o(p, m, h, y) {
    return l(u(p, h, y), p.align);
  }
  function s(p, m, h, y) {
    const v = f(p, h, y), g = l([v]);
    return g.slice(0, g.indexOf(`
`));
  }
  function c(p, m, h, y) {
    const v = h.enter("tableCell"), g = h.enter("phrasing"), b = h.containerPhrasing(p, {
      ...y,
      before: a,
      after: a
    });
    return g(), v(), b;
  }
  function l(p, m) {
    return JD(p, {
      align: m,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function u(p, m, h) {
    const y = p.children;
    let v = -1;
    const g = [], b = m.enter("table");
    for (; ++v < y.length; )
      g[v] = f(y[v], m, h);
    return b(), g;
  }
  function f(p, m, h) {
    const y = p.children;
    let v = -1;
    const g = [], b = m.enter("tableRow");
    for (; ++v < y.length; )
      g[v] = c(y[v], p, m, h);
    return b(), g;
  }
  function d(p, m, h) {
    let y = KS.inlineCode(p, m, h);
    return h.stack.includes("tableCell") && (y = y.replace(/\|/g, "\\$&")), y;
  }
}
function LM() {
  return {
    exit: {
      taskListCheckValueChecked: Ng,
      taskListCheckValueUnchecked: Ng,
      paragraph: BM
    }
  };
}
function FM() {
  return {
    unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
    handlers: { listItem: UM }
  };
}
function Ng(e) {
  const t = this.stack[this.stack.length - 2];
  t.type, t.checked = e.type === "taskListCheckValueChecked";
}
function BM(e) {
  const t = this.stack[this.stack.length - 2];
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = this.stack[this.stack.length - 1];
    n.type;
    const r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let a = -1, o;
      for (; ++a < i.length; ) {
        const s = i[a];
        if (s.type === "paragraph") {
          o = s;
          break;
        }
      }
      o === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function UM(e, t, n, r) {
  const i = e.children[0], a = typeof e.checked == "boolean" && i && i.type === "paragraph", o = "[" + (e.checked ? "x" : " ") + "] ", s = n.createTracker(r);
  a && s.move(o);
  let c = KS.listItem(e, t, n, {
    ...r,
    ...s.current()
  });
  return a && (c = c.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, l)), c;
  function l(u) {
    return u + o;
  }
}
function zM() {
  return [
    bD(),
    ID(),
    qD(),
    IM(),
    LM()
  ];
}
function VM(e) {
  return {
    extensions: [
      xD(),
      AD(),
      WD(),
      jM(e),
      FM()
    ]
  };
}
const HM = {
  tokenize: YM,
  partial: !0
}, GS = {
  tokenize: JM,
  partial: !0
}, YS = {
  tokenize: XM,
  partial: !0
}, JS = {
  tokenize: QM,
  partial: !0
}, qM = {
  tokenize: ej,
  partial: !0
}, XS = {
  name: "wwwAutolink",
  tokenize: KM,
  previous: e_
}, QS = {
  name: "protocolAutolink",
  tokenize: GM,
  previous: t_
}, Zr = {
  name: "emailAutolink",
  tokenize: ZM,
  previous: n_
}, Cr = {};
function WM() {
  return {
    text: Cr
  };
}
let Ii = 48;
for (; Ii < 123; )
  Cr[Ii] = Zr, Ii++, Ii === 58 ? Ii = 65 : Ii === 91 && (Ii = 97);
Cr[43] = Zr;
Cr[45] = Zr;
Cr[46] = Zr;
Cr[95] = Zr;
Cr[72] = [Zr, QS];
Cr[104] = [Zr, QS];
Cr[87] = [Zr, XS];
Cr[119] = [Zr, XS];
function ZM(e, t, n) {
  const r = this;
  let i, a;
  return o;
  function o(f) {
    return !Zp(f) || !n_.call(r, r.previous) || Cm(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(f));
  }
  function s(f) {
    return Zp(f) ? (e.consume(f), s) : f === 64 ? (e.consume(f), c) : n(f);
  }
  function c(f) {
    return f === 46 ? e.check(qM, u, l)(f) : f === 45 || f === 95 || an(f) ? (a = !0, e.consume(f), c) : u(f);
  }
  function l(f) {
    return e.consume(f), i = !0, c;
  }
  function u(f) {
    return a && i && dn(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function KM(e, t, n) {
  const r = this;
  return i;
  function i(o) {
    return o !== 87 && o !== 119 || !e_.call(r, r.previous) || Cm(r.events) ? n(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(HM, e.attempt(GS, e.attempt(YS, a), n), n)(o));
  }
  function a(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(o);
  }
}
function GM(e, t, n) {
  const r = this;
  let i = "", a = !1;
  return o;
  function o(f) {
    return (f === 72 || f === 104) && t_.call(r, r.previous) && !Cm(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(f), e.consume(f), s) : n(f);
  }
  function s(f) {
    if (dn(f) && i.length < 5)
      return i += String.fromCodePoint(f), e.consume(f), s;
    if (f === 58) {
      const d = i.toLowerCase();
      if (d === "http" || d === "https")
        return e.consume(f), c;
    }
    return n(f);
  }
  function c(f) {
    return f === 47 ? (e.consume(f), a ? l : (a = !0, c)) : n(f);
  }
  function l(f) {
    return f === null || Ac(f) || yt(f) || Vi(f) || bu(f) ? n(f) : e.attempt(GS, e.attempt(YS, u), n)(f);
  }
  function u(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function YM(e, t, n) {
  let r = 0;
  return i;
  function i(o) {
    return (o === 87 || o === 119) && r < 3 ? (r++, e.consume(o), i) : o === 46 && r === 3 ? (e.consume(o), a) : n(o);
  }
  function a(o) {
    return o === null ? n(o) : t(o);
  }
}
function JM(e, t, n) {
  let r, i, a;
  return o;
  function o(l) {
    return l === 46 || l === 95 ? e.check(JS, c, s)(l) : l === null || yt(l) || Vi(l) || l !== 45 && bu(l) ? c(l) : (a = !0, e.consume(l), o);
  }
  function s(l) {
    return l === 95 ? r = !0 : (i = r, r = void 0), e.consume(l), o;
  }
  function c(l) {
    return i || r || !a ? n(l) : t(l);
  }
}
function XM(e, t) {
  let n = 0, r = 0;
  return i;
  function i(o) {
    return o === 40 ? (n++, e.consume(o), i) : o === 41 && r < n ? a(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(JS, t, a)(o) : o === null || yt(o) || Vi(o) ? t(o) : (e.consume(o), i);
  }
  function a(o) {
    return o === 41 && r++, e.consume(o), i;
  }
}
function QM(e, t, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (e.consume(s), r) : s === 38 ? (e.consume(s), a) : s === 93 ? (e.consume(s), i) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || yt(s) || Vi(s) ? t(s) : n(s)
    );
  }
  function i(s) {
    return s === null || s === 40 || s === 91 || yt(s) || Vi(s) ? t(s) : r(s);
  }
  function a(s) {
    return dn(s) ? o(s) : n(s);
  }
  function o(s) {
    return s === 59 ? (e.consume(s), r) : dn(s) ? (e.consume(s), o) : n(s);
  }
}
function ej(e, t, n) {
  return r;
  function r(a) {
    return e.consume(a), i;
  }
  function i(a) {
    return an(a) ? n(a) : t(a);
  }
}
function e_(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || yt(e);
}
function t_(e) {
  return !dn(e);
}
function n_(e) {
  return !(e === 47 || Zp(e));
}
function Zp(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || an(e);
}
function Cm(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const tj = {
  tokenize: cj,
  partial: !0
};
function nj() {
  return {
    document: {
      91: {
        name: "gfmFootnoteDefinition",
        tokenize: oj,
        continuation: {
          tokenize: sj
        },
        exit: lj
      }
    },
    text: {
      91: {
        name: "gfmFootnoteCall",
        tokenize: aj
      },
      93: {
        name: "gfmPotentialFootnoteCall",
        add: "after",
        tokenize: rj,
        resolveTo: ij
      }
    }
  };
}
function rj(e, t, n) {
  const r = this;
  let i = r.events.length;
  const a = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o;
  for (; i--; ) {
    const c = r.events[i][1];
    if (c.type === "labelImage") {
      o = c;
      break;
    }
    if (c.type === "gfmFootnoteCall" || c.type === "labelLink" || c.type === "label" || c.type === "image" || c.type === "link")
      break;
  }
  return s;
  function s(c) {
    if (!o || !o._balanced)
      return n(c);
    const l = tr(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }));
    return l.codePointAt(0) !== 94 || !a.includes(l.slice(1)) ? n(c) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(c), e.exit("gfmFootnoteCallLabelMarker"), t(c));
  }
}
function ij(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const a = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, o = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, a.start),
    end: Object.assign({}, a.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", a, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", a, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...s), e;
}
function aj(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a = 0, o;
  return s;
  function s(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), c;
  }
  function c(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", l);
  }
  function l(f) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      f === 93 && !o || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      f === null || f === 91 || yt(f)
    )
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const d = e.exit("gfmFootnoteCallString");
      return i.includes(tr(r.sliceSerialize(d))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return yt(f) || (o = !0), a++, e.consume(f), f === 92 ? u : l;
  }
  function u(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), a++, l) : l(f);
  }
}
function oj(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a, o = 0, s;
  return c;
  function c(m) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(m), e.exit("gfmFootnoteDefinitionLabelMarker"), l;
  }
  function l(m) {
    return m === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(m), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", u) : n(m);
  }
  function u(m) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      m === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      m === null || m === 91 || yt(m)
    )
      return n(m);
    if (m === 93) {
      e.exit("chunkString");
      const h = e.exit("gfmFootnoteDefinitionLabelString");
      return a = tr(r.sliceSerialize(h)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(m), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), d;
    }
    return yt(m) || (s = !0), o++, e.consume(m), m === 92 ? f : u;
  }
  function f(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), o++, u) : u(m);
  }
  function d(m) {
    return m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), i.includes(a) || i.push(a), et(e, p, "gfmFootnoteDefinitionWhitespace")) : n(m);
  }
  function p(m) {
    return t(m);
  }
}
function sj(e, t, n) {
  return e.check(Ms, t, e.attempt(tj, t, n));
}
function lj(e) {
  e.exit("gfmFootnoteDefinition");
}
function cj(e, t, n) {
  const r = this;
  return et(e, i, "gfmFootnoteDefinitionIndent", 5);
  function i(a) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? t(a) : n(a);
  }
}
function uj(e) {
  let n = (e || {}).singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: a,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(o, s) {
    let c = -1;
    for (; ++c < o.length; )
      if (o[c][0] === "enter" && o[c][1].type === "strikethroughSequenceTemporary" && o[c][1]._close) {
        let l = c;
        for (; l--; )
          if (o[l][0] === "exit" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._open && // If the sizes are the same:
          o[c][1].end.offset - o[c][1].start.offset === o[l][1].end.offset - o[l][1].start.offset) {
            o[c][1].type = "strikethroughSequence", o[l][1].type = "strikethroughSequence";
            const u = {
              type: "strikethrough",
              start: Object.assign({}, o[l][1].start),
              end: Object.assign({}, o[c][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, o[l][1].end),
              end: Object.assign({}, o[c][1].start)
            }, d = [["enter", u, s], ["enter", o[l][1], s], ["exit", o[l][1], s], ["enter", f, s]], p = s.parser.constructs.insideSpan.null;
            p && Un(d, d.length, 0, xu(p, o.slice(l + 1, c), s)), Un(d, d.length, 0, [["exit", f, s], ["enter", o[c][1], s], ["exit", o[c][1], s], ["exit", u, s]]), Un(o, l - 1, c - l + 3, d), c = l + d.length - 2;
            break;
          }
      }
    for (c = -1; ++c < o.length; )
      o[c][1].type === "strikethroughSequenceTemporary" && (o[c][1].type = "data");
    return o;
  }
  function a(o, s, c) {
    const l = this.previous, u = this.events;
    let f = 0;
    return d;
    function d(m) {
      return l === 126 && u[u.length - 1][1].type !== "characterEscape" ? c(m) : (o.enter("strikethroughSequenceTemporary"), p(m));
    }
    function p(m) {
      const h = Pc(l);
      if (m === 126)
        return f > 1 ? c(m) : (o.consume(m), f++, p);
      if (f < 2 && !n) return c(m);
      const y = o.exit("strikethroughSequenceTemporary"), v = Pc(m);
      return y._open = !v || v === 2 && !!h, y._close = !h || h === 2 && !!v, s(m);
    }
  }
}
class fj {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */
  add(t, n, r) {
    dj(this, t, n, r);
  }
  // To do: add this when moving to `micromark`.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {undefined}
  //  */
  // addBefore(index, remove, add) {
  //   addImplementation(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */
  consume(t) {
    if (this.map.sort(function(a, o) {
      return a[0] - o[0];
    }), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1]), this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let i = r.pop();
    for (; i; )
      t.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function dj(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function pj(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const a = r.length - 1;
          r[a] = r[a] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
function hj() {
  return {
    flow: {
      null: {
        name: "table",
        tokenize: mj,
        resolveAll: vj
      }
    }
  };
}
function mj(e, t, n) {
  const r = this;
  let i = 0, a = 0, o;
  return s;
  function s(k) {
    let A = r.events.length - 1;
    for (; A > -1; ) {
      const L = r.events[A][1].type;
      if (L === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      L === "linePrefix") A--;
      else break;
    }
    const V = A > -1 ? r.events[A][1].type : null, $ = V === "tableHead" || V === "tableRow" ? E : c;
    return $ === E && r.parser.lazy[r.now().line] ? n(k) : $(k);
  }
  function c(k) {
    return e.enter("tableHead"), e.enter("tableRow"), l(k);
  }
  function l(k) {
    return k === 124 || (o = !0, a += 1), u(k);
  }
  function u(k) {
    return k === null ? n(k) : $e(k) ? a > 1 ? (a = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), p) : n(k) : qe(k) ? et(e, u, "whitespace")(k) : (a += 1, o && (o = !1, i += 1), k === 124 ? (e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), o = !0, u) : (e.enter("data"), f(k)));
  }
  function f(k) {
    return k === null || k === 124 || yt(k) ? (e.exit("data"), u(k)) : (e.consume(k), k === 92 ? d : f);
  }
  function d(k) {
    return k === 92 || k === 124 ? (e.consume(k), f) : f(k);
  }
  function p(k) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(k) : (e.enter("tableDelimiterRow"), o = !1, qe(k) ? et(e, m, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(k) : m(k));
  }
  function m(k) {
    return k === 45 || k === 58 ? y(k) : k === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), h) : S(k);
  }
  function h(k) {
    return qe(k) ? et(e, y, "whitespace")(k) : y(k);
  }
  function y(k) {
    return k === 58 ? (a += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(k), e.exit("tableDelimiterMarker"), v) : k === 45 ? (a += 1, v(k)) : k === null || $e(k) ? T(k) : S(k);
  }
  function v(k) {
    return k === 45 ? (e.enter("tableDelimiterFiller"), g(k)) : S(k);
  }
  function g(k) {
    return k === 45 ? (e.consume(k), g) : k === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(k), e.exit("tableDelimiterMarker"), b) : (e.exit("tableDelimiterFiller"), b(k));
  }
  function b(k) {
    return qe(k) ? et(e, T, "whitespace")(k) : T(k);
  }
  function T(k) {
    return k === 124 ? m(k) : k === null || $e(k) ? !o || i !== a ? S(k) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(k)) : S(k);
  }
  function S(k) {
    return n(k);
  }
  function E(k) {
    return e.enter("tableRow"), O(k);
  }
  function O(k) {
    return k === 124 ? (e.enter("tableCellDivider"), e.consume(k), e.exit("tableCellDivider"), O) : k === null || $e(k) ? (e.exit("tableRow"), t(k)) : qe(k) ? et(e, O, "whitespace")(k) : (e.enter("data"), j(k));
  }
  function j(k) {
    return k === null || k === 124 || yt(k) ? (e.exit("data"), O(k)) : (e.consume(k), k === 92 ? D : j);
  }
  function D(k) {
    return k === 92 || k === 124 ? (e.consume(k), j) : j(k);
  }
}
function vj(e, t) {
  let n = -1, r = !0, i = 0, a = [0, 0, 0, 0], o = [0, 0, 0, 0], s = !1, c = 0, l, u, f;
  const d = new fj();
  for (; ++n < e.length; ) {
    const p = e[n], m = p[1];
    p[0] === "enter" ? m.type === "tableHead" ? (s = !1, c !== 0 && (Dg(d, t, c, l, u), u = void 0, c = 0), l = {
      type: "table",
      start: Object.assign({}, m.start),
      // Note: correct end is set later.
      end: Object.assign({}, m.end)
    }, d.add(n, 0, [["enter", l, t]])) : m.type === "tableRow" || m.type === "tableDelimiterRow" ? (r = !0, f = void 0, a = [0, 0, 0, 0], o = [0, n + 1, 0, 0], s && (s = !1, u = {
      type: "tableBody",
      start: Object.assign({}, m.start),
      // Note: correct end is set later.
      end: Object.assign({}, m.end)
    }, d.add(n, 0, [["enter", u, t]])), i = m.type === "tableDelimiterRow" ? 2 : u ? 3 : 1) : i && (m.type === "data" || m.type === "tableDelimiterMarker" || m.type === "tableDelimiterFiller") ? (r = !1, o[2] === 0 && (a[1] !== 0 && (o[0] = o[1], f = xl(d, t, a, i, void 0, f), a = [0, 0, 0, 0]), o[2] = n)) : m.type === "tableCellDivider" && (r ? r = !1 : (a[1] !== 0 && (o[0] = o[1], f = xl(d, t, a, i, void 0, f)), a = o, o = [a[1], n, 0, 0])) : m.type === "tableHead" ? (s = !0, c = n) : m.type === "tableRow" || m.type === "tableDelimiterRow" ? (c = n, a[1] !== 0 ? (o[0] = o[1], f = xl(d, t, a, i, n, f)) : o[1] !== 0 && (f = xl(d, t, o, i, n, f)), i = 0) : i && (m.type === "data" || m.type === "tableDelimiterMarker" || m.type === "tableDelimiterFiller") && (o[3] = n);
  }
  for (c !== 0 && Dg(d, t, c, l, u), d.consume(t.events), n = -1; ++n < t.events.length; ) {
    const p = t.events[n];
    p[0] === "enter" && p[1].type === "table" && (p[1]._align = pj(t.events, n));
  }
  return e;
}
function xl(e, t, n, r, i, a) {
  const o = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (a.end = Object.assign({}, ya(t.events, n[0])), e.add(n[0], 0, [["exit", a, t]]));
  const c = ya(t.events, n[1]);
  if (a = {
    type: o,
    start: Object.assign({}, c),
    // Note: correct end is set later.
    end: Object.assign({}, c)
  }, e.add(n[1], 0, [["enter", a, t]]), n[2] !== 0) {
    const l = ya(t.events, n[2]), u = ya(t.events, n[3]), f = {
      type: s,
      start: Object.assign({}, l),
      end: Object.assign({}, u)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const d = t.events[n[2]], p = t.events[n[3]];
      if (d[1].end = Object.assign({}, p[1].end), d[1].type = "chunkText", d[1].contentType = "text", n[3] > n[2] + 1) {
        const m = n[2] + 1, h = n[3] - n[2] - 1;
        e.add(m, h, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return i !== void 0 && (a.end = Object.assign({}, ya(t.events, i)), e.add(i, 0, [["exit", a, t]]), a = void 0), a;
}
function Dg(e, t, n, r, i) {
  const a = [], o = ya(t.events, n);
  i && (i.end = Object.assign({}, o), a.push(["exit", i, t])), r.end = Object.assign({}, o), a.push(["exit", r, t]), e.add(n + 1, 0, a);
}
function ya(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const yj = {
  name: "tasklistCheck",
  tokenize: bj
};
function gj() {
  return {
    text: {
      91: yj
    }
  };
}
function bj(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(c) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), a)
    );
  }
  function a(c) {
    return yt(c) ? (e.enter("taskListCheckValueUnchecked"), e.consume(c), e.exit("taskListCheckValueUnchecked"), o) : c === 88 || c === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(c), e.exit("taskListCheckValueChecked"), o) : n(c);
  }
  function o(c) {
    return c === 93 ? (e.enter("taskListCheckMarker"), e.consume(c), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), s) : n(c);
  }
  function s(c) {
    return $e(c) ? t(c) : qe(c) ? e.check({
      tokenize: xj
    }, t, n)(c) : n(c);
  }
}
function xj(e, t, n) {
  return et(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function wj(e) {
  return dS([
    WM(),
    nj(),
    uj(e),
    hj(),
    gj()
  ]);
}
const Sj = {};
function _j(e) {
  const t = (
    /** @type {Processor} */
    this
  ), n = e || Sj, r = t.data(), i = r.micromarkExtensions || (r.micromarkExtensions = []), a = r.fromMarkdownExtensions || (r.fromMarkdownExtensions = []), o = r.toMarkdownExtensions || (r.toMarkdownExtensions = []);
  i.push(wj(n)), a.push(zM()), o.push(VM(n));
}
const bt = {
  container: {
    className: "bpReset bpContainer bpFont"
  },
  loader: {
    className: "bpReset bpLoader"
  },
  modal: {
    container: {
      className: "bpReset bpModalContainer"
    },
    overlay: {
      className: "bpModalOverlay"
    },
    dialog: {
      container: {
        className: "bpReset bpModalDialogContainer"
      },
      title: {
        container: {
          className: "bpReset bpModalDialogTitleContainer"
        },
        text: {
          className: "bpModalDialogTitleText"
        },
        closeIcon: {
          className: "bpModalDialogTitleCloseIcon"
        }
      },
      content: {
        className: "bpModalDialogContent"
      },
      newConversation: {
        button: {
          className: "bpModalDialogNewConversationButton"
        },
        text: {
          className: "bpModalDialogNewConversationText"
        }
      }
    }
  },
  fab: {
    container: {
      className: "bpReset bpFabContainer"
    },
    icon: {
      className: "bpFabIcon"
    }
  },
  notification: {
    container: {
      className: "bpReset bpNotificationContainer"
    },
    title: {
      className: "bpNotificationTitle"
    },
    description: {
      className: "bpNotificationDescription"
    },
    icon: {
      className: "bpNotificationIcon"
    },
    closeIcon: {
      className: "bpNotificationCloseIcon"
    }
  },
  header: {
    container: {
      className: "bpReset bpHeaderContainer"
    },
    content: {
      container: {
        className: "bpReset bpHeaderContentContainer"
      },
      title: {
        className: "bpHeaderContentTitle"
      },
      description: {
        className: "bpHeaderContentDescription"
      },
      avatar: {
        container: {
          className: "bpReset bpHeaderContentAvatarContainer"
        },
        image: {
          className: "bpHeaderContentAvatarImage"
        },
        fallback: {
          className: "bpHeaderContentAvatarFallback"
        }
      },
      actions: {
        container: {
          className: "bpReset bpHeaderContentActionsContainer"
        },
        icons: {
          className: "bpHeaderContentActionsIcons"
        }
      }
    },
    expandedContent: {
      container: {
        className: "bpReset bpHeaderExpandedContentContainer"
      },
      descriptionItems: {
        container: {
          className: "bpReset bpHeaderExpandedContentDescriptionItemsContainer"
        },
        icon: {
          className: "bpHeaderExpandedContentDescriptionItemsIcon"
        },
        text: {
          className: "bpHeaderExpandedContentDescriptionItemsText"
        },
        link: {
          className: "bpHeaderExpandedContentDescriptionItemsLink"
        }
      },
      group: {
        className: "bpHeaderExpandedContentGroup"
      }
    },
    newConversationIcon: {
      className: "bpHeaderNewConversationIcon"
    }
  },
  composer: {
    container: {
      className: "bpReset bpComposerContainer"
    },
    poweredBy: {
      className: "bpComposerPoweredBy"
    },
    input: {
      className: "bpComposerInput"
    },
    button: {
      container: {
        className: "bpReset bpComposerButtonContainer"
      },
      icon: {
        className: "bpComposerButtonIcon"
      }
    },
    uploadButton: {
      icon: {
        className: "bpComposerUploadButtonIcon"
      },
      container: {
        className: "bpReset bpComposerUploadButtonContainer"
      }
    },
    voiceButton: {
      icon: {
        className: "bpComposerVoiceButtonIcon"
      },
      container: {
        className: "bpReset bpComposerVoiceButtonContainer"
      }
    }
  },
  messageList: {
    scrollDownButton: {
      container: {
        className: "bpReset bpMessageListScrollDownButtonContainer"
      },
      button: {
        className: "bpMessageListScrollDownButtonButton"
      },
      icon: {
        className: "bpMessageListScrollDownButtonIcon"
      }
    },
    container: {
      className: "bpReset bpMessageListContainer"
    },
    viewPort: {
      className: "bpMessageListViewport"
    },
    marquee: {
      container: {
        className: "bpReset bpMessageListMarqueeContainer"
      },
      content: {
        className: "bpMessageListMarqueeContent"
      },
      title: {
        className: "bpMessageListMarqueeTitle"
      },
      description: {
        className: "bpMessageListMarqueeDescription"
      },
      avatar: {
        container: {
          className: "bpReset bpMessageListMarqueeAvatarContainer"
        },
        image: {
          className: "bpMessageListMarqueeAvatarImage"
        },
        fallback: {
          className: "bpMessageListMarqueeAvatarFallback"
        }
      }
    },
    headerMessage: {
      className: "bpMessageListHeaderMessage"
    }
  },
  message: {
    container: {
      className: "bpReset bpMessageContainer"
    },
    avatar: {
      container: {
        className: "bpReset bpMessageAvatarContainer"
      },
      image: {
        className: "bpMessageAvatarImage"
      },
      fallback: {
        className: "bpMessageAvatarFallback"
      }
    },
    blocks: {
      text: {
        heading1: {
          className: "bpMessageBlocksTextHeading1"
        },
        heading2: {
          className: "bpMessageBlocksTextHeading2"
        },
        heading3: {
          className: "bpMessageBlocksTextHeading3"
        },
        unorderedList: {
          className: "bpMessageBlocksTextUnorderedList"
        },
        orderedList: {
          className: "bpMessageBlocksTextOrderedList"
        },
        link: {
          className: "bpMessageBlocksTextLink"
        },
        italic: {
          className: "bpMessageBlocksTextItalic"
        },
        bold: {
          className: "bpMessageBlocksTextBold"
        },
        text: {
          className: "bpMessageBlocksTextText"
        },
        horizontalRule: {
          className: "bpMessageBlocksTextHorizontalRule"
        },
        listItem: {
          className: "bpMessageBlocksTextListItem"
        },
        lineBreak: {
          className: "bpMessageBlocksTextLineBreak"
        },
        pre: {
          className: "bpMessageBlocksTextPre"
        }
      },
      audio: {
        className: "bpMessageBlocksAudio"
      },
      image: {
        image: {
          className: "bpMessageBlocksImageImage"
        },
        placeholder: {
          className: "bpMessageBlocksImagePlaceholder"
        }
      },
      video: {
        className: "bpMessageBlocksVideo"
      },
      location: {
        container: {
          className: "bpMessageBlocksLocationContainer"
        },
        title: {
          className: "bpMessageBlocksLocationTitle"
        },
        icon: {
          className: "bpMessageBlocksLocationIcon"
        }
      },
      file: {
        container: {
          className: "bpMessageBlocksFileContainer"
        },
        title: {
          className: "bpMessageBlocksFileTitle"
        },
        icon: {
          className: "bpMessageBlocksFileIcon"
        }
      },
      row: {
        className: "bpMessageBlocksRow"
      },
      column: {
        className: "bpMessageBlocksColumn"
      },
      bubble: {
        className: "bpMessageBlocksBubble"
      },
      carousel: {
        container: {
          className: "bpMessageBlocksCarouselContainer"
        },
        slidesContainer: {
          className: "bpMessageBlocksCarouselSlidesContainer"
        },
        backButton: {
          className: "bpMessageBlocksCarouselBackButton"
        },
        nextButton: {
          className: "bpMessageBlocksCarouselNextButton"
        }
      },
      dropdown: {
        button: {
          container: {
            className: "bpMessageBlocksDropdownButtonContainer"
          },
          text: {
            className: "bpMessageBlocksDropdownButtonText"
          },
          icon: {
            className: "bpMessageBlocksDropdownButtonIcon"
          }
        },
        content: {
          container: {
            className: "bpMessageBlocksDropdownContentContainer"
          },
          item: {
            className: "bpMessageBlocksDropdownContentItem"
          }
        }
      },
      button: {
        className: "bpMessageBlocksButton"
      }
    }
  },
  typingIndicator: {
    container: {
      className: "bpTypingIndicatorContainer"
    },
    loader: {
      className: "bpTypingIndicatorLoader"
    }
  }
}, Ej = ({ text: e }) => {
  const {
    message: {
      blocks: { text: t }
    }
  } = bt, n = {
    h1: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("h1", { ...i, ...t == null ? void 0 : t.heading1 }),
    h2: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("h2", { ...i, ...t == null ? void 0 : t.heading2 }),
    h3: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("h3", { ...i, ...t == null ? void 0 : t.heading3 }),
    h4: "h3",
    h5: "h3",
    h6: "h3",
    em: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("em", { ...i, ...t == null ? void 0 : t.italic }),
    strong: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("strong", { ...i, ...t == null ? void 0 : t.bold }),
    p: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("p", { ...i, ...t == null ? void 0 : t.text }),
    hr: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("hr", { ...i, ...t == null ? void 0 : t.horizontalRule }),
    a: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("a", { ...i, ...t == null ? void 0 : t.link, target: "_blank" }),
    ol: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("ol", { ...i, ...t == null ? void 0 : t.orderedList }),
    ul: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("ul", { ...i, ...t == null ? void 0 : t.unorderedList }),
    li: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("li", { ...i, ...t == null ? void 0 : t.listItem }),
    br: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("br", { ...i, ...t == null ? void 0 : t.lineBreak }),
    pre: ({ node: r, ...i }) => /* @__PURE__ */ R.jsx("pre", { ...i, ...t == null ? void 0 : t.pre })
  };
  return /* @__PURE__ */ R.jsx(uD, { components: n, remarkPlugins: [_j, gD], children: e });
}, Tj = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API_BASE_URL: "https://api.botpress.dev", VITE_APP_ENVIRONMENT: "development", VITE_CDM_BACKEND_BASE_URL: "https://controller.botpress.dev", VITE_CDM_STUDIO_BASE_URL: "https://studio.botpress.dev", VITE_CDM_STUDIO_LAMBDA_API_URL: "https://studio.botpress.dev/api", VITE_CDN_BASE_URL: "https://cdn.botpress.dev", VITE_DASHBOARD_URL: "https://app.botpress.dev", VITE_GMAIL_CLIENT_ID: "293378330844-okgoo9h35i54bbfsdn7ugp1gslemgdcv.apps.googleusercontent.com", VITE_HITL_BASE_URL: "https://hitl.botpress.dev", VITE_INTERCOM_APP_ID: "bjzkw2xf", VITE_LINEAR_CLIENT_ID: "364cc18b5fd2edc8abc3b7113e6a7908", VITE_MEDIA_BASE_URL: "https://mediafiles.botpress.dev", VITE_NOVU_APP_ID: "ntsZWyVMn70f", VITE_SEGMENT_ANALYTICS_WRITE_KEY: "D179MXTggog75Y83s1DTu9K2wm2o0oZv", VITE_SENTRY_AUTH_TOKEN: "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", VITE_SENTRY_DSN: "https://0d48ba556e5f062ef222bfb81238297c@o363631.ingest.sentry.io/4506277087608832", VITE_SENTRY_ENVIRONMENT: "cloud-staging", VITE_SENTRY_ORG: "botpress-rm'", VITE_SENTRY_PROJECT: "dashboard'", VITE_SSO_BASE_URL: "https://sso.botpress.dev", VITE_STRIPE_COMMUNITY_PLAN_PRODUCT_ID: "prod_P1EgUQxIWbzyUH", VITE_STRIPE_PLUS_PLAN_PRODUCT_ID: "prod_RfykmPLrb7tnmG", VITE_STRIPE_PUBLISHABLE_KEY: "pk_test_51KfofSBcZkr7pv9qUzKQO9IoNS73k1oHvtM0MoYmrkjZ4oFSSKwYE9V1BSEs3vPuYkIU08eDs1HzuIMwIE1uDPlG00FM7R7Lji", VITE_STRIPE_TEAM_PLAN_PRODUCT_ID: "prod_P1EptkEHNmlCxx", VITE_TYPEFORM_ONBOARDING_FORM_ID: "iHO5lmej", VITE_UNLEASH_APP_NAME: "cdm", VITE_UNLEASH_PROXY_CLIENT_KEY: "cdm:development.23c5337748c2fa1433ab463704660120ff4b3430451b3274ab53a909", VITE_UNLEASH_PROXY_URL: "https://unleash.botpress.dev/proxy", VITE_USE_PAT: "false", VITE_WEBCHAT_URL: "https://webchat.botpress.dev", VITE_WEBHOOK_BASE_URL: "https://webhook.botpress.dev" }, Mg = (e) => {
  let t;
  const n = /* @__PURE__ */ new Set(), r = (u, f) => {
    const d = typeof u == "function" ? u(t) : u;
    if (!Object.is(d, t)) {
      const p = t;
      t = f ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), n.forEach((m) => m(t, p));
    }
  }, i = () => t, c = { setState: r, getState: i, getInitialState: () => l, subscribe: (u) => (n.add(u), () => n.delete(u)), destroy: () => {
    (Tj ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, l = t = e(r, i, c);
  return c;
}, kj = (e) => e ? Mg(e) : Mg;
var Kp = { exports: {} }, Df = {}, wl = { exports: {} }, Mf = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jg;
function Oj() {
  if (jg) return Mf;
  jg = 1;
  var e = vt;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, a = e.useLayoutEffect, o = e.useDebugValue;
  function s(f, d) {
    var p = d(), m = r({ inst: { value: p, getSnapshot: d } }), h = m[0].inst, y = m[1];
    return a(function() {
      h.value = p, h.getSnapshot = d, c(h) && y({ inst: h });
    }, [f, p, d]), i(function() {
      return c(h) && y({ inst: h }), f(function() {
        c(h) && y({ inst: h });
      });
    }, [f]), o(p), p;
  }
  function c(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function l(f, d) {
    return d();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? l : s;
  return Mf.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : u, Mf;
}
var jf = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lg;
function Cj() {
  return Lg || (Lg = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = vt, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(b) {
      {
        for (var T = arguments.length, S = new Array(T > 1 ? T - 1 : 0), E = 1; E < T; E++)
          S[E - 1] = arguments[E];
        r("error", b, S);
      }
    }
    function r(b, T, S) {
      {
        var E = t.ReactDebugCurrentFrame, O = E.getStackAddendum();
        O !== "" && (T += "%s", S = S.concat([O]));
        var j = S.map(function(D) {
          return String(D);
        });
        j.unshift("Warning: " + T), Function.prototype.apply.call(console[b], console, j);
      }
    }
    function i(b, T) {
      return b === T && (b !== 0 || 1 / b === 1 / T) || b !== b && T !== T;
    }
    var a = typeof Object.is == "function" ? Object.is : i, o = e.useState, s = e.useEffect, c = e.useLayoutEffect, l = e.useDebugValue, u = !1, f = !1;
    function d(b, T, S) {
      u || e.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var E = T();
      if (!f) {
        var O = T();
        a(E, O) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var j = o({
        inst: {
          value: E,
          getSnapshot: T
        }
      }), D = j[0].inst, k = j[1];
      return c(function() {
        D.value = E, D.getSnapshot = T, p(D) && k({
          inst: D
        });
      }, [b, E, T]), s(function() {
        p(D) && k({
          inst: D
        });
        var A = function() {
          p(D) && k({
            inst: D
          });
        };
        return b(A);
      }, [b]), l(E), E;
    }
    function p(b) {
      var T = b.getSnapshot, S = b.value;
      try {
        var E = T();
        return !a(S, E);
      } catch {
        return !0;
      }
    }
    function m(b, T, S) {
      return T();
    }
    var h = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y = !h, v = y ? m : d, g = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : v;
    jf.useSyncExternalStore = g, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), jf;
}
var Fg;
function r_() {
  return Fg || (Fg = 1, process.env.NODE_ENV === "production" ? wl.exports = Oj() : wl.exports = Cj()), wl.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bg;
function Rj() {
  if (Bg) return Df;
  Bg = 1;
  var e = vt, t = r_();
  function n(l, u) {
    return l === u && (l !== 0 || 1 / l === 1 / u) || l !== l && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, a = e.useRef, o = e.useEffect, s = e.useMemo, c = e.useDebugValue;
  return Df.useSyncExternalStoreWithSelector = function(l, u, f, d, p) {
    var m = a(null);
    if (m.current === null) {
      var h = { hasValue: !1, value: null };
      m.current = h;
    } else h = m.current;
    m = s(function() {
      function v(E) {
        if (!g) {
          if (g = !0, b = E, E = d(E), p !== void 0 && h.hasValue) {
            var O = h.value;
            if (p(O, E)) return T = O;
          }
          return T = E;
        }
        if (O = T, r(b, E)) return O;
        var j = d(E);
        return p !== void 0 && p(O, j) ? O : (b = E, T = j);
      }
      var g = !1, b, T, S = f === void 0 ? null : f;
      return [function() {
        return v(u());
      }, S === null ? void 0 : function() {
        return v(S());
      }];
    }, [u, f, d, p]);
    var y = i(l, m[0], m[1]);
    return o(function() {
      h.hasValue = !0, h.value = y;
    }, [y]), c(y), y;
  }, Df;
}
var Lf = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ug;
function $j() {
  return Ug || (Ug = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = vt, t = r_();
    function n(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, a = e.useRef, o = e.useEffect, s = e.useMemo, c = e.useDebugValue;
    function l(u, f, d, p, m) {
      var h = a(null), y;
      h.current === null ? (y = {
        hasValue: !1,
        value: null
      }, h.current = y) : y = h.current;
      var v = s(function() {
        var S = !1, E, O, j = function(V) {
          if (!S) {
            S = !0, E = V;
            var $ = p(V);
            if (m !== void 0 && y.hasValue) {
              var L = y.value;
              if (m(L, $))
                return O = L, L;
            }
            return O = $, $;
          }
          var M = E, F = O;
          if (r(M, V))
            return F;
          var q = p(V);
          return m !== void 0 && m(F, q) ? F : (E = V, O = q, q);
        }, D = d === void 0 ? null : d, k = function() {
          return j(f());
        }, A = D === null ? void 0 : function() {
          return j(D());
        };
        return [k, A];
      }, [f, d, p, m]), g = v[0], b = v[1], T = i(u, g, b);
      return o(function() {
        y.hasValue = !0, y.value = T;
      }, [T]), c(T), T;
    }
    Lf.useSyncExternalStoreWithSelector = l, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Lf;
}
process.env.NODE_ENV === "production" ? Kp.exports = Rj() : Kp.exports = $j();
var Ij = Kp.exports;
const Aj = /* @__PURE__ */ Ke(Ij), i_ = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API_BASE_URL: "https://api.botpress.dev", VITE_APP_ENVIRONMENT: "development", VITE_CDM_BACKEND_BASE_URL: "https://controller.botpress.dev", VITE_CDM_STUDIO_BASE_URL: "https://studio.botpress.dev", VITE_CDM_STUDIO_LAMBDA_API_URL: "https://studio.botpress.dev/api", VITE_CDN_BASE_URL: "https://cdn.botpress.dev", VITE_DASHBOARD_URL: "https://app.botpress.dev", VITE_GMAIL_CLIENT_ID: "293378330844-okgoo9h35i54bbfsdn7ugp1gslemgdcv.apps.googleusercontent.com", VITE_HITL_BASE_URL: "https://hitl.botpress.dev", VITE_INTERCOM_APP_ID: "bjzkw2xf", VITE_LINEAR_CLIENT_ID: "364cc18b5fd2edc8abc3b7113e6a7908", VITE_MEDIA_BASE_URL: "https://mediafiles.botpress.dev", VITE_NOVU_APP_ID: "ntsZWyVMn70f", VITE_SEGMENT_ANALYTICS_WRITE_KEY: "D179MXTggog75Y83s1DTu9K2wm2o0oZv", VITE_SENTRY_AUTH_TOKEN: "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", VITE_SENTRY_DSN: "https://0d48ba556e5f062ef222bfb81238297c@o363631.ingest.sentry.io/4506277087608832", VITE_SENTRY_ENVIRONMENT: "cloud-staging", VITE_SENTRY_ORG: "botpress-rm'", VITE_SENTRY_PROJECT: "dashboard'", VITE_SSO_BASE_URL: "https://sso.botpress.dev", VITE_STRIPE_COMMUNITY_PLAN_PRODUCT_ID: "prod_P1EgUQxIWbzyUH", VITE_STRIPE_PLUS_PLAN_PRODUCT_ID: "prod_RfykmPLrb7tnmG", VITE_STRIPE_PUBLISHABLE_KEY: "pk_test_51KfofSBcZkr7pv9qUzKQO9IoNS73k1oHvtM0MoYmrkjZ4oFSSKwYE9V1BSEs3vPuYkIU08eDs1HzuIMwIE1uDPlG00FM7R7Lji", VITE_STRIPE_TEAM_PLAN_PRODUCT_ID: "prod_P1EptkEHNmlCxx", VITE_TYPEFORM_ONBOARDING_FORM_ID: "iHO5lmej", VITE_UNLEASH_APP_NAME: "cdm", VITE_UNLEASH_PROXY_CLIENT_KEY: "cdm:development.23c5337748c2fa1433ab463704660120ff4b3430451b3274ab53a909", VITE_UNLEASH_PROXY_URL: "https://unleash.botpress.dev/proxy", VITE_USE_PAT: "false", VITE_WEBCHAT_URL: "https://webchat.botpress.dev", VITE_WEBHOOK_BASE_URL: "https://webhook.botpress.dev" }, { useDebugValue: Pj } = vt, { useSyncExternalStoreWithSelector: Nj } = Aj;
let zg = !1;
const Dj = (e) => e;
function Mj(e, t = Dj, n) {
  (i_ ? "production" : void 0) !== "production" && n && !zg && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), zg = !0);
  const r = Nj(
    e.subscribe,
    e.getState,
    e.getServerState || e.getInitialState,
    t,
    n
  );
  return Pj(r), r;
}
const jj = (e) => {
  (i_ ? "production" : void 0) !== "production" && typeof e != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const t = typeof e == "function" ? kj(e) : e, n = (r, i) => Mj(t, r, i);
  return Object.assign(n, t), n;
}, Ls = (e) => jj, Ql = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_API_BASE_URL: "https://api.botpress.dev", VITE_APP_ENVIRONMENT: "development", VITE_CDM_BACKEND_BASE_URL: "https://controller.botpress.dev", VITE_CDM_STUDIO_BASE_URL: "https://studio.botpress.dev", VITE_CDM_STUDIO_LAMBDA_API_URL: "https://studio.botpress.dev/api", VITE_CDN_BASE_URL: "https://cdn.botpress.dev", VITE_DASHBOARD_URL: "https://app.botpress.dev", VITE_GMAIL_CLIENT_ID: "293378330844-okgoo9h35i54bbfsdn7ugp1gslemgdcv.apps.googleusercontent.com", VITE_HITL_BASE_URL: "https://hitl.botpress.dev", VITE_INTERCOM_APP_ID: "bjzkw2xf", VITE_LINEAR_CLIENT_ID: "364cc18b5fd2edc8abc3b7113e6a7908", VITE_MEDIA_BASE_URL: "https://mediafiles.botpress.dev", VITE_NOVU_APP_ID: "ntsZWyVMn70f", VITE_SEGMENT_ANALYTICS_WRITE_KEY: "D179MXTggog75Y83s1DTu9K2wm2o0oZv", VITE_SENTRY_AUTH_TOKEN: "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", VITE_SENTRY_DSN: "https://0d48ba556e5f062ef222bfb81238297c@o363631.ingest.sentry.io/4506277087608832", VITE_SENTRY_ENVIRONMENT: "cloud-staging", VITE_SENTRY_ORG: "botpress-rm'", VITE_SENTRY_PROJECT: "dashboard'", VITE_SSO_BASE_URL: "https://sso.botpress.dev", VITE_STRIPE_COMMUNITY_PLAN_PRODUCT_ID: "prod_P1EgUQxIWbzyUH", VITE_STRIPE_PLUS_PLAN_PRODUCT_ID: "prod_RfykmPLrb7tnmG", VITE_STRIPE_PUBLISHABLE_KEY: "pk_test_51KfofSBcZkr7pv9qUzKQO9IoNS73k1oHvtM0MoYmrkjZ4oFSSKwYE9V1BSEs3vPuYkIU08eDs1HzuIMwIE1uDPlG00FM7R7Lji", VITE_STRIPE_TEAM_PLAN_PRODUCT_ID: "prod_P1EptkEHNmlCxx", VITE_TYPEFORM_ONBOARDING_FORM_ID: "iHO5lmej", VITE_UNLEASH_APP_NAME: "cdm", VITE_UNLEASH_PROXY_CLIENT_KEY: "cdm:development.23c5337748c2fa1433ab463704660120ff4b3430451b3274ab53a909", VITE_UNLEASH_PROXY_URL: "https://unleash.botpress.dev/proxy", VITE_USE_PAT: "false", VITE_WEBCHAT_URL: "https://webchat.botpress.dev", VITE_WEBHOOK_BASE_URL: "https://webhook.botpress.dev" }, Gp = /* @__PURE__ */ new Map(), Sl = (e) => {
  const t = Gp.get(e);
  return t ? Object.fromEntries(
    Object.entries(t.stores).map(([n, r]) => [n, r.getState()])
  ) : {};
}, Lj = (e, t, n) => {
  if (e === void 0)
    return {
      type: "untracked",
      connection: t.connect(n)
    };
  const r = Gp.get(n.name);
  if (r)
    return { type: "tracked", store: e, ...r };
  const i = {
    connection: t.connect(n),
    stores: {}
  };
  return Gp.set(n.name, i), { type: "tracked", store: e, ...i };
}, Fj = (e, t = {}) => (n, r, i) => {
  const { enabled: a, anonymousActionType: o, store: s, ...c } = t;
  let l;
  try {
    l = (a ?? (Ql ? "production" : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
  } catch {
  }
  if (!l)
    return (Ql ? "production" : void 0) !== "production" && a && console.warn(
      "[zustand devtools middleware] Please install/enable Redux devtools extension"
    ), e(n, r, i);
  const { connection: u, ...f } = Lj(s, l, c);
  let d = !0;
  i.setState = (h, y, v) => {
    const g = n(h, y);
    if (!d) return g;
    const b = v === void 0 ? { type: o || "anonymous" } : typeof v == "string" ? { type: v } : v;
    return s === void 0 ? (u == null || u.send(b, r()), g) : (u == null || u.send(
      {
        ...b,
        type: `${s}/${b.type}`
      },
      {
        ...Sl(c.name),
        [s]: i.getState()
      }
    ), g);
  };
  const p = (...h) => {
    const y = d;
    d = !1, n(...h), d = y;
  }, m = e(i.setState, r, i);
  if (f.type === "untracked" ? u == null || u.init(m) : (f.stores[f.store] = i, u == null || u.init(
    Object.fromEntries(
      Object.entries(f.stores).map(([h, y]) => [
        h,
        h === f.store ? m : y.getState()
      ])
    )
  )), i.dispatchFromDevtools && typeof i.dispatch == "function") {
    let h = !1;
    const y = i.dispatch;
    i.dispatch = (...v) => {
      (Ql ? "production" : void 0) !== "production" && v[0].type === "__setState" && !h && (console.warn(
        '[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.'
      ), h = !0), y(...v);
    };
  }
  return u.subscribe((h) => {
    var y;
    switch (h.type) {
      case "ACTION":
        if (typeof h.payload != "string") {
          console.error(
            "[zustand devtools middleware] Unsupported action format"
          );
          return;
        }
        return Ff(
          h.payload,
          (v) => {
            if (v.type === "__setState") {
              if (s === void 0) {
                p(v.state);
                return;
              }
              Object.keys(v.state).length !== 1 && console.error(
                `
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `
              );
              const g = v.state[s];
              if (g == null)
                return;
              JSON.stringify(i.getState()) !== JSON.stringify(g) && p(g);
              return;
            }
            i.dispatchFromDevtools && typeof i.dispatch == "function" && i.dispatch(v);
          }
        );
      case "DISPATCH":
        switch (h.payload.type) {
          case "RESET":
            return p(m), s === void 0 ? u == null ? void 0 : u.init(i.getState()) : u == null ? void 0 : u.init(Sl(c.name));
          case "COMMIT":
            if (s === void 0) {
              u == null || u.init(i.getState());
              return;
            }
            return u == null ? void 0 : u.init(Sl(c.name));
          case "ROLLBACK":
            return Ff(h.state, (v) => {
              if (s === void 0) {
                p(v), u == null || u.init(i.getState());
                return;
              }
              p(v[s]), u == null || u.init(Sl(c.name));
            });
          case "JUMP_TO_STATE":
          case "JUMP_TO_ACTION":
            return Ff(h.state, (v) => {
              if (s === void 0) {
                p(v);
                return;
              }
              JSON.stringify(i.getState()) !== JSON.stringify(v[s]) && p(v[s]);
            });
          case "IMPORT_STATE": {
            const { nextLiftedState: v } = h.payload, g = (y = v.computedStates.slice(-1)[0]) == null ? void 0 : y.state;
            if (!g) return;
            p(s === void 0 ? g : g[s]), u == null || u.send(
              null,
              // FIXME no-any
              v
            );
            return;
          }
          case "PAUSE_RECORDING":
            return d = !d;
        }
        return;
    }
  }), m;
}, Eu = Fj, Ff = (e, t) => {
  let n;
  try {
    n = JSON.parse(e);
  } catch (r) {
    console.error(
      "[zustand devtools middleware] Could not parse the received json",
      r
    );
  }
  n !== void 0 && t(n);
};
function Bj(e, t) {
  let n;
  try {
    n = e();
  } catch {
    return;
  }
  return {
    getItem: (i) => {
      var a;
      const o = (c) => c === null ? null : JSON.parse(c, void 0), s = (a = n.getItem(i)) != null ? a : null;
      return s instanceof Promise ? s.then(o) : o(s);
    },
    setItem: (i, a) => n.setItem(
      i,
      JSON.stringify(a, void 0)
    ),
    removeItem: (i) => n.removeItem(i)
  };
}
const as = (e) => (t) => {
  try {
    const n = e(t);
    return n instanceof Promise ? n : {
      then(r) {
        return as(r)(n);
      },
      catch(r) {
        return this;
      }
    };
  } catch (n) {
    return {
      then(r) {
        return this;
      },
      catch(r) {
        return as(r)(n);
      }
    };
  }
}, Uj = (e, t) => (n, r, i) => {
  let a = {
    getStorage: () => localStorage,
    serialize: JSON.stringify,
    deserialize: JSON.parse,
    partialize: (y) => y,
    version: 0,
    merge: (y, v) => ({
      ...v,
      ...y
    }),
    ...t
  }, o = !1;
  const s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let l;
  try {
    l = a.getStorage();
  } catch {
  }
  if (!l)
    return e(
      (...y) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`
        ), n(...y);
      },
      r,
      i
    );
  const u = as(a.serialize), f = () => {
    const y = a.partialize({ ...r() });
    let v;
    const g = u({ state: y, version: a.version }).then(
      (b) => l.setItem(a.name, b)
    ).catch((b) => {
      v = b;
    });
    if (v)
      throw v;
    return g;
  }, d = i.setState;
  i.setState = (y, v) => {
    d(y, v), f();
  };
  const p = e(
    (...y) => {
      n(...y), f();
    },
    r,
    i
  );
  let m;
  const h = () => {
    var y;
    if (!l) return;
    o = !1, s.forEach((g) => g(r()));
    const v = ((y = a.onRehydrateStorage) == null ? void 0 : y.call(a, r())) || void 0;
    return as(l.getItem.bind(l))(a.name).then((g) => {
      if (g)
        return a.deserialize(g);
    }).then((g) => {
      if (g)
        if (typeof g.version == "number" && g.version !== a.version) {
          if (a.migrate)
            return a.migrate(
              g.state,
              g.version
            );
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return g.state;
    }).then((g) => {
      var b;
      return m = a.merge(
        g,
        (b = r()) != null ? b : p
      ), n(m, !0), f();
    }).then(() => {
      v == null || v(m, void 0), o = !0, c.forEach((g) => g(m));
    }).catch((g) => {
      v == null || v(void 0, g);
    });
  };
  return i.persist = {
    setOptions: (y) => {
      a = {
        ...a,
        ...y
      }, y.getStorage && (l = y.getStorage());
    },
    clearStorage: () => {
      l == null || l.removeItem(a.name);
    },
    getOptions: () => a,
    rehydrate: () => h(),
    hasHydrated: () => o,
    onHydrate: (y) => (s.add(y), () => {
      s.delete(y);
    }),
    onFinishHydration: (y) => (c.add(y), () => {
      c.delete(y);
    })
  }, h(), m || p;
}, zj = (e, t) => (n, r, i) => {
  let a = {
    storage: Bj(() => localStorage),
    partialize: (h) => h,
    version: 0,
    merge: (h, y) => ({
      ...y,
      ...h
    }),
    ...t
  }, o = !1;
  const s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set();
  let l = a.storage;
  if (!l)
    return e(
      (...h) => {
        console.warn(
          `[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`
        ), n(...h);
      },
      r,
      i
    );
  const u = () => {
    const h = a.partialize({ ...r() });
    return l.setItem(a.name, {
      state: h,
      version: a.version
    });
  }, f = i.setState;
  i.setState = (h, y) => {
    f(h, y), u();
  };
  const d = e(
    (...h) => {
      n(...h), u();
    },
    r,
    i
  );
  i.getInitialState = () => d;
  let p;
  const m = () => {
    var h, y;
    if (!l) return;
    o = !1, s.forEach((g) => {
      var b;
      return g((b = r()) != null ? b : d);
    });
    const v = ((y = a.onRehydrateStorage) == null ? void 0 : y.call(a, (h = r()) != null ? h : d)) || void 0;
    return as(l.getItem.bind(l))(a.name).then((g) => {
      if (g)
        if (typeof g.version == "number" && g.version !== a.version) {
          if (a.migrate)
            return [
              !0,
              a.migrate(
                g.state,
                g.version
              )
            ];
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, g.state];
      return [!1, void 0];
    }).then((g) => {
      var b;
      const [T, S] = g;
      if (p = a.merge(
        S,
        (b = r()) != null ? b : d
      ), n(p, !0), T)
        return u();
    }).then(() => {
      v == null || v(p, void 0), p = r(), o = !0, c.forEach((g) => g(p));
    }).catch((g) => {
      v == null || v(void 0, g);
    });
  };
  return i.persist = {
    setOptions: (h) => {
      a = {
        ...a,
        ...h
      }, h.storage && (l = h.storage);
    },
    clearStorage: () => {
      l == null || l.removeItem(a.name);
    },
    getOptions: () => a,
    rehydrate: () => m(),
    hasHydrated: () => o,
    onHydrate: (h) => (s.add(h), () => {
      s.delete(h);
    }),
    onFinishHydration: (h) => (c.add(h), () => {
      c.delete(h);
    })
  }, a.skipHydration || m(), p || d;
}, Vj = (e, t) => "getStorage" in t || "serialize" in t || "deserialize" in t ? ((Ql ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead."
), Uj(e, t)) : zj(e, t), a_ = Vj, Vg = Ls()(
  Eu(
    a_(
      (e) => ({
        messageHistory: [],
        addMessageToHistory: (t) => e((n) => ({
          ...n,
          messageHistory: [t, ...(n.messageHistory ?? []).slice(0, 100)]
        }))
      }),
      {
        name: "botpress-message-history"
        // Dynamically set the store name
      }
    )
  )
), wo = Ls()(
  Eu(
    (e) => ({
      messages: [],
      isFetching: !1,
      setMessages: (t) => e({ messages: t }),
      addMessage: (t) => e(({ messages: n }) => {
        var i;
        const r = (i = t.metadata) == null ? void 0 : i.clientMessageId;
        if (r) {
          const a = n.findIndex((o) => {
            var s;
            return ((s = o.metadata) == null ? void 0 : s.clientMessageId) === r;
          });
          if (a !== -1)
            return {
              messages: [...n.slice(0, a), t, ...n.slice(a + 1)]
            };
        }
        return { messages: [...n.filter((a) => a.id !== t.id), t] };
      }),
      updateMessage: (t, n) => e(({ messages: r }) => ({
        messages: r.map((i) => i.id === t ? { ...i, ...n } : i)
      })),
      clearMessages: () => e({ messages: [] }),
      fetchMessages: async ({ client: t, userKey: n, conversationId: r }) => {
        const i = [];
        e({ isFetching: !0 });
        let a;
        do {
          const o = await t.listConversationMessages({ id: r, "x-user-key": n, nextToken: a });
          i.push(...o.messages), a = o.meta.nextToken;
        } while (a);
        return e({ isFetching: !1 }), i.reverse();
      }
    }),
    { name: "messagesStore" }
  )
), Hj = (e) => Ls()(
  Eu(
    a_(
      (t) => ({
        setUser: (n) => t((r) => ({
          ...r,
          user: n
        })),
        setConversationId: (n) => t((r) => ({
          ...r,
          conversationId: n
        })),
        clearAll: () => {
          t((n) => ({
            ...n,
            messageHistory: {},
            user: void 0,
            conversationId: void 0
          }));
        }
      }),
      {
        name: e
        // Dynamically set the store name
      }
    )
  )
), Ea = class Ea {
  constructor() {
  }
  static getInstance(t = "bp-webchat") {
    return Ea._instances[t] || (Ea._instances[t] = Hj(t)), Ea._instances[t];
  }
};
Se(Ea, "_instances", {});
let Yp = Ea;
const qj = Yp.getInstance, Rm = Ls()(
  Eu(
    (e) => ({
      eventEmitter: _R,
      messageContainerRef: { current: null },
      setMessageContainerRef: (t) => e({ messageContainerRef: t })
    }),
    { name: "webchatStore" }
  )
), Wj = ({ text: e, buttonValue: t, variant: n, groupId: r, reusable: i, sendMessage: a, isReadOnly: o, ...s }) => {
  const c = Rm((v) => v.eventEmitter), [l, u] = rt(!1), [f, d] = rt(!1), [p, m] = rt(!1), {
    message: {
      blocks: { button: h }
    }
  } = bt;
  Ht(() => {
    if (r)
      return c.on(`button-group-${r}-click`, () => {
        d(!0), i || m(!0);
      });
  }, [c, r, i]);
  function y() {
    r && c.emit(`button-group-${r}-click`), u(!0), i || m(!0), n !== "link" && (a == null || a({ type: "text", text: t }));
  }
  return /* @__PURE__ */ R.jsx(
    Zj,
    {
      ...s,
      variant: n,
      onClick: y,
      disabled: p || o,
      "data-activated": l ? "" : void 0,
      "data-group-activated": f ? "" : void 0,
      "data-type": n,
      value: t,
      ...h,
      children: e
    }
  );
}, Zj = (e) => {
  if (e.variant === "link") {
    const { value: r, variant: i, ...a } = e;
    return /* @__PURE__ */ R.jsx("a", { ...a, href: r, target: "_blank", rel: "noopener noreferrer" });
  }
  const { variant: t, ...n } = e;
  return /* @__PURE__ */ R.jsx("button", { type: "button", ...n });
}, o_ = In(
  ({ block: e, direction: t, timestamp: n, sender: r, metadata: i, sendMessage: a, messageId: o, ...s }, c) => {
    const {
      message: {
        blocks: { bubble: l }
      }
    } = bt;
    return /* @__PURE__ */ R.jsx("div", { "data-direction": t, ...s, ...l, ref: c, children: /* @__PURE__ */ R.jsx(
      qs,
      {
        block: { ...e, direction: t, timestamp: n, sender: r, messageId: o, sendMessage: a },
        direction: t,
        timestamp: n,
        sender: r,
        metadata: i,
        sendMessage: a,
        messageId: o
      }
    ) });
  }
);
o_.displayName = "Bubble";
const s_ = h1(null);
function Kj() {
  const e = Xa(s_);
  if (!e)
    throw new Error("useMessageContext must be used within a Message");
  return e;
}
const l_ = h1(null);
function c_() {
  const e = Xa(l_);
  if (!e)
    throw new Error("useModalContext must be used within a ModalProvider");
  return e;
}
const Gj = (e, t = {}) => new Promise((n, r) => {
  if (typeof window > "u")
    return r("Window is not defined");
  if (!e)
    return r("Url is not defined");
  let i = null;
  const a = new Image();
  a.addEventListener("load", () => {
    i && clearTimeout(i), n({ width: a.naturalWidth, height: a.naturalHeight });
  }), a.addEventListener("error", (o) => {
    i && clearTimeout(i), r(`${o.type}: ${o.message}`);
  }), a.src = e, t.timeout && (i = setTimeout(() => r("Timeout"), t.timeout));
});
let Yj = { data: "" }, Jj = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || Yj, Xj = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Qj = /\/\*[^]*?\*\/|  +/g, Hg = /\n+/g, ai = (e, t) => {
  let n = "", r = "", i = "";
  for (let a in e) {
    let o = e[a];
    a[0] == "@" ? a[1] == "i" ? n = a + " " + o + ";" : r += a[1] == "f" ? ai(o, a) : a + "{" + ai(o, a[1] == "k" ? "" : t) + "}" : typeof o == "object" ? r += ai(o, t ? t.replace(/([^,])+/g, (s) => a.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (c) => /&/.test(c) ? c.replace(/&/g, s) : s ? s + " " + c : c)) : a) : o != null && (a = /^--/.test(a) ? a : a.replace(/[A-Z]/g, "-$&").toLowerCase(), i += ai.p ? ai.p(a, o) : a + ":" + o + ";");
  }
  return n + (t && i ? t + "{" + i + "}" : i) + r;
}, Mr = {}, u_ = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let n in e) t += n + u_(e[n]);
    return t;
  }
  return e;
}, e2 = (e, t, n, r, i) => {
  let a = u_(e), o = Mr[a] || (Mr[a] = ((c) => {
    let l = 0, u = 11;
    for (; l < c.length; ) u = 101 * u + c.charCodeAt(l++) >>> 0;
    return "go" + u;
  })(a));
  if (!Mr[o]) {
    let c = a !== e ? e : ((l) => {
      let u, f, d = [{}];
      for (; u = Xj.exec(l.replace(Qj, "")); ) u[4] ? d.shift() : u[3] ? (f = u[3].replace(Hg, " ").trim(), d.unshift(d[0][f] = d[0][f] || {})) : d[0][u[1]] = u[2].replace(Hg, " ").trim();
      return d[0];
    })(e);
    Mr[o] = ai(i ? { ["@keyframes " + o]: c } : c, n ? "" : "." + o);
  }
  let s = n && Mr.g ? Mr.g : null;
  return n && (Mr.g = Mr[o]), ((c, l, u, f) => {
    f ? l.data = l.data.replace(f, c) : l.data.indexOf(c) === -1 && (l.data = u ? c + l.data : l.data + c);
  })(Mr[o], t, r, s), o;
}, t2 = (e, t, n) => e.reduce((r, i, a) => {
  let o = t[a];
  if (o && o.call) {
    let s = o(n), c = s && s.props && s.props.className || /^go/.test(s) && s;
    o = c ? "." + c : s && typeof s == "object" ? s.props ? "" : ai(s, "") : s === !1 ? "" : s;
  }
  return r + i + (o ?? "");
}, "");
function Tu(e) {
  let t = this || {}, n = e.call ? e(t.p) : e;
  return e2(n.unshift ? n.raw ? t2(n, [].slice.call(arguments, 1), t.p) : n.reduce((r, i) => Object.assign(r, i && i.call ? i(t.p) : i), {}) : n, Jj(t.target), t.g, t.o, t.k);
}
let f_, Jp, Xp;
Tu.bind({ g: 1 });
let Hr = Tu.bind({ k: 1 });
function n2(e, t, n, r) {
  ai.p = t, f_ = e, Jp = n, Xp = r;
}
function Ti(e, t) {
  let n = this || {};
  return function() {
    let r = arguments;
    function i(a, o) {
      let s = Object.assign({}, a), c = s.className || i.className;
      n.p = Object.assign({ theme: Jp && Jp() }, s), n.o = / *go\d+/.test(c), s.className = Tu.apply(n, r) + (c ? " " + c : "");
      let l = e;
      return e[0] && (l = s.as || e, delete s.as), Xp && l[0] && Xp(s), f_(l, s);
    }
    return i;
  };
}
var r2 = (e) => typeof e == "function", jc = (e, t) => r2(e) ? e(t) : e, i2 = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), d_ = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), a2 = 20, ec = /* @__PURE__ */ new Map(), o2 = 1e3, qg = (e) => {
  if (ec.has(e)) return;
  let t = setTimeout(() => {
    ec.delete(e), Ji({ type: 4, toastId: e });
  }, o2);
  ec.set(e, t);
}, s2 = (e) => {
  let t = ec.get(e);
  t && clearTimeout(t);
}, Qp = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, a2) };
    case 1:
      return t.toast.id && s2(t.toast.id), { ...e, toasts: e.toasts.map((a) => a.id === t.toast.id ? { ...a, ...t.toast } : a) };
    case 2:
      let { toast: n } = t;
      return e.toasts.find((a) => a.id === n.id) ? Qp(e, { type: 1, toast: n }) : Qp(e, { type: 0, toast: n });
    case 3:
      let { toastId: r } = t;
      return r ? qg(r) : e.toasts.forEach((a) => {
        qg(a.id);
      }), { ...e, toasts: e.toasts.map((a) => a.id === r || r === void 0 ? { ...a, visible: !1 } : a) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((a) => a.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let i = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((a) => ({ ...a, pauseDuration: a.pauseDuration + i })) };
  }
}, tc = [], nc = { toasts: [], pausedAt: void 0 }, Ji = (e) => {
  nc = Qp(nc, e), tc.forEach((t) => {
    t(nc);
  });
}, l2 = { blank: 4e3, error: 4e3, success: 2e3, loading: 1 / 0, custom: 4e3 }, c2 = (e = {}) => {
  let [t, n] = rt(nc);
  Ht(() => (tc.push(n), () => {
    let i = tc.indexOf(n);
    i > -1 && tc.splice(i, 1);
  }), [t]);
  let r = t.toasts.map((i) => {
    var a, o;
    return { ...e, ...e[i.type], ...i, duration: i.duration || ((a = e[i.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || l2[i.type], style: { ...e.style, ...(o = e[i.type]) == null ? void 0 : o.style, ...i.style } };
  });
  return { ...t, toasts: r };
}, u2 = (e, t = "blank", n) => ({ createdAt: Date.now(), visible: !0, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...n, id: (n == null ? void 0 : n.id) || i2() }), Fs = (e) => (t, n) => {
  let r = u2(t, e, n);
  return Ji({ type: 2, toast: r }), r.id;
}, Bn = (e, t) => Fs("blank")(e, t);
Bn.error = Fs("error");
Bn.success = Fs("success");
Bn.loading = Fs("loading");
Bn.custom = Fs("custom");
Bn.dismiss = (e) => {
  Ji({ type: 3, toastId: e });
};
Bn.remove = (e) => Ji({ type: 4, toastId: e });
Bn.promise = (e, t, n) => {
  let r = Bn.loading(t.loading, { ...n, ...n == null ? void 0 : n.loading });
  return e.then((i) => (Bn.success(jc(t.success, i), { id: r, ...n, ...n == null ? void 0 : n.success }), i)).catch((i) => {
    Bn.error(jc(t.error, i), { id: r, ...n, ...n == null ? void 0 : n.error });
  }), e;
};
var f2 = (e, t) => {
  Ji({ type: 1, toast: { id: e, height: t } });
}, d2 = () => {
  Ji({ type: 5, time: Date.now() });
}, p2 = (e) => {
  let { toasts: t, pausedAt: n } = c2(e);
  Ht(() => {
    if (n) return;
    let a = Date.now(), o = t.map((s) => {
      if (s.duration === 1 / 0) return;
      let c = (s.duration || 0) + s.pauseDuration - (a - s.createdAt);
      if (c < 0) {
        s.visible && Bn.dismiss(s.id);
        return;
      }
      return setTimeout(() => Bn.dismiss(s.id), c);
    });
    return () => {
      o.forEach((s) => s && clearTimeout(s));
    };
  }, [t, n]);
  let r = kt(() => {
    n && Ji({ type: 6, time: Date.now() });
  }, [n]), i = kt((a, o) => {
    let { reverseOrder: s = !1, gutter: c = 8, defaultPosition: l } = o || {}, u = t.filter((p) => (p.position || l) === (a.position || l) && p.height), f = u.findIndex((p) => p.id === a.id), d = u.filter((p, m) => m < f && p.visible).length;
    return u.filter((p) => p.visible).slice(...s ? [d + 1] : [0, d]).reduce((p, m) => p + (m.height || 0) + c, 0);
  }, [t]);
  return { toasts: t, handlers: { updateHeight: f2, startPause: d2, endPause: r, calculateOffset: i } };
}, h2 = Hr`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, m2 = Hr`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, v2 = Hr`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, y2 = Ti("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${h2} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${m2} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${v2} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, g2 = Hr`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, b2 = Ti("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${g2} 1s linear infinite;
`, x2 = Hr`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, w2 = Hr`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, S2 = Ti("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${x2} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${w2} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, _2 = Ti("div")`
  position: absolute;
`, E2 = Ti("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, T2 = Hr`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, k2 = Ti("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${T2} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, O2 = ({ toast: e }) => {
  let { icon: t, type: n, iconTheme: r } = e;
  return t !== void 0 ? typeof t == "string" ? w.createElement(k2, null, t) : t : n === "blank" ? null : w.createElement(E2, null, w.createElement(b2, { ...r }), n !== "loading" && w.createElement(_2, null, n === "error" ? w.createElement(y2, { ...r }) : w.createElement(S2, { ...r })));
}, C2 = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, R2 = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $2 = "0%{opacity:0;} 100%{opacity:1;}", I2 = "0%{opacity:1;} 100%{opacity:0;}", A2 = Ti("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, P2 = Ti("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, N2 = (e, t) => {
  let n = e.includes("top") ? 1 : -1, [r, i] = d_() ? [$2, I2] : [C2(n), R2(n)];
  return { animation: t ? `${Hr(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${Hr(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
}, D2 = w.memo(({ toast: e, position: t, style: n, children: r }) => {
  let i = e.height ? N2(e.position || t || "top-center", e.visible) : { opacity: 0 }, a = w.createElement(O2, { toast: e }), o = w.createElement(P2, { ...e.ariaProps }, jc(e.message, e));
  return w.createElement(A2, { className: e.className, style: { ...i, ...n, ...e.style } }, typeof r == "function" ? r({ icon: a, message: o }) : w.createElement(w.Fragment, null, a, o));
});
n2(w.createElement);
var M2 = ({ id: e, className: t, style: n, onHeightUpdate: r, children: i }) => {
  let a = w.useCallback((o) => {
    if (o) {
      let s = () => {
        let c = o.getBoundingClientRect().height;
        r(e, c);
      };
      s(), new MutationObserver(s).observe(o, { subtree: !0, childList: !0, characterData: !0 });
    }
  }, [e, r]);
  return w.createElement("div", { ref: a, className: t, style: n }, i);
}, j2 = (e, t) => {
  let n = e.includes("top"), r = n ? { top: 0 } : { bottom: 0 }, i = e.includes("center") ? { justifyContent: "center" } : e.includes("right") ? { justifyContent: "flex-end" } : {};
  return { left: 0, right: 0, display: "flex", position: "absolute", transition: d_() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)", transform: `translateY(${t * (n ? 1 : -1)}px)`, ...r, ...i };
}, L2 = Tu`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, _l = 16, F2 = ({ reverseOrder: e, position: t = "top-center", toastOptions: n, gutter: r, children: i, containerStyle: a, containerClassName: o }) => {
  let { toasts: s, handlers: c } = p2(n);
  return w.createElement("div", { style: { position: "fixed", zIndex: 9999, top: _l, left: _l, right: _l, bottom: _l, pointerEvents: "none", ...a }, className: o, onMouseEnter: c.startPause, onMouseLeave: c.endPause }, s.map((l) => {
    let u = l.position || t, f = c.calculateOffset(l, { reverseOrder: e, gutter: r, defaultPosition: t }), d = j2(u, f);
    return w.createElement(M2, { id: l.id, key: l.id, onHeightUpdate: c.updateHeight, className: l.visible ? L2 : "", style: d }, l.type === "custom" ? jc(l.message, l) : i ? i(l) : w.createElement(D2, { toast: l, position: u }));
  }));
};
function p_(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = p_(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ku() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = p_(e)) && (r && (r += " "), r += t);
  return r;
}
function Ou() {
  return typeof window < "u";
}
function no(e) {
  return h_(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Cn(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Rr(e) {
  var t;
  return (t = (h_(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function h_(e) {
  return Ou() ? e instanceof Node || e instanceof Cn(e).Node : !1;
}
function ir(e) {
  return Ou() ? e instanceof Element || e instanceof Cn(e).Element : !1;
}
function Tr(e) {
  return Ou() ? e instanceof HTMLElement || e instanceof Cn(e).HTMLElement : !1;
}
function Wg(e) {
  return !Ou() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Cn(e).ShadowRoot;
}
function Bs(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ar(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function B2(e) {
  return ["table", "td", "th"].includes(no(e));
}
function Cu(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function $m(e) {
  const t = Im(), n = ir(e) ? ar(e) : e;
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function U2(e) {
  let t = yi(e);
  for (; Tr(t) && !Ma(t); ) {
    if ($m(t))
      return t;
    if (Cu(t))
      return null;
    t = yi(t);
  }
  return null;
}
function Im() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ma(e) {
  return ["html", "body", "#document"].includes(no(e));
}
function ar(e) {
  return Cn(e).getComputedStyle(e);
}
function Ru(e) {
  return ir(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function yi(e) {
  if (no(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Wg(e) && e.host || // Fallback.
    Rr(e)
  );
  return Wg(t) ? t.host : t;
}
function m_(e) {
  const t = yi(e);
  return Ma(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Tr(t) && Bs(t) ? t : m_(t);
}
function ui(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = m_(e), a = i === ((r = e.ownerDocument) == null ? void 0 : r.body), o = Cn(i);
  if (a) {
    const s = eh(o);
    return t.concat(o, o.visualViewport || [], Bs(i) ? i : [], s && n ? ui(s) : []);
  }
  return t.concat(i, ui(i, [], n));
}
function eh(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
const ja = Math.min, On = Math.max, Lc = Math.round, El = Math.floor, gi = (e) => ({
  x: e,
  y: e
});
function Zg(e, t, n) {
  return On(e, ja(t, n));
}
function $u(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Us(e) {
  return e.split("-")[0];
}
function Am(e) {
  return e.split("-")[1];
}
function v_(e) {
  return e === "x" ? "y" : "x";
}
function z2(e) {
  return e === "y" ? "height" : "width";
}
function zs(e) {
  return ["top", "bottom"].includes(Us(e)) ? "y" : "x";
}
function V2(e) {
  return v_(zs(e));
}
function H2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function q2(e) {
  return typeof e != "number" ? H2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Fc(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var W2 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], th = /* @__PURE__ */ W2.join(","), y_ = typeof Element > "u", os = y_ ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Bc = !y_ && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Uc = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), a = i === "" || i === "true", o = a || n && t && e(t.parentNode);
  return o;
}, Z2 = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, K2 = function(t, n, r) {
  if (Uc(t))
    return [];
  var i = Array.prototype.slice.apply(t.querySelectorAll(th));
  return n && os.call(t, th) && i.unshift(t), i = i.filter(r), i;
}, G2 = function e(t, n, r) {
  for (var i = [], a = Array.from(t); a.length; ) {
    var o = a.shift();
    if (!Uc(o, !1))
      if (o.tagName === "SLOT") {
        var s = o.assignedElements(), c = s.length ? s : o.children, l = e(c, !0, r);
        r.flatten ? i.push.apply(i, l) : i.push({
          scopeParent: o,
          candidates: l
        });
      } else {
        var u = os.call(o, th);
        u && r.filter(o) && (n || !t.includes(o)) && i.push(o);
        var f = o.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(o), d = !Uc(f, !1) && (!r.shadowRootFilter || r.shadowRootFilter(o));
        if (f && d) {
          var p = e(f === !0 ? o.children : f.children, !0, r);
          r.flatten ? i.push.apply(i, p) : i.push({
            scopeParent: o,
            candidates: p
          });
        } else
          a.unshift.apply(a, o.children);
      }
  }
  return i;
}, g_ = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, b_ = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Z2(t)) && !g_(t) ? 0 : t.tabIndex;
}, Y2 = function(t, n) {
  var r = b_(t);
  return r < 0 && n && !g_(t) ? 0 : r;
}, J2 = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, x_ = function(t) {
  return t.tagName === "INPUT";
}, X2 = function(t) {
  return x_(t) && t.type === "hidden";
}, Q2 = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, eL = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, tL = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Bc(t), r = function(s) {
    return n.querySelectorAll('input[type="radio"][name="' + s + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(t.name));
  else
    try {
      i = r(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var a = eL(i, t.form);
  return !a || a === t;
}, nL = function(t) {
  return x_(t) && t.type === "radio";
}, rL = function(t) {
  return nL(t) && !tL(t);
}, iL = function(t) {
  var n, r = t && Bc(t), i = (n = r) === null || n === void 0 ? void 0 : n.host, a = !1;
  if (r && r !== t) {
    var o, s, c;
    for (a = !!((o = i) !== null && o !== void 0 && (s = o.ownerDocument) !== null && s !== void 0 && s.contains(i) || t != null && (c = t.ownerDocument) !== null && c !== void 0 && c.contains(t)); !a && i; ) {
      var l, u, f;
      r = Bc(i), i = (l = r) === null || l === void 0 ? void 0 : l.host, a = !!((u = i) !== null && u !== void 0 && (f = u.ownerDocument) !== null && f !== void 0 && f.contains(i));
    }
  }
  return a;
}, Kg = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, i = n.height;
  return r === 0 && i === 0;
}, aL = function(t, n) {
  var r = n.displayCheck, i = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var a = os.call(t, "details>summary:first-of-type"), o = a ? t.parentElement : t;
  if (os.call(o, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var s = t; t; ) {
        var c = t.parentElement, l = Bc(t);
        if (c && !c.shadowRoot && i(c) === !0)
          return Kg(t);
        t.assignedSlot ? t = t.assignedSlot : !c && l !== t.ownerDocument ? t = l.host : t = c;
      }
      t = s;
    }
    if (iL(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Kg(t);
  return !1;
}, oL = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var i = n.children.item(r);
          if (i.tagName === "LEGEND")
            return os.call(n, "fieldset[disabled] *") ? !0 : !i.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, sL = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Uc(n) || X2(n) || aL(n, t) || // For a details element with a summary, the summary element gets the focus
  Q2(n) || oL(n));
}, Gg = function(t, n) {
  return !(rL(n) || b_(n) < 0 || !sL(t, n));
}, lL = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, cL = function e(t) {
  var n = [], r = [];
  return t.forEach(function(i, a) {
    var o = !!i.scopeParent, s = o ? i.scopeParent : i, c = Y2(s, o), l = o ? e(i.candidates) : s;
    c === 0 ? o ? n.push.apply(n, l) : n.push(s) : r.push({
      documentOrder: a,
      tabIndex: c,
      item: i,
      isScope: o,
      content: l
    });
  }), r.sort(J2).reduce(function(i, a) {
    return a.isScope ? i.push.apply(i, a.content) : i.push(a.content), i;
  }, []).concat(n);
}, Pm = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = G2([t], n.includeContainer, {
    filter: Gg.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: lL
  }) : r = K2(t, n.includeContainer, Gg.bind(null, n)), cL(r);
};
function Yg(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const a = zs(t), o = V2(t), s = z2(o), c = Us(t), l = a === "y", u = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, d = r[s] / 2 - i[s] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Am(t)) {
    case "start":
      p[o] -= d * (n && l ? -1 : 1);
      break;
    case "end":
      p[o] += d * (n && l ? -1 : 1);
      break;
  }
  return p;
}
const uL = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: a = [],
    platform: o
  } = n, s = a.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let l = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: u,
    y: f
  } = Yg(l, r, c), d = r, p = {}, m = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: y,
      fn: v
    } = s[h], {
      x: g,
      y: b,
      data: T,
      reset: S
    } = await v({
      x: u,
      y: f,
      initialPlacement: r,
      placement: d,
      strategy: i,
      middlewareData: p,
      rects: l,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = g ?? u, f = b ?? f, p = {
      ...p,
      [y]: {
        ...p[y],
        ...T
      }
    }, S && m <= 50 && (m++, typeof S == "object" && (S.placement && (d = S.placement), S.rects && (l = S.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : S.rects), {
      x: u,
      y: f
    } = Yg(l, d, c)), h = -1);
  }
  return {
    x: u,
    y: f,
    placement: d,
    strategy: i,
    middlewareData: p
  };
};
async function w_(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: a,
    rects: o,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: f = "floating",
    altBoundary: d = !1,
    padding: p = 0
  } = $u(t, e), m = q2(p), y = s[d ? f === "floating" ? "reference" : "floating" : f], v = Fc(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(y))) == null || n ? y : y.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), g = f === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), T = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Fc(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: g,
    offsetParent: b,
    strategy: c
  }) : g);
  return {
    top: (v.top - S.top + m.top) / T.y,
    bottom: (S.bottom - v.bottom + m.bottom) / T.y,
    left: (v.left - S.left + m.left) / T.x,
    right: (S.right - v.right + m.right) / T.x
  };
}
async function fL(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = Us(n), s = Am(n), c = zs(n) === "y", l = ["left", "top"].includes(o) ? -1 : 1, u = a && c ? -1 : 1, f = $u(t, e);
  let {
    mainAxis: d,
    crossAxis: p,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof m == "number" && (p = s === "end" ? m * -1 : m), c ? {
    x: p * u,
    y: d * l
  } : {
    x: d * l,
    y: p * u
  };
}
const dL = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: a,
        placement: o,
        middlewareData: s
      } = t, c = await fL(t, e);
      return o === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: a + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, pL = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: a = !0,
        crossAxis: o = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: v,
              y: g
            } = y;
            return {
              x: v,
              y: g
            };
          }
        },
        ...c
      } = $u(e, t), l = {
        x: n,
        y: r
      }, u = await w_(t, c), f = zs(Us(i)), d = v_(f);
      let p = l[d], m = l[f];
      if (a) {
        const y = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", g = p + u[y], b = p - u[v];
        p = Zg(g, p, b);
      }
      if (o) {
        const y = f === "y" ? "top" : "left", v = f === "y" ? "bottom" : "right", g = m + u[y], b = m - u[v];
        m = Zg(g, m, b);
      }
      const h = s.fn({
        ...t,
        [d]: p,
        [f]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [d]: a,
            [f]: o
          }
        }
      };
    }
  };
}, hL = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: a,
        platform: o,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = $u(e, t), u = await w_(t, l), f = Us(i), d = Am(i), p = zs(i) === "y", {
        width: m,
        height: h
      } = a.floating;
      let y, v;
      f === "top" || f === "bottom" ? (y = f, v = d === (await (o.isRTL == null ? void 0 : o.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = f, y = d === "end" ? "top" : "bottom");
      const g = h - u.top - u.bottom, b = m - u.left - u.right, T = ja(h - u[y], g), S = ja(m - u[v], b), E = !t.middlewareData.shift;
      let O = T, j = S;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (j = b), (r = t.middlewareData.shift) != null && r.enabled.y && (O = g), E && !d) {
        const k = On(u.left, 0), A = On(u.right, 0), V = On(u.top, 0), $ = On(u.bottom, 0);
        p ? j = m - 2 * (k !== 0 || A !== 0 ? k + A : On(u.left, u.right)) : O = h - 2 * (V !== 0 || $ !== 0 ? V + $ : On(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: j,
        availableHeight: O
      });
      const D = await o.getDimensions(s.floating);
      return m !== D.width || h !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function S_(e) {
  const t = ar(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Tr(e), a = i ? e.offsetWidth : n, o = i ? e.offsetHeight : r, s = Lc(n) !== a || Lc(r) !== o;
  return s && (n = a, r = o), {
    width: n,
    height: r,
    $: s
  };
}
function Nm(e) {
  return ir(e) ? e : e.contextElement;
}
function ka(e) {
  const t = Nm(e);
  if (!Tr(t))
    return gi(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: a
  } = S_(t);
  let o = (a ? Lc(n.width) : n.width) / r, s = (a ? Lc(n.height) : n.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: o,
    y: s
  };
}
const mL = /* @__PURE__ */ gi(0);
function __(e) {
  const t = Cn(e);
  return !Im() || !t.visualViewport ? mL : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function vL(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Cn(e) ? !1 : t;
}
function Hi(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), a = Nm(e);
  let o = gi(1);
  t && (r ? ir(r) && (o = ka(r)) : o = ka(e));
  const s = vL(a, n, r) ? __(a) : gi(0);
  let c = (i.left + s.x) / o.x, l = (i.top + s.y) / o.y, u = i.width / o.x, f = i.height / o.y;
  if (a) {
    const d = Cn(a), p = r && ir(r) ? Cn(r) : r;
    let m = d, h = eh(m);
    for (; h && r && p !== m; ) {
      const y = ka(h), v = h.getBoundingClientRect(), g = ar(h), b = v.left + (h.clientLeft + parseFloat(g.paddingLeft)) * y.x, T = v.top + (h.clientTop + parseFloat(g.paddingTop)) * y.y;
      c *= y.x, l *= y.y, u *= y.x, f *= y.y, c += b, l += T, m = Cn(h), h = eh(m);
    }
  }
  return Fc({
    width: u,
    height: f,
    x: c,
    y: l
  });
}
function yL(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const a = i === "fixed", o = Rr(r), s = t ? Cu(t.floating) : !1;
  if (r === o || s && a)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = gi(1);
  const u = gi(0), f = Tr(r);
  if ((f || !f && !a) && ((no(r) !== "body" || Bs(o)) && (c = Ru(r)), Tr(r))) {
    const d = Hi(r);
    l = ka(r), u.x = d.x + r.clientLeft, u.y = d.y + r.clientTop;
  }
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - c.scrollLeft * l.x + u.x,
    y: n.y * l.y - c.scrollTop * l.y + u.y
  };
}
function gL(e) {
  return Array.from(e.getClientRects());
}
function nh(e, t) {
  const n = Ru(e).scrollLeft;
  return t ? t.left + n : Hi(Rr(e)).left + n;
}
function bL(e) {
  const t = Rr(e), n = Ru(e), r = e.ownerDocument.body, i = On(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = On(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + nh(e);
  const s = -n.scrollTop;
  return ar(r).direction === "rtl" && (o += On(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: a,
    x: o,
    y: s
  };
}
function xL(e, t) {
  const n = Cn(e), r = Rr(e), i = n.visualViewport;
  let a = r.clientWidth, o = r.clientHeight, s = 0, c = 0;
  if (i) {
    a = i.width, o = i.height;
    const l = Im();
    (!l || l && t === "fixed") && (s = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s,
    y: c
  };
}
function wL(e, t) {
  const n = Hi(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, a = Tr(e) ? ka(e) : gi(1), o = e.clientWidth * a.x, s = e.clientHeight * a.y, c = i * a.x, l = r * a.y;
  return {
    width: o,
    height: s,
    x: c,
    y: l
  };
}
function Jg(e, t, n) {
  let r;
  if (t === "viewport")
    r = xL(e, n);
  else if (t === "document")
    r = bL(Rr(e));
  else if (ir(t))
    r = wL(t, n);
  else {
    const i = __(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return Fc(r);
}
function E_(e, t) {
  const n = yi(e);
  return n === t || !ir(n) || Ma(n) ? !1 : ar(n).position === "fixed" || E_(n, t);
}
function SL(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ui(e, [], !1).filter((s) => ir(s) && no(s) !== "body"), i = null;
  const a = ar(e).position === "fixed";
  let o = a ? yi(e) : e;
  for (; ir(o) && !Ma(o); ) {
    const s = ar(o), c = $m(o);
    !c && s.position === "fixed" && (i = null), (a ? !c && !i : !c && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Bs(o) && !c && E_(e, o)) ? r = r.filter((u) => u !== o) : i = s, o = yi(o);
  }
  return t.set(e, r), r;
}
function _L(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const o = [...n === "clippingAncestors" ? Cu(t) ? [] : SL(t, this._c) : [].concat(n), r], s = o[0], c = o.reduce((l, u) => {
    const f = Jg(t, u, i);
    return l.top = On(f.top, l.top), l.right = ja(f.right, l.right), l.bottom = ja(f.bottom, l.bottom), l.left = On(f.left, l.left), l;
  }, Jg(t, s, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function EL(e) {
  const {
    width: t,
    height: n
  } = S_(e);
  return {
    width: t,
    height: n
  };
}
function TL(e, t, n) {
  const r = Tr(t), i = Rr(t), a = n === "fixed", o = Hi(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = gi(0);
  if (r || !r && !a)
    if ((no(t) !== "body" || Bs(i)) && (s = Ru(t)), r) {
      const p = Hi(t, !0, a, t);
      c.x = p.x + t.clientLeft, c.y = p.y + t.clientTop;
    } else i && (c.x = nh(i));
  let l = 0, u = 0;
  if (i && !r && !a) {
    const p = i.getBoundingClientRect();
    u = p.top + s.scrollTop, l = p.left + s.scrollLeft - // RTL <body> scrollbar.
    nh(i, p);
  }
  const f = o.left + s.scrollLeft - c.x - l, d = o.top + s.scrollTop - c.y - u;
  return {
    x: f,
    y: d,
    width: o.width,
    height: o.height
  };
}
function Bf(e) {
  return ar(e).position === "static";
}
function Xg(e, t) {
  if (!Tr(e) || ar(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Rr(e) === n && (n = n.ownerDocument.body), n;
}
function T_(e, t) {
  const n = Cn(e);
  if (Cu(e))
    return n;
  if (!Tr(e)) {
    let i = yi(e);
    for (; i && !Ma(i); ) {
      if (ir(i) && !Bf(i))
        return i;
      i = yi(i);
    }
    return n;
  }
  let r = Xg(e, t);
  for (; r && B2(r) && Bf(r); )
    r = Xg(r, t);
  return r && Ma(r) && Bf(r) && !$m(r) ? n : r || U2(e) || n;
}
const kL = async function(e) {
  const t = this.getOffsetParent || T_, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: TL(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function OL(e) {
  return ar(e).direction === "rtl";
}
const CL = {
  convertOffsetParentRelativeRectToViewportRelativeRect: yL,
  getDocumentElement: Rr,
  getClippingRect: _L,
  getOffsetParent: T_,
  getElementRects: kL,
  getClientRects: gL,
  getDimensions: EL,
  getScale: ka,
  isElement: ir,
  isRTL: OL
};
function RL(e, t) {
  let n = null, r;
  const i = Rr(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function o(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), a();
    const {
      left: l,
      top: u,
      width: f,
      height: d
    } = e.getBoundingClientRect();
    if (s || t(), !f || !d)
      return;
    const p = El(u), m = El(i.clientWidth - (l + f)), h = El(i.clientHeight - (u + d)), y = El(l), g = {
      rootMargin: -p + "px " + -m + "px " + -h + "px " + -y + "px",
      threshold: On(0, ja(1, c)) || 1
    };
    let b = !0;
    function T(S) {
      const E = S[0].intersectionRatio;
      if (E !== c) {
        if (!b)
          return o();
        E ? o(!1, E) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(T, {
        ...g,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(T, g);
    }
    n.observe(e);
  }
  return o(!0), a;
}
function $L(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: a = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, l = Nm(e), u = i || a ? [...l ? ui(l) : [], ...ui(t)] : [];
  u.forEach((v) => {
    i && v.addEventListener("scroll", n, {
      passive: !0
    }), a && v.addEventListener("resize", n);
  });
  const f = l && s ? RL(l, n) : null;
  let d = -1, p = null;
  o && (p = new ResizeObserver((v) => {
    let [g] = v;
    g && g.target === l && p && (p.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var b;
      (b = p) == null || b.observe(t);
    })), n();
  }), l && !c && p.observe(l), p.observe(t));
  let m, h = c ? Hi(e) : null;
  c && y();
  function y() {
    const v = Hi(e);
    h && (v.x !== h.x || v.y !== h.y || v.width !== h.width || v.height !== h.height) && n(), h = v, m = requestAnimationFrame(y);
  }
  return n(), () => {
    var v;
    u.forEach((g) => {
      i && g.removeEventListener("scroll", n), a && g.removeEventListener("resize", n);
    }), f == null || f(), (v = p) == null || v.disconnect(), p = null, c && cancelAnimationFrame(m);
  };
}
const IL = dL, AL = pL, PL = hL, NL = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: CL,
    ...n
  }, a = {
    ...i.platform,
    _c: r
  };
  return uL(e, t, {
    ...i,
    platform: a
  });
};
var rc = typeof document < "u" ? Qa : Ht;
function zc(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!zc(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = i[r];
      if (!(a === "_owner" && e.$$typeof) && !zc(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function k_(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Qg(e, t) {
  const n = k_(e);
  return Math.round(t * n) / n;
}
function Uf(e) {
  const t = w.useRef(e);
  return rc(() => {
    t.current = e;
  }), t;
}
function DL(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: a,
      floating: o
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, f] = w.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, p] = w.useState(r);
  zc(d, r) || p(r);
  const [m, h] = w.useState(null), [y, v] = w.useState(null), g = w.useCallback((B) => {
    B !== E.current && (E.current = B, h(B));
  }, []), b = w.useCallback((B) => {
    B !== O.current && (O.current = B, v(B));
  }, []), T = a || m, S = o || y, E = w.useRef(null), O = w.useRef(null), j = w.useRef(u), D = c != null, k = Uf(c), A = Uf(i), V = Uf(l), $ = w.useCallback(() => {
    if (!E.current || !O.current)
      return;
    const B = {
      placement: t,
      strategy: n,
      middleware: d
    };
    A.current && (B.platform = A.current), NL(E.current, O.current, B).then((N) => {
      const x = {
        ...N,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: V.current !== !1
      };
      L.current && !zc(j.current, x) && (j.current = x, m1.flushSync(() => {
        f(x);
      }));
    });
  }, [d, t, n, A, V]);
  rc(() => {
    l === !1 && j.current.isPositioned && (j.current.isPositioned = !1, f((B) => ({
      ...B,
      isPositioned: !1
    })));
  }, [l]);
  const L = w.useRef(!1);
  rc(() => (L.current = !0, () => {
    L.current = !1;
  }), []), rc(() => {
    if (T && (E.current = T), S && (O.current = S), T && S) {
      if (k.current)
        return k.current(T, S, $);
      $();
    }
  }, [T, S, $, k, D]);
  const M = w.useMemo(() => ({
    reference: E,
    floating: O,
    setReference: g,
    setFloating: b
  }), [g, b]), F = w.useMemo(() => ({
    reference: T,
    floating: S
  }), [T, S]), q = w.useMemo(() => {
    const B = {
      position: n,
      left: 0,
      top: 0
    };
    if (!F.floating)
      return B;
    const N = Qg(F.floating, u.x), x = Qg(F.floating, u.y);
    return s ? {
      ...B,
      transform: "translate(" + N + "px, " + x + "px)",
      ...k_(F.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: N,
      top: x
    };
  }, [n, s, F.floating, u.x, u.y]);
  return w.useMemo(() => ({
    ...u,
    update: $,
    refs: M,
    elements: F,
    floatingStyles: q
  }), [u, $, M, F, q]);
}
const ML = (e, t) => ({
  ...IL(e),
  options: [e, t]
}), jL = (e, t) => ({
  ...AL(e),
  options: [e, t]
}), LL = (e, t) => ({
  ...PL(e),
  options: [e, t]
});
var Fn = function() {
  return Fn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Fn.apply(this, arguments);
};
function O_(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function FL(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function BL() {
  var e = Dt(!1), t = kt(function() {
    return e.current;
  }, []);
  return Ht(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), t;
}
function UL(e, t, n) {
  t === void 0 && (t = []), n === void 0 && (n = { loading: !1 });
  var r = Dt(0), i = BL(), a = rt(n), o = a[0], s = a[1], c = kt(function() {
    for (var l = [], u = 0; u < arguments.length; u++)
      l[u] = arguments[u];
    var f = ++r.current;
    return o.loading || s(function(d) {
      return Fn(Fn({}, d), { loading: !0 });
    }), e.apply(void 0, l).then(function(d) {
      return i() && f === r.current && s({ value: d, loading: !1 }), d;
    }, function(d) {
      return i() && f === r.current && s({ error: d, loading: !1 }), d;
    });
  }, t);
  return [o, c];
}
function zL(e, t) {
  t === void 0 && (t = []);
  var n = UL(e, t, {
    loading: !0
  }), r = n[0], i = n[1];
  return Ht(function() {
    i();
  }, [i]), r;
}
const C_ = In(({ url: e, type: t, orientation: n = "auto", ...r }, i) => {
  const a = AC(), { setIsLoading: o } = Kj(), [s, c] = rt(n), [l, u] = rt(!1), {
    message: {
      blocks: { image: f }
    }
  } = bt;
  return Qa(() => {
    o((d) => [...d, a]);
  }, []), zL(async () => {
    if (e) {
      try {
        const { width: d, height: p } = await Gj(e);
        s === "auto" && c(VL(d, p));
      } catch (d) {
        c("square"), console.error(d);
      }
      o((d) => d.filter((p) => p !== a));
    }
  }, [e]), /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    l ? null : /* @__PURE__ */ R.jsx("div", { "data-orientation": s, ...f.placeholder }),
    /* @__PURE__ */ R.jsx(
      "img",
      {
        "data-orientation": s,
        "data-loaded": l,
        ...r,
        ...f.image,
        src: e,
        alt: "",
        ref: i,
        loading: "lazy",
        onLoad: () => {
          u(!0);
        }
      }
    )
  ] });
});
C_.displayName = "Image";
function VL(e, t) {
  const n = {
    square: 1,
    portrait: 0.75,
    landscape: 1.3333333333333333
  }, r = e / t;
  return Object.keys(n).reduce((a, o) => Math.abs(n[o] - r) < Math.abs(n[a] - r) ? o : a);
}
const HL = In(({ url: e, type: t, ...n }, r) => {
  const {
    message: {
      blocks: { video: i }
    }
  } = bt;
  return /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx("video", { ...n, "data-chromatic": "ignore", controls: !0, src: e, ...i, ref: r }) });
}), qL = In(({ url: e, type: t, ...n }, r) => {
  const {
    message: {
      blocks: { audio: i }
    }
  } = bt;
  return /* @__PURE__ */ R.jsx("div", { children: /* @__PURE__ */ R.jsx("audio", { ...n, controls: !0, src: e, ...i, ref: r }) });
});
function WL({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M15.312 11.424a5.5 5.5 0 0 1-9.201 2.466l-.312-.311h2.433a.75.75 0 0 0 0-1.5H3.989a.75.75 0 0 0-.75.75v4.242a.75.75 0 0 0 1.5 0v-2.43l.31.31a7 7 0 0 0 11.712-3.138.75.75 0 0 0-1.449-.39Zm1.23-3.723a.75.75 0 0 0 .219-.53V2.929a.75.75 0 0 0-1.5 0V5.36l-.31-.31A7 7 0 0 0 3.239 8.188a.75.75 0 1 0 1.448.389A5.5 5.5 0 0 1 13.89 6.11l.311.31h-2.432a.75.75 0 0 0 0 1.5h4.243a.75.75 0 0 0 .53-.219Z",
    clipRule: "evenodd"
  }));
}
const ZL = /* @__PURE__ */ w.forwardRef(WL);
function KL({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
    clipRule: "evenodd"
  }));
}
const GL = /* @__PURE__ */ w.forwardRef(KL);
function YL({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M4.5 2A1.5 1.5 0 0 0 3 3.5v13A1.5 1.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V7.621a1.5 1.5 0 0 0-.44-1.06l-4.12-4.122A1.5 1.5 0 0 0 11.378 2H4.5Zm4.75 6.75a.75.75 0 0 1 1.5 0v2.546l.943-1.048a.75.75 0 0 1 1.114 1.004l-2.25 2.5a.75.75 0 0 1-1.114 0l-2.25-2.5a.75.75 0 1 1 1.114-1.004l.943 1.048V8.75Z",
    clipRule: "evenodd"
  }));
}
const JL = /* @__PURE__ */ w.forwardRef(YL);
function XL({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "m9.69 18.933.003.001C9.89 19.02 10 19 10 19s.11.02.308-.066l.002-.001.006-.003.018-.008a5.741 5.741 0 0 0 .281-.14c.186-.096.446-.24.757-.433.62-.384 1.445-.966 2.274-1.765C15.302 14.988 17 12.493 17 9A7 7 0 1 0 3 9c0 3.492 1.698 5.988 3.355 7.584a13.731 13.731 0 0 0 2.273 1.765 11.842 11.842 0 0 0 .976.544l.062.029.018.008.006.003ZM10 11.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    clipRule: "evenodd"
  }));
}
const QL = /* @__PURE__ */ w.forwardRef(XL), eF = In(({ type: e, latitude: t, longitude: n, title: r, ...i }, a) => {
  const o = `https://www.google.com/maps/search/?api=1&query=${t},${n}`, {
    message: {
      blocks: { location: s }
    }
  } = bt;
  return /* @__PURE__ */ R.jsxs("a", { ...i, ...s.container, href: o, type: "_blank", rel: "noopener", ref: a, children: [
    /* @__PURE__ */ R.jsx("p", { ...s.title, children: r }),
    /* @__PURE__ */ R.jsx(QL, { ...s.icon })
  ] });
}), R_ = In(
  ({
    blocks: e,
    horizontalAlignment: t,
    verticalAlignment: n,
    direction: r,
    sender: i,
    timestamp: a,
    metadata: o,
    messageId: s,
    sendMessage: c,
    ...l
  }, u) => {
    const {
      message: {
        blocks: { column: f }
      }
    } = bt;
    return /* @__PURE__ */ R.jsx("div", { "data-horizontal": t, "data-vertical": n, ...l, ...f, ref: u, children: e.map((d, p) => /* @__PURE__ */ R.jsx(
      qs,
      {
        block: { ...d, direction: r, timestamp: a, sender: i, messageId: s, sendMessage: c },
        direction: r,
        sender: i,
        timestamp: a,
        metadata: o,
        sendMessage: c,
        messageId: s
      },
      p
    )) });
  }
);
R_.displayName = "Column";
const $_ = In(
  ({
    blocks: e,
    horizontalAlignment: t,
    verticalAlignment: n,
    direction: r,
    sender: i,
    timestamp: a,
    metadata: o,
    sendMessage: s,
    messageId: c,
    ...l
  }, u) => {
    const {
      message: {
        blocks: { row: f }
      }
    } = bt;
    return /* @__PURE__ */ R.jsx("div", { "data-horizontal": t, "data-vertical": n, ...l, ...f, ref: u, children: e.map((d, p) => /* @__PURE__ */ R.jsx(
      qs,
      {
        block: { ...d, direction: r, timestamp: a, sender: i, messageId: c, sendMessage: s },
        direction: r,
        sender: i,
        timestamp: a,
        metadata: o,
        sendMessage: s,
        messageId: c
      },
      p
    )) });
  }
);
$_.displayName = "Row";
function tF(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function eb(e) {
  return tF(e) || Array.isArray(e);
}
function nF() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Dm(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(e.breakpoints || {})), a = JSON.stringify(Object.keys(t.breakpoints || {}));
  return i !== a ? !1 : n.every((o) => {
    const s = e[o], c = t[o];
    return typeof s == "function" ? `${s}` == `${c}` : !eb(s) || !eb(c) ? s === c : Dm(s, c);
  });
}
function tb(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function rF(e, t) {
  if (e.length !== t.length) return !1;
  const n = tb(e), r = tb(t);
  return n.every((i, a) => {
    const o = r[a];
    return Dm(i, o);
  });
}
function Mm(e) {
  return typeof e == "number";
}
function nb(e) {
  return typeof e == "string";
}
function jm(e) {
  return typeof e == "boolean";
}
function rb(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ot(e) {
  return Math.abs(e);
}
function Lm(e) {
  return Math.sign(e);
}
function ic(e, t) {
  return Ot(e - t);
}
function iF(e, t) {
  if (e === 0 || t === 0 || Ot(e) <= Ot(t)) return 0;
  const n = ic(Ot(e), Ot(t));
  return Ot(n / e);
}
function ss(e) {
  return Vc(e).map(Number);
}
function Br(e) {
  return e[Iu(e)];
}
function Iu(e) {
  return Math.max(0, e.length - 1);
}
function Vc(e) {
  return Object.keys(e);
}
function I_(e, t) {
  return [e, t].reduce((n, r) => (Vc(r).forEach((i) => {
    const a = n[i], o = r[i], s = rb(a) && rb(o);
    n[i] = s ? I_(a, o) : o;
  }), n), {});
}
function A_(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function aF(e, t) {
  const n = {
    start: r,
    center: i,
    end: a
  };
  function r() {
    return 0;
  }
  function i(l) {
    return a(l) / 2;
  }
  function a(l) {
    return t - l;
  }
  function o() {
    return t * Number(e);
  }
  function s(l) {
    return Mm(e) ? o() : n[e](l);
  }
  return {
    measure: s
  };
}
function oF(e, t) {
  const n = e === "y" ? "y" : "x", r = e === "y" ? "x" : "y", i = s(), a = c();
  function o(u) {
    const {
      width: f,
      height: d
    } = u;
    return n === "x" ? f : d;
  }
  function s() {
    return n === "y" ? "top" : t === "rtl" ? "right" : "left";
  }
  function c() {
    return n === "y" ? "bottom" : t === "rtl" ? "left" : "right";
  }
  return {
    scroll: n,
    cross: r,
    startEdge: i,
    endEdge: a,
    measureSize: o
  };
}
function bi(e, t) {
  const n = Ot(e - t);
  function r(l) {
    return l < e;
  }
  function i(l) {
    return l > t;
  }
  function a(l) {
    return r(l) || i(l);
  }
  function o(l) {
    return a(l) ? r(l) ? e : t : l;
  }
  function s(l) {
    return n ? l - n * Math.ceil((l - t) / n) : l;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: o,
    reachedAny: a,
    reachedMax: i,
    reachedMin: r,
    removeOffset: s
  };
}
function P_(e, t, n) {
  const {
    constrain: r
  } = bi(0, e), i = e + 1;
  let a = o(t);
  function o(d) {
    return n ? Ot((i + d) % i) : r(d);
  }
  function s() {
    return a;
  }
  function c(d) {
    return a = o(d), f;
  }
  function l(d) {
    return u().set(s() + d);
  }
  function u() {
    return P_(e, s(), n);
  }
  const f = {
    get: s,
    set: c,
    add: l,
    clone: u
  };
  return f;
}
function sF(e) {
  const t = e === "rtl" ? -1 : 1;
  function n(i) {
    return i * t;
  }
  return {
    apply: n
  };
}
function ls() {
  let e = [];
  function t(i, a, o, s = {
    passive: !0
  }) {
    return i.addEventListener(a, o, s), e.push(() => i.removeEventListener(a, o, s)), r;
  }
  function n() {
    e = e.filter((i) => i());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function lF(e, t, n, r, i, a, o, s, c, l, u, f, d, p, m, h, y, v, g) {
  const {
    cross: b
  } = e, T = ["INPUT", "SELECT", "TEXTAREA"], S = {
    passive: !1
  }, E = ls(), O = ls(), j = bi(50, 225).constrain(m.measure(20)), D = {
    mouse: 300,
    touch: 400
  }, k = {
    mouse: 500,
    touch: 600
  }, A = h ? 43 : 25;
  let V = !1, $ = 0, L = 0, M = !1, F = !1, q = !1, B = !1;
  function N(X, W) {
    if (!W) return;
    function fe(Oe) {
      (jm(W) || W(X, Oe)) && ae(Oe);
    }
    const me = n;
    E.add(me, "dragstart", (Oe) => Oe.preventDefault(), S).add(me, "touchmove", () => {
    }, S).add(me, "touchend", () => {
    }).add(me, "touchstart", fe).add(me, "mousedown", fe).add(me, "touchcancel", se).add(me, "contextmenu", se).add(me, "click", de, !0);
  }
  function x() {
    E.clear(), O.clear();
  }
  function z() {
    const X = B ? r : n;
    O.add(X, "touchmove", te, S).add(X, "touchend", se).add(X, "mousemove", te, S).add(X, "mouseup", se);
  }
  function Z(X) {
    const W = X.nodeName || "";
    return T.includes(W);
  }
  function _() {
    return (h ? k : D)[B ? "mouse" : "touch"];
  }
  function G(X, W) {
    const fe = d.add(Lm(X) * -1), me = f.byDistance(X, !h).distance;
    return h || Ot(X) < j ? me : v && W ? me * 0.5 : f.byIndex(fe.get(), 0).distance;
  }
  function ae(X) {
    const W = A_(X, i);
    B = W, !(W && X.button !== 0) && (Z(X.target) || (q = h && W && !X.buttons && V, V = ic(a.get(), s.get()) >= 2, M = !0, o.pointerDown(X), u.useFriction(0).useDuration(0), a.set(s), z(), $ = o.readPoint(X), L = o.readPoint(X, b), p.emit("pointerDown")));
  }
  function te(X) {
    const W = o.readPoint(X), fe = o.readPoint(X, b), me = ic(W, $), Oe = ic(fe, L);
    if (!F && !B && (!X.cancelable || (F = me > Oe, !F)))
      return se(X);
    const I = o.pointerMove(X);
    me > y && (q = !0), u.useFriction(0.3).useDuration(1), c.start(), a.add(t.apply(I)), X.preventDefault();
  }
  function se(X) {
    const fe = f.byDistance(0, !1).index !== d.get(), me = o.pointerUp(X) * _(), Oe = G(t.apply(me), fe), I = iF(me, Oe), Y = A - 10 * I, re = g + I / 50;
    F = !1, M = !1, O.clear(), u.useDuration(Y).useFriction(re), l.distance(Oe, !h), B = !1, p.emit("pointerUp");
  }
  function de(X) {
    q && (X.stopPropagation(), X.preventDefault());
  }
  function pe() {
    return M;
  }
  return {
    init: N,
    pointerDown: pe,
    destroy: x
  };
}
function cF(e, t) {
  let r, i;
  function a(f) {
    return f.timeStamp;
  }
  function o(f, d) {
    const m = `client${(d || e.scroll) === "x" ? "X" : "Y"}`;
    return (A_(f, t) ? f : f.touches[0])[m];
  }
  function s(f) {
    return r = f, i = f, o(f);
  }
  function c(f) {
    const d = o(f) - o(i), p = a(f) - a(r) > 170;
    return i = f, p && (r = f), d;
  }
  function l(f) {
    if (!r || !i) return 0;
    const d = o(i) - o(r), p = a(f) - a(r), m = a(f) - a(i) > 170, h = d / p;
    return p && !m && Ot(h) > 0.1 ? h : 0;
  }
  return {
    pointerDown: s,
    pointerMove: c,
    pointerUp: l,
    readPoint: o
  };
}
function uF(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function fF(e, t, n, r, i) {
  let a, o, s = [], c = !1;
  function l(p) {
    return i.measureSize(p.getBoundingClientRect());
  }
  function u(p, m) {
    if (!m) return;
    o = l(e), s = r.map(l);
    function h(v) {
      for (const g of v) {
        const b = g.target === e, T = r.indexOf(g.target), S = b ? o : s[T], E = l(b ? e : r[T]);
        if (S !== E) {
          n.requestAnimationFrame(() => {
            p.reInit(), t.emit("resize");
          });
          break;
        }
      }
    }
    a = new ResizeObserver((v) => {
      c || (jm(m) || m(p, v)) && h(v);
    }), [e].concat(r).forEach((v) => a.observe(v));
  }
  function f() {
    a && a.disconnect(), c = !0;
  }
  return {
    init: u,
    destroy: f
  };
}
function dF(e, t, n, r) {
  let i = !0, a = 0, o = 0, s = n, c = r, l = e.get(), u = 0;
  function f() {
    const S = t.get() - e.get(), E = !s;
    let O = 0;
    return E ? (a = 0, e.set(t), O = S) : (a += S / s, a *= c, l += a, e.add(a), O = l - u), o = Lm(O), u = l, i = Ot(S) < 1e-3, T;
  }
  function d() {
    return i;
  }
  function p() {
    return s;
  }
  function m() {
    return o;
  }
  function h() {
    return a;
  }
  function y() {
    return g(n);
  }
  function v() {
    return b(r);
  }
  function g(S) {
    return s = S, T;
  }
  function b(S) {
    return c = S, T;
  }
  const T = {
    direction: m,
    duration: p,
    velocity: h,
    seek: f,
    settled: d,
    useBaseFriction: v,
    useBaseDuration: y,
    useFriction: b,
    useDuration: g
  };
  return T;
}
function pF(e, t, n, r, i) {
  const a = i.measure(10), o = i.measure(50), s = bi(0.1, 0.99);
  let c = !1;
  function l() {
    return !(c || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function u(p) {
    if (!l()) return;
    const m = e.reachedMin(t.get()) ? "min" : "max", h = Ot(e[m] - t.get()), y = n.get() - t.get(), v = s.constrain(h / o);
    n.subtract(y * v), !p && Ot(y) < a && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function f(p) {
    c = !p;
  }
  return {
    constrain: u,
    toggleActive: f
  };
}
function hF(e, t, n, r) {
  const i = bi(-t + e, n[0]), a = c(), o = l();
  function s() {
    const f = a[0], d = Br(a), p = a.lastIndexOf(f), m = a.indexOf(d) + 1;
    return bi(p, m);
  }
  function c() {
    return n.map(i.constrain).map((f) => parseFloat(f.toFixed(3)));
  }
  function l() {
    if (t <= e) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: f,
      max: d
    } = s();
    return a.slice(f, d);
  }
  return {
    snapsContained: o
  };
}
function mF(e, t, n) {
  const r = t[0], i = n ? r - e : Br(t);
  return {
    limit: bi(i, r)
  };
}
function vF(e, t, n, r) {
  const a = t.min + 0.1, o = t.max + 0.1, {
    reachedMin: s,
    reachedMax: c
  } = bi(a, o);
  function l(d) {
    return d === 1 ? c(n.get()) : d === -1 ? s(n.get()) : !1;
  }
  function u(d) {
    if (!l(d)) return;
    const p = e * (d * -1);
    r.forEach((m) => m.add(p));
  }
  return {
    loop: u
  };
}
function yF(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(a) {
    return (a - t) / -n;
  }
  return {
    get: r
  };
}
function gF(e, t, n, r, i, a, o) {
  const {
    startEdge: s,
    endEdge: c
  } = e, {
    groupSlides: l
  } = a, u = p().map(t.measure), f = m(), d = h();
  function p() {
    return l(r).map((v) => Br(v)[c] - v[0][s]).map(Ot);
  }
  function m() {
    return r.map((v) => n[s] - v[s]).map((v) => -Ot(v));
  }
  function h() {
    const g = Br(f) - Br(i);
    return l(f).map((b) => b[0]).map((b, T, S) => {
      const E = !T, O = T === Iu(S);
      return o && E ? 0 : o && O ? g : b + u[T];
    });
  }
  return {
    snaps: f,
    snapsAligned: d
  };
}
function bF(e, t, n, r, i) {
  const {
    reachedAny: a,
    removeOffset: o,
    constrain: s
  } = r;
  function c(m) {
    return m.concat().sort((h, y) => Ot(h) - Ot(y))[0];
  }
  function l(m) {
    const h = e ? o(m) : s(m), y = t.map((g) => g - h).map((g) => u(g, 0)).map((g, b) => ({
      diff: g,
      index: b
    })).sort((g, b) => Ot(g.diff) - Ot(b.diff)), {
      index: v
    } = y[0];
    return {
      index: v,
      distance: h
    };
  }
  function u(m, h) {
    const y = [m, m + n, m - n];
    if (!e) return y[0];
    if (!h) return c(y);
    const v = y.filter((g) => Lm(g) === h);
    return c(v);
  }
  function f(m, h) {
    const y = t[m] - i.get(), v = u(y, h);
    return {
      index: m,
      distance: v
    };
  }
  function d(m, h) {
    const y = i.get() + m, {
      index: v,
      distance: g
    } = l(y), b = !e && a(y);
    if (!h || b) return {
      index: v,
      distance: m
    };
    const T = t[v] - g, S = m + u(T, 0);
    return {
      index: v,
      distance: S
    };
  }
  return {
    byDistance: d,
    byIndex: f,
    shortcut: u
  };
}
function xF(e, t, n, r, i, a, o) {
  function s(f) {
    const d = f.distance, p = f.index !== t.get();
    a.add(d), d && (i.duration() ? e.start() : (e.update(), e.render(1), e.update())), p && (n.set(t.get()), t.set(f.index), o.emit("select"));
  }
  function c(f, d) {
    const p = r.byDistance(f, d);
    s(p);
  }
  function l(f, d) {
    const p = t.clone().set(f), m = r.byIndex(p.get(), d);
    s(m);
  }
  return {
    distance: c,
    index: l
  };
}
function ac(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(c) {
    t = o(c);
  }
  function i(c) {
    t += o(c);
  }
  function a(c) {
    t -= o(c);
  }
  function o(c) {
    return Mm(c) ? c : c.get();
  }
  return {
    get: n,
    set: r,
    add: i,
    subtract: a
  };
}
function N_(e, t, n) {
  const r = e.scroll === "x" ? o : s, i = n.style;
  let a = !1;
  function o(d) {
    return `translate3d(${d}px,0px,0px)`;
  }
  function s(d) {
    return `translate3d(0px,${d}px,0px)`;
  }
  function c(d) {
    a || (i.transform = r(t.apply(d)));
  }
  function l(d) {
    a = !d;
  }
  function u() {
    a || (i.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: u,
    to: c,
    toggleActive: l
  };
}
function wF(e, t, n, r, i, a, o, s, c) {
  const l = ss(i), u = ss(i).reverse(), f = h().concat(y());
  function d(S, E) {
    return S.reduce((O, j) => O - i[j], E);
  }
  function p(S, E) {
    return S.reduce((O, j) => d(O, E) > 0 ? O.concat([j]) : O, []);
  }
  function m(S, E) {
    const O = E === "start", j = O ? -r : r, D = o.findSlideBounds([j]);
    return S.map((k) => {
      const A = O ? 0 : -r, V = O ? r : 0, L = D.filter((M) => M.index === k)[0][O ? "end" : "start"];
      return {
        index: k,
        slideLocation: ac(-1),
        translate: N_(e, t, c[k]),
        target: () => s.get() > L ? A : V
      };
    });
  }
  function h() {
    const S = a[0] - 1, E = p(u, S);
    return m(E, "end");
  }
  function y() {
    const S = n - a[0] - 1, E = p(l, S);
    return m(E, "start");
  }
  function v() {
    return f.every(({
      index: S
    }) => {
      const E = l.filter((O) => O !== S);
      return d(E, n) <= 0.1;
    });
  }
  function g() {
    f.forEach((S) => {
      const {
        target: E,
        translate: O,
        slideLocation: j
      } = S, D = E();
      D !== j.get() && (O.to(D), j.set(D));
    });
  }
  function b() {
    f.forEach((S) => S.translate.clear());
  }
  return {
    canLoop: v,
    clear: b,
    loop: g,
    loopPoints: f
  };
}
function SF(e, t) {
  let n, r = !1;
  function i(s, c) {
    if (!c) return;
    function l(u) {
      for (const f of u)
        if (f.type === "childList") {
          s.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    n = new MutationObserver((u) => {
      r || (jm(c) || c(s, u)) && l(u);
    }), n.observe(e, {
      childList: !0
    });
  }
  function a() {
    n && n.disconnect(), r = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function _F(e, t, n, r, i, a, o) {
  const {
    removeOffset: s,
    constrain: c
  } = i, l = 0.5, u = a ? [0, t, -t] : [0], f = p(u, o);
  function d(y) {
    const v = y || 0;
    return n.map((g) => bi(l, g - l).constrain(g * v));
  }
  function p(y, v) {
    const g = y || u, b = d(v);
    return g.reduce((T, S) => {
      const E = r.map((O, j) => ({
        start: O - n[j] + b[j] + S,
        end: O + e - b[j] + S,
        index: j
      }));
      return T.concat(E);
    }, []);
  }
  function m(y, v) {
    const g = a ? s(y) : c(y);
    return (v || f).reduce((T, S) => {
      const {
        index: E,
        start: O,
        end: j
      } = S, D = T.includes(E), k = O < g && j > g;
      return !D && k ? T.concat([E]) : T;
    }, []);
  }
  return {
    check: m,
    findSlideBounds: p
  };
}
function EF(e, t, n, r, i, a) {
  const {
    measureSize: o,
    startEdge: s,
    endEdge: c
  } = e, l = n[0] && i, u = m(), f = h(), d = n.map(o), p = y();
  function m() {
    if (!l) return 0;
    const g = n[0];
    return Ot(t[s] - g[s]);
  }
  function h() {
    if (!l) return 0;
    const g = a.getComputedStyle(Br(r));
    return parseFloat(g.getPropertyValue(`margin-${c}`));
  }
  function y() {
    return n.map((g, b, T) => {
      const S = !b, E = b === Iu(T);
      return S ? d[b] + u : E ? d[b] + f : T[b + 1][s] - g[s];
    }).map(Ot);
  }
  return {
    slideSizes: d,
    slideSizesWithGaps: p
  };
}
function TF(e, t, n) {
  const r = Mm(n);
  function i(c, l) {
    return ss(c).filter((u) => u % l === 0).map((u) => c.slice(u, u + l));
  }
  function a(c) {
    return ss(c).reduce((l, u) => {
      const d = t.slice(Br(l), u + 1).reduce((p, m) => p + m, 0);
      return !u || d > e ? l.concat(u) : l;
    }, []).map((l, u, f) => c.slice(l, f[u + 1]));
  }
  function o(c) {
    return r ? i(c, n) : a(c);
  }
  return {
    groupSlides: o
  };
}
function kF(e, t, n, r, i, a, o, s) {
  const {
    align: c,
    axis: l,
    direction: u,
    startIndex: f,
    inViewThreshold: d,
    loop: p,
    duration: m,
    dragFree: h,
    dragThreshold: y,
    slidesToScroll: v,
    skipSnaps: g,
    containScroll: b
  } = a, T = t.getBoundingClientRect(), S = n.map((re) => re.getBoundingClientRect()), E = sF(u), O = oF(l, u), j = O.measureSize(T), D = uF(j), k = aF(c, j), A = !p && !!b, V = p || !!b, {
    slideSizes: $,
    slideSizesWithGaps: L
  } = EF(O, T, S, n, V, i), M = TF(j, L, v), {
    snaps: F,
    snapsAligned: q
  } = gF(O, k, T, S, L, M, A), B = -Br(F) + Br(L), {
    snapsContained: N
  } = hF(j, B, q, b), x = A ? N : q, {
    limit: z
  } = mF(B, x, p), Z = P_(Iu(x), f, p), _ = Z.clone(), G = ss(n), ae = ({
    dragHandler: re,
    scrollBody: Q,
    scrollBounds: Ee,
    eventHandler: xe,
    animation: Re,
    options: {
      loop: Ve
    }
  }) => {
    const Ie = re.pointerDown();
    Ve || Ee.constrain(Ie);
    const Me = Q.seek().settled();
    Me && !Ie && (Re.stop(), xe.emit("settle")), Me || xe.emit("scroll");
  }, te = ({
    scrollBody: re,
    translate: Q,
    location: Ee,
    offsetLocation: xe,
    scrollLooper: Re,
    slideLooper: Ve,
    options: {
      loop: Ie
    }
  }, Me) => {
    const U = re.velocity();
    xe.set(Ee.get() - U + U * Me), Ie && (Re.loop(re.direction()), Ve.loop()), Q.to(xe.get());
  }, se = {
    start: () => s.start(Y),
    stop: () => s.stop(Y),
    update: () => ae(Y),
    render: (re) => te(Y, re)
  }, de = 0.68, pe = x[Z.get()], le = ac(pe), X = ac(pe), W = ac(pe), fe = dF(le, W, m, de), me = bF(p, x, B, z, W), Oe = xF(se, Z, _, me, fe, W, o), I = _F(j, B, $, F, z, p, d), Y = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: o,
    containerRect: T,
    slideRects: S,
    animation: se,
    axis: O,
    direction: E,
    dragHandler: lF(O, E, e, r, i, W, cF(O, i), le, se, Oe, fe, me, Z, o, D, h, y, g, de),
    eventStore: ls(),
    percentOfView: D,
    index: Z,
    indexPrevious: _,
    limit: z,
    location: le,
    offsetLocation: X,
    options: a,
    resizeHandler: fF(t, o, i, n, O),
    scrollBody: fe,
    scrollBounds: pF(z, le, W, fe, D),
    scrollLooper: vF(B, z, X, [le, X, W]),
    scrollProgress: yF(z),
    scrollSnaps: x,
    scrollTarget: me,
    scrollTo: Oe,
    slideLooper: wF(O, E, j, B, L, x, I, X, n),
    slidesHandler: SF(t, o),
    slidesInView: I,
    slideIndexes: G,
    slidesToScroll: M,
    target: W,
    translate: N_(O, E, t)
  };
  return Y;
}
function OF(e) {
  const t = 16.666666666666668;
  let n = [], r = null, i = 0, a = 0;
  function o(f) {
    r || (r = f);
    const d = f - r;
    for (r = f, i += d; i >= t; )
      n.forEach(({
        animation: m
      }) => m.update()), i -= t;
    const p = Ot(i / t);
    n.forEach(({
      animation: m
    }) => m.render(p)), a && e.requestAnimationFrame(o);
  }
  function s(f) {
    n.includes(f) || n.push(f), !a && (a = e.requestAnimationFrame(o));
  }
  function c(f) {
    n = n.filter((d) => d !== f), !n.length && (e.cancelAnimationFrame(a), r = null, i = 0, a = 0);
  }
  function l() {
    r = null, i = 0;
  }
  return {
    start: s,
    stop: c,
    reset: l,
    window: e
  };
}
function CF() {
  const e = {};
  let t;
  function n(c) {
    t = c;
  }
  function r(c) {
    return e[c] || [];
  }
  function i(c) {
    return r(c).forEach((l) => l(t, c)), s;
  }
  function a(c, l) {
    return e[c] = r(c).concat([l]), s;
  }
  function o(c, l) {
    return e[c] = r(c).filter((u) => u !== l), s;
  }
  const s = {
    init: n,
    emit: i,
    off: o,
    on: a
  };
  return s;
}
const RF = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  inViewThreshold: 0,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0
};
function $F(e) {
  function t(a, o) {
    return I_(a, o || {});
  }
  function n(a) {
    const o = a.breakpoints || {}, s = Vc(o).filter((c) => e.matchMedia(c).matches).map((c) => o[c]).reduce((c, l) => t(c, l), {});
    return t(a, s);
  }
  function r(a) {
    return a.map((o) => Vc(o.breakpoints || {})).reduce((o, s) => o.concat(s), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function IF(e) {
  let t = [];
  function n(a, o) {
    return t = a.filter(({
      options: s
    }) => e.optionsAtMedia(s).active !== !1), t.forEach((s) => s.init(o, e)), a.reduce((s, c) => Object.assign(s, {
      [c.name]: c
    }), {});
  }
  function r() {
    t = t.filter((a) => a.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function La(e, t, n) {
  const r = e.ownerDocument, i = r.defaultView, a = $F(i), o = IF(a), s = ls(), c = ls(), l = CF(), {
    animationRealms: u
  } = La, {
    mergeOptions: f,
    optionsAtMedia: d,
    optionsMediaQueries: p
  } = a, {
    on: m,
    off: h,
    emit: y
  } = l, v = $;
  let g = !1, b, T = f(RF, La.globalOptions), S = f(T), E = [], O, j, D;
  function k() {
    const {
      container: fe,
      slides: me
    } = S;
    j = (nb(fe) ? e.querySelector(fe) : fe) || e.children[0];
    const I = nb(me) ? j.querySelectorAll(me) : me;
    D = [].slice.call(I || j.children);
  }
  function A(fe, me) {
    const Oe = kF(e, j, D, r, i, fe, l, me);
    if (fe.loop && !Oe.slideLooper.canLoop()) {
      const I = Object.assign({}, fe, {
        loop: !1
      });
      return A(I, me);
    }
    return Oe;
  }
  function V(fe, me) {
    if (g) return;
    const Oe = u.find((Y) => Y.window === i), I = Oe || OF(i);
    Oe || u.push(I), T = f(T, fe), S = d(T), E = me || E, k(), b = A(S, I), p([T, ...E.map(({
      options: Y
    }) => Y)]).forEach((Y) => s.add(Y, "change", $)), S.active && (b.translate.to(b.location.get()), b.eventHandler.init(W), b.resizeHandler.init(W, S.watchResize), b.slidesHandler.init(W, S.watchSlides), c.add(r, "visibilitychange", () => {
      r.hidden && I.reset();
    }), b.options.loop && b.slideLooper.loop(), j.offsetParent && D.length && b.dragHandler.init(W, S.watchDrag), O = o.init(E, W));
  }
  function $(fe, me) {
    const Oe = ae();
    L(), V(f({
      startIndex: Oe
    }, fe), me), l.emit("reInit");
  }
  function L() {
    b.dragHandler.destroy(), b.animation.stop(), b.eventStore.clear(), b.translate.clear(), b.slideLooper.clear(), b.resizeHandler.destroy(), b.slidesHandler.destroy(), o.destroy(), s.clear(), c.clear();
  }
  function M() {
    g || (g = !0, s.clear(), L(), l.emit("destroy"));
  }
  function F(fe) {
    const me = b[fe ? "target" : "location"].get(), Oe = S.loop ? "removeOffset" : "constrain";
    return b.slidesInView.check(b.limit[Oe](me));
  }
  function q(fe) {
    const me = F(fe);
    return b.slideIndexes.filter((Oe) => !me.includes(Oe));
  }
  function B(fe, me, Oe) {
    !S.active || g || (b.scrollBody.useBaseFriction().useDuration(me ? 0 : S.duration), b.scrollTo.index(fe, Oe || 0));
  }
  function N(fe) {
    const me = b.index.add(1).get();
    B(me, fe === !0, -1);
  }
  function x(fe) {
    const me = b.index.add(-1).get();
    B(me, fe === !0, 1);
  }
  function z() {
    return b.index.add(1).get() !== ae();
  }
  function Z() {
    return b.index.add(-1).get() !== ae();
  }
  function _() {
    return b.scrollSnaps.map(b.scrollProgress.get);
  }
  function G() {
    return b.scrollProgress.get(b.location.get());
  }
  function ae() {
    return b.index.get();
  }
  function te() {
    return b.indexPrevious.get();
  }
  function se() {
    return O;
  }
  function de() {
    return b;
  }
  function pe() {
    return e;
  }
  function le() {
    return j;
  }
  function X() {
    return D;
  }
  const W = {
    canScrollNext: z,
    canScrollPrev: Z,
    containerNode: le,
    internalEngine: de,
    destroy: M,
    off: h,
    on: m,
    emit: y,
    plugins: se,
    previousScrollSnap: te,
    reInit: v,
    rootNode: pe,
    scrollNext: N,
    scrollPrev: x,
    scrollProgress: G,
    scrollSnapList: _,
    scrollTo: B,
    selectedScrollSnap: ae,
    slideNodes: X,
    slidesInView: F,
    slidesNotInView: q
  };
  return V(t, n), setTimeout(() => l.emit("init"), 0), W;
}
La.animationRealms = [];
La.globalOptions = void 0;
function Fm(e = {}, t = []) {
  const n = Dt(e), r = Dt(t), [i, a] = rt(), [o, s] = rt(), c = kt(() => {
    i && i.reInit(n.current, r.current);
  }, [i]);
  return Ht(() => {
    if (nF() && o) {
      La.globalOptions = Fm.globalOptions;
      const l = La(o, n.current, r.current);
      return a(l), () => l.destroy();
    } else
      a(void 0);
  }, [o, a]), Ht(() => {
    Dm(n.current, e) || (n.current = e, c());
  }, [e, c]), Ht(() => {
    rF(r.current, t) || (r.current = t, c());
  }, [t, c]), [s, i];
}
Fm.globalOptions = void 0;
function AF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M15.75 2.25H21a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V4.81L8.03 17.03a.75.75 0 0 1-1.06-1.06L19.19 3.75h-3.44a.75.75 0 0 1 0-1.5Zm-10.5 4.5a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V10.5a.75.75 0 0 1 1.5 0v8.25a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h8.25a.75.75 0 0 1 0 1.5H5.25Z",
    clipRule: "evenodd"
  }));
}
const PF = /* @__PURE__ */ w.forwardRef(AF);
function NF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
    clipRule: "evenodd"
  }));
}
const DF = /* @__PURE__ */ w.forwardRef(NF);
function MF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
    clipRule: "evenodd"
  }));
}
const jF = /* @__PURE__ */ w.forwardRef(MF);
function LF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M5.625 1.5c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5H5.625ZM7.5 15a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5h-7.5A.75.75 0 0 1 7.5 15Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H8.25Z",
    clipRule: "evenodd"
  }), /* @__PURE__ */ w.createElement("path", {
    d: "M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z"
  }));
}
const FF = /* @__PURE__ */ w.forwardRef(LF);
function BF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    d: "M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z"
  }), /* @__PURE__ */ w.createElement("path", {
    d: "M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z"
  }));
}
const UF = /* @__PURE__ */ w.forwardRef(BF);
function zF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z"
  }));
}
const VF = /* @__PURE__ */ w.forwardRef(zF);
function HF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z",
    clipRule: "evenodd"
  }));
}
const qF = /* @__PURE__ */ w.forwardRef(HF);
function WF({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 4.5a3 3 0 0 1 3-3h1.372c.86 0 1.61.586 1.819 1.42l1.105 4.423a1.875 1.875 0 0 1-.694 1.955l-1.293.97c-.135.101-.164.249-.126.352a11.285 11.285 0 0 0 6.697 6.697c.103.038.25.009.352-.126l.97-1.293a1.875 1.875 0 0 1 1.955-.694l4.423 1.105c.834.209 1.42.959 1.42 1.82V19.5a3 3 0 0 1-3 3h-2.25C8.552 22.5 1.5 15.448 1.5 6.75V4.5Z",
    clipRule: "evenodd"
  }));
}
const ZF = /* @__PURE__ */ w.forwardRef(WF), D_ = In(
  ({ blocks: e, direction: t, sender: n, timestamp: r, metadata: i, sendMessage: a, messageId: o }, s) => {
    const [c, l] = Fm({ skipSnaps: !0, loop: !0 }), [u, f] = rt(!0), [d, p] = rt(!0), m = kt(() => l == null ? void 0 : l.scrollPrev(), [l]), h = kt(() => l == null ? void 0 : l.scrollNext(), [l]), {
      message: {
        blocks: { carousel: y }
      }
    } = bt, v = kt((g) => {
      f(!g.canScrollPrev()), p(!g.canScrollNext());
    }, []);
    return Ht(() => {
      l && (v(l), l.on("reInit", v), l.on("select", v));
    }, [l, v]), /* @__PURE__ */ R.jsxs("div", { ...y == null ? void 0 : y.container, "data-container": "carousel", ref: c, children: [
      /* @__PURE__ */ R.jsx("div", { ref: s, ...y == null ? void 0 : y.slidesContainer, children: e.map((g, b) => /* @__PURE__ */ R.jsx(
        qs,
        {
          block: { ...g, direction: t, timestamp: r, sender: n, messageId: o, sendMessage: a },
          direction: t,
          sender: n,
          timestamp: r,
          metadata: i,
          sendMessage: a,
          messageId: o
        },
        b
      )) }),
      e.length > 1 && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(
          DF,
          {
            ...y == null ? void 0 : y.backButton,
            "data-disabled": u ? "" : void 0,
            onClick: m
          }
        ),
        /* @__PURE__ */ R.jsx(
          jF,
          {
            ...y == null ? void 0 : y.nextButton,
            "data-disabled": d ? "" : void 0,
            onClick: h
          }
        )
      ] })
    ] });
  }
);
D_.displayName = "Carousel";
const ib = Math.floor;
function M_(e) {
  return j_(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Vs(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function KF(e) {
  var t;
  return (t = (j_(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function j_(e) {
  return e instanceof Node || e instanceof Vs(e).Node;
}
function Ln(e) {
  return e instanceof Element || e instanceof Vs(e).Element;
}
function Fa(e) {
  return e instanceof HTMLElement || e instanceof Vs(e).HTMLElement;
}
function rh(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Vs(e).ShadowRoot;
}
function GF(e) {
  return ["html", "body", "#document"].includes(M_(e));
}
function YF(e) {
  return Vs(e).getComputedStyle(e);
}
function JF(e) {
  if (M_(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    rh(e) && e.host || // Fallback.
    KF(e)
  );
  return rh(t) ? t.host : t;
}
function oi(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function bn(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && rh(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function L_() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function XF() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function F_(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return !0;
  const t = /Android/i;
  return (t.test(L_()) || t.test(XF())) && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function B_(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0;
}
function U_() {
  return /apple/i.test(navigator.vendor);
}
function QF() {
  return L_().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function ab(e, t) {
  return ["mouse", "pen"].includes(e);
}
function e5(e) {
  return "nativeEvent" in e;
}
function t5(e) {
  return e.matches("html,body");
}
function Jn(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function zf(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function z_(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const n5 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function V_(e) {
  return Fa(e) && e.matches(n5);
}
function Qt(e) {
  e.preventDefault(), e.stopPropagation();
}
const Bm = "ArrowUp", Au = "ArrowDown", Ba = "ArrowLeft", Hs = "ArrowRight";
function Tl(e, t, n) {
  return Math.floor(e / t) !== n;
}
function Lo(e, t) {
  return t < 0 || t >= e.current.length;
}
function Vf(e, t) {
  return rn(e, {
    disabledIndices: t
  });
}
function ob(e, t) {
  return rn(e, {
    decrement: !0,
    startingIndex: e.current.length,
    disabledIndices: t
  });
}
function rn(e, t) {
  let {
    startingIndex: n = -1,
    decrement: r = !1,
    disabledIndices: i,
    amount: a = 1
  } = t === void 0 ? {} : t;
  const o = e.current;
  let s = n;
  do {
    var c, l;
    s = s + (r ? -a : a);
  } while (s >= 0 && s <= o.length - 1 && (i ? i.includes(s) : o[s] == null || (c = o[s]) != null && c.hasAttribute("disabled") || ((l = o[s]) == null ? void 0 : l.getAttribute("aria-disabled")) === "true"));
  return s;
}
function r5(e, t) {
  let {
    event: n,
    orientation: r,
    loop: i,
    cols: a,
    disabledIndices: o,
    minIndex: s,
    maxIndex: c,
    prevIndex: l,
    stopEvent: u = !1
  } = t, f = l;
  if (n.key === Bm) {
    if (u && Qt(n), l === -1)
      f = c;
    else if (f = rn(e, {
      startingIndex: f,
      amount: a,
      decrement: !0,
      disabledIndices: o
    }), i && (l - a < s || f < 0)) {
      const d = l % a, p = c % a, m = c - (p - d);
      p === d ? f = c : f = p > d ? m : m - a;
    }
    Lo(e, f) && (f = l);
  }
  if (n.key === Au && (u && Qt(n), l === -1 ? f = s : (f = rn(e, {
    startingIndex: l,
    amount: a,
    disabledIndices: o
  }), i && l + a > c && (f = rn(e, {
    startingIndex: l % a - a,
    amount: a,
    disabledIndices: o
  }))), Lo(e, f) && (f = l)), r === "both") {
    const d = ib(l / a);
    n.key === Hs && (u && Qt(n), l % a !== a - 1 ? (f = rn(e, {
      startingIndex: l,
      disabledIndices: o
    }), i && Tl(f, a, d) && (f = rn(e, {
      startingIndex: l - l % a - 1,
      disabledIndices: o
    }))) : i && (f = rn(e, {
      startingIndex: l - l % a - 1,
      disabledIndices: o
    })), Tl(f, a, d) && (f = l)), n.key === Ba && (u && Qt(n), l % a !== 0 ? (f = rn(e, {
      startingIndex: l,
      disabledIndices: o,
      decrement: !0
    }), i && Tl(f, a, d) && (f = rn(e, {
      startingIndex: l + (a - l % a),
      decrement: !0,
      disabledIndices: o
    }))) : i && (f = rn(e, {
      startingIndex: l + (a - l % a),
      decrement: !0,
      disabledIndices: o
    })), Tl(f, a, d) && (f = l));
    const p = ib(c / a) === d;
    Lo(e, f) && (i && p ? f = n.key === Ba ? c : rn(e, {
      startingIndex: l - l % a - 1,
      disabledIndices: o
    }) : f = l);
  }
  return f;
}
let sb = 0;
function Lr(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = t;
  r && cancelAnimationFrame(sb);
  const a = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  i ? a() : sb = requestAnimationFrame(a);
}
var Vt = typeof document < "u" ? Qa : Ht;
function Hc() {
  return Hc = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hc.apply(this, arguments);
}
let Hf = !1, i5 = 0;
const lb = () => "floating-ui-" + i5++;
function a5() {
  const [e, t] = w.useState(() => Hf ? lb() : void 0);
  return Vt(() => {
    e == null && t(lb());
  }, []), w.useEffect(() => {
    Hf || (Hf = !0);
  }, []), e;
}
const o5 = w.useId, Um = o5 || a5;
function s5() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((i) => i(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((i) => i !== n)) || []);
    }
  };
}
const l5 = /* @__PURE__ */ w.createContext(null), c5 = /* @__PURE__ */ w.createContext(null), H_ = () => {
  var e;
  return ((e = w.useContext(l5)) == null ? void 0 : e.id) || null;
}, Pu = () => w.useContext(c5);
function cs(e) {
  return "data-floating-ui-" + e;
}
function fi(e) {
  const t = Dt(e);
  return Vt(() => {
    t.current = e;
  }), t;
}
function u5(e, t) {
  var n;
  let r = [], i = (n = e.find((a) => a.id === t)) == null ? void 0 : n.parentId;
  for (; i; ) {
    const a = e.find((o) => o.id === i);
    i = a == null ? void 0 : a.parentId, a && (r = r.concat(a));
  }
  return r;
}
function Oa(e, t) {
  let n = e.filter((i) => {
    var a;
    return i.parentId === t && ((a = i.context) == null ? void 0 : a.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((i) => {
      var a;
      return (a = r) == null ? void 0 : a.some((o) => {
        var s;
        return i.parentId === o.id && ((s = i.context) == null ? void 0 : s.open);
      });
    }), n = n.concat(r);
  return n;
}
function f5(e, t) {
  let n, r = -1;
  function i(a, o) {
    o > r && (n = a, r = o), Oa(e, a).forEach((c) => {
      i(c.id, o + 1);
    });
  }
  return i(t, 0), e.find((a) => a.id === n);
}
let aa = /* @__PURE__ */ new WeakMap(), kl = /* @__PURE__ */ new WeakSet(), Ol = {}, qf = 0;
const d5 = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, q_ = (e) => e && (e.host || q_(e.parentNode)), p5 = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = q_(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function h5(e, t, n, r) {
  const i = "data-floating-ui-inert", a = r ? "inert" : n ? "aria-hidden" : null, o = p5(t, e), s = /* @__PURE__ */ new Set(), c = new Set(o), l = [];
  Ol[i] || (Ol[i] = /* @__PURE__ */ new WeakMap());
  const u = Ol[i];
  o.forEach(f), d(t), s.clear();
  function f(p) {
    !p || s.has(p) || (s.add(p), p.parentNode && f(p.parentNode));
  }
  function d(p) {
    !p || c.has(p) || Array.prototype.forEach.call(p.children, (m) => {
      if (s.has(m))
        d(m);
      else {
        const h = a ? m.getAttribute(a) : null, y = h !== null && h !== "false", v = (aa.get(m) || 0) + 1, g = (u.get(m) || 0) + 1;
        aa.set(m, v), u.set(m, g), l.push(m), v === 1 && y && kl.add(m), g === 1 && m.setAttribute(i, ""), !y && a && m.setAttribute(a, "true");
      }
    });
  }
  return qf++, () => {
    l.forEach((p) => {
      const m = (aa.get(p) || 0) - 1, h = (u.get(p) || 0) - 1;
      aa.set(p, m), u.set(p, h), m || (!kl.has(p) && a && p.removeAttribute(a), kl.delete(p)), h || p.removeAttribute(i);
    }), qf--, qf || (aa = /* @__PURE__ */ new WeakMap(), aa = /* @__PURE__ */ new WeakMap(), kl = /* @__PURE__ */ new WeakSet(), Ol = {});
  };
}
function cb(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = Jn(e[0]).body;
  return h5(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const zm = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function W_(e, t) {
  const n = Pm(e, zm());
  t === "prev" && n.reverse();
  const r = n.indexOf(oi(Jn(e)));
  return n.slice(r + 1)[0];
}
function Z_() {
  return W_(document.body, "next");
}
function K_() {
  return W_(document.body, "prev");
}
function Fo(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !bn(n, r);
}
function m5(e) {
  Pm(e, zm()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function v5(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const Vm = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let y5;
function ub(e) {
  e.key === "Tab" && (e.target, clearTimeout(y5));
}
const qc = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const [r, i] = w.useState();
  Vt(() => (U_() && i("button"), document.addEventListener("keydown", ub), () => {
    document.removeEventListener("keydown", ub);
  }), []);
  const a = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [cs("focus-guard")]: "",
    style: Vm
  };
  return /* @__PURE__ */ w.createElement("span", Hc({}, t, a));
}), G_ = /* @__PURE__ */ w.createContext(null);
function g5(e) {
  let {
    id: t,
    root: n
  } = e === void 0 ? {} : e;
  const [r, i] = w.useState(null), a = Um(), o = Y_(), s = w.useMemo(() => ({
    id: t,
    root: n,
    portalContext: o,
    uniqueId: a
  }), [t, n, o, a]), c = w.useRef();
  return Vt(() => () => {
    r == null || r.remove();
  }, [r, s]), Vt(() => {
    if (c.current === s) return;
    c.current = s;
    const {
      id: l,
      root: u,
      portalContext: f,
      uniqueId: d
    } = s, p = l ? document.getElementById(l) : null, m = cs("portal");
    if (p) {
      const h = document.createElement("div");
      h.id = d, h.setAttribute(m, ""), p.appendChild(h), i(h);
    } else {
      let h = u || (f == null ? void 0 : f.portalNode);
      h && !Ln(h) && (h = h.current), h = h || document.body;
      let y = null;
      l && (y = document.createElement("div"), y.id = l, h.appendChild(y));
      const v = document.createElement("div");
      v.id = d, v.setAttribute(m, ""), h = y || h, h.appendChild(v), i(v);
    }
  }, [s]), r;
}
function b5(e) {
  let {
    children: t,
    id: n,
    root: r = null,
    preserveTabOrder: i = !0
  } = e;
  const a = g5({
    id: n,
    root: r
  }), [o, s] = w.useState(null), c = w.useRef(null), l = w.useRef(null), u = w.useRef(null), f = w.useRef(null), d = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!o && // Guards are only for non-modal focus management.
    !o.modal && // Don't render if unmount is transitioning.
    o.open && i && !!(r || a)
  );
  return w.useEffect(() => {
    if (!a || !i || o != null && o.modal)
      return;
    function p(m) {
      a && Fo(m) && (m.type === "focusin" ? v5 : m5)(a);
    }
    return a.addEventListener("focusin", p, !0), a.addEventListener("focusout", p, !0), () => {
      a.removeEventListener("focusin", p, !0), a.removeEventListener("focusout", p, !0);
    };
  }, [a, i, o == null ? void 0 : o.modal]), /* @__PURE__ */ w.createElement(G_.Provider, {
    value: w.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: c,
      afterOutsideRef: l,
      beforeInsideRef: u,
      afterInsideRef: f,
      portalNode: a,
      setFocusManagerState: s
    }), [i, a])
  }, d && a && /* @__PURE__ */ w.createElement(qc, {
    "data-type": "outside",
    ref: c,
    onFocus: (p) => {
      if (Fo(p, a)) {
        var m;
        (m = u.current) == null || m.focus();
      } else {
        const h = K_() || (o == null ? void 0 : o.refs.domReference.current);
        h == null || h.focus();
      }
    }
  }), d && a && /* @__PURE__ */ w.createElement("span", {
    "aria-owns": a.id,
    style: Vm
  }), a && /* @__PURE__ */ PC(t, a), d && a && /* @__PURE__ */ w.createElement(qc, {
    "data-type": "outside",
    ref: l,
    onFocus: (p) => {
      if (Fo(p, a)) {
        var m;
        (m = f.current) == null || m.focus();
      } else {
        const h = Z_() || (o == null ? void 0 : o.refs.domReference.current);
        h == null || h.focus(), o != null && o.closeOnFocusOut && (o == null || o.onOpenChange(!1, p.nativeEvent));
      }
    }
  }));
}
const Y_ = () => w.useContext(G_), x5 = /* @__PURE__ */ w.forwardRef(function(t, n) {
  return /* @__PURE__ */ w.createElement("button", Hc({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: Vm
  }));
});
function w5(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: i = ["content"],
    guards: a = !0,
    initialFocus: o = 0,
    returnFocus: s = !0,
    modal: c = !0,
    visuallyHiddenDismiss: l = !1,
    closeOnFocusOut: u = !0
  } = e, {
    open: f,
    refs: d,
    nodeId: p,
    onOpenChange: m,
    events: h,
    dataRef: y,
    elements: {
      domReference: v,
      floating: g
    }
  } = t, b = d5() ? a : !0, T = fi(i), S = fi(o), E = fi(s), O = Pu(), j = Y_(), D = typeof o == "number" && o < 0, k = w.useRef(null), A = w.useRef(null), V = w.useRef(!1), $ = w.useRef(null), L = w.useRef(!1), M = j != null, F = v && v.getAttribute("role") === "combobox" && V_(v) && D, q = w.useCallback(function(z) {
    return z === void 0 && (z = g), z ? Pm(z, zm()) : [];
  }, [g]), B = w.useCallback((z) => {
    const Z = q(z);
    return T.current.map((_) => v && _ === "reference" ? v : g && _ === "floating" ? g : Z).filter(Boolean).flat();
  }, [v, g, T, q]);
  w.useEffect(() => {
    if (r || !c) return;
    function z(_) {
      if (_.key === "Tab") {
        bn(g, oi(Jn(g))) && q().length === 0 && !F && Qt(_);
        const G = B(), ae = z_(_);
        T.current[0] === "reference" && ae === v && (Qt(_), _.shiftKey ? Lr(G[G.length - 1]) : Lr(G[1])), T.current[1] === "floating" && ae === g && _.shiftKey && (Qt(_), Lr(G[0]));
      }
    }
    const Z = Jn(g);
    return Z.addEventListener("keydown", z), () => {
      Z.removeEventListener("keydown", z);
    };
  }, [r, v, g, c, T, d, F, q, B]), w.useEffect(() => {
    if (r || !u) return;
    function z() {
      L.current = !0, setTimeout(() => {
        L.current = !1;
      });
    }
    function Z(_) {
      const G = _.relatedTarget;
      queueMicrotask(() => {
        const ae = !(bn(v, G) || bn(g, G) || bn(G, g) || bn(j == null ? void 0 : j.portalNode, G) || G != null && G.hasAttribute(cs("focus-guard")) || O && (Oa(O.nodesRef.current, p).find((te) => {
          var se, de;
          return bn((se = te.context) == null ? void 0 : se.elements.floating, G) || bn((de = te.context) == null ? void 0 : de.elements.domReference, G);
        }) || u5(O.nodesRef.current, p).find((te) => {
          var se, de;
          return ((se = te.context) == null ? void 0 : se.elements.floating) === G || ((de = te.context) == null ? void 0 : de.elements.domReference) === G;
        })));
        G && ae && !L.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        G !== $.current && (V.current = !0, m(!1, _));
      });
    }
    if (g && Fa(v))
      return v.addEventListener("focusout", Z), v.addEventListener("pointerdown", z), !c && g.addEventListener("focusout", Z), () => {
        v.removeEventListener("focusout", Z), v.removeEventListener("pointerdown", z), !c && g.removeEventListener("focusout", Z);
      };
  }, [r, v, g, c, p, O, j, m, u]), w.useEffect(() => {
    var z;
    if (r) return;
    const Z = Array.from((j == null || (z = j.portalNode) == null ? void 0 : z.querySelectorAll("[" + cs("portal") + "]")) || []);
    if (g) {
      const _ = [g, ...Z, k.current, A.current, T.current.includes("reference") || F ? v : null].filter((ae) => ae != null), G = c ? cb(_, b, !b) : cb(_);
      return () => {
        G();
      };
    }
  }, [r, v, g, c, T, j, F, b]), Vt(() => {
    if (r || !g) return;
    const z = Jn(g), Z = oi(z);
    queueMicrotask(() => {
      const _ = B(g), G = S.current, ae = (typeof G == "number" ? _[G] : G.current) || g, te = bn(g, Z);
      !D && !te && f && Lr(ae, {
        preventScroll: ae === g
      });
    });
  }, [r, f, g, D, B, S]), Vt(() => {
    if (r || !g) return;
    let z = !1;
    const Z = Jn(g), _ = oi(Z), G = y.current;
    $.current = _;
    function ae(te) {
      if (te.type === "escapeKey" && d.domReference.current && ($.current = d.domReference.current), ["referencePress", "escapeKey"].includes(te.type))
        return;
      const se = te.data.returnFocus;
      typeof se == "object" ? (V.current = !1, z = se.preventScroll) : V.current = !se;
    }
    return h.on("dismiss", ae), () => {
      h.off("dismiss", ae);
      const te = oi(Z);
      (bn(g, te) || O && Oa(O.nodesRef.current, p).some((de) => {
        var pe;
        return bn((pe = de.context) == null ? void 0 : pe.elements.floating, te);
      }) || G.openEvent && ["click", "mousedown"].includes(G.openEvent.type)) && d.domReference.current && ($.current = d.domReference.current), // eslint-disable-next-line react-hooks/exhaustive-deps
      E.current && Fa($.current) && !V.current && Lr($.current, {
        // When dismissing nested floating elements, by the time the rAF has
        // executed, the menus will all have been unmounted. When they try
        // to get focused, the calls get ignored — leaving the root
        // reference focused as desired.
        cancelPrevious: !1,
        preventScroll: z
      });
    };
  }, [r, g, E, y, d, h, O, p]), Vt(() => {
    if (!(r || !j))
      return j.setFocusManagerState({
        modal: c,
        closeOnFocusOut: u,
        open: f,
        onOpenChange: m,
        refs: d
      }), () => {
        j.setFocusManagerState(null);
      };
  }, [r, j, c, f, m, d, u]), Vt(() => {
    if (!r && g && typeof MutationObserver == "function" && !D) {
      const z = () => {
        const _ = g.getAttribute("tabindex");
        T.current.includes("floating") || oi(Jn(g)) !== d.domReference.current && q().length === 0 ? _ !== "0" && g.setAttribute("tabindex", "0") : _ !== "-1" && g.setAttribute("tabindex", "-1");
      };
      z();
      const Z = new MutationObserver(z);
      return Z.observe(g, {
        childList: !0,
        subtree: !0,
        attributes: !0
      }), () => {
        Z.disconnect();
      };
    }
  }, [r, g, d, T, q, D]);
  function N(z) {
    return r || !l || !c ? null : /* @__PURE__ */ w.createElement(x5, {
      ref: z === "start" ? k : A,
      onClick: (Z) => m(!1, Z.nativeEvent)
    }, typeof l == "string" ? l : "Dismiss");
  }
  const x = !r && b && !F && (M || c);
  return /* @__PURE__ */ w.createElement(w.Fragment, null, x && /* @__PURE__ */ w.createElement(qc, {
    "data-type": "inside",
    ref: j == null ? void 0 : j.beforeInsideRef,
    onFocus: (z) => {
      if (c) {
        const _ = B();
        Lr(i[0] === "reference" ? _[0] : _[_.length - 1]);
      } else if (j != null && j.preserveTabOrder && j.portalNode)
        if (V.current = !1, Fo(z, j.portalNode)) {
          const _ = Z_() || v;
          _ == null || _.focus();
        } else {
          var Z;
          (Z = j.beforeOutsideRef.current) == null || Z.focus();
        }
    }
  }), !F && N("start"), n, N("end"), x && /* @__PURE__ */ w.createElement(qc, {
    "data-type": "inside",
    ref: j == null ? void 0 : j.afterInsideRef,
    onFocus: (z) => {
      if (c)
        Lr(B()[0]);
      else if (j != null && j.preserveTabOrder && j.portalNode)
        if (u && (V.current = !0), Fo(z, j.portalNode)) {
          const _ = K_() || v;
          _ == null || _.focus();
        } else {
          var Z;
          (Z = j.afterOutsideRef.current) == null || Z.focus();
        }
    }
  }));
}
function fb(e) {
  return Fa(e.target) && e.target.tagName === "BUTTON";
}
function db(e) {
  return V_(e);
}
function S5(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: a
    }
  } = e, {
    enabled: o = !0,
    event: s = "click",
    toggle: c = !0,
    ignoreMouse: l = !1,
    keyboardHandlers: u = !0
  } = t, f = w.useRef(), d = w.useRef(!1);
  return w.useMemo(() => o ? {
    reference: {
      onPointerDown(p) {
        f.current = p.pointerType;
      },
      onMouseDown(p) {
        p.button === 0 && (ab(f.current) && l || s !== "click" && (n && c && (!i.current.openEvent || i.current.openEvent.type === "mousedown") ? r(!1, p.nativeEvent) : (p.preventDefault(), r(!0, p.nativeEvent))));
      },
      onClick(p) {
        if (s === "mousedown" && f.current) {
          f.current = void 0;
          return;
        }
        ab(f.current) && l || (n && c && (!i.current.openEvent || i.current.openEvent.type === "click") ? r(!1, p.nativeEvent) : r(!0, p.nativeEvent));
      },
      onKeyDown(p) {
        f.current = void 0, !(p.defaultPrevented || !u || fb(p)) && (p.key === " " && !db(a) && (p.preventDefault(), d.current = !0), p.key === "Enter" && r(!(n && c), p.nativeEvent));
      },
      onKeyUp(p) {
        p.defaultPrevented || !u || fb(p) || db(a) || p.key === " " && d.current && (d.current = !1, r(!(n && c), p.nativeEvent));
      }
    }
  } : {}, [o, i, s, l, u, a, c, n, r]);
}
const _5 = w.useInsertionEffect, E5 = _5 || ((e) => e());
function di(e) {
  const t = w.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return E5(() => {
    t.current = e;
  }), w.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const T5 = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, k5 = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, O5 = (e) => {
  var t, n;
  return {
    escapeKeyBubbles: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePressBubbles: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function C5(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: i,
    nodeId: a,
    elements: {
      reference: o,
      domReference: s,
      floating: c
    },
    dataRef: l
  } = e, {
    enabled: u = !0,
    escapeKey: f = !0,
    outsidePress: d = !0,
    outsidePressEvent: p = "pointerdown",
    referencePress: m = !1,
    referencePressEvent: h = "pointerdown",
    ancestorScroll: y = !1,
    bubbles: v
  } = t, g = Pu(), b = H_() != null, T = di(typeof d == "function" ? d : () => !1), S = typeof d == "function" ? T : d, E = w.useRef(!1), {
    escapeKeyBubbles: O,
    outsidePressBubbles: j
  } = O5(v), D = di((A) => {
    if (!n || !u || !f || A.key !== "Escape")
      return;
    const V = g ? Oa(g.nodesRef.current, a) : [];
    if (!O && (A.stopPropagation(), V.length > 0)) {
      let $ = !0;
      if (V.forEach((L) => {
        var M;
        if ((M = L.context) != null && M.open && !L.context.dataRef.current.__escapeKeyBubbles) {
          $ = !1;
          return;
        }
      }), !$)
        return;
    }
    i.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: !1
        }
      }
    }), r(!1, e5(A) ? A.nativeEvent : A);
  }), k = di((A) => {
    const V = E.current;
    if (E.current = !1, V || typeof S == "function" && !S(A))
      return;
    const $ = z_(A), L = "[" + cs("inert") + "]", M = Jn(c).querySelectorAll(L);
    let F = Ln($) ? $ : null;
    for (; F && !GF(F); ) {
      const N = JF(F);
      if (N === Jn(c).body || !Ln(N))
        break;
      F = N;
    }
    if (M.length && Ln($) && !t5($) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !bn($, c) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(M).every((N) => !bn(F, N)))
      return;
    if (Fa($) && c) {
      const N = $.clientWidth > 0 && $.scrollWidth > $.clientWidth, x = $.clientHeight > 0 && $.scrollHeight > $.clientHeight;
      let z = x && A.offsetX > $.clientWidth;
      if (x && YF($).direction === "rtl" && (z = A.offsetX <= $.offsetWidth - $.clientWidth), z || N && A.offsetY > $.clientHeight)
        return;
    }
    const q = g && Oa(g.nodesRef.current, a).some((N) => {
      var x;
      return zf(A, (x = N.context) == null ? void 0 : x.elements.floating);
    });
    if (zf(A, c) || zf(A, s) || q)
      return;
    const B = g ? Oa(g.nodesRef.current, a) : [];
    if (B.length > 0) {
      let N = !0;
      if (B.forEach((x) => {
        var z;
        if ((z = x.context) != null && z.open && !x.context.dataRef.current.__outsidePressBubbles) {
          N = !1;
          return;
        }
      }), !N)
        return;
    }
    i.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: b ? {
          preventScroll: !0
        } : F_(A) || B_(A)
      }
    }), r(!1, A);
  });
  return w.useEffect(() => {
    if (!n || !u)
      return;
    l.current.__escapeKeyBubbles = O, l.current.__outsidePressBubbles = j;
    function A(L) {
      r(!1, L);
    }
    const V = Jn(c);
    f && V.addEventListener("keydown", D), S && V.addEventListener(p, k);
    let $ = [];
    return y && (Ln(s) && ($ = ui(s)), Ln(c) && ($ = $.concat(ui(c))), !Ln(o) && o && o.contextElement && ($ = $.concat(ui(o.contextElement)))), $ = $.filter((L) => {
      var M;
      return L !== ((M = V.defaultView) == null ? void 0 : M.visualViewport);
    }), $.forEach((L) => {
      L.addEventListener("scroll", A, {
        passive: !0
      });
    }), () => {
      f && V.removeEventListener("keydown", D), S && V.removeEventListener(p, k), $.forEach((L) => {
        L.removeEventListener("scroll", A);
      });
    };
  }, [l, c, s, o, f, S, p, n, r, y, u, O, j, D, k]), w.useEffect(() => {
    E.current = !1;
  }, [S, p]), w.useMemo(() => u ? {
    reference: {
      onKeyDown: D,
      [T5[h]]: (A) => {
        m && (i.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1, A.nativeEvent));
      }
    },
    floating: {
      onKeyDown: D,
      [k5[p]]: () => {
        E.current = !0;
      }
    }
  } : {}, [u, i, m, p, h, r, D]);
}
let ih;
process.env.NODE_ENV !== "production" && (ih = /* @__PURE__ */ new Set());
function R5(e) {
  var t;
  e === void 0 && (e = {});
  const {
    open: n = !1,
    onOpenChange: r,
    nodeId: i
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var a;
    const O = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((a = e.elements) != null && a.reference && !Ln(e.elements.reference)) {
      var o;
      if (!((o = ih) != null && o.has(O))) {
        var s;
        (s = ih) == null || s.add(O), console.error(O);
      }
    }
  }
  const [c, l] = w.useState(null), u = ((t = e.elements) == null ? void 0 : t.reference) || c, f = DL(e), d = Pu(), p = di((O, j) => {
    O && (h.current.openEvent = j), r == null || r(O, j);
  }), m = w.useRef(null), h = w.useRef({}), y = w.useState(() => s5())[0], v = Um(), g = w.useCallback((O) => {
    const j = Ln(O) ? {
      getBoundingClientRect: () => O.getBoundingClientRect(),
      contextElement: O
    } : O;
    f.refs.setReference(j);
  }, [f.refs]), b = w.useCallback((O) => {
    (Ln(O) || O === null) && (m.current = O, l(O)), (Ln(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    O !== null && !Ln(O)) && f.refs.setReference(O);
  }, [f.refs]), T = w.useMemo(() => ({
    ...f.refs,
    setReference: b,
    setPositionReference: g,
    domReference: m
  }), [f.refs, b, g]), S = w.useMemo(() => ({
    ...f.elements,
    domReference: u
  }), [f.elements, u]), E = w.useMemo(() => ({
    ...f,
    refs: T,
    elements: S,
    dataRef: h,
    nodeId: i,
    floatingId: v,
    events: y,
    open: n,
    onOpenChange: p
  }), [f, i, v, y, n, p, T, S]);
  return Vt(() => {
    const O = d == null ? void 0 : d.nodesRef.current.find((j) => j.id === i);
    O && (O.context = E);
  }), w.useMemo(() => ({
    ...f,
    context: E,
    refs: T,
    elements: S
  }), [f, T, S, E]);
}
function Wf(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...e,
    ...t.map((i) => i ? i[n] : null).concat(e).reduce((i, a) => (a && Object.entries(a).forEach((o) => {
      let [s, c] = o;
      if (s.indexOf("on") === 0) {
        if (r.has(s) || r.set(s, []), typeof c == "function") {
          var l;
          (l = r.get(s)) == null || l.push(c), i[s] = function() {
            for (var u, f = arguments.length, d = new Array(f), p = 0; p < f; p++)
              d[p] = arguments[p];
            return (u = r.get(s)) == null ? void 0 : u.map((m) => m(...d)).find((m) => m !== void 0);
          };
        }
      } else
        i[s] = c;
    }), i), {})
  };
}
function $5(e) {
  e === void 0 && (e = []);
  const t = e, n = w.useCallback(
    (a) => Wf(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), r = w.useCallback(
    (a) => Wf(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), i = w.useCallback(
    (a) => Wf(a, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((a) => a == null ? void 0 : a.item)
  );
  return w.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: i
  }), [n, r, i]);
}
let pb = !1;
function Nu(e, t, n) {
  switch (e) {
    case "vertical":
      return t;
    case "horizontal":
      return n;
    default:
      return t || n;
  }
}
function hb(e, t) {
  return Nu(t, e === Bm || e === Au, e === Ba || e === Hs);
}
function Zf(e, t, n) {
  return Nu(t, e === Au, n ? e === Ba : e === Hs) || e === "Enter" || e == " " || e === "";
}
function I5(e, t, n) {
  return Nu(t, n ? e === Ba : e === Hs, e === Au);
}
function mb(e, t, n) {
  return Nu(t, n ? e === Hs : e === Ba, e === Bm);
}
function A5(e, t) {
  const {
    open: n,
    onOpenChange: r,
    refs: i,
    elements: {
      domReference: a,
      floating: o
    }
  } = e, {
    listRef: s,
    activeIndex: c,
    onNavigate: l = () => {
    },
    enabled: u = !0,
    selectedIndex: f = null,
    allowEscape: d = !1,
    loop: p = !1,
    nested: m = !1,
    rtl: h = !1,
    virtual: y = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: g = !0,
    openOnArrowKeyDown: b = !0,
    disabledIndices: T = void 0,
    orientation: S = "vertical",
    cols: E = 1,
    scrollItemIntoView: O = !0,
    virtualItemRef: j
  } = t;
  process.env.NODE_ENV !== "production" && (d && (p || console.warn(["Floating UI: `useListNavigation` looping must be enabled to allow", "escaping."].join(" ")), y || console.warn(["Floating UI: `useListNavigation` must be virtual to allow", "escaping."].join(" "))), S === "vertical" && E > 1 && console.warn(["Floating UI: In grid list navigation mode (`cols` > 1), the", '`orientation` should be either "horizontal" or "both".'].join(" ")));
  const D = H_(), k = Pu(), A = di(l), V = w.useRef(v), $ = w.useRef(f ?? -1), L = w.useRef(null), M = w.useRef(!0), F = w.useRef(A), q = w.useRef(!!o), B = w.useRef(!1), N = w.useRef(!1), x = fi(T), z = fi(n), Z = fi(O), [_, G] = w.useState(), [ae, te] = w.useState(), se = di(function(le, X, W) {
    W === void 0 && (W = !1);
    const fe = le.current[X.current];
    fe && (y ? (G(fe.id), k == null || k.events.emit("virtualfocus", fe), j && (j.current = fe)) : Lr(fe, {
      preventScroll: !0,
      // Mac Safari does not move the virtual cursor unless the focus call
      // is sync. However, for the very first focus call, we need to wait
      // for the position to be ready in order to prevent unwanted
      // scrolling. This means the virtual cursor will not move to the first
      // item when first opening the floating element, but will on
      // subsequent calls. `preventScroll` is supported in modern Safari,
      // so we can use that instead.
      // iOS Safari must be async or the first item will not be focused.
      sync: QF() && U_() ? pb || B.current : !1
    }), requestAnimationFrame(() => {
      const me = Z.current;
      me && fe && (W || !M.current) && (fe.scrollIntoView == null || fe.scrollIntoView(typeof me == "boolean" ? {
        block: "nearest",
        inline: "nearest"
      } : me));
    }));
  });
  Vt(() => {
    document.createElement("div").focus({
      get preventScroll() {
        return pb = !0, !1;
      }
    });
  }, []), Vt(() => {
    u && (n && o ? V.current && f != null && (N.current = !0, A(f)) : q.current && ($.current = -1, F.current(null)));
  }, [u, n, o, f, A]), Vt(() => {
    if (u && n && o)
      if (c == null) {
        if (B.current = !1, f != null)
          return;
        if (q.current && ($.current = -1, se(s, $)), !q.current && V.current && (L.current != null || V.current === !0 && L.current == null)) {
          let le = 0;
          const X = () => {
            s.current[0] == null ? (le < 2 && (le ? requestAnimationFrame : queueMicrotask)(X), le++) : ($.current = L.current == null || Zf(L.current, S, h) || m ? Vf(s, x.current) : ob(s, x.current), L.current = null, A($.current));
          };
          X();
        }
      } else Lo(s, c) || ($.current = c, se(s, $, N.current), N.current = !1);
  }, [u, n, o, c, f, m, s, S, h, A, se, x]), Vt(() => {
    var le, X;
    if (!u || o || !k || y || !q.current)
      return;
    const W = k.nodesRef.current, fe = (le = W.find((I) => I.id === D)) == null || (X = le.context) == null ? void 0 : X.elements.floating, me = oi(Jn(o)), Oe = W.some((I) => I.context && bn(I.context.elements.floating, me));
    fe && !Oe && M.current && fe.focus({
      preventScroll: !0
    });
  }, [u, o, k, D, y]), Vt(() => {
    if (!u || !k || !y || D) return;
    function le(X) {
      te(X.id), j && (j.current = X);
    }
    return k.events.on("virtualfocus", le), () => {
      k.events.off("virtualfocus", le);
    };
  }, [u, k, y, D, j]), Vt(() => {
    F.current = A, q.current = !!o;
  }), Vt(() => {
    n || (L.current = null);
  }, [n]);
  const de = c != null, pe = w.useMemo(() => {
    function le(W) {
      if (!n) return;
      const fe = s.current.indexOf(W);
      fe !== -1 && A(fe);
    }
    return {
      onFocus(W) {
        let {
          currentTarget: fe
        } = W;
        le(fe);
      },
      onClick: (W) => {
        let {
          currentTarget: fe
        } = W;
        return fe.focus({
          preventScroll: !0
        });
      },
      // Safari
      ...g && {
        onMouseMove(W) {
          let {
            currentTarget: fe
          } = W;
          le(fe);
        },
        onPointerLeave(W) {
          let {
            pointerType: fe
          } = W;
          !M.current || fe === "touch" || ($.current = -1, se(s, $), A(null), y || Lr(i.floating.current, {
            preventScroll: !0
          }));
        }
      }
    };
  }, [n, i, se, g, s, A, y]);
  return w.useMemo(() => {
    if (!u)
      return {};
    const le = x.current;
    function X(I) {
      if (M.current = !1, B.current = !0, !z.current && I.currentTarget === i.floating.current)
        return;
      if (m && mb(I.key, S, h)) {
        Qt(I), r(!1, I.nativeEvent), Fa(a) && !y && a.focus();
        return;
      }
      const Y = $.current, re = Vf(s, le), Q = ob(s, le);
      if (I.key === "Home" && (Qt(I), $.current = re, A($.current)), I.key === "End" && (Qt(I), $.current = Q, A($.current)), !(E > 1 && ($.current = r5(s, {
        event: I,
        orientation: S,
        loop: p,
        cols: E,
        disabledIndices: le,
        minIndex: re,
        maxIndex: Q,
        prevIndex: $.current,
        stopEvent: !0
      }), A($.current), S === "both")) && hb(I.key, S)) {
        if (Qt(I), n && !y && oi(I.currentTarget.ownerDocument) === I.currentTarget) {
          $.current = Zf(I.key, S, h) ? re : Q, A($.current);
          return;
        }
        Zf(I.key, S, h) ? p ? $.current = Y >= Q ? d && Y !== s.current.length ? -1 : re : rn(s, {
          startingIndex: Y,
          disabledIndices: le
        }) : $.current = Math.min(Q, rn(s, {
          startingIndex: Y,
          disabledIndices: le
        })) : p ? $.current = Y <= re ? d && Y !== -1 ? s.current.length : Q : rn(s, {
          startingIndex: Y,
          decrement: !0,
          disabledIndices: le
        }) : $.current = Math.max(re, rn(s, {
          startingIndex: Y,
          decrement: !0,
          disabledIndices: le
        })), Lo(s, $.current) ? A(null) : A($.current);
      }
    }
    function W(I) {
      v === "auto" && F_(I.nativeEvent) && (V.current = !0);
    }
    function fe(I) {
      V.current = v, v === "auto" && B_(I.nativeEvent) && (V.current = !0);
    }
    const me = y && n && de && {
      "aria-activedescendant": ae || _
    }, Oe = s.current.find((I) => (I == null ? void 0 : I.id) === _);
    return {
      reference: {
        ...me,
        onKeyDown(I) {
          M.current = !1;
          const Y = I.key.indexOf("Arrow") === 0, re = I5(I.key, S, h), Q = mb(I.key, S, h), Ee = hb(I.key, S), xe = (m ? re : Ee) || I.key === "Enter" || I.key.trim() === "";
          if (y && n) {
            const Me = k == null ? void 0 : k.nodesRef.current.find((P) => P.parentId == null), U = k && Me ? f5(k.nodesRef.current, Me.id) : null;
            if (Y && U && j) {
              const P = new KeyboardEvent("keydown", {
                key: I.key,
                bubbles: !0
              });
              if (re || Q) {
                var Re, Ve;
                const J = ((Re = U.context) == null ? void 0 : Re.elements.domReference) === I.currentTarget, ce = Q && !J ? (Ve = U.context) == null ? void 0 : Ve.elements.domReference : re ? Oe : null;
                ce && (Qt(I), ce.dispatchEvent(P), te(void 0));
              }
              if (Ee && U.context && U.context.open && U.parentId && I.currentTarget !== U.context.elements.domReference) {
                var Ie;
                Qt(I), (Ie = U.context.elements.domReference) == null || Ie.dispatchEvent(P);
                return;
              }
            }
            return X(I);
          }
          if (!(!n && !b && Y)) {
            if (xe && (L.current = m && Ee ? null : I.key), m) {
              re && (Qt(I), n ? ($.current = Vf(s, le), A($.current)) : r(!0, I.nativeEvent));
              return;
            }
            Ee && (f != null && ($.current = f), Qt(I), !n && b ? r(!0, I.nativeEvent) : X(I), n && A($.current));
          }
        },
        onFocus() {
          n && A(null);
        },
        onPointerDown: fe,
        onMouseDown: W,
        onClick: W
      },
      floating: {
        "aria-orientation": S === "both" ? void 0 : S,
        ...me,
        onKeyDown: X,
        onPointerMove() {
          M.current = !0;
        }
      },
      item: pe
    };
  }, [a, i, _, ae, x, z, s, u, S, h, y, n, de, m, f, b, d, E, p, v, A, r, pe, k, j]);
}
function P5(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    floatingId: r
  } = e, {
    enabled: i = !0,
    role: a = "dialog"
  } = t, o = Um();
  return w.useMemo(() => {
    const s = {
      id: r,
      role: a
    };
    return i ? a === "tooltip" ? {
      reference: {
        "aria-describedby": n ? r : void 0
      },
      floating: s
    } : {
      reference: {
        "aria-expanded": n ? "true" : "false",
        "aria-haspopup": a === "alertdialog" ? "dialog" : a,
        "aria-controls": n ? r : void 0,
        ...a === "listbox" && {
          role: "combobox"
        },
        ...a === "menu" && {
          id: o
        }
      },
      floating: {
        ...s,
        ...a === "menu" && {
          "aria-labelledby": o
        }
      }
    } : {};
  }, [i, a, n, r, o]);
}
function N5(e, t) {
  var n;
  const {
    open: r,
    dataRef: i
  } = e, {
    listRef: a,
    activeIndex: o,
    onMatch: s,
    onTypingChange: c,
    enabled: l = !0,
    findMatch: u = null,
    resetMs: f = 750,
    ignoreKeys: d = [],
    selectedIndex: p = null
  } = t, m = w.useRef(), h = w.useRef(""), y = w.useRef((n = p ?? o) != null ? n : -1), v = w.useRef(null), g = di(s), b = di(c), T = fi(u), S = fi(d);
  return Vt(() => {
    r && (clearTimeout(m.current), v.current = null, h.current = "");
  }, [r]), Vt(() => {
    if (r && h.current === "") {
      var E;
      y.current = (E = p ?? o) != null ? E : -1;
    }
  }, [r, p, o]), w.useMemo(() => {
    if (!l)
      return {};
    function E(D) {
      D ? i.current.typing || (i.current.typing = D, b(D)) : i.current.typing && (i.current.typing = D, b(D));
    }
    function O(D, k, A) {
      const V = T.current ? T.current(k, A) : k.find(($) => ($ == null ? void 0 : $.toLocaleLowerCase().indexOf(A.toLocaleLowerCase())) === 0);
      return V ? D.indexOf(V) : -1;
    }
    function j(D) {
      const k = a.current;
      if (h.current.length > 0 && h.current[0] !== " " && (O(k, k, h.current) === -1 ? E(!1) : D.key === " " && Qt(D)), k == null || S.current.includes(D.key) || // Character key.
      D.key.length !== 1 || // Modifier key.
      D.ctrlKey || D.metaKey || D.altKey)
        return;
      r && D.key !== " " && (Qt(D), E(!0)), k.every((L) => {
        var M, F;
        return L ? ((M = L[0]) == null ? void 0 : M.toLocaleLowerCase()) !== ((F = L[1]) == null ? void 0 : F.toLocaleLowerCase()) : !0;
      }) && h.current === D.key && (h.current = "", y.current = v.current), h.current += D.key, clearTimeout(m.current), m.current = setTimeout(() => {
        h.current = "", y.current = v.current, E(!1);
      }, f);
      const V = y.current, $ = O(k, [...k.slice((V || 0) + 1), ...k.slice(0, (V || 0) + 1)], h.current);
      $ !== -1 ? (g($), v.current = $) : D.key !== " " && (h.current = "", E(!1));
    }
    return {
      reference: {
        onKeyDown: j
      },
      floating: {
        onKeyDown: j,
        onKeyUp(D) {
          D.key === " " && E(!1);
        }
      }
    };
  }, [l, r, i, a, f, S, T, g, b]);
}
const D5 = ({ options: e, label: t, reusable: n, sendMessage: r, isReadOnly: i }) => {
  var M, F, q, B, N;
  const a = Rm((x) => x.messageContainerRef), [o, s] = w.useState(!1), [c, l] = w.useState(null), [u, f] = w.useState(null), {
    message: {
      blocks: { dropdown: d }
    }
  } = bt, p = e.reduce(
    (x, z) => (x[z.label] = z.value, x),
    {}
  ), m = p ? Object.keys(p) : [], h = (x) => {
    s(u !== null && !n ? !1 : x);
  }, { refs: y, floatingStyles: v, context: g } = R5({
    placement: "bottom-start",
    open: o,
    onOpenChange: h,
    whileElementsMounted: $L,
    middleware: [
      ML(5),
      jL({
        padding: 10,
        boundary: (a == null ? void 0 : a.current) ?? void 0,
        crossAxis: !0
      }),
      LL({
        apply({ rects: x, elements: z, availableHeight: Z }) {
          Object.assign(z.floating.style, {
            maxHeight: `${Z}px`,
            minWidth: `${x.reference.width}px`
          });
        },
        padding: 10
      })
    ]
  }), b = w.useRef([]), T = w.useRef(m), S = w.useRef(!1), E = S5(g, { event: "mousedown" }), O = C5(g), j = P5(g, { role: "listbox" }), D = A5(g, {
    listRef: b,
    activeIndex: c,
    selectedIndex: u,
    onNavigate: l,
    // This is a large list, allow looping.
    loop: !0
  }), k = N5(g, {
    listRef: T,
    activeIndex: c,
    selectedIndex: u,
    onMatch: o ? l : f,
    onTypingChange(x) {
      S.current = x;
    }
  }), { getReferenceProps: A, getFloatingProps: V, getItemProps: $ } = $5([
    O,
    j,
    D,
    k,
    E
  ]), L = (x) => {
    f(x), m[x] !== void 0 && (r == null || r({ type: "text", text: p[m[x]] ?? "" })), s(!1);
  };
  return u !== null && m[u], /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsxs(
      "div",
      {
        tabIndex: 0,
        ref: y.setReference,
        "aria-labelledby": "select-label",
        "aria-autocomplete": "none",
        "data-disabled": u !== null && !n ? "" : void 0,
        ...(M = d.button) == null ? void 0 : M.container,
        ...A(),
        children: [
          /* @__PURE__ */ R.jsx("span", { ...(F = d.button) == null ? void 0 : F.text, children: "Select..." }),
          /* @__PURE__ */ R.jsx(GL, { ...(q = d.button) == null ? void 0 : q.icon })
        ]
      }
    ),
    o && /* @__PURE__ */ R.jsx(b5, { children: /* @__PURE__ */ R.jsx(w5, { context: g, modal: !1, children: /* @__PURE__ */ R.jsx(
      "div",
      {
        ref: y.setFloating,
        className: (N = (B = d.content) == null ? void 0 : B.container) == null ? void 0 : N.className,
        style: { ...v },
        ...V(),
        children: m.map((x, z) => {
          var Z;
          return /* @__PURE__ */ R.jsx(
            "div",
            {
              ref: (_) => {
                b.current[z] = _;
              },
              role: "option",
              tabIndex: z === c ? 0 : -1,
              "aria-selected": z === u && z === c,
              "data-active": z === c ? "" : void 0,
              ...(Z = d.content) == null ? void 0 : Z.item,
              ...$({
                onClick() {
                  i || L(z);
                },
                onKeyDown(_) {
                  i || (_.key === "Enter" && (_.preventDefault(), L(z)), _.key === " " && !S.current && (_.preventDefault(), L(z)));
                }
              }),
              children: x
            },
            x
          );
        })
      }
    ) }) })
  ] });
}, M5 = In(({ type: e, title: t, url: n, ...r }, i) => {
  const {
    message: {
      blocks: { file: a }
    }
  } = bt;
  return /* @__PURE__ */ R.jsxs("a", { ...r, ...a.container, href: n, download: !0, ref: i, target: "_blank", rel: "noreferrer", children: [
    /* @__PURE__ */ R.jsx("p", { ...a.title, children: t || n }),
    /* @__PURE__ */ R.jsx(JL, { ...a.icon })
  ] });
}), j5 = Ls()((e, t) => ({
  components: {},
  getCustomComponent: async (n) => {
    const r = t().components[n];
    if (r)
      return r;
    const i = await fetch(n).then((l) => l.text()), a = new Blob([i], { type: "application/javascript" }), s = await import(URL.createObjectURL(a)), c = () => s.default;
    return e((l) => ({ components: { ...l.components, [n]: c } })), c;
  }
}));
globalThis.React = vt;
const L5 = ({ url: e, name: t, data: n, ...r }) => {
  const i = j5((l) => l.getCustomComponent), [a, o] = rt(null), [s, c] = rt(null);
  return Ht(() => {
    i(e).then(o).catch((l) => {
      c(l.message);
    });
  }, [e]), s ? /* @__PURE__ */ R.jsx("div", { style: { color: "red" }, children: s }) : a ? /* @__PURE__ */ R.jsx(a, { ...n, ...r }) : null;
}, F5 = {
  audio: qL,
  bubble: o_,
  button: Wj,
  carousel: D_,
  column: R_,
  dropdown: D5,
  file: M5,
  image: C_,
  location: eF,
  row: $_,
  text: Ej,
  video: HL,
  custom: L5
}, qs = ({ block: e, renderers: t, ...n }) => {
  const r = (t == null ? void 0 : t[e.type]) ?? F5[e.type], i = { ...n, ...e };
  return /* @__PURE__ */ R.jsx(r, { ...i });
};
function B5({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    fillRule: "evenodd",
    d: "M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14Z",
    clipRule: "evenodd"
  }));
}
const U5 = /* @__PURE__ */ w.forwardRef(B5);
function z5({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    d: "M8 1a2 2 0 0 0-2 2v4a2 2 0 1 0 4 0V3a2 2 0 0 0-2-2Z"
  }), /* @__PURE__ */ w.createElement("path", {
    d: "M4.5 7A.75.75 0 0 0 3 7a5.001 5.001 0 0 0 4.25 4.944V13.5h-1.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-1.5v-1.556A5.001 5.001 0 0 0 13 7a.75.75 0 0 0-1.5 0 3.5 3.5 0 1 1-7 0Z"
  }));
}
const V5 = /* @__PURE__ */ w.forwardRef(z5);
function H5({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    d: "M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z"
  }));
}
const q5 = /* @__PURE__ */ w.forwardRef(H5);
function ah() {
  return ah = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ah.apply(null, arguments);
}
function W5(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.includes(r)) continue;
    n[r] = e[r];
  }
  return n;
}
var Z5 = Qa, K5 = function(t) {
  var n = w.useRef(t);
  return Z5(function() {
    n.current = t;
  }), n;
}, vb = function(t, n) {
  if (typeof t == "function") {
    t(n);
    return;
  }
  t.current = n;
}, G5 = function(t, n) {
  var r = Dt();
  return kt(function(i) {
    t.current = i, r.current && vb(r.current, null), r.current = n, n && vb(n, i);
  }, [n]);
}, yb = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0",
  display: "block"
}, Y5 = function(t) {
  Object.keys(yb).forEach(function(n) {
    t.style.setProperty(n, yb[n], "important");
  });
}, gb = Y5, fn = null, bb = function(t, n) {
  var r = t.scrollHeight;
  return n.sizingStyle.boxSizing === "border-box" ? r + n.borderSize : r - n.paddingSize;
};
function J5(e, t, n, r) {
  n === void 0 && (n = 1), r === void 0 && (r = 1 / 0), fn || (fn = document.createElement("textarea"), fn.setAttribute("tabindex", "-1"), fn.setAttribute("aria-hidden", "true"), gb(fn)), fn.parentNode === null && document.body.appendChild(fn);
  var i = e.paddingSize, a = e.borderSize, o = e.sizingStyle, s = o.boxSizing;
  Object.keys(o).forEach(function(d) {
    var p = d;
    fn.style[p] = o[p];
  }), gb(fn), fn.value = t;
  var c = bb(fn, e);
  fn.value = t, c = bb(fn, e), fn.value = "x";
  var l = fn.scrollHeight - i, u = l * n;
  s === "border-box" && (u = u + i + a), c = Math.max(u, c);
  var f = l * r;
  return s === "border-box" && (f = f + i + a), c = Math.min(f, c), [c, l];
}
var xb = function() {
}, X5 = function(t, n) {
  return t.reduce(function(r, i) {
    return r[i] = n[i], r;
  }, {});
}, Q5 = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], e3 = !!document.documentElement.currentStyle, t3 = function(t) {
  var n = window.getComputedStyle(t);
  if (n === null)
    return null;
  var r = X5(Q5, n), i = r.boxSizing;
  if (i === "")
    return null;
  e3 && i === "border-box" && (r.width = parseFloat(r.width) + parseFloat(r.borderRightWidth) + parseFloat(r.borderLeftWidth) + parseFloat(r.paddingRight) + parseFloat(r.paddingLeft) + "px");
  var a = parseFloat(r.paddingBottom) + parseFloat(r.paddingTop), o = parseFloat(r.borderBottomWidth) + parseFloat(r.borderTopWidth);
  return {
    sizingStyle: r,
    paddingSize: a,
    borderSize: o
  };
}, n3 = t3;
function J_(e, t, n) {
  var r = K5(n);
  w.useLayoutEffect(function() {
    var i = function(o) {
      return r.current(o);
    };
    if (e)
      return e.addEventListener(t, i), function() {
        return e.removeEventListener(t, i);
      };
  }, []);
}
var r3 = function(t) {
  J_(window, "resize", t);
}, i3 = function(t) {
  J_(document.fonts, "loadingdone", t);
}, a3 = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], o3 = function(t, n) {
  var r = t.cacheMeasurements, i = t.maxRows, a = t.minRows, o = t.onChange, s = o === void 0 ? xb : o, c = t.onHeightChange, l = c === void 0 ? xb : c, u = W5(t, a3), f = u.value !== void 0, d = w.useRef(null), p = G5(d, n), m = w.useRef(0), h = w.useRef(), y = function() {
    var b = d.current, T = r && h.current ? h.current : n3(b);
    if (T) {
      h.current = T;
      var S = J5(T, b.value || b.placeholder || "x", a, i), E = S[0], O = S[1];
      m.current !== E && (m.current = E, b.style.setProperty("height", E + "px", "important"), l(E, {
        rowHeight: O
      }));
    }
  }, v = function(b) {
    f || y(), s(b);
  };
  return w.useLayoutEffect(y), r3(y), i3(y), /* @__PURE__ */ w.createElement("textarea", ah({}, u, {
    onChange: v,
    ref: p
  }));
}, s3 = /* @__PURE__ */ w.forwardRef(o3);
const l3 = yu(
  In(
    ({
      className: e,
      inputRef: t,
      disableComposer: n,
      isReadOnly: r,
      allowFileUpload: i,
      connected: a,
      composerPlaceholder: o,
      showPoweredBy: s,
      sendMessage: c,
      uploadFile: l,
      ...u
    }, f) => {
      const { composer: d } = bt, [p, m] = rt(""), [h, y] = rt(-1), [v, g] = rt(!1), b = Dt(null), T = Dt(null), S = Vg(($) => $.messageHistory), E = Vg(($) => $.addMessageToHistory);
      if (r)
        return null;
      const O = () => {
        var $;
        b.current && (($ = b.current) == null || $.click());
      }, j = n || r || !a, D = async ($) => {
        var M;
        if (!l) return;
        const L = (M = $.target.files) == null ? void 0 : M[0];
        if (L)
          try {
            const { fileUrl: F, type: q } = await l(L), B = q === "image" ? { type: q, imageUrl: F } : q === "audio" ? { type: q, audioUrl: F } : q === "video" ? { type: q, videoUrl: F } : { type: q, fileUrl: F };
            await (c == null ? void 0 : c(B));
          } catch (F) {
            console.error("Error sending file:", F);
          }
      }, k = window.SpeechRecognition || window.webkitSpeechRecognition, A = () => {
        T.current || (T.current = new k());
        const $ = T.current;
        $ && ($.continuous = !0, $.onresult = (L) => {
          var F, q, B;
          const M = ((B = (q = (F = L.results) == null ? void 0 : F[0]) == null ? void 0 : q[0]) == null ? void 0 : B.transcript) ?? "";
          m(M ?? ""), $.stop(), g(!1);
        }, v ? ($.stop(), g(!1)) : ($.start(), g(!0)));
      }, V = () => {
        p && (c == null || c({ type: "text", text: p }), m(""), E(p), y(-1));
      };
      return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsxs(
          "div",
          {
            "data-disabled": j,
            ...u,
            className: ku(d.container.className, e),
            ref: f,
            children: [
              i && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                /* @__PURE__ */ R.jsx(
                  "button",
                  {
                    type: "button",
                    disabled: j,
                    ...d.uploadButton.container,
                    onClick: O,
                    children: /* @__PURE__ */ R.jsx(q5, { ...d.uploadButton.icon })
                  }
                ),
                /* @__PURE__ */ R.jsx("input", { type: "file", ref: b, style: { display: "none" }, onChange: D })
              ] }),
              /* @__PURE__ */ R.jsx(
                s3,
                {
                  ...d == null ? void 0 : d.input,
                  ref: t,
                  placeholder: o ?? "Type your message...",
                  disabled: j,
                  value: p,
                  "data-has-value": !!p,
                  onChange: ($) => m($.target.value),
                  maxRows: 5,
                  onKeyDown: ($) => {
                    j || ($.key === "Enter" && $.shiftKey ? ($.preventDefault(), m(`${p}
`)) : $.key === "Enter" && ($.preventDefault(), V()), $.key === "ArrowUp" && ($.preventDefault(), h < S.length - 1 && m(S[h + 1] ?? ""), y(() => Math.min(h + 1, S.length - 1))), $.key === "ArrowDown" && ($.preventDefault(), m(h === 0 ? "" : S[h - 1] ?? ""), y(() => Math.max(h - 1, -1))));
                  }
                }
              ),
              p && /* @__PURE__ */ R.jsx(
                "button",
                {
                  type: "button",
                  "aria-label": "Send message",
                  ...d.button.container,
                  disabled: !p || j,
                  onClick: V,
                  children: /* @__PURE__ */ R.jsx(U5, { ...d.button.icon })
                }
              ),
              !p && k && /* @__PURE__ */ R.jsx(
                "button",
                {
                  type: "button",
                  "aria-label": "Activate voice input",
                  ...d.voiceButton.container,
                  disabled: !!p,
                  onClick: A,
                  "data-listens": !!v,
                  children: /* @__PURE__ */ R.jsx(V5, { ...d.voiceButton.icon })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ R.jsx(
          "a",
          {
            ...d.poweredBy,
            "data-hidden": s === !1,
            hidden: s === !1,
            href: "https://botpress.com/?from=webchat",
            target: "_blank",
            rel: "noopener noreferrer",
            children: "⚡ by Botpress"
          }
        )
      ] });
    }
  )
), c3 = ({ children: e }) => {
  const [t, n] = rt(!1), [r, i] = rt(""), [a, o] = rt(null), s = ({ title: l, content: u }) => {
    i(l), o(u), n(!0);
  }, c = () => {
    n(!1);
  };
  return /* @__PURE__ */ R.jsxs(l_.Provider, { value: { hideModal: c, showModal: s, title: r, content: a, open: t }, children: [
    /* @__PURE__ */ R.jsx(Wi, { open: t, onOpenChange: n, children: /* @__PURE__ */ R.jsx(Wi.Content, { title: r, children: a }) }),
    e
  ] });
}, u3 = ({ color: e, fontFamily: t, radius: n, themeMode: r, variant: i }) => {
  const a = kn(
    () => z$({ color: e, fontFamily: t, radius: n, themeMode: r, variant: i }),
    [e, t, n, r, i]
  );
  return /* @__PURE__ */ R.jsx("style", { children: a });
};
function Ur(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function wb(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function X_(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const a = wb(i, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const a = r[i];
          typeof a == "function" ? a() : wb(e[i], null);
        }
      };
  };
}
function ki(...e) {
  return w.useCallback(X_(...e), e);
}
function f3(e, t) {
  const n = w.createContext(t), r = (a) => {
    const { children: o, ...s } = a, c = w.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ R.jsx(n.Provider, { value: c, children: o });
  };
  r.displayName = e + "Provider";
  function i(a) {
    const o = w.useContext(n);
    if (o) return o;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, i];
}
function Q_(e, t = []) {
  let n = [];
  function r(a, o) {
    const s = w.createContext(o), c = n.length;
    n = [...n, o];
    const l = (f) => {
      var v;
      const { scope: d, children: p, ...m } = f, h = ((v = d == null ? void 0 : d[e]) == null ? void 0 : v[c]) || s, y = w.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ R.jsx(h.Provider, { value: y, children: p });
    };
    l.displayName = a + "Provider";
    function u(f, d) {
      var h;
      const p = ((h = d == null ? void 0 : d[e]) == null ? void 0 : h[c]) || s, m = w.useContext(p);
      if (m) return m;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [l, u];
  }
  const i = () => {
    const a = n.map((o) => w.createContext(o));
    return function(s) {
      const c = (s == null ? void 0 : s[e]) || a;
      return w.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return i.scopeName = e, [r, d3(i, ...t)];
}
function d3(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(a) {
      const o = r.reduce((s, { useScope: c, scopeName: l }) => {
        const f = c(a)[`__scope${l}`];
        return { ...s, ...f };
      }, {});
      return w.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var p3 = w.useId || (() => {
}), h3 = 0;
function oc(e) {
  const [t, n] = w.useState(p3());
  return Aa(() => {
    e || n((r) => r ?? String(h3++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function eE({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = m3({ defaultProp: t, onChange: n }), a = e !== void 0, o = a ? e : r, s = mi(n), c = w.useCallback(
    (l) => {
      if (a) {
        const f = typeof l == "function" ? l(e) : l;
        f !== e && s(f);
      } else
        i(l);
    },
    [a, e, i, s]
  );
  return [o, c];
}
function m3({
  defaultProp: e,
  onChange: t
}) {
  const n = w.useState(e), [r] = n, i = w.useRef(r), a = mi(t);
  return w.useEffect(() => {
    i.current !== r && (a(r), i.current = r);
  }, [r, i, a]), n;
}
var Hm = w.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = w.Children.toArray(n), a = i.find(y3);
  if (a) {
    const o = a.props.children, s = i.map((c) => c === a ? w.Children.count(o) > 1 ? w.Children.only(null) : w.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ R.jsx(oh, { ...r, ref: t, children: w.isValidElement(o) ? w.cloneElement(o, void 0, s) : null });
  }
  return /* @__PURE__ */ R.jsx(oh, { ...r, ref: t, children: n });
});
Hm.displayName = "Slot";
var oh = w.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (w.isValidElement(n)) {
    const i = b3(n);
    return w.cloneElement(n, {
      ...g3(r, n.props),
      // @ts-ignore
      ref: t ? X_(t, i) : i
    });
  }
  return w.Children.count(n) > 1 ? w.Children.only(null) : null;
});
oh.displayName = "SlotClone";
var v3 = ({ children: e }) => /* @__PURE__ */ R.jsx(R.Fragment, { children: e });
function y3(e) {
  return w.isValidElement(e) && e.type === v3;
}
function g3(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? i && a ? n[r] = (...s) => {
      a(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...a } : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function b3(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var x3 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], sr = x3.reduce((e, t) => {
  const n = w.forwardRef((r, i) => {
    const { asChild: a, ...o } = r, s = a ? Hm : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ R.jsx(s, { ...o, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function w3(e, t) {
  e && m1.flushSync(() => e.dispatchEvent(t));
}
function S3(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(e);
  w.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var _3 = "DismissableLayer", sh = "dismissableLayer.update", E3 = "dismissableLayer.pointerDownOutside", T3 = "dismissableLayer.focusOutside", Sb, tE = w.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nE = w.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: a,
      onInteractOutside: o,
      onDismiss: s,
      ...c
    } = e, l = w.useContext(tE), [u, f] = w.useState(null), d = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, p] = w.useState({}), m = ki(t, (O) => f(O)), h = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), v = h.indexOf(y), g = u ? h.indexOf(u) : -1, b = l.layersWithOutsidePointerEventsDisabled.size > 0, T = g >= v, S = C3((O) => {
      const j = O.target, D = [...l.branches].some((k) => k.contains(j));
      !T || D || (i == null || i(O), o == null || o(O), O.defaultPrevented || s == null || s());
    }, d), E = R3((O) => {
      const j = O.target;
      [...l.branches].some((k) => k.contains(j)) || (a == null || a(O), o == null || o(O), O.defaultPrevented || s == null || s());
    }, d);
    return S3((O) => {
      g === l.layers.size - 1 && (r == null || r(O), !O.defaultPrevented && s && (O.preventDefault(), s()));
    }, d), w.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Sb = d.body.style.pointerEvents, d.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), _b(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (d.body.style.pointerEvents = Sb);
        };
    }, [u, d, n, l]), w.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), _b());
    }, [u, l]), w.useEffect(() => {
      const O = () => p({});
      return document.addEventListener(sh, O), () => document.removeEventListener(sh, O);
    }, []), /* @__PURE__ */ R.jsx(
      sr.div,
      {
        ...c,
        ref: m,
        style: {
          pointerEvents: b ? T ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ur(e.onFocusCapture, E.onFocusCapture),
        onBlurCapture: Ur(e.onBlurCapture, E.onBlurCapture),
        onPointerDownCapture: Ur(
          e.onPointerDownCapture,
          S.onPointerDownCapture
        )
      }
    );
  }
);
nE.displayName = _3;
var k3 = "DismissableLayerBranch", O3 = w.forwardRef((e, t) => {
  const n = w.useContext(tE), r = w.useRef(null), i = ki(t, r);
  return w.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ R.jsx(sr.div, { ...e, ref: i });
});
O3.displayName = k3;
function C3(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(e), r = w.useRef(!1), i = w.useRef(() => {
  });
  return w.useEffect(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let c = function() {
          rE(
            E3,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = c, t.addEventListener("click", i.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", a), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function R3(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = mi(e), r = w.useRef(!1);
  return w.useEffect(() => {
    const i = (a) => {
      a.target && !r.current && rE(T3, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function _b() {
  const e = new CustomEvent(sh);
  document.dispatchEvent(e);
}
function rE(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? w3(i, a) : i.dispatchEvent(a);
}
var Kf = "focusScope.autoFocusOnMount", Gf = "focusScope.autoFocusOnUnmount", Eb = { bubbles: !1, cancelable: !0 }, $3 = "FocusScope", iE = w.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: a,
    ...o
  } = e, [s, c] = w.useState(null), l = mi(i), u = mi(a), f = w.useRef(null), d = ki(t, (h) => c(h)), p = w.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  w.useEffect(() => {
    if (r) {
      let h = function(b) {
        if (p.paused || !s) return;
        const T = b.target;
        s.contains(T) ? f.current = T : ni(f.current, { select: !0 });
      }, y = function(b) {
        if (p.paused || !s) return;
        const T = b.relatedTarget;
        T !== null && (s.contains(T) || ni(f.current, { select: !0 }));
      }, v = function(b) {
        if (document.activeElement === document.body)
          for (const S of b)
            S.removedNodes.length > 0 && ni(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", y);
      const g = new MutationObserver(v);
      return s && g.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", y), g.disconnect();
      };
    }
  }, [r, s, p.paused]), w.useEffect(() => {
    if (s) {
      kb.add(p);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const v = new CustomEvent(Kf, Eb);
        s.addEventListener(Kf, l), s.dispatchEvent(v), v.defaultPrevented || (I3(M3(aE(s)), { select: !0 }), document.activeElement === h && ni(s));
      }
      return () => {
        s.removeEventListener(Kf, l), setTimeout(() => {
          const v = new CustomEvent(Gf, Eb);
          s.addEventListener(Gf, u), s.dispatchEvent(v), v.defaultPrevented || ni(h ?? document.body, { select: !0 }), s.removeEventListener(Gf, u), kb.remove(p);
        }, 0);
      };
    }
  }, [s, l, u, p]);
  const m = w.useCallback(
    (h) => {
      if (!n && !r || p.paused) return;
      const y = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, v = document.activeElement;
      if (y && v) {
        const g = h.currentTarget, [b, T] = A3(g);
        b && T ? !h.shiftKey && v === T ? (h.preventDefault(), n && ni(b, { select: !0 })) : h.shiftKey && v === b && (h.preventDefault(), n && ni(T, { select: !0 })) : v === g && h.preventDefault();
      }
    },
    [n, r, p.paused]
  );
  return /* @__PURE__ */ R.jsx(sr.div, { tabIndex: -1, ...o, ref: d, onKeyDown: m });
});
iE.displayName = $3;
function I3(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ni(r, { select: t }), document.activeElement !== n) return;
}
function A3(e) {
  const t = aE(e), n = Tb(t, e), r = Tb(t.reverse(), e);
  return [n, r];
}
function aE(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Tb(e, t) {
  for (const n of e)
    if (!P3(n, { upTo: t })) return n;
}
function P3(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function N3(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function ni(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && N3(e) && t && e.select();
  }
}
var kb = D3();
function D3() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Ob(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Ob(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Ob(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function M3(e) {
  return e.filter((t) => t.tagName !== "A");
}
function j3(e, t) {
  return w.useReducer((n, r) => t[n][r] ?? n, e);
}
var Du = (e) => {
  const { present: t, children: n } = e, r = L3(t), i = typeof n == "function" ? n({ present: r.isPresent }) : w.Children.only(n), a = ki(r.ref, F3(i));
  return typeof n == "function" || r.isPresent ? w.cloneElement(i, { ref: a }) : null;
};
Du.displayName = "Presence";
function L3(e) {
  const [t, n] = w.useState(), r = w.useRef({}), i = w.useRef(e), a = w.useRef("none"), o = e ? "mounted" : "unmounted", [s, c] = j3(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return w.useEffect(() => {
    const l = Cl(r.current);
    a.current = s === "mounted" ? l : "none";
  }, [s]), Aa(() => {
    const l = r.current, u = i.current;
    if (u !== e) {
      const d = a.current, p = Cl(l);
      e ? c("MOUNT") : p === "none" || (l == null ? void 0 : l.display) === "none" ? c("UNMOUNT") : c(u && d !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [e, c]), Aa(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, f = (p) => {
        const h = Cl(r.current).includes(p.animationName);
        if (p.target === t && h && (c("ANIMATION_END"), !i.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, d = (p) => {
        p.target === t && (a.current = Cl(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: w.useCallback((l) => {
      l && (r.current = getComputedStyle(l)), n(l);
    }, [])
  };
}
function Cl(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function F3(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Yf = 0;
function B3() {
  w.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Cb()), document.body.insertAdjacentElement("beforeend", e[1] ?? Cb()), Yf++, () => {
      Yf === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Yf--;
    };
  }, []);
}
function Cb() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var sc = "right-scroll-bar-position", lc = "width-before-scroll-bar", U3 = "with-scroll-bars-hidden", z3 = "--removed-body-scroll-bar-size";
function Jf(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function V3(e, t) {
  var n = rt(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var H3 = typeof window < "u" ? w.useLayoutEffect : w.useEffect, Rb = /* @__PURE__ */ new WeakMap();
function q3(e, t) {
  var n = V3(null, function(r) {
    return e.forEach(function(i) {
      return Jf(i, r);
    });
  });
  return H3(function() {
    var r = Rb.get(n);
    if (r) {
      var i = new Set(r), a = new Set(e), o = n.current;
      i.forEach(function(s) {
        a.has(s) || Jf(s, null);
      }), a.forEach(function(s) {
        i.has(s) || Jf(s, o);
      });
    }
    Rb.set(n, e);
  }, [e]), n;
}
function W3(e) {
  return e;
}
function Z3(e, t) {
  t === void 0 && (t = W3);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var o = t(a, r);
      return n.push(o), function() {
        n = n.filter(function(s) {
          return s !== o;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var o = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), o = n;
      }
      var c = function() {
        var u = o;
        o = [], u.forEach(a);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), n = {
        push: function(u) {
          o.push(u), l();
        },
        filter: function(u) {
          return o = o.filter(u), n;
        }
      };
    }
  };
  return i;
}
function K3(e) {
  e === void 0 && (e = {});
  var t = Z3(null);
  return t.options = Fn({ async: !0, ssr: !1 }, e), t;
}
var oE = function(e) {
  var t = e.sideCar, n = O_(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return w.createElement(r, Fn({}, n));
};
oE.isSideCarExport = !0;
function G3(e, t) {
  return e.useMedium(t), oE;
}
var sE = K3(), Xf = function() {
}, Mu = w.forwardRef(function(e, t) {
  var n = w.useRef(null), r = w.useState({
    onScrollCapture: Xf,
    onWheelCapture: Xf,
    onTouchMoveCapture: Xf
  }), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, f = e.shards, d = e.sideCar, p = e.noIsolation, m = e.inert, h = e.allowPinchZoom, y = e.as, v = y === void 0 ? "div" : y, g = e.gapMode, b = O_(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), T = d, S = q3([n, t]), E = Fn(Fn({}, b), i);
  return w.createElement(
    w.Fragment,
    null,
    u && w.createElement(T, { sideCar: sE, removeScrollBar: l, shards: f, noIsolation: p, inert: m, setCallbacks: a, allowPinchZoom: !!h, lockRef: n, gapMode: g }),
    o ? w.cloneElement(w.Children.only(s), Fn(Fn({}, E), { ref: S })) : w.createElement(v, Fn({}, E, { className: c, ref: S }), s)
  );
});
Mu.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Mu.classNames = {
  fullWidth: lc,
  zeroRight: sc
};
var Y3 = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function J3() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Y3();
  return t && e.setAttribute("nonce", t), e;
}
function X3(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Q3(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var eB = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = J3()) && (X3(t, n), Q3(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, tB = function() {
  var e = eB();
  return function(t, n) {
    w.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, lE = function() {
  var e = tB(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, nB = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Qf = function(e) {
  return parseInt(e || "", 10) || 0;
}, rB = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Qf(n), Qf(r), Qf(i)];
}, iB = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return nB;
  var t = rB(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, aB = lE(), Ca = "data-scroll-locked", oB = function(e, t, n, r) {
  var i = e.left, a = e.top, o = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(U3, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(Ca, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(sc, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(lc, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(sc, " .").concat(sc, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(lc, " .").concat(lc, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(Ca, `] {
    `).concat(z3, ": ").concat(s, `px;
  }
`);
}, $b = function() {
  var e = parseInt(document.body.getAttribute(Ca) || "0", 10);
  return isFinite(e) ? e : 0;
}, sB = function() {
  w.useEffect(function() {
    return document.body.setAttribute(Ca, ($b() + 1).toString()), function() {
      var e = $b() - 1;
      e <= 0 ? document.body.removeAttribute(Ca) : document.body.setAttribute(Ca, e.toString());
    };
  }, []);
}, lB = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  sB();
  var a = w.useMemo(function() {
    return iB(i);
  }, [i]);
  return w.createElement(aB, { styles: oB(a, !t, i, n ? "" : "!important") });
}, lh = !1;
if (typeof window < "u")
  try {
    var Rl = Object.defineProperty({}, "passive", {
      get: function() {
        return lh = !0, !0;
      }
    });
    window.addEventListener("test", Rl, Rl), window.removeEventListener("test", Rl, Rl);
  } catch {
    lh = !1;
  }
var oa = lh ? { passive: !1 } : !1, cB = function(e) {
  return e.tagName === "TEXTAREA";
}, cE = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !cB(e) && n[t] === "visible")
  );
}, uB = function(e) {
  return cE(e, "overflowY");
}, fB = function(e) {
  return cE(e, "overflowX");
}, Ib = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = uE(e, r);
    if (i) {
      var a = fE(e, r), o = a[1], s = a[2];
      if (o > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, dB = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, pB = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, uE = function(e, t) {
  return e === "v" ? uB(t) : fB(t);
}, fE = function(e, t) {
  return e === "v" ? dB(t) : pB(t);
}, hB = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, mB = function(e, t, n, r, i) {
  var a = hB(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, f = 0, d = 0;
  do {
    var p = fE(e, s), m = p[0], h = p[1], y = p[2], v = h - y - a * m;
    (m || v) && uE(e, s) && (f += v, d += m), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && (Math.abs(f) < 1 || !i) || !u && (Math.abs(d) < 1 || !i)) && (l = !0), l;
}, $l = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Ab = function(e) {
  return [e.deltaX, e.deltaY];
}, Pb = function(e) {
  return e && "current" in e ? e.current : e;
}, vB = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, yB = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, gB = 0, sa = [];
function bB(e) {
  var t = w.useRef([]), n = w.useRef([0, 0]), r = w.useRef(), i = w.useState(gB++)[0], a = w.useState(lE)[0], o = w.useRef(e);
  w.useEffect(function() {
    o.current = e;
  }, [e]), w.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var h = FL([e.lockRef.current], (e.shards || []).map(Pb), !0).filter(Boolean);
      return h.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), h.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = w.useCallback(function(h, y) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !o.current.allowPinchZoom;
    var v = $l(h), g = n.current, b = "deltaX" in h ? h.deltaX : g[0] - v[0], T = "deltaY" in h ? h.deltaY : g[1] - v[1], S, E = h.target, O = Math.abs(b) > Math.abs(T) ? "h" : "v";
    if ("touches" in h && O === "h" && E.type === "range")
      return !1;
    var j = Ib(O, E);
    if (!j)
      return !0;
    if (j ? S = O : (S = O === "v" ? "h" : "v", j = Ib(O, E)), !j)
      return !1;
    if (!r.current && "changedTouches" in h && (b || T) && (r.current = S), !S)
      return !0;
    var D = r.current || S;
    return mB(D, y, h, D === "h" ? b : T, !0);
  }, []), c = w.useCallback(function(h) {
    var y = h;
    if (!(!sa.length || sa[sa.length - 1] !== a)) {
      var v = "deltaY" in y ? Ab(y) : $l(y), g = t.current.filter(function(S) {
        return S.name === y.type && (S.target === y.target || y.target === S.shadowParent) && vB(S.delta, v);
      })[0];
      if (g && g.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!g) {
        var b = (o.current.shards || []).map(Pb).filter(Boolean).filter(function(S) {
          return S.contains(y.target);
        }), T = b.length > 0 ? s(y, b[0]) : !o.current.noIsolation;
        T && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = w.useCallback(function(h, y, v, g) {
    var b = { name: h, delta: y, target: v, should: g, shadowParent: xB(v) };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(T) {
        return T !== b;
      });
    }, 1);
  }, []), u = w.useCallback(function(h) {
    n.current = $l(h), r.current = void 0;
  }, []), f = w.useCallback(function(h) {
    l(h.type, Ab(h), h.target, s(h, e.lockRef.current));
  }, []), d = w.useCallback(function(h) {
    l(h.type, $l(h), h.target, s(h, e.lockRef.current));
  }, []);
  w.useEffect(function() {
    return sa.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: d
    }), document.addEventListener("wheel", c, oa), document.addEventListener("touchmove", c, oa), document.addEventListener("touchstart", u, oa), function() {
      sa = sa.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", c, oa), document.removeEventListener("touchmove", c, oa), document.removeEventListener("touchstart", u, oa);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return w.createElement(
    w.Fragment,
    null,
    m ? w.createElement(a, { styles: yB(i) }) : null,
    p ? w.createElement(lB, { gapMode: e.gapMode }) : null
  );
}
function xB(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const wB = G3(sE, bB);
var dE = w.forwardRef(function(e, t) {
  return w.createElement(Mu, Fn({}, e, { ref: t, sideCar: wB }));
});
dE.classNames = Mu.classNames;
var SB = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, la = /* @__PURE__ */ new WeakMap(), Il = /* @__PURE__ */ new WeakMap(), Al = {}, ed = 0, pE = function(e) {
  return e && (e.host || pE(e.parentNode));
}, _B = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = pE(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, EB = function(e, t, n, r) {
  var i = _B(t, Array.isArray(e) ? e : [e]);
  Al[n] || (Al[n] = /* @__PURE__ */ new WeakMap());
  var a = Al[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(f) {
    !f || s.has(f) || (s.add(f), l(f.parentNode));
  };
  i.forEach(l);
  var u = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(d) {
      if (s.has(d))
        u(d);
      else
        try {
          var p = d.getAttribute(r), m = p !== null && p !== "false", h = (la.get(d) || 0) + 1, y = (a.get(d) || 0) + 1;
          la.set(d, h), a.set(d, y), o.push(d), h === 1 && m && Il.set(d, !0), y === 1 && d.setAttribute(n, "true"), m || d.setAttribute(r, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", d, v);
        }
    });
  };
  return u(t), s.clear(), ed++, function() {
    o.forEach(function(f) {
      var d = la.get(f) - 1, p = a.get(f) - 1;
      la.set(f, d), a.set(f, p), d || (Il.has(f) || f.removeAttribute(r), Il.delete(f)), p || f.removeAttribute(n);
    }), ed--, ed || (la = /* @__PURE__ */ new WeakMap(), la = /* @__PURE__ */ new WeakMap(), Il = /* @__PURE__ */ new WeakMap(), Al = {});
  };
}, TB = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = SB(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), EB(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, qm = "Dialog", [hE, Qle] = Q_(qm), [kB, $r] = hE(qm), mE = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: a,
    modal: o = !0
  } = e, s = w.useRef(null), c = w.useRef(null), [l = !1, u] = eE({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ R.jsx(
    kB,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: oc(),
      titleId: oc(),
      descriptionId: oc(),
      open: l,
      onOpenChange: u,
      onOpenToggle: w.useCallback(() => u((f) => !f), [u]),
      modal: o,
      children: n
    }
  );
};
mE.displayName = qm;
var vE = "DialogTrigger", yE = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = $r(vE, n), a = ki(t, i.triggerRef);
    return /* @__PURE__ */ R.jsx(
      sr.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": Zm(i.open),
        ...r,
        ref: a,
        onClick: Ur(e.onClick, i.onOpenToggle)
      }
    );
  }
);
yE.displayName = vE;
var OB = "DialogPortal", [ece, gE] = hE(OB, {
  forceMount: void 0
}), Wc = "DialogOverlay", bE = w.forwardRef(
  (e, t) => {
    const n = gE(Wc, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = $r(Wc, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ R.jsx(Du, { present: r || a.open, children: /* @__PURE__ */ R.jsx(CB, { ...i, ref: t }) }) : null;
  }
);
bE.displayName = Wc;
var CB = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = $r(Wc, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ R.jsx(dE, { as: Hm, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ R.jsx(
        sr.div,
        {
          "data-state": Zm(i.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), qi = "DialogContent", xE = w.forwardRef(
  (e, t) => {
    const n = gE(qi, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = $r(qi, e.__scopeDialog);
    return /* @__PURE__ */ R.jsx(Du, { present: r || a.open, children: a.modal ? /* @__PURE__ */ R.jsx(RB, { ...i, ref: t }) : /* @__PURE__ */ R.jsx($B, { ...i, ref: t }) });
  }
);
xE.displayName = qi;
var RB = w.forwardRef(
  (e, t) => {
    const n = $r(qi, e.__scopeDialog), r = w.useRef(null), i = ki(t, n.contentRef, r);
    return w.useEffect(() => {
      const a = r.current;
      if (a) return TB(a);
    }, []), /* @__PURE__ */ R.jsx(
      wE,
      {
        ...e,
        ref: i,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ur(e.onCloseAutoFocus, (a) => {
          var o;
          a.preventDefault(), (o = n.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Ur(e.onPointerDownOutside, (a) => {
          const o = a.detail.originalEvent, s = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: Ur(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), $B = w.forwardRef(
  (e, t) => {
    const n = $r(qi, e.__scopeDialog), r = w.useRef(!1), i = w.useRef(!1);
    return /* @__PURE__ */ R.jsx(
      wE,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var o, s;
          (o = e.onCloseAutoFocus) == null || o.call(e, a), a.defaultPrevented || (r.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (a) => {
          var c, l;
          (c = e.onInteractOutside) == null || c.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(o)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && i.current && a.preventDefault();
        }
      }
    );
  }
), wE = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = $r(qi, n), c = w.useRef(null), l = ki(t, c);
    return B3(), /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      /* @__PURE__ */ R.jsx(
        iE,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ R.jsx(
            nE,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Zm(s.open),
              ...o,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx(AB, { titleId: s.titleId }),
        /* @__PURE__ */ R.jsx(NB, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Wm = "DialogTitle", SE = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = $r(Wm, n);
    return /* @__PURE__ */ R.jsx(sr.h2, { id: i.titleId, ...r, ref: t });
  }
);
SE.displayName = Wm;
var _E = "DialogDescription", IB = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = $r(_E, n);
    return /* @__PURE__ */ R.jsx(sr.p, { id: i.descriptionId, ...r, ref: t });
  }
);
IB.displayName = _E;
var EE = "DialogClose", TE = w.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, i = $r(EE, n);
    return /* @__PURE__ */ R.jsx(
      sr.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: Ur(e.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
TE.displayName = EE;
function Zm(e) {
  return e ? "open" : "closed";
}
var kE = "DialogTitleWarning", [tce, OE] = f3(kE, {
  contentName: qi,
  titleName: Wm,
  docsSlug: "dialog"
}), AB = ({ titleId: e }) => {
  const t = OE(kE), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return w.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, PB = "DialogDescriptionWarning", NB = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${OE(PB).contentName}}.`;
  return w.useEffect(() => {
    var a;
    const i = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && i && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, DB = mE, MB = yE, jB = bE, LB = xE, FB = SE, CE = TE;
function BB({
  title: e,
  titleId: t,
  ...n
}, r) {
  return /* @__PURE__ */ w.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon",
    ref: r,
    "aria-labelledby": t
  }, n), e ? /* @__PURE__ */ w.createElement("title", {
    id: t
  }, e) : null, /* @__PURE__ */ w.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18 18 6M6 6l12 12"
  }));
}
const RE = /* @__PURE__ */ w.forwardRef(BB);
function Wi({
  open: e,
  onOpenChange: t,
  children: n
}) {
  return /* @__PURE__ */ R.jsx(DB, { open: e, onOpenChange: t, children: n });
}
function UB({ title: e, children: t }) {
  var r, i, a, o, s, c, l, u;
  const { modal: n } = bt;
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(jB, { ...n == null ? void 0 : n.overlay }),
    /* @__PURE__ */ R.jsx("div", { ...n == null ? void 0 : n.container, children: /* @__PURE__ */ R.jsxs(LB, { ...(r = n == null ? void 0 : n.dialog) == null ? void 0 : r.container, children: [
      /* @__PURE__ */ R.jsxs("div", { ...(a = (i = n == null ? void 0 : n.dialog) == null ? void 0 : i.title) == null ? void 0 : a.container, children: [
        /* @__PURE__ */ R.jsx(FB, { ...(s = (o = n == null ? void 0 : n.dialog) == null ? void 0 : o.title) == null ? void 0 : s.text, children: e }),
        /* @__PURE__ */ R.jsx(CE, { children: /* @__PURE__ */ R.jsx(RE, { role: "button", tabIndex: 0, ...(l = (c = n == null ? void 0 : n.dialog) == null ? void 0 : c.title) == null ? void 0 : l.closeIcon }) })
      ] }),
      /* @__PURE__ */ R.jsx("div", { ...(u = n == null ? void 0 : n.dialog) == null ? void 0 : u.content, children: t })
    ] }) })
  ] });
}
Wi.Button = MB;
Wi.Close = CE;
Wi.Content = UB;
const $E = ({ children: e, className: t, connected: n, ...r }) => {
  const {
    container: { className: i }
  } = bt, a = Rm((s) => s.setMessageContainerRef), o = Dt(null);
  return Ht(() => {
    a(o);
  }, [o]), /* @__PURE__ */ R.jsxs("div", { ...r, className: ku(i, t), ref: o, children: [
    /* @__PURE__ */ R.jsx(F2, {}),
    /* @__PURE__ */ R.jsxs(c3, { children: [
      /* @__PURE__ */ R.jsx(zB, { connected: n }),
      e
    ] })
  ] });
}, zB = ({ connected: e }) => {
  const { modal: t } = bt, { showModal: n } = c_();
  return Ht(() => {
    var r, i, a, o;
    e === !1 && n({
      title: "Connection Error",
      content: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx("p", { ...(i = (r = t == null ? void 0 : t.dialog) == null ? void 0 : r.newConversation) == null ? void 0 : i.text, children: "There was an error connecting to the server. Please check your internet connection and try again." }),
        /* @__PURE__ */ R.jsx(Wi.Close, { asChild: !0, children: /* @__PURE__ */ R.jsx(
          "button",
          {
            type: "button",
            ...(o = (a = t == null ? void 0 : t.dialog) == null ? void 0 : a.newConversation) == null ? void 0 : o.button,
            onClick: () => window.location.reload(),
            children: "Restart"
          }
        ) })
      ] })
    });
  }, [e]), /* @__PURE__ */ R.jsx(R.Fragment, {});
};
$E.displayName = "Container";
const VB = In(({ children: e, onClick: t, ...n }, r) => {
  const { fab: i } = bt, { container: a, icon: o } = i ?? {};
  return /* @__PURE__ */ R.jsx("div", { ...n, ...a, ref: r, onClick: t, children: /* @__PURE__ */ R.jsx("div", { ...o }) });
});
VB.displayName = "Fab";
var Km = "Collapsible", [HB, nce] = Q_(Km), [qB, Gm] = HB(Km), IE = w.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: r,
      defaultOpen: i,
      disabled: a,
      onOpenChange: o,
      ...s
    } = e, [c = !1, l] = eE({
      prop: r,
      defaultProp: i,
      onChange: o
    });
    return /* @__PURE__ */ R.jsx(
      qB,
      {
        scope: n,
        disabled: a,
        contentId: oc(),
        open: c,
        onOpenToggle: w.useCallback(() => l((u) => !u), [l]),
        children: /* @__PURE__ */ R.jsx(
          sr.div,
          {
            "data-state": Jm(c),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
IE.displayName = Km;
var AE = "CollapsibleTrigger", PE = w.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...r } = e, i = Gm(AE, n);
    return /* @__PURE__ */ R.jsx(
      sr.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": Jm(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: t,
        onClick: Ur(e.onClick, i.onOpenToggle)
      }
    );
  }
);
PE.displayName = AE;
var Ym = "CollapsibleContent", NE = w.forwardRef(
  (e, t) => {
    const { forceMount: n, ...r } = e, i = Gm(Ym, e.__scopeCollapsible);
    return /* @__PURE__ */ R.jsx(Du, { present: n || i.open, children: ({ present: a }) => /* @__PURE__ */ R.jsx(WB, { ...r, ref: t, present: a }) });
  }
);
NE.displayName = Ym;
var WB = w.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...a } = e, o = Gm(Ym, n), [s, c] = w.useState(r), l = w.useRef(null), u = ki(t, l), f = w.useRef(0), d = f.current, p = w.useRef(0), m = p.current, h = o.open || s, y = w.useRef(h), v = w.useRef(void 0);
  return w.useEffect(() => {
    const g = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(g);
  }, []), Aa(() => {
    const g = l.current;
    if (g) {
      v.current = v.current || {
        transitionDuration: g.style.transitionDuration,
        animationName: g.style.animationName
      }, g.style.transitionDuration = "0s", g.style.animationName = "none";
      const b = g.getBoundingClientRect();
      f.current = b.height, p.current = b.width, y.current || (g.style.transitionDuration = v.current.transitionDuration, g.style.animationName = v.current.animationName), c(r);
    }
  }, [o.open, r]), /* @__PURE__ */ R.jsx(
    sr.div,
    {
      "data-state": Jm(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      id: o.contentId,
      hidden: !h,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": d ? `${d}px` : void 0,
        "--radix-collapsible-content-width": m ? `${m}px` : void 0,
        ...e.style
      },
      children: h && i
    }
  );
});
function Jm(e) {
  return e ? "open" : "closed";
}
var ZB = IE, KB = NE;
const GB = ({ onClick: e, ...t }) => {
  var o, s;
  const { header: n, modal: r } = bt, { showModal: i } = c_(), a = (c) => {
    var l, u, f, d;
    c.stopPropagation(), i({
      title: "Restart Conversation",
      content: /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
        /* @__PURE__ */ R.jsx("p", { ...(u = (l = r == null ? void 0 : r.dialog) == null ? void 0 : l.newConversation) == null ? void 0 : u.text, children: "Are you sure you want to restart a new conversation?" }),
        /* @__PURE__ */ R.jsx(Wi.Close, { asChild: !0, children: /* @__PURE__ */ R.jsx("button", { type: "button", ...(d = (f = r == null ? void 0 : r.dialog) == null ? void 0 : f.newConversation) == null ? void 0 : d.button, onClick: e, children: "Restart" }) })
      ] })
    });
  };
  return /* @__PURE__ */ R.jsx(
    ZL,
    {
      ...t,
      ...(s = (o = n == null ? void 0 : n.content) == null ? void 0 : o.actions) == null ? void 0 : s.icons,
      role: "button",
      tabIndex: 0,
      onClick: a,
      onKeyDown: (c) => {
        c.key === "Enter" && a(c);
      }
    }
  );
}, YB = ({ onClick: e, ...t }) => {
  const { header: n } = bt, r = (i) => {
    i.stopPropagation(), e == null || e();
  };
  return /* @__PURE__ */ R.jsx(
    RE,
    {
      ...t,
      ...n.content.actions.icons,
      role: "button",
      tabIndex: 0,
      onClick: r,
      onKeyDown: (i) => {
        i.key === "Enter" && r(i);
      }
    }
  );
}, So = ({ icon: e, title: t, link: n, ...r }) => {
  var o, s, c, l, u, f, d, p, m, h, y, v;
  const { header: i } = bt, a = e ?? PF;
  return t ? n ? /* @__PURE__ */ R.jsxs(
    "a",
    {
      ...r,
      ...(s = (o = i.expandedContent) == null ? void 0 : o.descriptionItems) == null ? void 0 : s.container,
      href: n,
      target: "_blank",
      rel: "noreferrer noopener",
      children: [
        /* @__PURE__ */ R.jsx(a, { ...(l = (c = i.expandedContent) == null ? void 0 : c.descriptionItems) == null ? void 0 : l.icon }),
        /* @__PURE__ */ R.jsx("p", { ...(f = (u = i.expandedContent) == null ? void 0 : u.descriptionItems) == null ? void 0 : f.link, children: t })
      ]
    }
  ) : /* @__PURE__ */ R.jsxs("div", { ...r, ...(p = (d = i.expandedContent) == null ? void 0 : d.descriptionItems) == null ? void 0 : p.container, children: [
    /* @__PURE__ */ R.jsx(a, { ...(h = (m = i.expandedContent) == null ? void 0 : m.descriptionItems) == null ? void 0 : h.icon }),
    /* @__PURE__ */ R.jsx("p", { ...(v = (y = i.expandedContent) == null ? void 0 : y.descriptionItems) == null ? void 0 : v.text, children: t })
  ] }) : null;
}, JB = ({ defaultOpen: e, closeWindow: t, configuration: n, restartConversation: r, ...i }) => {
  var l, u, f, d, p, m, h, y, v, g, b, T, S, E, O, j, D, k, A, V, $, L;
  const { header: a } = bt, [o, s] = rt(!!e), c = !!((l = n.email) != null && l.title) || !!((u = n.phone) != null && u.title) || !!((f = n.website) != null && f.title) || !!((d = n.termsOfService) != null && d.link) || !!((p = n.privacyPolicy) != null && p.link);
  return /* @__PURE__ */ R.jsxs(
    ZB,
    {
      open: c ? o : !1,
      onOpenChange: s,
      "data-disabled": c ? void 0 : "",
      ...a.container,
      ...i,
      children: [
        /* @__PURE__ */ R.jsxs(PE, { ...a.content.container, children: [
          /* @__PURE__ */ R.jsx(um, { ...i, src: n.botAvatar, ...a.content.avatar, children: n.botName || "Bot" }),
          /* @__PURE__ */ R.jsx("h2", { ...a.content.title, children: n.botName || "Bot" }),
          n.botDescription && /* @__PURE__ */ R.jsx("p", { ...a.content.description, children: n.botDescription }),
          /* @__PURE__ */ R.jsxs("div", { ...a.content.actions.container, children: [
            /* @__PURE__ */ R.jsx(GB, { onClick: r }),
            t && /* @__PURE__ */ R.jsx(YB, { onClick: t })
          ] })
        ] }),
        /* @__PURE__ */ R.jsxs(KB, { ...a.expandedContent.container, children: [
          /* @__PURE__ */ R.jsxs("div", { "data-links": "", ...a.expandedContent.group, children: [
            /* @__PURE__ */ R.jsx(
              So,
              {
                "data-email": "",
                icon: UF,
                title: (m = n.email) == null ? void 0 : m.title,
                link: (y = (h = n.email) == null ? void 0 : h.link) != null && y.startsWith("mailto:") ? (v = n.email) == null ? void 0 : v.link : `mailto:${(g = n.email) == null ? void 0 : g.link}`
              }
            ),
            /* @__PURE__ */ R.jsx(
              So,
              {
                "data-phone": "",
                icon: ZF,
                title: (b = n.phone) == null ? void 0 : b.title,
                link: (S = (T = n.phone) == null ? void 0 : T.link) != null && S.startsWith("tel:") ? (E = n.phone) == null ? void 0 : E.link : `tel:${(O = n.phone) == null ? void 0 : O.link}`
              }
            ),
            /* @__PURE__ */ R.jsx(
              So,
              {
                "data-website": "",
                link: (j = n.website) == null ? void 0 : j.link,
                icon: VF,
                title: (D = n.website) == null ? void 0 : D.title
              }
            )
          ] }),
          /* @__PURE__ */ R.jsxs("div", { "data-legal": "", ...(k = a.expandedContent) == null ? void 0 : k.group, children: [
            /* @__PURE__ */ R.jsx(
              So,
              {
                "data-terms": "",
                link: (A = n.termsOfService) == null ? void 0 : A.link,
                icon: FF,
                title: (V = n.termsOfService) == null ? void 0 : V.title
              }
            ),
            /* @__PURE__ */ R.jsx(
              So,
              {
                "data-privacy": "",
                link: ($ = n.privacyPolicy) == null ? void 0 : $.link,
                icon: qF,
                title: (L = n.privacyPolicy) == null ? void 0 : L.title
              }
            )
          ] })
        ] })
      ]
    }
  );
}, XB = yu(({ ...e }) => {
  const { typingIndicator: t } = bt;
  return /* @__PURE__ */ R.jsx("div", { ...e, ...t == null ? void 0 : t.container, children: /* @__PURE__ */ R.jsx("div", { ...t == null ? void 0 : t.loader }) });
}), Nb = yu(
  In(
    ({
      direction: e,
      block: t,
      disableInput: n,
      children: r,
      sender: i,
      id: a,
      metadata: o,
      authorId: s,
      renderers: c,
      sendMessage: l,
      isReadOnly: u,
      ...f
    }, d) => {
      var v, g, b;
      const [p, m] = rt([]), { message: h } = bt, y = R1(s ?? "", 15);
      return /* @__PURE__ */ R.jsx(s_.Provider, { value: { isLoading: p, setIsLoading: m }, children: /* @__PURE__ */ R.jsxs(
        "div",
        {
          ...f,
          ...h == null ? void 0 : h.container,
          "data-loaded": p.length === 0,
          "data-disable-input": !!n,
          "data-direction": e,
          ref: d,
          children: [
            /* @__PURE__ */ R.jsxs(am, { "data-color": y, ...(v = h == null ? void 0 : h.avatar) == null ? void 0 : v.container, children: [
              /* @__PURE__ */ R.jsx(om, { ...(g = h == null ? void 0 : h.avatar) == null ? void 0 : g.image, src: i == null ? void 0 : i.avatar }),
              /* @__PURE__ */ R.jsx(sm, { ...(b = h == null ? void 0 : h.avatar) == null ? void 0 : b.fallback, children: i == null ? void 0 : i.name[0] })
            ] }),
            t && /* @__PURE__ */ R.jsx(
              qs,
              {
                block: { ...t, direction: e, timestamp: f.timestamp, sender: i, messageId: a, sendMessage: l },
                direction: e,
                sendMessage: l,
                isReadOnly: u,
                sender: i,
                timestamp: f.timestamp,
                messageId: a,
                metadata: o,
                renderers: c
              }
            ),
            r
          ]
        }
      ) });
    }
  )
);
function QB({ botAvatar: e, botDescription: t, botName: n }) {
  const {
    messageList: { marquee: r }
  } = bt;
  return /* @__PURE__ */ R.jsxs("li", { ...r.container, children: [
    /* @__PURE__ */ R.jsx(um, { src: e, ...r.avatar, children: (n || "Bot").slice(0, 1) }),
    /* @__PURE__ */ R.jsxs("div", { ...r.content, children: [
      /* @__PURE__ */ R.jsx("h1", { ...r.title, children: n || "Bot" }),
      /* @__PURE__ */ R.jsx("p", { ...r.description, children: t })
    ] })
  ] });
}
function e4(e, t) {
  try {
    var n = global, r = n.document;
    if (typeof r < "u" && r.createElement && r.head && r.head.appendChild) {
      var i = r.querySelector('html meta[name="'.concat(encodeURI(e), '"]')) || r.createElement("meta");
      i.setAttribute("name", e), i.setAttribute("content", t), r.head.appendChild(i);
    }
  } catch {
  }
}
function t4() {
  e4("react-scroll-to-bottom:version", "4.2.0");
}
var _o = function(e) {
  return e && e.Math === Math && e;
}, qt = (
  // eslint-disable-next-line es/no-global-this -- safe
  _o(typeof globalThis == "object" && globalThis) || _o(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  _o(typeof self == "object" && self) || _o(typeof pt == "object" && pt) || _o(typeof pt == "object" && pt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), Wt = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, n4 = Wt, ju = !n4(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), r4 = ju, DE = Function.prototype, Db = DE.apply, Mb = DE.call, Xm = typeof Reflect == "object" && Reflect.apply || (r4 ? Mb.bind(Db) : function() {
  return Mb.apply(Db, arguments);
}), ME = ju, jE = Function.prototype, ch = jE.call, i4 = ME && jE.bind.bind(ch, ch), Zt = ME ? i4 : function(e) {
  return function() {
    return ch.apply(e, arguments);
  };
}, LE = Zt, a4 = LE({}.toString), o4 = LE("".slice), Xi = function(e) {
  return o4(a4(e), 8, -1);
}, s4 = Xi, l4 = Zt, Qm = function(e) {
  if (s4(e) === "Function") return l4(e);
}, td = typeof document == "object" && document.all, cn = typeof td > "u" && td !== void 0 ? function(e) {
  return typeof e == "function" || e === td;
} : function(e) {
  return typeof e == "function";
}, Ws = {}, c4 = Wt, _n = !c4(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), u4 = ju, Pl = Function.prototype.call, Ir = u4 ? Pl.bind(Pl) : function() {
  return Pl.apply(Pl, arguments);
}, ev = {}, FE = {}.propertyIsEnumerable, BE = Object.getOwnPropertyDescriptor, f4 = BE && !FE.call({ 1: 2 }, 1);
ev.f = f4 ? function(t) {
  var n = BE(this, t);
  return !!n && n.enumerable;
} : FE;
var Zs = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, d4 = Zt, p4 = Wt, h4 = Xi, nd = Object, m4 = d4("".split), UE = p4(function() {
  return !nd("z").propertyIsEnumerable(0);
}) ? function(e) {
  return h4(e) === "String" ? m4(e, "") : nd(e);
} : nd, tv = function(e) {
  return e == null;
}, v4 = tv, y4 = TypeError, nv = function(e) {
  if (v4(e)) throw new y4("Can't call method on " + e);
  return e;
}, g4 = UE, b4 = nv, Ar = function(e) {
  return g4(b4(e));
}, x4 = cn, Kr = function(e) {
  return typeof e == "object" ? e !== null : x4(e);
}, tn = {}, rd = tn, id = qt, w4 = cn, jb = function(e) {
  return w4(e) ? e : void 0;
}, Pr = function(e, t) {
  return arguments.length < 2 ? jb(rd[e]) || jb(id[e]) : rd[e] && rd[e][t] || id[e] && id[e][t];
}, S4 = Zt, Gr = S4({}.isPrototypeOf), _4 = qt, Lb = _4.navigator, Fb = Lb && Lb.userAgent, rv = Fb ? String(Fb) : "", zE = qt, ad = rv, Bb = zE.process, Ub = zE.Deno, zb = Bb && Bb.versions || Ub && Ub.version, Vb = zb && zb.v8, Yn, Zc;
Vb && (Yn = Vb.split("."), Zc = Yn[0] > 0 && Yn[0] < 4 ? 1 : +(Yn[0] + Yn[1]));
!Zc && ad && (Yn = ad.match(/Edge\/(\d+)/), (!Yn || Yn[1] >= 74) && (Yn = ad.match(/Chrome\/(\d+)/), Yn && (Zc = +Yn[1])));
var iv = Zc, Hb = iv, E4 = Wt, T4 = qt, k4 = T4.String, ro = !!Object.getOwnPropertySymbols && !E4(function() {
  var e = Symbol("symbol detection");
  return !k4(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && Hb && Hb < 41;
}), O4 = ro, VE = O4 && !Symbol.sham && typeof Symbol.iterator == "symbol", C4 = Pr, R4 = cn, $4 = Gr, I4 = VE, A4 = Object, Ks = I4 ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = C4("Symbol");
  return R4(t) && $4(t.prototype, A4(e));
}, P4 = String, Lu = function(e) {
  try {
    return P4(e);
  } catch {
    return "Object";
  }
}, N4 = cn, D4 = Lu, M4 = TypeError, av = function(e) {
  if (N4(e)) return e;
  throw new M4(D4(e) + " is not a function");
}, j4 = av, L4 = tv, ov = function(e, t) {
  var n = e[t];
  return L4(n) ? void 0 : j4(n);
}, od = Ir, sd = cn, ld = Kr, F4 = TypeError, B4 = function(e, t) {
  var n, r;
  if (t === "string" && sd(n = e.toString) && !ld(r = od(n, e)) || sd(n = e.valueOf) && !ld(r = od(n, e)) || t !== "string" && sd(n = e.toString) && !ld(r = od(n, e))) return r;
  throw new F4("Can't convert object to primitive value");
}, HE = { exports: {} }, qb = qt, U4 = Object.defineProperty, z4 = function(e, t) {
  try {
    U4(qb, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    qb[e] = t;
  }
  return t;
}, V4 = qt, H4 = z4, Wb = "__core-js_shared__", Zb = HE.exports = V4[Wb] || H4(Wb, {});
(Zb.versions || (Zb.versions = [])).push({
  version: "3.38.1",
  mode: "pure",
  copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.38.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var sv = HE.exports, Kb = sv, io = function(e, t) {
  return Kb[e] || (Kb[e] = t || {});
}, q4 = nv, W4 = Object, Yr = function(e) {
  return W4(q4(e));
}, Z4 = Zt, K4 = Yr, G4 = Z4({}.hasOwnProperty), An = Object.hasOwn || function(t, n) {
  return G4(K4(t), n);
}, Y4 = Zt, J4 = 0, X4 = Math.random(), Q4 = Y4(1 .toString), lv = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + Q4(++J4 + X4, 36);
}, eU = qt, tU = io, Gb = An, nU = lv, rU = ro, iU = VE, xa = eU.Symbol, cd = tU("wks"), aU = iU ? xa.for || xa : xa && xa.withoutSetter || nU, Yt = function(e) {
  return Gb(cd, e) || (cd[e] = rU && Gb(xa, e) ? xa[e] : aU("Symbol." + e)), cd[e];
}, oU = Ir, Yb = Kr, Jb = Ks, sU = ov, lU = B4, cU = Yt, uU = TypeError, fU = cU("toPrimitive"), dU = function(e, t) {
  if (!Yb(e) || Jb(e)) return e;
  var n = sU(e, fU), r;
  if (n) {
    if (t === void 0 && (t = "default"), r = oU(n, e, t), !Yb(r) || Jb(r)) return r;
    throw new uU("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), lU(e, t);
}, pU = dU, hU = Ks, cv = function(e) {
  var t = pU(e, "string");
  return hU(t) ? t : t + "";
}, mU = qt, Xb = Kr, uh = mU.document, vU = Xb(uh) && Xb(uh.createElement), qE = function(e) {
  return vU ? uh.createElement(e) : {};
}, yU = _n, gU = Wt, bU = qE, WE = !yU && !gU(function() {
  return Object.defineProperty(bU("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), xU = _n, wU = Ir, SU = ev, _U = Zs, EU = Ar, TU = cv, kU = An, OU = WE, Qb = Object.getOwnPropertyDescriptor;
Ws.f = xU ? Qb : function(t, n) {
  if (t = EU(t), n = TU(n), OU) try {
    return Qb(t, n);
  } catch {
  }
  if (kU(t, n)) return _U(!wU(SU.f, t, n), t[n]);
};
var CU = Wt, RU = cn, $U = /#|\.prototype\./, Gs = function(e, t) {
  var n = AU[IU(e)];
  return n === NU ? !0 : n === PU ? !1 : RU(t) ? CU(t) : !!t;
}, IU = Gs.normalize = function(e) {
  return String(e).replace($U, ".").toLowerCase();
}, AU = Gs.data = {}, PU = Gs.NATIVE = "N", NU = Gs.POLYFILL = "P", DU = Gs, ex = Qm, MU = av, jU = ju, LU = ex(ex.bind), uv = function(e, t) {
  return MU(e), t === void 0 ? e : jU ? LU(e, t) : function() {
    return e.apply(t, arguments);
  };
}, lr = {}, FU = _n, BU = Wt, ZE = FU && BU(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), UU = Kr, zU = String, VU = TypeError, Oi = function(e) {
  if (UU(e)) return e;
  throw new VU(zU(e) + " is not an object");
}, HU = _n, qU = WE, WU = ZE, Nl = Oi, tx = cv, ZU = TypeError, ud = Object.defineProperty, KU = Object.getOwnPropertyDescriptor, fd = "enumerable", dd = "configurable", pd = "writable";
lr.f = HU ? WU ? function(t, n, r) {
  if (Nl(t), n = tx(n), Nl(r), typeof t == "function" && n === "prototype" && "value" in r && pd in r && !r[pd]) {
    var i = KU(t, n);
    i && i[pd] && (t[n] = r.value, r = {
      configurable: dd in r ? r[dd] : i[dd],
      enumerable: fd in r ? r[fd] : i[fd],
      writable: !1
    });
  }
  return ud(t, n, r);
} : ud : function(t, n, r) {
  if (Nl(t), n = tx(n), Nl(r), qU) try {
    return ud(t, n, r);
  } catch {
  }
  if ("get" in r || "set" in r) throw new ZU("Accessors not supported");
  return "value" in r && (t[n] = r.value), t;
};
var GU = _n, YU = lr, JU = Zs, Fu = GU ? function(e, t, n) {
  return YU.f(e, t, JU(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, Eo = qt, XU = Xm, QU = Qm, ez = cn, tz = Ws.f, nz = DU, ca = tn, rz = uv, ua = Fu, nx = An, iz = function(e) {
  var t = function(n, r, i) {
    if (this instanceof t) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(n);
        case 2:
          return new e(n, r);
      }
      return new e(n, r, i);
    }
    return XU(e, this, arguments);
  };
  return t.prototype = e.prototype, t;
}, ht = function(e, t) {
  var n = e.target, r = e.global, i = e.stat, a = e.proto, o = r ? Eo : i ? Eo[n] : Eo[n] && Eo[n].prototype, s = r ? ca : ca[n] || ua(ca, n, {})[n], c = s.prototype, l, u, f, d, p, m, h, y, v;
  for (d in t)
    l = nz(r ? d : n + (i ? "." : "#") + d, e.forced), u = !l && o && nx(o, d), m = s[d], u && (e.dontCallGetSet ? (v = tz(o, d), h = v && v.value) : h = o[d]), p = u && h ? h : t[d], !(!l && !a && typeof m == typeof p) && (e.bind && u ? y = rz(p, Eo) : e.wrap && u ? y = iz(p) : a && ez(p) ? y = QU(p) : y = p, (e.sham || p && p.sham || m && m.sham) && ua(y, "sham", !0), ua(s, d, y), a && (f = n + "Prototype", nx(ca, f) || ua(ca, f, {}), ua(ca[f], d, p), e.real && c && (l || !c[d]) && ua(c, d, p)));
}, az = Xi, ao = Array.isArray || function(t) {
  return az(t) === "Array";
}, oz = ht, sz = ao;
oz({ target: "Array", stat: !0 }, {
  isArray: sz
});
var lz = tn, cz = lz.Array.isArray, uz = cz, KE = uz, fz = KE, dz = fz, pz = dz, hz = pz, mz = hz;
const GE = /* @__PURE__ */ Ke(mz);
function vz(e) {
  if (GE(e)) return e;
}
var yz = Math.ceil, gz = Math.floor, bz = Math.trunc || function(t) {
  var n = +t;
  return (n > 0 ? gz : yz)(n);
}, xz = bz, Bu = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : xz(t);
}, wz = Bu, Sz = Math.min, _z = function(e) {
  var t = wz(e);
  return t > 0 ? Sz(t, 9007199254740991) : 0;
}, Ez = _z, Qi = function(e) {
  return Ez(e.length);
}, Tz = TypeError, kz = 9007199254740991, fv = function(e) {
  if (e > kz) throw Tz("Maximum allowed index exceeded");
  return e;
}, Oz = _n, Cz = lr, Rz = Zs, Ys = function(e, t, n) {
  Oz ? Cz.f(e, t, Rz(0, n)) : e[t] = n;
}, $z = Yt, Iz = $z("toStringTag"), YE = {};
YE[Iz] = "z";
var dv = String(YE) === "[object z]", Az = dv, Pz = cn, cc = Xi, Nz = Yt, Dz = Nz("toStringTag"), Mz = Object, jz = cc(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", Lz = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, Js = Az ? cc : function(e) {
  var t, n, r;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = Lz(t = Mz(e), Dz)) == "string" ? n : jz ? cc(t) : (r = cc(t)) === "Object" && Pz(t.callee) ? "Arguments" : r;
}, Fz = Zt, Bz = cn, fh = sv, Uz = Fz(Function.toString);
Bz(fh.inspectSource) || (fh.inspectSource = function(e) {
  return Uz(e);
});
var zz = fh.inspectSource, Vz = Zt, Hz = Wt, JE = cn, qz = Js, Wz = Pr, Zz = zz, XE = function() {
}, QE = Wz("Reflect", "construct"), pv = /^\s*(?:class|function)\b/, Kz = Vz(pv.exec), Gz = !pv.test(XE), To = function(t) {
  if (!JE(t)) return !1;
  try {
    return QE(XE, [], t), !0;
  } catch {
    return !1;
  }
}, eT = function(t) {
  if (!JE(t)) return !1;
  switch (qz(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Gz || !!Kz(pv, Zz(t));
  } catch {
    return !0;
  }
};
eT.sham = !0;
var hv = !QE || Hz(function() {
  var e;
  return To(To.call) || !To(Object) || !To(function() {
    e = !0;
  }) || e;
}) ? eT : To, rx = ao, Yz = hv, Jz = Kr, Xz = Yt, Qz = Xz("species"), ix = Array, e6 = function(e) {
  var t;
  return rx(e) && (t = e.constructor, Yz(t) && (t === ix || rx(t.prototype)) ? t = void 0 : Jz(t) && (t = t[Qz], t === null && (t = void 0))), t === void 0 ? ix : t;
}, t6 = e6, mv = function(e, t) {
  return new (t6(e))(t === 0 ? 0 : t);
}, n6 = Wt, r6 = Yt, i6 = iv, a6 = r6("species"), Uu = function(e) {
  return i6 >= 51 || !n6(function() {
    var t = [], n = t.constructor = {};
    return n[a6] = function() {
      return { foo: 1 };
    }, t[e](Boolean).foo !== 1;
  });
}, o6 = ht, s6 = Wt, l6 = ao, c6 = Kr, u6 = Yr, f6 = Qi, ax = fv, ox = Ys, d6 = mv, p6 = Uu, h6 = Yt, m6 = iv, tT = h6("isConcatSpreadable"), v6 = m6 >= 51 || !s6(function() {
  var e = [];
  return e[tT] = !1, e.concat()[0] !== e;
}), y6 = function(e) {
  if (!c6(e)) return !1;
  var t = e[tT];
  return t !== void 0 ? !!t : l6(e);
}, g6 = !v6 || !p6("concat");
o6({ target: "Array", proto: !0, arity: 1, forced: g6 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(t) {
    var n = u6(this), r = d6(n, 0), i = 0, a, o, s, c, l;
    for (a = -1, s = arguments.length; a < s; a++)
      if (l = a === -1 ? n : arguments[a], y6(l))
        for (c = f6(l), ax(i + c), o = 0; o < c; o++, i++) o in l && ox(r, i, l[o]);
      else
        ax(i + 1), ox(r, i++, l);
    return r.length = i, r;
  }
});
var b6 = Js, x6 = String, Xs = function(e) {
  if (b6(e) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
  return x6(e);
}, zu = {}, w6 = Bu, S6 = Math.max, _6 = Math.min, vv = function(e, t) {
  var n = w6(e);
  return n < 0 ? S6(n + t, 0) : _6(n, t);
}, E6 = Ar, T6 = vv, k6 = Qi, sx = function(e) {
  return function(t, n, r) {
    var i = E6(t), a = k6(i);
    if (a === 0) return !e && -1;
    var o = T6(r, a), s;
    if (e && n !== n) {
      for (; a > o; )
        if (s = i[o++], s !== s) return !0;
    } else for (; a > o; o++)
      if ((e || o in i) && i[o] === n) return e || o || 0;
    return !e && -1;
  };
}, nT = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: sx(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: sx(!1)
}, Vu = {}, O6 = Zt, hd = An, C6 = Ar, R6 = nT.indexOf, $6 = Vu, lx = O6([].push), rT = function(e, t) {
  var n = C6(e), r = 0, i = [], a;
  for (a in n) !hd($6, a) && hd(n, a) && lx(i, a);
  for (; t.length > r; ) hd(n, a = t[r++]) && (~R6(i, a) || lx(i, a));
  return i;
}, yv = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], I6 = rT, A6 = yv, gv = Object.keys || function(t) {
  return I6(t, A6);
}, P6 = _n, N6 = ZE, D6 = lr, M6 = Oi, j6 = Ar, L6 = gv;
zu.f = P6 && !N6 ? Object.defineProperties : function(t, n) {
  M6(t);
  for (var r = j6(n), i = L6(n), a = i.length, o = 0, s; a > o; ) D6.f(t, s = i[o++], r[s]);
  return t;
};
var F6 = Pr, B6 = F6("document", "documentElement"), U6 = io, z6 = lv, cx = U6("keys"), Hu = function(e) {
  return cx[e] || (cx[e] = z6(e));
}, V6 = Oi, H6 = zu, ux = yv, q6 = Vu, W6 = B6, Z6 = qE, K6 = Hu, fx = ">", dx = "<", dh = "prototype", ph = "script", iT = K6("IE_PROTO"), md = function() {
}, aT = function(e) {
  return dx + ph + fx + e + dx + "/" + ph + fx;
}, px = function(e) {
  e.write(aT("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, G6 = function() {
  var e = Z6("iframe"), t = "java" + ph + ":", n;
  return e.style.display = "none", W6.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(aT("document.F=Object")), n.close(), n.F;
}, Dl, uc = function() {
  try {
    Dl = new ActiveXObject("htmlfile");
  } catch {
  }
  uc = typeof document < "u" ? document.domain && Dl ? px(Dl) : G6() : px(Dl);
  for (var e = ux.length; e--; ) delete uc[dh][ux[e]];
  return uc();
};
q6[iT] = !0;
var bv = Object.create || function(t, n) {
  var r;
  return t !== null ? (md[dh] = V6(t), r = new md(), md[dh] = null, r[iT] = t) : r = uc(), n === void 0 ? r : H6.f(r, n);
}, qu = {}, Y6 = rT, J6 = yv, X6 = J6.concat("length", "prototype");
qu.f = Object.getOwnPropertyNames || function(t) {
  return Y6(t, X6);
};
var oT = {}, Q6 = Zt, Wu = Q6([].slice), e7 = Xi, t7 = Ar, sT = qu.f, n7 = Wu, lT = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], r7 = function(e) {
  try {
    return sT(e);
  } catch {
    return n7(lT);
  }
};
oT.f = function(t) {
  return lT && e7(t) === "Window" ? r7(t) : sT(t7(t));
};
var Zu = {};
Zu.f = Object.getOwnPropertySymbols;
var i7 = Fu, Ku = function(e, t, n, r) {
  return r && r.enumerable ? e[t] = n : i7(e, t, n), e;
}, a7 = lr, o7 = function(e, t, n) {
  return a7.f(e, t, n);
}, Qs = {}, s7 = Yt;
Qs.f = s7;
var hx = tn, l7 = An, c7 = Qs, u7 = lr.f, Et = function(e) {
  var t = hx.Symbol || (hx.Symbol = {});
  l7(t, e) || u7(t, e, {
    value: c7.f(e)
  });
}, f7 = Ir, d7 = Pr, p7 = Yt, h7 = Ku, cT = function() {
  var e = d7("Symbol"), t = e && e.prototype, n = t && t.valueOf, r = p7("toPrimitive");
  t && !t[r] && h7(t, r, function(i) {
    return f7(n, this);
  }, { arity: 1 });
}, m7 = dv, v7 = Js, y7 = m7 ? {}.toString : function() {
  return "[object " + v7(this) + "]";
}, g7 = dv, b7 = lr.f, x7 = Fu, w7 = An, S7 = y7, _7 = Yt, mx = _7("toStringTag"), oo = function(e, t, n, r) {
  var i = n ? e : e && e.prototype;
  i && (w7(i, mx) || b7(i, mx, { configurable: !0, value: t }), r && !g7 && x7(i, "toString", S7));
}, E7 = qt, T7 = cn, vx = E7.WeakMap, k7 = T7(vx) && /native code/.test(String(vx)), O7 = k7, uT = qt, C7 = Kr, R7 = Fu, vd = An, yd = sv, $7 = Hu, I7 = Vu, yx = "Object already initialized", hh = uT.TypeError, A7 = uT.WeakMap, Kc, us, Gc, P7 = function(e) {
  return Gc(e) ? us(e) : Kc(e, {});
}, N7 = function(e) {
  return function(t) {
    var n;
    if (!C7(t) || (n = us(t)).type !== e)
      throw new hh("Incompatible receiver, " + e + " required");
    return n;
  };
};
if (O7 || yd.state) {
  var fr = yd.state || (yd.state = new A7());
  fr.get = fr.get, fr.has = fr.has, fr.set = fr.set, Kc = function(e, t) {
    if (fr.has(e)) throw new hh(yx);
    return t.facade = e, fr.set(e, t), t;
  }, us = function(e) {
    return fr.get(e) || {};
  }, Gc = function(e) {
    return fr.has(e);
  };
} else {
  var fa = $7("state");
  I7[fa] = !0, Kc = function(e, t) {
    if (vd(e, fa)) throw new hh(yx);
    return t.facade = e, R7(e, fa, t), t;
  }, us = function(e) {
    return vd(e, fa) ? e[fa] : {};
  }, Gc = function(e) {
    return vd(e, fa);
  };
}
var xv = {
  set: Kc,
  get: us,
  has: Gc,
  enforce: P7,
  getterFor: N7
}, D7 = uv, M7 = Zt, j7 = UE, L7 = Yr, F7 = Qi, B7 = mv, gx = M7([].push), ei = function(e) {
  var t = e === 1, n = e === 2, r = e === 3, i = e === 4, a = e === 6, o = e === 7, s = e === 5 || a;
  return function(c, l, u, f) {
    for (var d = L7(c), p = j7(d), m = F7(p), h = D7(l, u), y = 0, v = f || B7, g = t ? v(c, m) : n || o ? v(c, 0) : void 0, b, T; m > y; y++) if ((s || y in p) && (b = p[y], T = h(b, y, d), e))
      if (t) g[y] = T;
      else if (T) switch (e) {
        case 3:
          return !0;
        case 5:
          return b;
        case 6:
          return y;
        case 2:
          gx(g, b);
      }
      else switch (e) {
        case 4:
          return !1;
        case 7:
          gx(g, b);
      }
    return a ? -1 : r || i ? i : g;
  };
}, wv = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: ei(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: ei(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: ei(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: ei(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: ei(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: ei(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: ei(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: ei(7)
}, Gu = ht, el = qt, Sv = Ir, U7 = Zt, Ua = _n, za = ro, z7 = Wt, Gt = An, V7 = Gr, mh = Oi, Yu = Ar, _v = cv, H7 = Xs, vh = Zs, Va = bv, fT = gv, q7 = qu, dT = oT, W7 = Zu, pT = Ws, hT = lr, Z7 = zu, mT = ev, bx = Ku, K7 = o7, Ev = io, G7 = Hu, vT = Vu, xx = lv, Y7 = Yt, J7 = Qs, X7 = Et, Q7 = cT, eV = oo, yT = xv, Ju = wv.forEach, xn = G7("hidden"), Xu = "Symbol", fs = "prototype", tV = yT.set, wx = yT.getterFor(Xu), Xn = Object[fs], Mi = el.Symbol, Po = Mi && Mi[fs], nV = el.RangeError, rV = el.TypeError, gd = el.QObject, gT = pT.f, ji = hT.f, bT = dT.f, iV = mT.f, xT = U7([].push), qr = Ev("symbols"), tl = Ev("op-symbols"), aV = Ev("wks"), yh = !gd || !gd[fs] || !gd[fs].findChild, wT = function(e, t, n) {
  var r = gT(Xn, t);
  r && delete Xn[t], ji(e, t, n), r && e !== Xn && ji(Xn, t, r);
}, gh = Ua && z7(function() {
  return Va(ji({}, "a", {
    get: function() {
      return ji(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? wT : ji, bd = function(e, t) {
  var n = qr[e] = Va(Po);
  return tV(n, {
    type: Xu,
    tag: e,
    description: t
  }), Ua || (n.description = t), n;
}, Qu = function(t, n, r) {
  t === Xn && Qu(tl, n, r), mh(t);
  var i = _v(n);
  return mh(r), Gt(qr, i) ? (r.enumerable ? (Gt(t, xn) && t[xn][i] && (t[xn][i] = !1), r = Va(r, { enumerable: vh(0, !1) })) : (Gt(t, xn) || ji(t, xn, vh(1, Va(null))), t[xn][i] = !0), gh(t, i, r)) : ji(t, i, r);
}, Tv = function(t, n) {
  mh(t);
  var r = Yu(n), i = fT(r).concat(TT(r));
  return Ju(i, function(a) {
    (!Ua || Sv(ST, r, a)) && Qu(t, a, r[a]);
  }), t;
}, oV = function(t, n) {
  return n === void 0 ? Va(t) : Tv(Va(t), n);
}, ST = function(t) {
  var n = _v(t), r = Sv(iV, this, n);
  return this === Xn && Gt(qr, n) && !Gt(tl, n) ? !1 : r || !Gt(this, n) || !Gt(qr, n) || Gt(this, xn) && this[xn][n] ? r : !0;
}, _T = function(t, n) {
  var r = Yu(t), i = _v(n);
  if (!(r === Xn && Gt(qr, i) && !Gt(tl, i))) {
    var a = gT(r, i);
    return a && Gt(qr, i) && !(Gt(r, xn) && r[xn][i]) && (a.enumerable = !0), a;
  }
}, ET = function(t) {
  var n = bT(Yu(t)), r = [];
  return Ju(n, function(i) {
    !Gt(qr, i) && !Gt(vT, i) && xT(r, i);
  }), r;
}, TT = function(e) {
  var t = e === Xn, n = bT(t ? tl : Yu(e)), r = [];
  return Ju(n, function(i) {
    Gt(qr, i) && (!t || Gt(Xn, i)) && xT(r, qr[i]);
  }), r;
};
za || (Mi = function() {
  if (V7(Po, this)) throw new rV("Symbol is not a constructor");
  var t = !arguments.length || arguments[0] === void 0 ? void 0 : H7(arguments[0]), n = xx(t), r = function(i) {
    var a = this === void 0 ? el : this;
    a === Xn && Sv(r, tl, i), Gt(a, xn) && Gt(a[xn], n) && (a[xn][n] = !1);
    var o = vh(1, i);
    try {
      gh(a, n, o);
    } catch (s) {
      if (!(s instanceof nV)) throw s;
      wT(a, n, o);
    }
  };
  return Ua && yh && gh(Xn, n, { configurable: !0, set: r }), bd(n, t);
}, Po = Mi[fs], bx(Po, "toString", function() {
  return wx(this).tag;
}), bx(Mi, "withoutSetter", function(e) {
  return bd(xx(e), e);
}), mT.f = ST, hT.f = Qu, Z7.f = Tv, pT.f = _T, q7.f = dT.f = ET, W7.f = TT, J7.f = function(e) {
  return bd(Y7(e), e);
}, Ua && K7(Po, "description", {
  configurable: !0,
  get: function() {
    return wx(this).description;
  }
}));
Gu({ global: !0, constructor: !0, wrap: !0, forced: !za, sham: !za }, {
  Symbol: Mi
});
Ju(fT(aV), function(e) {
  X7(e);
});
Gu({ target: Xu, stat: !0, forced: !za }, {
  useSetter: function() {
    yh = !0;
  },
  useSimple: function() {
    yh = !1;
  }
});
Gu({ target: "Object", stat: !0, forced: !za, sham: !Ua }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: oV,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: Qu,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: Tv,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: _T
});
Gu({ target: "Object", stat: !0, forced: !za }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: ET
});
Q7();
eV(Mi, Xu);
vT[xn] = !0;
var sV = ro, kT = sV && !!Symbol.for && !!Symbol.keyFor, lV = ht, cV = Pr, uV = An, fV = Xs, OT = io, dV = kT, xd = OT("string-to-symbol-registry"), pV = OT("symbol-to-string-registry");
lV({ target: "Symbol", stat: !0, forced: !dV }, {
  for: function(e) {
    var t = fV(e);
    if (uV(xd, t)) return xd[t];
    var n = cV("Symbol")(t);
    return xd[t] = n, pV[n] = t, n;
  }
});
var hV = ht, mV = An, vV = Ks, yV = Lu, gV = io, bV = kT, Sx = gV("symbol-to-string-registry");
hV({ target: "Symbol", stat: !0, forced: !bV }, {
  keyFor: function(t) {
    if (!vV(t)) throw new TypeError(yV(t) + " is not a symbol");
    if (mV(Sx, t)) return Sx[t];
  }
});
var xV = Zt, _x = ao, wV = cn, Ex = Xi, SV = Xs, Tx = xV([].push), _V = function(e) {
  if (wV(e)) return e;
  if (_x(e)) {
    for (var t = e.length, n = [], r = 0; r < t; r++) {
      var i = e[r];
      typeof i == "string" ? Tx(n, i) : (typeof i == "number" || Ex(i) === "Number" || Ex(i) === "String") && Tx(n, SV(i));
    }
    var a = n.length, o = !0;
    return function(s, c) {
      if (o)
        return o = !1, c;
      if (_x(this)) return c;
      for (var l = 0; l < a; l++) if (n[l] === s) return c;
    };
  }
}, EV = ht, CT = Pr, RT = Xm, TV = Ir, nl = Zt, $T = Wt, kx = cn, Ox = Ks, IT = Wu, kV = _V, OV = ro, CV = String, pi = CT("JSON", "stringify"), Ml = nl(/./.exec), Cx = nl("".charAt), RV = nl("".charCodeAt), $V = nl("".replace), IV = nl(1 .toString), AV = /[\uD800-\uDFFF]/g, Rx = /^[\uD800-\uDBFF]$/, $x = /^[\uDC00-\uDFFF]$/, Ix = !OV || $T(function() {
  var e = CT("Symbol")("stringify detection");
  return pi([e]) !== "[null]" || pi({ a: e }) !== "{}" || pi(Object(e)) !== "{}";
}), Ax = $T(function() {
  return pi("\uDF06\uD834") !== '"\\udf06\\ud834"' || pi("\uDEAD") !== '"\\udead"';
}), PV = function(e, t) {
  var n = IT(arguments), r = kV(t);
  if (!(!kx(r) && (e === void 0 || Ox(e))))
    return n[1] = function(i, a) {
      if (kx(r) && (a = TV(r, this, CV(i), a)), !Ox(a)) return a;
    }, RT(pi, null, n);
}, NV = function(e, t, n) {
  var r = Cx(n, t - 1), i = Cx(n, t + 1);
  return Ml(Rx, e) && !Ml($x, i) || Ml($x, e) && !Ml(Rx, r) ? "\\u" + IV(RV(e, 0), 16) : e;
};
pi && EV({ target: "JSON", stat: !0, arity: 3, forced: Ix || Ax }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(t, n, r) {
    var i = IT(arguments), a = RT(Ix ? PV : pi, null, i);
    return Ax && typeof a == "string" ? $V(a, AV, NV) : a;
  }
});
var DV = ht, MV = ro, jV = Wt, AT = Zu, LV = Yr, FV = !MV || jV(function() {
  AT.f(1);
});
DV({ target: "Object", stat: !0, forced: FV }, {
  getOwnPropertySymbols: function(t) {
    var n = AT.f;
    return n ? n(LV(t)) : [];
  }
});
var BV = Et;
BV("asyncIterator");
var UV = Et;
UV("hasInstance");
var zV = Et;
zV("isConcatSpreadable");
var VV = Et;
VV("iterator");
var HV = Et;
HV("match");
var qV = Et;
qV("matchAll");
var WV = Et;
WV("replace");
var ZV = Et;
ZV("search");
var KV = Et;
KV("species");
var GV = Et;
GV("split");
var YV = Et, JV = cT;
YV("toPrimitive");
JV();
var XV = Pr, QV = Et, e9 = oo;
QV("toStringTag");
e9(XV("Symbol"), "Symbol");
var t9 = Et;
t9("unscopables");
var n9 = qt, r9 = oo;
r9(n9.JSON, "JSON", !0);
var i9 = tn, a9 = i9.Symbol, so = {}, bh = _n, o9 = An, PT = Function.prototype, s9 = bh && Object.getOwnPropertyDescriptor, kv = o9(PT, "name"), l9 = kv && (function() {
}).name === "something", c9 = kv && (!bh || bh && s9(PT, "name").configurable), u9 = {
  EXISTS: kv,
  PROPER: l9,
  CONFIGURABLE: c9
}, f9 = Wt, d9 = !f9(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), p9 = An, h9 = cn, m9 = Yr, v9 = Hu, y9 = d9, Px = v9("IE_PROTO"), xh = Object, g9 = xh.prototype, NT = y9 ? xh.getPrototypeOf : function(e) {
  var t = m9(e);
  if (p9(t, Px)) return t[Px];
  var n = t.constructor;
  return h9(n) && t instanceof n ? n.prototype : t instanceof xh ? g9 : null;
}, b9 = Wt, x9 = cn, w9 = Kr, S9 = bv, Nx = NT, _9 = Ku, E9 = Yt, wh = E9("iterator"), DT = !1, zr, wd, Sd;
[].keys && (Sd = [].keys(), "next" in Sd ? (wd = Nx(Nx(Sd)), wd !== Object.prototype && (zr = wd)) : DT = !0);
var T9 = !w9(zr) || b9(function() {
  var e = {};
  return zr[wh].call(e) !== e;
});
T9 ? zr = {} : zr = S9(zr);
x9(zr[wh]) || _9(zr, wh, function() {
  return this;
});
var MT = {
  IteratorPrototype: zr,
  BUGGY_SAFARI_ITERATORS: DT
}, k9 = MT.IteratorPrototype, O9 = bv, C9 = Zs, R9 = oo, $9 = so, I9 = function() {
  return this;
}, A9 = function(e, t, n, r) {
  var i = t + " Iterator";
  return e.prototype = O9(k9, { next: C9(+!r, n) }), R9(e, i, !1, !0), $9[i] = I9, e;
}, P9 = ht, N9 = Ir, jT = u9, D9 = A9, M9 = NT, j9 = oo, Dx = Ku, L9 = Yt, Mx = so, LT = MT, F9 = jT.PROPER;
jT.CONFIGURABLE;
LT.IteratorPrototype;
var jl = LT.BUGGY_SAFARI_ITERATORS, _d = L9("iterator"), jx = "keys", Ll = "values", Lx = "entries", B9 = function() {
  return this;
}, FT = function(e, t, n, r, i, a, o) {
  D9(n, t, r);
  var s = function(v) {
    if (v === i && d) return d;
    if (!jl && v && v in u) return u[v];
    switch (v) {
      case jx:
        return function() {
          return new n(this, v);
        };
      case Ll:
        return function() {
          return new n(this, v);
        };
      case Lx:
        return function() {
          return new n(this, v);
        };
    }
    return function() {
      return new n(this);
    };
  }, c = t + " Iterator", l = !1, u = e.prototype, f = u[_d] || u["@@iterator"] || i && u[i], d = !jl && f || s(i), p = t === "Array" && u.entries || f, m, h, y;
  if (p && (m = M9(p.call(new e())), m !== Object.prototype && m.next && (j9(m, c, !0, !0), Mx[c] = B9)), F9 && i === Ll && f && f.name !== Ll && (l = !0, d = function() {
    return N9(f, this);
  }), i)
    if (h = {
      values: s(Ll),
      keys: a ? d : s(jx),
      entries: s(Lx)
    }, o) for (y in h)
      (jl || l || !(y in u)) && Dx(u, y, h[y]);
    else P9({ target: t, proto: !0, forced: jl || l }, h);
  return o && u[_d] !== d && Dx(u, _d, d, { name: i }), Mx[t] = d, h;
}, BT = function(e, t) {
  return { value: e, done: t };
}, U9 = Ar, Fx = so, UT = xv;
lr.f;
var z9 = FT, Fl = BT, zT = "Array Iterator", V9 = UT.set, H9 = UT.getterFor(zT);
z9(Array, "Array", function(e, t) {
  V9(this, {
    type: zT,
    target: U9(e),
    // target
    index: 0,
    // next index
    kind: t
    // kind
  });
}, function() {
  var e = H9(this), t = e.target, n = e.index++;
  if (!t || n >= t.length)
    return e.target = null, Fl(void 0, !0);
  switch (e.kind) {
    case "keys":
      return Fl(n, !1);
    case "values":
      return Fl(t[n], !1);
  }
  return Fl([n, t[n]], !1);
}, "values");
Fx.Arguments = Fx.Array;
var q9 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, W9 = q9, Z9 = qt, K9 = oo, Bx = so;
for (var Ed in W9)
  K9(Z9[Ed], Ed), Bx[Ed] = Bx.Array;
var G9 = a9, Y9 = G9, J9 = Yt, X9 = lr.f, Ux = J9("metadata"), zx = Function.prototype;
zx[Ux] === void 0 && X9(zx, Ux, {
  value: null
});
var Q9 = Et;
Q9("asyncDispose");
var eH = Et;
eH("dispose");
var tH = Et;
tH("metadata");
var nH = Y9, rH = nH, iH = Pr, aH = Zt, Ov = iH("Symbol"), oH = Ov.keyFor, sH = aH(Ov.prototype.valueOf), VT = Ov.isRegisteredSymbol || function(t) {
  try {
    return oH(sH(t)) !== void 0;
  } catch {
    return !1;
  }
}, lH = ht, cH = VT;
lH({ target: "Symbol", stat: !0 }, {
  isRegisteredSymbol: cH
});
var uH = io, HT = Pr, fH = Zt, dH = Ks, pH = Yt, Yc = HT("Symbol"), Vx = Yc.isWellKnownSymbol, qT = HT("Object", "getOwnPropertyNames"), hH = fH(Yc.prototype.valueOf), Hx = uH("wks");
for (var Td = 0, qx = qT(Yc), mH = qx.length; Td < mH; Td++)
  try {
    var Wx = qx[Td];
    dH(Yc[Wx]) && pH(Wx);
  } catch {
  }
var WT = function(t) {
  if (Vx && Vx(t)) return !0;
  try {
    for (var n = hH(t), r = 0, i = qT(Hx), a = i.length; r < a; r++)
      if (Hx[i[r]] == n) return !0;
  } catch {
  }
  return !1;
}, vH = ht, yH = WT;
vH({ target: "Symbol", stat: !0, forced: !0 }, {
  isWellKnownSymbol: yH
});
var gH = Et;
gH("customMatcher");
var bH = Et;
bH("observable");
var xH = ht, wH = VT;
xH({ target: "Symbol", stat: !0, name: "isRegisteredSymbol" }, {
  isRegistered: wH
});
var SH = ht, _H = WT;
SH({ target: "Symbol", stat: !0, name: "isWellKnownSymbol", forced: !0 }, {
  isWellKnown: _H
});
var EH = Et;
EH("matcher");
var TH = Et;
TH("metadataKey");
var kH = Et;
kH("patternMatch");
var OH = Et;
OH("replaceAll");
var CH = rH, RH = CH, $H = RH;
const wa = /* @__PURE__ */ Ke($H);
var Cv = Zt, IH = Bu, AH = Xs, PH = nv, NH = Cv("".charAt), Zx = Cv("".charCodeAt), DH = Cv("".slice), Kx = function(e) {
  return function(t, n) {
    var r = AH(PH(t)), i = IH(n), a = r.length, o, s;
    return i < 0 || i >= a ? e ? "" : void 0 : (o = Zx(r, i), o < 55296 || o > 56319 || i + 1 === a || (s = Zx(r, i + 1)) < 56320 || s > 57343 ? e ? NH(r, i) : o : e ? DH(r, i, i + 2) : (o - 55296 << 10) + (s - 56320) + 65536);
  };
}, MH = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Kx(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Kx(!0)
}, jH = MH.charAt, LH = Xs, ZT = xv, FH = FT, Gx = BT, KT = "String Iterator", BH = ZT.set, UH = ZT.getterFor(KT);
FH(String, "String", function(e) {
  BH(this, {
    type: KT,
    string: LH(e),
    index: 0
  });
}, function() {
  var t = UH(this), n = t.string, r = t.index, i;
  return r >= n.length ? Gx(void 0, !0) : (i = jH(n, r), t.index += i.length, Gx(i, !1));
});
var zH = Js, Yx = ov, VH = tv, HH = so, qH = Yt, WH = qH("iterator"), Rv = function(e) {
  if (!VH(e)) return Yx(e, WH) || Yx(e, "@@iterator") || HH[zH(e)];
}, ZH = Rv, KH = ZH, GH = KH, YH = GH, JH = YH, XH = JH, QH = XH, eq = QH, tq = eq;
const GT = /* @__PURE__ */ Ke(tq);
var nq = _n, rq = ao, iq = TypeError, aq = Object.getOwnPropertyDescriptor, oq = nq && !function() {
  if (this !== void 0) return !0;
  try {
    Object.defineProperty([], "length", { writable: !1 }).length = 1;
  } catch (e) {
    return e instanceof TypeError;
  }
}(), YT = oq ? function(e, t) {
  if (rq(e) && !aq(e, "length").writable)
    throw new iq("Cannot set read only .length");
  return e.length = t;
} : function(e, t) {
  return e.length = t;
}, sq = ht, lq = Yr, cq = Qi, uq = YT, fq = fv, dq = Wt, pq = dq(function() {
  return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
}), hq = function() {
  try {
    Object.defineProperty([], "length", { writable: !1 }).push();
  } catch (e) {
    return e instanceof TypeError;
  }
}, mq = pq || !hq();
sq({ target: "Array", proto: !0, arity: 1, forced: mq }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function(t) {
    var n = lq(this), r = cq(n), i = arguments.length;
    fq(r + i);
    for (var a = 0; a < i; a++)
      n[r] = arguments[a], r++;
    return uq(n, r), r;
  }
});
var vq = qt, yq = tn, ea = function(e, t) {
  var n = yq[e + "Prototype"], r = n && n[t];
  if (r) return r;
  var i = vq[e], a = i && i.prototype;
  return a && a[t];
}, gq = ea, bq = gq("Array", "push"), xq = Gr, wq = bq, kd = Array.prototype, Sq = function(e) {
  var t = e.push;
  return e === kd || xq(kd, e) && t === kd.push ? wq : t;
}, _q = Sq, Eq = _q, Tq = Eq, kq = Tq, Oq = kq, Cq = Oq, Rq = Cq;
const $q = /* @__PURE__ */ Ke(Rq);
function Iq(e, t) {
  var n = e == null ? null : typeof wa < "u" && GT(e) || e["@@iterator"];
  if (n != null) {
    var r, i, a, o, s = [], c = !0, l = !1;
    try {
      if (a = (n = n.call(e)).next, t === 0) {
        if (Object(n) !== n) return;
        c = !1;
      } else for (; !(c = (r = a.call(n)).done) && ($q(s).call(s, r.value), s.length !== t); c = !0) ;
    } catch (u) {
      l = !0, i = u;
    } finally {
      try {
        if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
      } finally {
        if (l) throw i;
      }
    }
    return s;
  }
}
var Aq = ht, Jx = ao, Pq = hv, Nq = Kr, Xx = vv, Dq = Qi, Mq = Ar, jq = Ys, Lq = Yt, Fq = Uu, Bq = Wu, Uq = Fq("slice"), zq = Lq("species"), Od = Array, Vq = Math.max;
Aq({ target: "Array", proto: !0, forced: !Uq }, {
  slice: function(t, n) {
    var r = Mq(this), i = Dq(r), a = Xx(t, i), o = Xx(n === void 0 ? i : n, i), s, c, l;
    if (Jx(r) && (s = r.constructor, Pq(s) && (s === Od || Jx(s.prototype)) ? s = void 0 : Nq(s) && (s = s[zq], s === null && (s = void 0)), s === Od || s === void 0))
      return Bq(r, a, o);
    for (c = new (s === void 0 ? Od : s)(Vq(o - a, 0)), l = 0; a < o; a++, l++) a in r && jq(c, l, r[a]);
    return c.length = l, c;
  }
});
var Hq = ea, qq = Hq("Array", "slice"), Wq = Gr, Zq = qq, Cd = Array.prototype, Kq = function(e) {
  var t = e.slice;
  return e === Cd || Wq(Cd, e) && t === Cd.slice ? Zq : t;
}, Gq = Kq, Yq = Gq, Jq = Yq, Xq = Jq, Qq = Xq, e8 = Qq, t8 = e8;
const n8 = /* @__PURE__ */ Ke(t8);
var r8 = Ir, Qx = Oi, i8 = ov, a8 = function(e, t, n) {
  var r, i;
  Qx(e);
  try {
    if (r = i8(e, "return"), !r) {
      if (t === "throw") throw n;
      return n;
    }
    r = r8(r, e);
  } catch (a) {
    i = !0, r = a;
  }
  if (t === "throw") throw n;
  if (i) throw r;
  return Qx(r), n;
}, o8 = Oi, s8 = a8, l8 = function(e, t, n, r) {
  try {
    return r ? t(o8(n)[0], n[1]) : t(n);
  } catch (i) {
    s8(e, "throw", i);
  }
}, c8 = Yt, u8 = so, f8 = c8("iterator"), d8 = Array.prototype, p8 = function(e) {
  return e !== void 0 && (u8.Array === e || d8[f8] === e);
}, h8 = Ir, m8 = av, v8 = Oi, y8 = Lu, g8 = Rv, b8 = TypeError, x8 = function(e, t) {
  var n = arguments.length < 2 ? g8(e) : t;
  if (m8(n)) return v8(h8(n, e));
  throw new b8(y8(e) + " is not iterable");
}, w8 = uv, S8 = Ir, _8 = Yr, E8 = l8, T8 = p8, k8 = hv, O8 = Qi, ew = Ys, C8 = x8, R8 = Rv, tw = Array, $8 = function(t) {
  var n = _8(t), r = k8(this), i = arguments.length, a = i > 1 ? arguments[1] : void 0, o = a !== void 0;
  o && (a = w8(a, i > 2 ? arguments[2] : void 0));
  var s = R8(n), c = 0, l, u, f, d, p, m;
  if (s && !(this === tw && T8(s)))
    for (u = r ? new this() : [], d = C8(n, s), p = d.next; !(f = S8(p, d)).done; c++)
      m = o ? E8(d, a, [f.value, c], !0) : f.value, ew(u, c, m);
  else
    for (l = O8(n), u = r ? new this(l) : tw(l); l > c; c++)
      m = o ? a(n[c], c) : n[c], ew(u, c, m);
  return u.length = c, u;
}, I8 = Yt, JT = I8("iterator"), XT = !1;
try {
  var A8 = 0, nw = {
    next: function() {
      return { done: !!A8++ };
    },
    return: function() {
      XT = !0;
    }
  };
  nw[JT] = function() {
    return this;
  }, Array.from(nw, function() {
    throw 2;
  });
} catch {
}
var P8 = function(e, t) {
  try {
    if (!t && !XT) return !1;
  } catch {
    return !1;
  }
  var n = !1;
  try {
    var r = {};
    r[JT] = function() {
      return {
        next: function() {
          return { done: n = !0 };
        }
      };
    }, e(r);
  } catch {
  }
  return n;
}, N8 = ht, D8 = $8, M8 = P8, j8 = !M8(function(e) {
  Array.from(e);
});
N8({ target: "Array", stat: !0, forced: j8 }, {
  from: D8
});
var L8 = tn, F8 = L8.Array.from, B8 = F8, U8 = B8, z8 = U8, V8 = z8, H8 = V8, q8 = H8, W8 = q8;
const QT = /* @__PURE__ */ Ke(W8);
function Sh(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ek(e, t) {
  if (e) {
    var n;
    if (typeof e == "string") return Sh(e, t);
    var r = n8(n = {}.toString.call(e)).call(n, 8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? QT(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? Sh(e, t) : void 0;
  }
}
function Z8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yr(e, t) {
  return vz(e) || Iq(e, t) || ek(e, t) || Z8();
}
var tk = { exports: {} };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var r = [], i = 0; i < arguments.length; i++) {
        var a = arguments[i];
        if (a) {
          var o = typeof a;
          if (o === "string" || o === "number")
            r.push(a);
          else if (Array.isArray(a)) {
            if (a.length) {
              var s = n.apply(null, a);
              s && r.push(s);
            }
          } else if (o === "object")
            if (a.toString === Object.prototype.toString)
              for (var c in a)
                t.call(a, c) && a[c] && r.push(c);
            else
              r.push(a.toString());
        }
      }
      return r.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(tk);
var K8 = tk.exports;
const $v = /* @__PURE__ */ Ke(K8);
var _h = { exports: {} }, Bl = { exports: {} }, ct = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rw;
function G8() {
  if (rw) return ct;
  rw = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function b(S) {
    if (typeof S == "object" && S !== null) {
      var E = S.$$typeof;
      switch (E) {
        case t:
          switch (S = S.type, S) {
            case c:
            case l:
            case r:
            case a:
            case i:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case u:
                case m:
                case p:
                case o:
                  return S;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function T(S) {
    return b(S) === l;
  }
  return ct.AsyncMode = c, ct.ConcurrentMode = l, ct.ContextConsumer = s, ct.ContextProvider = o, ct.Element = t, ct.ForwardRef = u, ct.Fragment = r, ct.Lazy = m, ct.Memo = p, ct.Portal = n, ct.Profiler = a, ct.StrictMode = i, ct.Suspense = f, ct.isAsyncMode = function(S) {
    return T(S) || b(S) === c;
  }, ct.isConcurrentMode = T, ct.isContextConsumer = function(S) {
    return b(S) === s;
  }, ct.isContextProvider = function(S) {
    return b(S) === o;
  }, ct.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, ct.isForwardRef = function(S) {
    return b(S) === u;
  }, ct.isFragment = function(S) {
    return b(S) === r;
  }, ct.isLazy = function(S) {
    return b(S) === m;
  }, ct.isMemo = function(S) {
    return b(S) === p;
  }, ct.isPortal = function(S) {
    return b(S) === n;
  }, ct.isProfiler = function(S) {
    return b(S) === a;
  }, ct.isStrictMode = function(S) {
    return b(S) === i;
  }, ct.isSuspense = function(S) {
    return b(S) === f;
  }, ct.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === l || S === a || S === i || S === f || S === d || typeof S == "object" && S !== null && (S.$$typeof === m || S.$$typeof === p || S.$$typeof === o || S.$$typeof === s || S.$$typeof === u || S.$$typeof === y || S.$$typeof === v || S.$$typeof === g || S.$$typeof === h);
  }, ct.typeOf = b, ct;
}
var ut = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var iw;
function Y8() {
  return iw || (iw = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function b(W) {
      return typeof W == "string" || typeof W == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      W === r || W === l || W === a || W === i || W === f || W === d || typeof W == "object" && W !== null && (W.$$typeof === m || W.$$typeof === p || W.$$typeof === o || W.$$typeof === s || W.$$typeof === u || W.$$typeof === y || W.$$typeof === v || W.$$typeof === g || W.$$typeof === h);
    }
    function T(W) {
      if (typeof W == "object" && W !== null) {
        var fe = W.$$typeof;
        switch (fe) {
          case t:
            var me = W.type;
            switch (me) {
              case c:
              case l:
              case r:
              case a:
              case i:
              case f:
                return me;
              default:
                var Oe = me && me.$$typeof;
                switch (Oe) {
                  case s:
                  case u:
                  case m:
                  case p:
                  case o:
                    return Oe;
                  default:
                    return fe;
                }
            }
          case n:
            return fe;
        }
      }
    }
    var S = c, E = l, O = s, j = o, D = t, k = u, A = r, V = m, $ = p, L = n, M = a, F = i, q = f, B = !1;
    function N(W) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), x(W) || T(W) === c;
    }
    function x(W) {
      return T(W) === l;
    }
    function z(W) {
      return T(W) === s;
    }
    function Z(W) {
      return T(W) === o;
    }
    function _(W) {
      return typeof W == "object" && W !== null && W.$$typeof === t;
    }
    function G(W) {
      return T(W) === u;
    }
    function ae(W) {
      return T(W) === r;
    }
    function te(W) {
      return T(W) === m;
    }
    function se(W) {
      return T(W) === p;
    }
    function de(W) {
      return T(W) === n;
    }
    function pe(W) {
      return T(W) === a;
    }
    function le(W) {
      return T(W) === i;
    }
    function X(W) {
      return T(W) === f;
    }
    ut.AsyncMode = S, ut.ConcurrentMode = E, ut.ContextConsumer = O, ut.ContextProvider = j, ut.Element = D, ut.ForwardRef = k, ut.Fragment = A, ut.Lazy = V, ut.Memo = $, ut.Portal = L, ut.Profiler = M, ut.StrictMode = F, ut.Suspense = q, ut.isAsyncMode = N, ut.isConcurrentMode = x, ut.isContextConsumer = z, ut.isContextProvider = Z, ut.isElement = _, ut.isForwardRef = G, ut.isFragment = ae, ut.isLazy = te, ut.isMemo = se, ut.isPortal = de, ut.isProfiler = pe, ut.isStrictMode = le, ut.isSuspense = X, ut.isValidElementType = b, ut.typeOf = T;
  }()), ut;
}
var aw;
function nk() {
  return aw || (aw = 1, process.env.NODE_ENV === "production" ? Bl.exports = G8() : Bl.exports = Y8()), Bl.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Rd, ow;
function J8() {
  if (ow) return Rd;
  ow = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Rd = i() ? Object.assign : function(a, o) {
    for (var s, c = r(a), l, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var f in s)
        t.call(s, f) && (c[f] = s[f]);
      if (e) {
        l = e(s);
        for (var d = 0; d < l.length; d++)
          n.call(s, l[d]) && (c[l[d]] = s[l[d]]);
      }
    }
    return c;
  }, Rd;
}
var $d, sw;
function Iv() {
  if (sw) return $d;
  sw = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $d = e, $d;
}
var Id, lw;
function X8() {
  if (lw) return Id;
  lw = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Iv(), n = {}, r = Function.call.bind(Object.prototype.hasOwnProperty);
    e = function(a) {
      var o = "Warning: " + a;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(a, o, s, c, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var f;
          try {
            if (typeof a[u] != "function") {
              var d = Error(
                (c || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = a[u](o, u, c, s, null, t);
          } catch (m) {
            f = m;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = l ? l() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Id = i, Id;
}
var Ad, cw;
function Q8() {
  if (cw) return Ad;
  cw = 1;
  var e = nk(), t = J8(), n = Iv(), r = X8(), i = Function.call.bind(Object.prototype.hasOwnProperty), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Ad = function(s, c) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function f(N) {
      var x = N && (l && N[l] || N[u]);
      if (typeof x == "function")
        return x;
    }
    var d = "<<anonymous>>", p = {
      array: v("array"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: g(),
      arrayOf: b,
      element: T(),
      elementType: S(),
      instanceOf: E,
      node: k(),
      objectOf: j,
      oneOf: O,
      oneOfType: D,
      shape: A,
      exact: V
    };
    function m(N, x) {
      return N === x ? N !== 0 || 1 / N === 1 / x : N !== N && x !== x;
    }
    function h(N) {
      this.message = N, this.stack = "";
    }
    h.prototype = Error.prototype;
    function y(N) {
      if (process.env.NODE_ENV !== "production")
        var x = {}, z = 0;
      function Z(G, ae, te, se, de, pe, le) {
        if (se = se || d, pe = pe || te, le !== n) {
          if (c) {
            var X = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw X.name = "Invariant Violation", X;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var W = se + ":" + te;
            !x[W] && // Avoid spamming the console because they are often not actionable except for lib authors
            z < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + pe + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), x[W] = !0, z++);
          }
        }
        return ae[te] == null ? G ? ae[te] === null ? new h("The " + de + " `" + pe + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new h("The " + de + " `" + pe + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : N(ae, te, se, de, pe);
      }
      var _ = Z.bind(null, !1);
      return _.isRequired = Z.bind(null, !0), _;
    }
    function v(N) {
      function x(z, Z, _, G, ae, te) {
        var se = z[Z], de = M(se);
        if (de !== N) {
          var pe = F(se);
          return new h("Invalid " + G + " `" + ae + "` of type " + ("`" + pe + "` supplied to `" + _ + "`, expected ") + ("`" + N + "`."));
        }
        return null;
      }
      return y(x);
    }
    function g() {
      return y(o);
    }
    function b(N) {
      function x(z, Z, _, G, ae) {
        if (typeof N != "function")
          return new h("Property `" + ae + "` of component `" + _ + "` has invalid PropType notation inside arrayOf.");
        var te = z[Z];
        if (!Array.isArray(te)) {
          var se = M(te);
          return new h("Invalid " + G + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + _ + "`, expected an array."));
        }
        for (var de = 0; de < te.length; de++) {
          var pe = N(te, de, _, G, ae + "[" + de + "]", n);
          if (pe instanceof Error)
            return pe;
        }
        return null;
      }
      return y(x);
    }
    function T() {
      function N(x, z, Z, _, G) {
        var ae = x[z];
        if (!s(ae)) {
          var te = M(ae);
          return new h("Invalid " + _ + " `" + G + "` of type " + ("`" + te + "` supplied to `" + Z + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(N);
    }
    function S() {
      function N(x, z, Z, _, G) {
        var ae = x[z];
        if (!e.isValidElementType(ae)) {
          var te = M(ae);
          return new h("Invalid " + _ + " `" + G + "` of type " + ("`" + te + "` supplied to `" + Z + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(N);
    }
    function E(N) {
      function x(z, Z, _, G, ae) {
        if (!(z[Z] instanceof N)) {
          var te = N.name || d, se = B(z[Z]);
          return new h("Invalid " + G + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + _ + "`, expected ") + ("instance of `" + te + "`."));
        }
        return null;
      }
      return y(x);
    }
    function O(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), o;
      function x(z, Z, _, G, ae) {
        for (var te = z[Z], se = 0; se < N.length; se++)
          if (m(te, N[se]))
            return null;
        var de = JSON.stringify(N, function(le, X) {
          var W = F(X);
          return W === "symbol" ? String(X) : X;
        });
        return new h("Invalid " + G + " `" + ae + "` of value `" + String(te) + "` " + ("supplied to `" + _ + "`, expected one of " + de + "."));
      }
      return y(x);
    }
    function j(N) {
      function x(z, Z, _, G, ae) {
        if (typeof N != "function")
          return new h("Property `" + ae + "` of component `" + _ + "` has invalid PropType notation inside objectOf.");
        var te = z[Z], se = M(te);
        if (se !== "object")
          return new h("Invalid " + G + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + _ + "`, expected an object."));
        for (var de in te)
          if (i(te, de)) {
            var pe = N(te, de, _, G, ae + "." + de, n);
            if (pe instanceof Error)
              return pe;
          }
        return null;
      }
      return y(x);
    }
    function D(N) {
      if (!Array.isArray(N))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var x = 0; x < N.length; x++) {
        var z = N[x];
        if (typeof z != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(z) + " at index " + x + "."
          ), o;
      }
      function Z(_, G, ae, te, se) {
        for (var de = 0; de < N.length; de++) {
          var pe = N[de];
          if (pe(_, G, ae, te, se, n) == null)
            return null;
        }
        return new h("Invalid " + te + " `" + se + "` supplied to " + ("`" + ae + "`."));
      }
      return y(Z);
    }
    function k() {
      function N(x, z, Z, _, G) {
        return $(x[z]) ? null : new h("Invalid " + _ + " `" + G + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
      }
      return y(N);
    }
    function A(N) {
      function x(z, Z, _, G, ae) {
        var te = z[Z], se = M(te);
        if (se !== "object")
          return new h("Invalid " + G + " `" + ae + "` of type `" + se + "` " + ("supplied to `" + _ + "`, expected `object`."));
        for (var de in N) {
          var pe = N[de];
          if (pe) {
            var le = pe(te, de, _, G, ae + "." + de, n);
            if (le)
              return le;
          }
        }
        return null;
      }
      return y(x);
    }
    function V(N) {
      function x(z, Z, _, G, ae) {
        var te = z[Z], se = M(te);
        if (se !== "object")
          return new h("Invalid " + G + " `" + ae + "` of type `" + se + "` " + ("supplied to `" + _ + "`, expected `object`."));
        var de = t({}, z[Z], N);
        for (var pe in de) {
          var le = N[pe];
          if (!le)
            return new h(
              "Invalid " + G + " `" + ae + "` key `" + pe + "` supplied to `" + _ + "`.\nBad object: " + JSON.stringify(z[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(N), null, "  ")
            );
          var X = le(te, pe, _, G, ae + "." + pe, n);
          if (X)
            return X;
        }
        return null;
      }
      return y(x);
    }
    function $(N) {
      switch (typeof N) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !N;
        case "object":
          if (Array.isArray(N))
            return N.every($);
          if (N === null || s(N))
            return !0;
          var x = f(N);
          if (x) {
            var z = x.call(N), Z;
            if (x !== N.entries) {
              for (; !(Z = z.next()).done; )
                if (!$(Z.value))
                  return !1;
            } else
              for (; !(Z = z.next()).done; ) {
                var _ = Z.value;
                if (_ && !$(_[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function L(N, x) {
      return N === "symbol" ? !0 : x ? x["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && x instanceof Symbol : !1;
    }
    function M(N) {
      var x = typeof N;
      return Array.isArray(N) ? "array" : N instanceof RegExp ? "object" : L(x, N) ? "symbol" : x;
    }
    function F(N) {
      if (typeof N > "u" || N === null)
        return "" + N;
      var x = M(N);
      if (x === "object") {
        if (N instanceof Date)
          return "date";
        if (N instanceof RegExp)
          return "regexp";
      }
      return x;
    }
    function q(N) {
      var x = F(N);
      switch (x) {
        case "array":
        case "object":
          return "an " + x;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + x;
        default:
          return x;
      }
    }
    function B(N) {
      return !N.constructor || !N.constructor.name ? d : N.constructor.name;
    }
    return p.checkPropTypes = r, p.resetWarningCache = r.resetWarningCache, p.PropTypes = p, p;
  }, Ad;
}
var Pd, uw;
function eW() {
  if (uw) return Pd;
  uw = 1;
  var e = Iv();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Pd = function() {
    function r(o, s, c, l, u, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var a = {
      array: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Pd;
}
if (process.env.NODE_ENV !== "production") {
  var tW = nk(), nW = !0;
  _h.exports = Q8()(tW.isElement, nW);
} else
  _h.exports = eW()();
var rW = _h.exports;
const tt = /* @__PURE__ */ Ke(rW);
var Av = /* @__PURE__ */ vt.createContext({
  scrollTo: function() {
    return 0;
  },
  scrollToBottom: function() {
    return 0;
  },
  scrollToEnd: function() {
    return 0;
  },
  scrollToStart: function() {
    return 0;
  },
  scrollToTop: function() {
    return 0;
  }
});
Av.displayName = "ScrollToBottomFunctionContext";
function iW() {
  return Xa(Av);
}
function aW() {
  var e = iW(), t = e.scrollToEnd;
  return t;
}
var Pv = /* @__PURE__ */ vt.createContext({
  atBottom: !0,
  atEnd: !0,
  atStart: !1,
  atTop: !0,
  mode: "bottom"
});
Pv.displayName = "ScrollToBottomState1Context";
var Nv = /* @__PURE__ */ vt.createContext({
  animating: !1,
  animatingToEnd: !1,
  sticky: !0
});
Nv.displayName = "ScrollToBottomState2Context";
var Dv = /* @__PURE__ */ vt.createContext({
  animating: !1,
  animatingToEnd: !1,
  atBottom: !0,
  atEnd: !0,
  atStart: !1,
  atTop: !0,
  mode: "bottom",
  sticky: !0
});
Dv.displayName = "ScrollToBottomStateContext";
var fw = [Dv, Pv, Nv];
function oW(e) {
  return Xa(fw[e] || fw[0]);
}
function sW() {
  var e = oW(2), t = e.sticky;
  return [t];
}
var ef = /* @__PURE__ */ vt.createContext({
  offsetHeight: 0,
  scrollHeight: 0,
  setTarget: function() {
    return 0;
  },
  styleToClassName: function() {
    return "";
  }
});
ef.displayName = "ScrollToBottomInternalContext";
function lW() {
  return Xa(ef);
}
function Mv() {
  var e = lW(), t = e.styleToClassName;
  return t;
}
var cW = {
  backgroundColor: "rgba(0, 0, 0, .2)",
  borderRadius: 10,
  borderWidth: 0,
  bottom: 5,
  cursor: "pointer",
  height: 20,
  outline: 0,
  position: "absolute",
  right: 20,
  width: 20,
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, .4)"
  },
  "&:active": {
    backgroundColor: "rgba(0, 0, 0, .6)"
  }
}, jv = function(t) {
  var n = t.children, r = t.className, i = sW(), a = yr(i, 1), o = a[0], s = Mv()(cW), c = aW();
  return !o && /* @__PURE__ */ vt.createElement("button", {
    className: $v(s, (r || "") + ""),
    onClick: c,
    type: "button"
  }, n);
};
jv.defaultProps = {
  children: void 0,
  className: ""
};
jv.propTypes = {
  children: tt.any,
  className: tt.string
};
var rk = { exports: {} }, uW = ht, fW = _n, dw = lr.f;
uW({ target: "Object", stat: !0, forced: Object.defineProperty !== dw, sham: !fW }, {
  defineProperty: dw
});
var dW = tn, ik = dW.Object, pW = rk.exports = function(t, n, r) {
  return ik.defineProperty(t, n, r);
};
ik.defineProperty.sham && (pW.sham = !0);
var hW = rk.exports, mW = hW, ak = mW, vW = ak, yW = vW, gW = yW, bW = gW, xW = bW;
const wW = /* @__PURE__ */ Ke(xW);
var SW = Qs, _W = SW.f("iterator"), EW = _W, TW = EW, kW = TW, OW = kW, CW = OW, RW = CW, $W = RW;
const IW = /* @__PURE__ */ Ke($W);
function ds(e) {
  "@babel/helpers - typeof";
  return ds = typeof wa == "function" && typeof IW == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof wa == "function" && t.constructor === wa && t !== wa.prototype ? "symbol" : typeof t;
  }, ds(e);
}
var AW = Qs, PW = AW.f("toPrimitive"), NW = PW, DW = NW, MW = DW, jW = MW, LW = jW, FW = LW, BW = FW;
const UW = /* @__PURE__ */ Ke(BW);
function zW(e, t) {
  if (ds(e) != "object" || !e) return e;
  var n = e[UW];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (ds(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function VW(e) {
  var t = zW(e, "string");
  return ds(t) == "symbol" ? t : t + "";
}
function HW(e, t, n) {
  return (t = VW(t)) in e ? wW(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function qW(e) {
  if (GE(e)) return Sh(e);
}
function WW(e) {
  if (typeof wa < "u" && GT(e) != null || e["@@iterator"] != null) return QT(e);
}
function ZW() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Xe(e) {
  return qW(e) || WW(e) || ek(e) || ZW();
}
var Ul = function(e) {
  return e && e.Math == Math && e;
}, Pn = (
  // eslint-disable-next-line es/no-global-this -- safe
  Ul(typeof globalThis == "object" && globalThis) || Ul(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Ul(typeof self == "object" && self) || Ul(typeof pt == "object" && pt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")()
), Lv = {}, cr = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, KW = cr, ta = !KW(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), ok = {}, sk = {}.propertyIsEnumerable, lk = Object.getOwnPropertyDescriptor, GW = lk && !sk.call({ 1: 2 }, 1);
ok.f = GW ? function(t) {
  var n = lk(this, t);
  return !!n && n.enumerable;
} : sk;
var ck = function(e, t) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: t
  };
}, YW = {}.toString, Fv = function(e) {
  return YW.call(e).slice(8, -1);
}, JW = cr, XW = Fv, QW = "".split, eZ = JW(function() {
  return !Object("z").propertyIsEnumerable(0);
}) ? function(e) {
  return XW(e) == "String" ? QW.call(e, "") : Object(e);
} : Object, tf = function(e) {
  if (e == null) throw TypeError("Can't call method on " + e);
  return e;
}, tZ = eZ, nZ = tf, Bv = function(e) {
  return tZ(nZ(e));
}, qn = function(e) {
  return typeof e == "function";
}, rZ = qn, rl = function(e) {
  return typeof e == "object" ? e !== null : rZ(e);
}, Nd = Pn, iZ = qn, aZ = function(e) {
  return iZ(e) ? e : void 0;
}, nf = function(e, t) {
  return arguments.length < 2 ? aZ(Nd[e]) : Nd[e] && Nd[e][t];
}, oZ = nf, sZ = oZ("navigator", "userAgent") || "", uk = Pn, Dd = sZ, pw = uk.process, hw = uk.Deno, mw = pw && pw.versions || hw && hw.version, vw = mw && mw.v8, dr, Jc;
vw ? (dr = vw.split("."), Jc = dr[0] < 4 ? 1 : dr[0] + dr[1]) : Dd && (dr = Dd.match(/Edge\/(\d+)/), (!dr || dr[1] >= 74) && (dr = Dd.match(/Chrome\/(\d+)/), dr && (Jc = dr[1])));
var lZ = Jc && +Jc, yw = lZ, cZ = cr, fk = !!Object.getOwnPropertySymbols && !cZ(function() {
  var e = Symbol();
  return !String(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && yw && yw < 41;
}), uZ = fk, dk = uZ && !Symbol.sham && typeof Symbol.iterator == "symbol", fZ = qn, dZ = nf, pZ = dk, pk = pZ ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var t = dZ("Symbol");
  return fZ(t) && Object(e) instanceof t;
}, hZ = function(e) {
  try {
    return String(e);
  } catch {
    return "Object";
  }
}, mZ = qn, vZ = hZ, yZ = function(e) {
  if (mZ(e)) return e;
  throw TypeError(vZ(e) + " is not a function");
}, gZ = yZ, hk = function(e, t) {
  var n = e[t];
  return n == null ? void 0 : gZ(n);
}, Md = qn, jd = rl, bZ = function(e, t) {
  var n, r;
  if (t === "string" && Md(n = e.toString) && !jd(r = n.call(e)) || Md(n = e.valueOf) && !jd(r = n.call(e)) || t !== "string" && Md(n = e.toString) && !jd(r = n.call(e))) return r;
  throw TypeError("Can't convert object to primitive value");
}, mk = { exports: {} }, gw = Pn, Uv = function(e, t) {
  try {
    Object.defineProperty(gw, e, { value: t, configurable: !0, writable: !0 });
  } catch {
    gw[e] = t;
  }
  return t;
}, xZ = Pn, wZ = Uv, bw = "__core-js_shared__", SZ = xZ[bw] || wZ(bw, {}), zv = SZ, xw = zv;
(mk.exports = function(e, t) {
  return xw[e] || (xw[e] = t !== void 0 ? t : {});
})("versions", []).push({
  version: "3.18.3",
  mode: "global",
  copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
});
var Vv = mk.exports, _Z = tf, vk = function(e) {
  return Object(_Z(e));
}, EZ = vk, TZ = {}.hasOwnProperty, na = Object.hasOwn || function(t, n) {
  return TZ.call(EZ(t), n);
}, kZ = 0, OZ = Math.random(), yk = function(e) {
  return "Symbol(" + String(e === void 0 ? "" : e) + ")_" + (++kZ + OZ).toString(36);
}, CZ = Pn, RZ = Vv, ww = na, $Z = yk, Sw = fk, IZ = dk, ko = RZ("wks"), Bo = CZ.Symbol, AZ = IZ ? Bo : Bo && Bo.withoutSetter || $Z, il = function(e) {
  return (!ww(ko, e) || !(Sw || typeof ko[e] == "string")) && (Sw && ww(Bo, e) ? ko[e] = Bo[e] : ko[e] = AZ("Symbol." + e)), ko[e];
}, _w = rl, Ew = pk, PZ = hk, NZ = bZ, DZ = il, MZ = DZ("toPrimitive"), jZ = function(e, t) {
  if (!_w(e) || Ew(e)) return e;
  var n = PZ(e, MZ), r;
  if (n) {
    if (t === void 0 && (t = "default"), r = n.call(e, t), !_w(r) || Ew(r)) return r;
    throw TypeError("Can't convert object to primitive value");
  }
  return t === void 0 && (t = "number"), NZ(e, t);
}, LZ = jZ, FZ = pk, gk = function(e) {
  var t = LZ(e, "string");
  return FZ(t) ? t : String(t);
}, BZ = Pn, Tw = rl, Eh = BZ.document, UZ = Tw(Eh) && Tw(Eh.createElement), bk = function(e) {
  return UZ ? Eh.createElement(e) : {};
}, zZ = ta, VZ = cr, HZ = bk, xk = !zZ && !VZ(function() {
  return Object.defineProperty(HZ("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), qZ = ta, WZ = ok, ZZ = ck, KZ = Bv, GZ = gk, YZ = na, JZ = xk, kw = Object.getOwnPropertyDescriptor;
Lv.f = qZ ? kw : function(t, n) {
  if (t = KZ(t), n = GZ(n), JZ) try {
    return kw(t, n);
  } catch {
  }
  if (YZ(t, n)) return ZZ(!WZ.f.call(t, n), t[n]);
};
var al = {}, XZ = rl, Ci = function(e) {
  if (XZ(e)) return e;
  throw TypeError(String(e) + " is not an object");
}, QZ = ta, eK = xk, Ow = Ci, tK = gk, Cw = Object.defineProperty;
al.f = QZ ? Cw : function(t, n, r) {
  if (Ow(t), n = tK(n), Ow(r), eK) try {
    return Cw(t, n, r);
  } catch {
  }
  if ("get" in r || "set" in r) throw TypeError("Accessors not supported");
  return "value" in r && (t[n] = r.value), t;
};
var nK = ta, rK = al, iK = ck, rf = nK ? function(e, t, n) {
  return rK.f(e, t, iK(1, n));
} : function(e, t, n) {
  return e[t] = n, e;
}, wk = { exports: {} }, aK = qn, Th = zv, oK = Function.toString;
aK(Th.inspectSource) || (Th.inspectSource = function(e) {
  return oK.call(e);
});
var Sk = Th.inspectSource, sK = Pn, lK = qn, cK = Sk, Rw = sK.WeakMap, uK = lK(Rw) && /native code/.test(cK(Rw)), fK = Vv, dK = yk, $w = fK("keys"), _k = function(e) {
  return $w[e] || ($w[e] = dK(e));
}, Hv = {}, pK = uK, hK = Pn, mK = rl, vK = rf, Ld = na, Fd = zv, yK = _k, gK = Hv, Iw = "Object already initialized", bK = hK.WeakMap, Xc, ps, Qc, xK = function(e) {
  return Qc(e) ? ps(e) : Xc(e, {});
}, wK = function(e) {
  return function(t) {
    var n;
    if (!mK(t) || (n = ps(t)).type !== e)
      throw TypeError("Incompatible receiver, " + e + " required");
    return n;
  };
};
if (pK || Fd.state) {
  var Ai = Fd.state || (Fd.state = new bK()), SK = Ai.get, Aw = Ai.has, _K = Ai.set;
  Xc = function(e, t) {
    if (Aw.call(Ai, e)) throw new TypeError(Iw);
    return t.facade = e, _K.call(Ai, e, t), t;
  }, ps = function(e) {
    return SK.call(Ai, e) || {};
  }, Qc = function(e) {
    return Aw.call(Ai, e);
  };
} else {
  var da = yK("state");
  gK[da] = !0, Xc = function(e, t) {
    if (Ld(e, da)) throw new TypeError(Iw);
    return t.facade = e, vK(e, da, t), t;
  }, ps = function(e) {
    return Ld(e, da) ? e[da] : {};
  }, Qc = function(e) {
    return Ld(e, da);
  };
}
var Ek = {
  set: Xc,
  get: ps,
  has: Qc,
  enforce: xK,
  getterFor: wK
}, kh = ta, EK = na, Tk = Function.prototype, TK = kh && Object.getOwnPropertyDescriptor, qv = EK(Tk, "name"), kK = qv && (function() {
}).name === "something", OK = qv && (!kh || kh && TK(Tk, "name").configurable), Wv = {
  EXISTS: qv,
  PROPER: kK,
  CONFIGURABLE: OK
}, CK = Pn, Pw = qn, RK = na, Nw = rf, $K = Uv, IK = Sk, kk = Ek, AK = Wv.CONFIGURABLE, PK = kk.get, NK = kk.enforce, DK = String(String).split("String");
(wk.exports = function(e, t, n, r) {
  var i = r ? !!r.unsafe : !1, a = r ? !!r.enumerable : !1, o = r ? !!r.noTargetGet : !1, s = r && r.name !== void 0 ? r.name : t, c;
  if (Pw(n) && (String(s).slice(0, 7) === "Symbol(" && (s = "[" + String(s).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!RK(n, "name") || AK && n.name !== s) && Nw(n, "name", s), c = NK(n), c.source || (c.source = DK.join(typeof s == "string" ? s : ""))), e === CK) {
    a ? e[t] = n : $K(t, n);
    return;
  } else i ? !o && e[t] && (a = !0) : delete e[t];
  a ? e[t] = n : Nw(e, t, n);
})(Function.prototype, "toString", function() {
  return Pw(this) && PK(this).source || IK(this);
});
var ol = wk.exports, Ok = {}, MK = Math.ceil, jK = Math.floor, af = function(e) {
  var t = +e;
  return t !== t || t === 0 ? 0 : (t > 0 ? jK : MK)(t);
}, LK = af, FK = Math.max, BK = Math.min, UK = function(e, t) {
  var n = LK(e);
  return n < 0 ? FK(n + t, 0) : BK(n, t);
}, zK = af, VK = Math.min, Ck = function(e) {
  return e > 0 ? VK(zK(e), 9007199254740991) : 0;
}, HK = Ck, qK = function(e) {
  return HK(e.length);
}, WK = Bv, ZK = UK, KK = qK, Dw = function(e) {
  return function(t, n, r) {
    var i = WK(t), a = KK(i), o = ZK(r, a), s;
    if (e && n != n) {
      for (; a > o; )
        if (s = i[o++], s != s) return !0;
    } else for (; a > o; o++)
      if ((e || o in i) && i[o] === n) return e || o || 0;
    return !e && -1;
  };
}, GK = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Dw(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: Dw(!1)
}, Bd = na, YK = Bv, JK = GK.indexOf, XK = Hv, Rk = function(e, t) {
  var n = YK(e), r = 0, i = [], a;
  for (a in n) !Bd(XK, a) && Bd(n, a) && i.push(a);
  for (; t.length > r; ) Bd(n, a = t[r++]) && (~JK(i, a) || i.push(a));
  return i;
}, Zv = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], QK = Rk, eG = Zv, tG = eG.concat("length", "prototype");
Ok.f = Object.getOwnPropertyNames || function(t) {
  return QK(t, tG);
};
var $k = {};
$k.f = Object.getOwnPropertySymbols;
var nG = nf, rG = Ok, iG = $k, aG = Ci, oG = nG("Reflect", "ownKeys") || function(t) {
  var n = rG.f(aG(t)), r = iG.f;
  return r ? n.concat(r(t)) : n;
}, sG = na, lG = oG, cG = Lv, uG = al, fG = function(e, t) {
  for (var n = lG(t), r = uG.f, i = cG.f, a = 0; a < n.length; a++) {
    var o = n[a];
    sG(e, o) || r(e, o, i(t, o));
  }
}, dG = cr, pG = qn, hG = /#|\.prototype\./, sl = function(e, t) {
  var n = vG[mG(e)];
  return n == gG ? !0 : n == yG ? !1 : pG(t) ? dG(t) : !!t;
}, mG = sl.normalize = function(e) {
  return String(e).replace(hG, ".").toLowerCase();
}, vG = sl.data = {}, yG = sl.NATIVE = "N", gG = sl.POLYFILL = "P", bG = sl, Ud = Pn, xG = Lv.f, wG = rf, SG = ol, _G = Uv, EG = fG, TG = bG, kG = function(e, t) {
  var n = e.target, r = e.global, i = e.stat, a, o, s, c, l, u;
  if (r ? o = Ud : i ? o = Ud[n] || _G(n, {}) : o = (Ud[n] || {}).prototype, o) for (s in t) {
    if (l = t[s], e.noTargetGet ? (u = xG(o, s), c = u && u.value) : c = o[s], a = TG(r ? s : n + (i ? "." : "#") + s, e.forced), !a && c !== void 0) {
      if (typeof l == typeof c) continue;
      EG(l, c);
    }
    (e.sham || c && c.sham) && wG(l, "sham", !0), SG(o, s, l, e);
  }
}, OG = il, CG = OG("toStringTag"), Ik = {};
Ik[CG] = "z";
var Kv = String(Ik) === "[object z]", RG = Kv, $G = qn, fc = Fv, IG = il, AG = IG("toStringTag"), PG = fc(/* @__PURE__ */ function() {
  return arguments;
}()) == "Arguments", NG = function(e, t) {
  try {
    return e[t];
  } catch {
  }
}, Ak = RG ? fc : function(e) {
  var t, n, r;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = NG(t = Object(e), AG)) == "string" ? n : PG ? fc(t) : (r = fc(t)) == "Object" && $G(t.callee) ? "Arguments" : r;
}, DG = Ak, of = function(e) {
  if (DG(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return String(e);
}, MG = Ci, Pk = function() {
  var e = MG(this), t = "";
  return e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.sticky && (t += "y"), t;
}, Gv = {}, Nk = cr, jG = Pn, Dk = jG.RegExp;
Gv.UNSUPPORTED_Y = Nk(function() {
  var e = Dk("a", "y");
  return e.lastIndex = 2, e.exec("abcd") != null;
});
Gv.BROKEN_CARET = Nk(function() {
  var e = Dk("^r", "gy");
  return e.lastIndex = 2, e.exec("str") != null;
});
var LG = Rk, FG = Zv, BG = Object.keys || function(t) {
  return LG(t, FG);
}, UG = ta, zG = al, VG = Ci, HG = BG, qG = UG ? Object.defineProperties : function(t, n) {
  VG(t);
  for (var r = HG(n), i = r.length, a = 0, o; i > a; ) zG.f(t, o = r[a++], n[o]);
  return t;
}, WG = nf, ZG = WG("document", "documentElement"), KG = Ci, GG = qG, Mw = Zv, YG = Hv, JG = ZG, XG = bk, QG = _k, jw = ">", Lw = "<", Oh = "prototype", Ch = "script", Mk = QG("IE_PROTO"), zd = function() {
}, jk = function(e) {
  return Lw + Ch + jw + e + Lw + "/" + Ch + jw;
}, Fw = function(e) {
  e.write(jk("")), e.close();
  var t = e.parentWindow.Object;
  return e = null, t;
}, eY = function() {
  var e = XG("iframe"), t = "java" + Ch + ":", n;
  return e.style.display = "none", JG.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(jk("document.F=Object")), n.close(), n.F;
}, zl, dc = function() {
  try {
    zl = new ActiveXObject("htmlfile");
  } catch {
  }
  dc = typeof document < "u" ? document.domain && zl ? Fw(zl) : eY() : Fw(zl);
  for (var e = Mw.length; e--; ) delete dc[Oh][Mw[e]];
  return dc();
};
YG[Mk] = !0;
var tY = Object.create || function(t, n) {
  var r;
  return t !== null ? (zd[Oh] = KG(t), r = new zd(), zd[Oh] = null, r[Mk] = t) : r = dc(), n === void 0 ? r : GG(r, n);
}, nY = cr, rY = Pn, iY = rY.RegExp, aY = nY(function() {
  var e = iY(".", "s");
  return !(e.dotAll && e.exec(`
`) && e.flags === "s");
}), oY = cr, sY = Pn, lY = sY.RegExp, cY = oY(function() {
  var e = lY("(?<a>b)", "g");
  return e.exec("b").groups.a !== "b" || "b".replace(e, "$<a>c") !== "bc";
}), uY = of, fY = Pk, Bw = Gv, dY = Vv, pY = tY, hY = Ek.get, mY = aY, vY = cY, eu = RegExp.prototype.exec, yY = dY("native-string-replace", String.prototype.replace), Rh = eu, $h = function() {
  var e = /a/, t = /b*/g;
  return eu.call(e, "a"), eu.call(t, "a"), e.lastIndex !== 0 || t.lastIndex !== 0;
}(), Lk = Bw.UNSUPPORTED_Y || Bw.BROKEN_CARET, Ih = /()??/.exec("")[1] !== void 0, gY = $h || Ih || Lk || mY || vY;
gY && (Rh = function(t) {
  var n = this, r = hY(n), i = uY(t), a = r.raw, o, s, c, l, u, f, d;
  if (a)
    return a.lastIndex = n.lastIndex, o = Rh.call(a, i), n.lastIndex = a.lastIndex, o;
  var p = r.groups, m = Lk && n.sticky, h = fY.call(n), y = n.source, v = 0, g = i;
  if (m && (h = h.replace("y", ""), h.indexOf("g") === -1 && (h += "g"), g = i.slice(n.lastIndex), n.lastIndex > 0 && (!n.multiline || n.multiline && i.charAt(n.lastIndex - 1) !== `
`) && (y = "(?: " + y + ")", g = " " + g, v++), s = new RegExp("^(?:" + y + ")", h)), Ih && (s = new RegExp("^" + y + "$(?!\\s)", h)), $h && (c = n.lastIndex), l = eu.call(m ? s : n, g), m ? l ? (l.input = l.input.slice(v), l[0] = l[0].slice(v), l.index = n.lastIndex, n.lastIndex += l[0].length) : n.lastIndex = 0 : $h && l && (n.lastIndex = n.global ? l.index + l[0].length : c), Ih && l && l.length > 1 && yY.call(l[0], s, function() {
    for (u = 1; u < arguments.length - 2; u++)
      arguments[u] === void 0 && (l[u] = void 0);
  }), l && p)
    for (l.groups = f = pY(null), u = 0; u < p.length; u++)
      d = p[u], f[d[0]] = l[d[1]];
  return l;
});
var Yv = Rh, bY = kG, Uw = Yv;
bY({ target: "RegExp", proto: !0, forced: /./.exec !== Uw }, {
  exec: Uw
});
var zw = ol, xY = Yv, Vw = cr, Fk = il, wY = rf, SY = Fk("species"), Vd = RegExp.prototype, _Y = function(e, t, n, r) {
  var i = Fk(e), a = !Vw(function() {
    var l = {};
    return l[i] = function() {
      return 7;
    }, ""[e](l) != 7;
  }), o = a && !Vw(function() {
    var l = !1, u = /a/;
    return e === "split" && (u = {}, u.constructor = {}, u.constructor[SY] = function() {
      return u;
    }, u.flags = "", u[i] = /./[i]), u.exec = function() {
      return l = !0, null;
    }, u[i](""), !l;
  });
  if (!a || !o || n) {
    var s = /./[i], c = t(i, ""[e], function(l, u, f, d, p) {
      var m = u.exec;
      return m === xY || m === Vd.exec ? a && !p ? { done: !0, value: s.call(u, f, d) } : { done: !0, value: l.call(f, u, d) } : { done: !1 };
    });
    zw(String.prototype, e, c[0]), zw(Vd, i, c[1]);
  }
  r && wY(Vd[i], "sham", !0);
}, EY = af, TY = of, kY = tf, Hw = function(e) {
  return function(t, n) {
    var r = TY(kY(t)), i = EY(n), a = r.length, o, s;
    return i < 0 || i >= a ? e ? "" : void 0 : (o = r.charCodeAt(i), o < 55296 || o > 56319 || i + 1 === a || (s = r.charCodeAt(i + 1)) < 56320 || s > 57343 ? e ? r.charAt(i) : o : e ? r.slice(i, i + 2) : (o - 55296 << 10) + (s - 56320) + 65536);
  };
}, OY = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Hw(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Hw(!0)
}, CY = OY.charAt, RY = function(e, t, n) {
  return t + (n ? CY(e, t).length : 1);
}, $Y = vk, IY = Math.floor, AY = "".replace, PY = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, NY = /\$([$&'`]|\d{1,2})/g, DY = function(e, t, n, r, i, a) {
  var o = n + e.length, s = r.length, c = NY;
  return i !== void 0 && (i = $Y(i), c = PY), AY.call(a, c, function(l, u) {
    var f;
    switch (u.charAt(0)) {
      case "$":
        return "$";
      case "&":
        return e;
      case "`":
        return t.slice(0, n);
      case "'":
        return t.slice(o);
      case "<":
        f = i[u.slice(1, -1)];
        break;
      default:
        var d = +u;
        if (d === 0) return l;
        if (d > s) {
          var p = IY(d / 10);
          return p === 0 ? l : p <= s ? r[p - 1] === void 0 ? u.charAt(1) : r[p - 1] + u.charAt(1) : l;
        }
        f = r[d - 1];
    }
    return f === void 0 ? "" : f;
  });
}, MY = Ci, jY = qn, LY = Fv, FY = Yv, BY = function(e, t) {
  var n = e.exec;
  if (jY(n)) {
    var r = n.call(e, t);
    return r !== null && MY(r), r;
  }
  if (LY(e) === "RegExp") return FY.call(e, t);
  throw TypeError("RegExp#exec called on incompatible receiver");
}, UY = _Y, zY = cr, VY = Ci, HY = qn, qY = af, WY = Ck, pa = of, ZY = tf, KY = RY, GY = hk, YY = DY, JY = BY, XY = il, Ah = XY("replace"), QY = Math.max, eJ = Math.min, tJ = function(e) {
  return e === void 0 ? e : String(e);
}, nJ = function() {
  return "a".replace(/./, "$0") === "$0";
}(), qw = function() {
  return /./[Ah] ? /./[Ah]("a", "$0") === "" : !1;
}(), rJ = !zY(function() {
  var e = /./;
  return e.exec = function() {
    var t = [];
    return t.groups = { a: "7" }, t;
  }, "".replace(e, "$<a>") !== "7";
});
UY("replace", function(e, t, n) {
  var r = qw ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(a, o) {
      var s = ZY(this), c = a == null ? void 0 : GY(a, Ah);
      return c ? c.call(a, s, o) : t.call(pa(s), a, o);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(i, a) {
      var o = VY(this), s = pa(i);
      if (typeof a == "string" && a.indexOf(r) === -1 && a.indexOf("$<") === -1) {
        var c = n(t, o, s, a);
        if (c.done) return c.value;
      }
      var l = HY(a);
      l || (a = pa(a));
      var u = o.global;
      if (u) {
        var f = o.unicode;
        o.lastIndex = 0;
      }
      for (var d = []; ; ) {
        var p = JY(o, s);
        if (p === null || (d.push(p), !u)) break;
        var m = pa(p[0]);
        m === "" && (o.lastIndex = KY(s, WY(o.lastIndex), f));
      }
      for (var h = "", y = 0, v = 0; v < d.length; v++) {
        p = d[v];
        for (var g = pa(p[0]), b = QY(eJ(qY(p.index), s.length), 0), T = [], S = 1; S < p.length; S++) T.push(tJ(p[S]));
        var E = p.groups;
        if (l) {
          var O = [g].concat(T, b, s);
          E !== void 0 && O.push(E);
          var j = pa(a.apply(void 0, O));
        } else
          j = YY(g, s, b, T, E, a);
        b >= y && (h += s.slice(y, b) + j, y = b + g.length);
      }
      return h + s.slice(y);
    }
  ];
}, !rJ || !nJ || qw);
var Oo = qt, iJ = rv, aJ = Xi, Vl = function(e) {
  return iJ.slice(0, e.length) === e;
}, oJ = function() {
  return Vl("Bun/") ? "BUN" : Vl("Cloudflare-Workers") ? "CLOUDFLARE" : Vl("Deno/") ? "DENO" : Vl("Node.js/") ? "NODE" : Oo.Bun && typeof Bun.version == "string" ? "BUN" : Oo.Deno && typeof Deno.version == "object" ? "DENO" : aJ(Oo.process) === "process" ? "NODE" : Oo.window && Oo.document ? "BROWSER" : "REST";
}(), sJ = TypeError, lJ = function(e, t) {
  if (e < t) throw new sJ("Not enough arguments");
  return e;
}, Bk = qt, cJ = Xm, uJ = cn, fJ = oJ, dJ = rv, pJ = Wu, hJ = lJ, mJ = Bk.Function, vJ = /MSIE .\./.test(dJ) || fJ === "BUN" && function() {
  var e = Bk.Bun.version.split(".");
  return e.length < 3 || e[0] === "0" && (e[1] < 3 || e[1] === "3" && e[2] === "0");
}(), Uk = function(e, t) {
  var n = t ? 2 : 1;
  return vJ ? function(r, i) {
    var a = hJ(arguments.length, 1) > n, o = uJ(r) ? r : mJ(r), s = a ? pJ(arguments, n) : [], c = a ? function() {
      cJ(o, this, s);
    } : o;
    return t ? e(c, i) : e(c);
  } : e;
}, yJ = ht, zk = qt, gJ = Uk, Ww = gJ(zk.setInterval, !0);
yJ({ global: !0, bind: !0, forced: zk.setInterval !== Ww }, {
  setInterval: Ww
});
var bJ = ht, Vk = qt, xJ = Uk, Zw = xJ(Vk.setTimeout, !0);
bJ({ global: !0, bind: !0, forced: Vk.setTimeout !== Zw }, {
  setTimeout: Zw
});
var wJ = tn, SJ = wJ.setInterval, _J = SJ;
const EJ = /* @__PURE__ */ Ke(_J);
var TJ = Wt, Hk = function(e, t) {
  var n = [][e];
  return !!n && TJ(function() {
    n.call(null, t || function() {
      return 1;
    }, 1);
  });
}, kJ = ht, OJ = Qm, CJ = nT.indexOf, RJ = Hk, Ph = OJ([].indexOf), qk = !!Ph && 1 / Ph([1], 1, -0) < 0, $J = qk || !RJ("indexOf");
kJ({ target: "Array", proto: !0, forced: $J }, {
  indexOf: function(t) {
    var n = arguments.length > 1 ? arguments[1] : void 0;
    return qk ? Ph(this, t, n) || 0 : CJ(this, t, n);
  }
});
var IJ = ea, AJ = IJ("Array", "indexOf"), PJ = Gr, NJ = AJ, Hd = Array.prototype, DJ = function(e) {
  var t = e.indexOf;
  return e === Hd || PJ(Hd, e) && t === Hd.indexOf ? NJ : t;
}, MJ = DJ, jJ = MJ, LJ = jJ;
const FJ = /* @__PURE__ */ Ke(LJ);
var Kw = Lu, BJ = TypeError, UJ = function(e, t) {
  if (!delete e[t]) throw new BJ("Cannot delete property " + Kw(t) + " of " + Kw(e));
}, zJ = ht, VJ = Yr, HJ = vv, qJ = Bu, WJ = Qi, ZJ = YT, KJ = fv, GJ = mv, YJ = Ys, qd = UJ, JJ = Uu, XJ = JJ("splice"), QJ = Math.max, eX = Math.min;
zJ({ target: "Array", proto: !0, forced: !XJ }, {
  splice: function(t, n) {
    var r = VJ(this), i = WJ(r), a = HJ(t, i), o = arguments.length, s, c, l, u, f, d;
    for (o === 0 ? s = c = 0 : o === 1 ? (s = 0, c = i - a) : (s = o - 2, c = eX(QJ(qJ(n), 0), i - a)), KJ(i + s - c), l = GJ(r, c), u = 0; u < c; u++)
      f = a + u, f in r && YJ(l, u, r[f]);
    if (l.length = c, s < c) {
      for (u = a; u < i - c; u++)
        f = u + c, d = u + s, f in r ? r[d] = r[f] : qd(r, d);
      for (u = i; u > i - c + s; u--) qd(r, u - 1);
    } else if (s > c)
      for (u = i - c; u > a; u--)
        f = u + c - 1, d = u + s - 1, f in r ? r[d] = r[f] : qd(r, d);
    for (u = 0; u < s; u++)
      r[u + a] = arguments[u + 2];
    return ZJ(r, i - c + s), l;
  }
});
var tX = ea, nX = tX("Array", "splice"), rX = Gr, iX = nX, Wd = Array.prototype, aX = function(e) {
  var t = e.splice;
  return e === Wd || rX(Wd, e) && t === Wd.splice ? iX : t;
}, oX = aX, sX = oX, lX = sX;
const cX = /* @__PURE__ */ Ke(lX);
var uX = ea, fX = uX("Array", "concat"), dX = Gr, pX = fX, Zd = Array.prototype, hX = function(e) {
  var t = e.concat;
  return e === Zd || dX(Zd, e) && t === Zd.concat ? pX : t;
}, mX = hX, vX = mX, yX = vX;
const St = /* @__PURE__ */ Ke(yX);
var gX = ht, bX = Zt, Wk = Date, xX = bX(Wk.prototype.getTime);
gX({ target: "Date", stat: !0 }, {
  now: function() {
    return xX(new Wk());
  }
});
var wX = tn, SX = wX.Date.now, _X = SX, EX = _X, TX = EX;
const hi = /* @__PURE__ */ Ke(TX);
var kX = wv.forEach, OX = Hk, CX = OX("forEach"), RX = CX ? [].forEach : function(t) {
  return kX(this, t, arguments.length > 1 ? arguments[1] : void 0);
}, $X = ht, Gw = RX;
$X({ target: "Array", proto: !0, forced: [].forEach !== Gw }, {
  forEach: Gw
});
var IX = ea, AX = IX("Array", "forEach"), PX = AX, NX = PX, DX = Js, MX = An, jX = Gr, LX = NX, Kd = Array.prototype, FX = {
  DOMTokenList: !0,
  NodeList: !0
}, BX = function(e) {
  var t = e.forEach;
  return e === Kd || jX(Kd, e) && t === Kd.forEach || MX(FX, DX(e)) ? LX : t;
}, UX = BX;
const tu = /* @__PURE__ */ Ke(UX);
var zX = ht, VX = Yr, Zk = gv, HX = Wt, qX = HX(function() {
  Zk(1);
});
zX({ target: "Object", stat: !0, forced: qX }, {
  keys: function(t) {
    return Zk(VX(t));
  }
});
var WX = tn, ZX = WX.Object.keys, KX = ZX, GX = KX, YX = GX;
const JX = /* @__PURE__ */ Ke(YX);
var XX = tn, QX = XX.Object.getOwnPropertySymbols, eQ = QX, tQ = eQ, nQ = tQ;
const Yw = /* @__PURE__ */ Ke(nQ);
var rQ = ht, iQ = wv.filter, aQ = Uu, oQ = aQ("filter");
rQ({ target: "Array", proto: !0, forced: !oQ }, {
  filter: function(t) {
    return iQ(this, t, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var sQ = ea, lQ = sQ("Array", "filter"), cQ = Gr, uQ = lQ, Gd = Array.prototype, fQ = function(e) {
  var t = e.filter;
  return e === Gd || cQ(Gd, e) && t === Gd.filter ? uQ : t;
}, dQ = fQ, pQ = dQ, hQ = pQ;
const mQ = /* @__PURE__ */ Ke(hQ);
var Kk = { exports: {} }, vQ = ht, yQ = Wt, gQ = Ar, Gk = Ws.f, Yk = _n, bQ = !Yk || yQ(function() {
  Gk(1);
});
vQ({ target: "Object", stat: !0, forced: bQ, sham: !Yk }, {
  getOwnPropertyDescriptor: function(t, n) {
    return Gk(gQ(t), n);
  }
});
var xQ = tn, Jk = xQ.Object, wQ = Kk.exports = function(t, n) {
  return Jk.getOwnPropertyDescriptor(t, n);
};
Jk.getOwnPropertyDescriptor.sham && (wQ.sham = !0);
var SQ = Kk.exports, _Q = SQ, EQ = _Q, TQ = EQ;
const Xk = /* @__PURE__ */ Ke(TQ);
var kQ = Pr, OQ = Zt, CQ = qu, RQ = Zu, $Q = Oi, IQ = OQ([].concat), AQ = kQ("Reflect", "ownKeys") || function(t) {
  var n = CQ.f($Q(t)), r = RQ.f;
  return r ? IQ(n, r(t)) : n;
}, PQ = ht, NQ = _n, DQ = AQ, MQ = Ar, jQ = Ws, LQ = Ys;
PQ({ target: "Object", stat: !0, sham: !NQ }, {
  getOwnPropertyDescriptors: function(t) {
    for (var n = MQ(t), r = jQ.f, i = DQ(n), a = {}, o = 0, s, c; i.length > o; )
      c = r(n, s = i[o++]), c !== void 0 && LQ(a, s, c);
    return a;
  }
});
var FQ = tn, BQ = FQ.Object.getOwnPropertyDescriptors, UQ = BQ, zQ = UQ, VQ = zQ;
const Jw = /* @__PURE__ */ Ke(VQ);
var Qk = { exports: {} }, HQ = ht, qQ = _n, Xw = zu.f;
HQ({ target: "Object", stat: !0, forced: Object.defineProperties !== Xw, sham: !qQ }, {
  defineProperties: Xw
});
var WQ = tn, eO = WQ.Object, ZQ = Qk.exports = function(t, n) {
  return eO.defineProperties(t, n);
};
eO.defineProperties.sham && (ZQ.sham = !0);
var KQ = Qk.exports, GQ = KQ, YQ = GQ, JQ = YQ;
const XQ = /* @__PURE__ */ Ke(JQ);
var QQ = ak;
const eee = /* @__PURE__ */ Ke(QQ);
var tee = !1;
function nee(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function ree(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var iee = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var a;
      r.tags.length === 0 ? r.insertionPoint ? a = r.insertionPoint.nextSibling : r.prepend ? a = r.container.firstChild : a = r.before : a = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, a), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !tee : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(ree(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = nee(i);
      try {
        a.insertRule(r, a.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), nn = "-ms-", nu = "-moz-", ot = "-webkit-", tO = "comm", Jv = "rule", Xv = "decl", aee = "@import", nO = "@keyframes", oee = "@layer", see = Math.abs, sf = String.fromCharCode, lee = Object.assign;
function cee(e, t) {
  return en(e, 0) ^ 45 ? (((t << 2 ^ en(e, 0)) << 2 ^ en(e, 1)) << 2 ^ en(e, 2)) << 2 ^ en(e, 3) : 0;
}
function rO(e) {
  return e.trim();
}
function uee(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function st(e, t, n) {
  return e.replace(t, n);
}
function Nh(e, t) {
  return e.indexOf(t);
}
function en(e, t) {
  return e.charCodeAt(t) | 0;
}
function hs(e, t, n) {
  return e.slice(t, n);
}
function br(e) {
  return e.length;
}
function Qv(e) {
  return e.length;
}
function Hl(e, t) {
  return t.push(e), e;
}
function fee(e, t) {
  return e.map(t).join("");
}
var lf = 1, Ha = 1, iO = 0, Sn = 0, Mt = 0, lo = "";
function cf(e, t, n, r, i, a, o) {
  return { value: e, root: t, parent: n, type: r, props: i, children: a, line: lf, column: Ha, length: o, return: "" };
}
function Co(e, t) {
  return lee(cf("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function dee() {
  return Mt;
}
function pee() {
  return Mt = Sn > 0 ? en(lo, --Sn) : 0, Ha--, Mt === 10 && (Ha = 1, lf--), Mt;
}
function Rn() {
  return Mt = Sn < iO ? en(lo, Sn++) : 0, Ha++, Mt === 10 && (Ha = 1, lf++), Mt;
}
function Sr() {
  return en(lo, Sn);
}
function pc() {
  return Sn;
}
function ll(e, t) {
  return hs(lo, e, t);
}
function ms(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function aO(e) {
  return lf = Ha = 1, iO = br(lo = e), Sn = 0, [];
}
function oO(e) {
  return lo = "", e;
}
function hc(e) {
  return rO(ll(Sn - 1, Dh(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function hee(e) {
  for (; (Mt = Sr()) && Mt < 33; )
    Rn();
  return ms(e) > 2 || ms(Mt) > 3 ? "" : " ";
}
function mee(e, t) {
  for (; --t && Rn() && !(Mt < 48 || Mt > 102 || Mt > 57 && Mt < 65 || Mt > 70 && Mt < 97); )
    ;
  return ll(e, pc() + (t < 6 && Sr() == 32 && Rn() == 32));
}
function Dh(e) {
  for (; Rn(); )
    switch (Mt) {
      case e:
        return Sn;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Dh(Mt);
        break;
      case 40:
        e === 41 && Dh(e);
        break;
      case 92:
        Rn();
        break;
    }
  return Sn;
}
function vee(e, t) {
  for (; Rn() && e + Mt !== 57; )
    if (e + Mt === 84 && Sr() === 47)
      break;
  return "/*" + ll(t, Sn - 1) + "*" + sf(e === 47 ? e : Rn());
}
function yee(e) {
  for (; !ms(Sr()); )
    Rn();
  return ll(e, Sn);
}
function gee(e) {
  return oO(mc("", null, null, null, [""], e = aO(e), 0, [0], e));
}
function mc(e, t, n, r, i, a, o, s, c) {
  for (var l = 0, u = 0, f = o, d = 0, p = 0, m = 0, h = 1, y = 1, v = 1, g = 0, b = "", T = i, S = a, E = r, O = b; y; )
    switch (m = g, g = Rn()) {
      case 40:
        if (m != 108 && en(O, f - 1) == 58) {
          Nh(O += st(hc(g), "&", "&\f"), "&\f") != -1 && (v = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += hc(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += hee(m);
        break;
      case 92:
        O += mee(pc() - 1, 7);
        continue;
      case 47:
        switch (Sr()) {
          case 42:
          case 47:
            Hl(bee(vee(Rn(), pc()), t, n), c);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * h:
        s[l++] = br(O) * v;
      case 125 * h:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            y = 0;
          case 59 + u:
            v == -1 && (O = st(O, /\f/g, "")), p > 0 && br(O) - f && Hl(p > 32 ? e0(O + ";", r, n, f - 1) : e0(st(O, " ", "") + ";", r, n, f - 2), c);
            break;
          case 59:
            O += ";";
          default:
            if (Hl(E = Qw(O, t, n, l, u, i, s, b, T = [], S = [], f), a), g === 123)
              if (u === 0)
                mc(O, t, E, E, T, a, f, s, S);
              else
                switch (d === 99 && en(O, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    mc(e, E, E, r && Hl(Qw(e, E, E, 0, 0, i, s, b, i, T = [], f), S), i, S, f, s, r ? T : S);
                    break;
                  default:
                    mc(O, E, E, E, [""], S, 0, s, S);
                }
        }
        l = u = p = 0, h = v = 1, b = O = "", f = o;
        break;
      case 58:
        f = 1 + br(O), p = m;
      default:
        if (h < 1) {
          if (g == 123)
            --h;
          else if (g == 125 && h++ == 0 && pee() == 125)
            continue;
        }
        switch (O += sf(g), g * h) {
          case 38:
            v = u > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            s[l++] = (br(O) - 1) * v, v = 1;
            break;
          case 64:
            Sr() === 45 && (O += hc(Rn())), d = Sr(), u = f = br(b = O += yee(pc())), g++;
            break;
          case 45:
            m === 45 && br(O) == 2 && (h = 0);
        }
    }
  return a;
}
function Qw(e, t, n, r, i, a, o, s, c, l, u) {
  for (var f = i - 1, d = i === 0 ? a : [""], p = Qv(d), m = 0, h = 0, y = 0; m < r; ++m)
    for (var v = 0, g = hs(e, f + 1, f = see(h = o[m])), b = e; v < p; ++v)
      (b = rO(h > 0 ? d[v] + " " + g : st(g, /&\f/g, d[v]))) && (c[y++] = b);
  return cf(e, t, n, i === 0 ? Jv : s, c, l, u);
}
function bee(e, t, n) {
  return cf(e, t, n, tO, sf(dee()), hs(e, 2, -2), 0);
}
function e0(e, t, n, r) {
  return cf(e, t, n, Xv, hs(e, 0, r), hs(e, r + 1, -1), r);
}
function Ra(e, t) {
  for (var n = "", r = Qv(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function xee(e, t, n, r) {
  switch (e.type) {
    case oee:
      if (e.children.length) break;
    case aee:
    case Xv:
      return e.return = e.return || e.value;
    case tO:
      return "";
    case nO:
      return e.return = e.value + "{" + Ra(e.children, r) + "}";
    case Jv:
      e.value = e.props.join(",");
  }
  return br(n = Ra(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function wee(e) {
  var t = Qv(e);
  return function(n, r, i, a) {
    for (var o = "", s = 0; s < t; s++)
      o += e[s](n, r, i, a) || "";
    return o;
  };
}
function See(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function _ee(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Eee = function(t, n, r) {
  for (var i = 0, a = 0; i = a, a = Sr(), i === 38 && a === 12 && (n[r] = 1), !ms(a); )
    Rn();
  return ll(t, Sn);
}, Tee = function(t, n) {
  var r = -1, i = 44;
  do
    switch (ms(i)) {
      case 0:
        i === 38 && Sr() === 12 && (n[r] = 1), t[r] += Eee(Sn - 1, n, r);
        break;
      case 2:
        t[r] += hc(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = Sr() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += sf(i);
    }
  while (i = Rn());
  return t;
}, kee = function(t, n) {
  return oO(Tee(aO(t), n));
}, t0 = /* @__PURE__ */ new WeakMap(), Oee = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !t0.get(r)) && !i) {
      t0.set(t, !0);
      for (var a = [], o = kee(n, a), s = r.props, c = 0, l = 0; c < o.length; c++)
        for (var u = 0; u < s.length; u++, l++)
          t.props[l] = a[c] ? o[c].replace(/&\f/g, s[u]) : s[u] + " " + o[c];
    }
  }
}, Cee = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function sO(e, t) {
  switch (cee(e, t)) {
    case 5103:
      return ot + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return ot + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return ot + e + nu + e + nn + e + e;
    case 6828:
    case 4268:
      return ot + e + nn + e + e;
    case 6165:
      return ot + e + nn + "flex-" + e + e;
    case 5187:
      return ot + e + st(e, /(\w+).+(:[^]+)/, ot + "box-$1$2" + nn + "flex-$1$2") + e;
    case 5443:
      return ot + e + nn + "flex-item-" + st(e, /flex-|-self/, "") + e;
    case 4675:
      return ot + e + nn + "flex-line-pack" + st(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return ot + e + nn + st(e, "shrink", "negative") + e;
    case 5292:
      return ot + e + nn + st(e, "basis", "preferred-size") + e;
    case 6060:
      return ot + "box-" + st(e, "-grow", "") + ot + e + nn + st(e, "grow", "positive") + e;
    case 4554:
      return ot + st(e, /([^-])(transform)/g, "$1" + ot + "$2") + e;
    case 6187:
      return st(st(st(e, /(zoom-|grab)/, ot + "$1"), /(image-set)/, ot + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return st(e, /(image-set\([^]*)/, ot + "$1$`$1");
    case 4968:
      return st(st(e, /(.+:)(flex-)?(.*)/, ot + "box-pack:$3" + nn + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + ot + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return st(e, /(.+)-inline(.+)/, ot + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (br(e) - 1 - t > 6) switch (en(e, t + 1)) {
        case 109:
          if (en(e, t + 4) !== 45) break;
        case 102:
          return st(e, /(.+:)(.+)-([^]+)/, "$1" + ot + "$2-$3$1" + nu + (en(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Nh(e, "stretch") ? sO(st(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (en(e, t + 1) !== 115) break;
    case 6444:
      switch (en(e, br(e) - 3 - (~Nh(e, "!important") && 10))) {
        case 107:
          return st(e, ":", ":" + ot) + e;
        case 101:
          return st(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + ot + (en(e, 14) === 45 ? "inline-" : "") + "box$3$1" + ot + "$2$3$1" + nn + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (en(e, t + 11)) {
        case 114:
          return ot + e + nn + st(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return ot + e + nn + st(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return ot + e + nn + st(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return ot + e + nn + e + e;
  }
  return e;
}
var Ree = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Xv:
      t.return = sO(t.value, t.length);
      break;
    case nO:
      return Ra([Co(t, {
        value: st(t.value, "@", "@" + ot)
      })], i);
    case Jv:
      if (t.length) return fee(t.props, function(a) {
        switch (uee(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Ra([Co(t, {
              props: [st(a, /:(read-\w+)/, ":" + nu + "$1")]
            })], i);
          case "::placeholder":
            return Ra([Co(t, {
              props: [st(a, /:(plac\w+)/, ":" + ot + "input-$1")]
            }), Co(t, {
              props: [st(a, /:(plac\w+)/, ":" + nu + "$1")]
            }), Co(t, {
              props: [st(a, /:(plac\w+)/, nn + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, $ee = [Ree], Iee = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(h) {
      var y = h.getAttribute("data-emotion");
      y.indexOf(" ") !== -1 && (document.head.appendChild(h), h.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || $ee, a = {}, o, s = [];
  o = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(h) {
      for (var y = h.getAttribute("data-emotion").split(" "), v = 1; v < y.length; v++)
        a[y[v]] = !0;
      s.push(h);
    }
  );
  var c, l = [Oee, Cee];
  {
    var u, f = [xee, See(function(h) {
      u.insert(h);
    })], d = wee(l.concat(i, f)), p = function(y) {
      return Ra(gee(y), d);
    };
    c = function(y, v, g, b) {
      u = g, p(y ? y + "{" + v.styles + "}" : v.styles), b && (m.inserted[v.name] = !0);
    };
  }
  var m = {
    key: n,
    sheet: new iee({
      key: n,
      container: o,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: c
  };
  return m.sheet.hydrate(s), m;
};
function Aee(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Pee = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Nee = !1, Dee = /[A-Z]|^ms/g, Mee = /_EMO_([^_]+?)_([^]*?)_EMO_/g, lO = function(t) {
  return t.charCodeAt(1) === 45;
}, n0 = function(t) {
  return t != null && typeof t != "boolean";
}, Yd = /* @__PURE__ */ _ee(function(e) {
  return lO(e) ? e : e.replace(Dee, "-$&").toLowerCase();
}), r0 = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Mee, function(r, i, a) {
          return li = {
            name: i,
            styles: a,
            next: li
          }, i;
        });
  }
  return Pee[t] !== 1 && !lO(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, jee = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function ru(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return li = {
          name: i.name,
          styles: i.styles,
          next: li
        }, i.name;
      var a = n;
      if (a.styles !== void 0) {
        var o = a.next;
        if (o !== void 0)
          for (; o !== void 0; )
            li = {
              name: o.name,
              styles: o.styles,
              next: li
            }, o = o.next;
        var s = a.styles + ";";
        return s;
      }
      return Lee(e, t, n);
    }
  }
  var c = n;
  if (t == null)
    return c;
  var l = t[c];
  return l !== void 0 ? l : c;
}
function Lee(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += ru(e, t, n[i]) + ";";
  else
    for (var a in n) {
      var o = n[a];
      if (typeof o != "object") {
        var s = o;
        t != null && t[s] !== void 0 ? r += a + "{" + t[s] + "}" : n0(s) && (r += Yd(a) + ":" + r0(a, s) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && Nee)
          throw new Error(jee);
        if (Array.isArray(o) && typeof o[0] == "string" && (t == null || t[o[0]] === void 0))
          for (var c = 0; c < o.length; c++)
            n0(o[c]) && (r += Yd(a) + ":" + r0(a, o[c]) + ";");
        else {
          var l = ru(e, t, o);
          switch (a) {
            case "animation":
            case "animationName": {
              r += Yd(a) + ":" + l + ";";
              break;
            }
            default:
              r += a + "{" + l + "}";
          }
        }
      }
    }
  return r;
}
var i0 = /label:\s*([^\s;{]+)\s*(;|$)/g, li;
function Jd(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  li = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    r = !1, i += ru(n, t, a);
  else {
    var o = a;
    i += o[0];
  }
  for (var s = 1; s < e.length; s++)
    if (i += ru(n, t, e[s]), r) {
      var c = a;
      i += c[s];
    }
  i0.lastIndex = 0;
  for (var l = "", u; (u = i0.exec(i)) !== null; )
    l += "-" + u[1];
  var f = Aee(i) + l;
  return {
    name: f,
    styles: i,
    next: li
  };
}
function cO(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : i && (r += i + " ");
  }), r;
}
var Fee = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, Bee = function(t, n, r) {
  Fee(t, n);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var a = n;
    do
      t.insert(n === a ? "." + i : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function a0(e, t) {
  if (e.inserted[t.name] === void 0)
    return e.insert("", t, e.sheet, !0);
}
function o0(e, t, n) {
  var r = [], i = cO(e, r, n);
  return r.length < 2 ? n : i + t(r);
}
var Uee = function(t) {
  var n = Iee(t);
  n.sheet.speedy = function(s) {
    if (process.env.NODE_ENV !== "production" && this.ctr !== 0)
      throw new Error("speedy must be changed before any rules are inserted");
    this.isSpeedy = s;
  }, n.compat = !0;
  var r = function() {
    for (var c = arguments.length, l = new Array(c), u = 0; u < c; u++)
      l[u] = arguments[u];
    var f = Jd(l, n.registered, void 0);
    return Bee(n, f), n.key + "-" + f.name;
  }, i = function() {
    for (var c = arguments.length, l = new Array(c), u = 0; u < c; u++)
      l[u] = arguments[u];
    var f = Jd(l, n.registered), d = "animation-" + f.name;
    return a0(n, {
      name: f.name,
      styles: "@keyframes " + d + "{" + f.styles + "}"
    }), d;
  }, a = function() {
    for (var c = arguments.length, l = new Array(c), u = 0; u < c; u++)
      l[u] = arguments[u];
    var f = Jd(l, n.registered);
    a0(n, f);
  }, o = function() {
    for (var c = arguments.length, l = new Array(c), u = 0; u < c; u++)
      l[u] = arguments[u];
    return o0(n.registered, r, zee(l));
  };
  return {
    css: r,
    cx: o,
    injectGlobal: a,
    keyframes: i,
    hydrate: function(c) {
      c.forEach(function(l) {
        n.inserted[l] = !0;
      });
    },
    flush: function() {
      n.registered = {}, n.inserted = {}, n.sheet.flush();
    },
    // $FlowFixMe
    sheet: n.sheet,
    cache: n,
    getRegisteredStyles: cO.bind(null, n.registered),
    merge: o0.bind(null, n.registered, r)
  };
}, zee = function e(t) {
  for (var n = "", r = 0; r < t.length; r++) {
    var i = t[r];
    if (i != null) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(i))
            a = e(i);
          else {
            a = "";
            for (var o in i)
              i[o] && o && (a && (a += " "), a += o);
          }
          break;
        }
        default:
          a = i;
      }
      a && (n && (n += " "), n += a);
    }
  }
  return n;
}, Vee = ol, ey = Date.prototype, s0 = "Invalid Date", uO = "toString", Hee = ey[uO], qee = ey.getTime;
String(/* @__PURE__ */ new Date(NaN)) != s0 && Vee(ey, uO, function() {
  var t = qee.call(this);
  return t === t ? Hee.call(this) : s0;
});
var Wee = Kv, Zee = Ak, Kee = Wee ? {}.toString : function() {
  return "[object " + Zee(this) + "]";
}, Gee = Kv, Yee = ol, Jee = Kee;
Gee || Yee(Object.prototype, "toString", Jee, { unsafe: !0 });
var Xee = Wv.PROPER, Qee = ol, ete = Ci, l0 = of, tte = cr, nte = Pk, ty = "toString", fO = RegExp.prototype, dO = fO[ty], rte = tte(function() {
  return dO.call({ source: "a", flags: "b" }) != "/a/b";
}), ite = Xee && dO.name != ty;
(rte || ite) && Qee(RegExp.prototype, ty, function() {
  var t = ete(this), n = l0(t.source), r = t.flags, i = l0(r === void 0 && t instanceof RegExp && !("flags" in fO) ? nte.call(t) : r);
  return "/" + n + "/" + i;
}, { unsafe: !0 });
var c0 = typeof window < "u" ? window : self, ate = c0.crypto || c0.msCrypto, ote = function(e) {
  if (!e) return Math.random;
  var t = Math.pow(2, 32), n = new Uint32Array(1);
  return function() {
    return e.getRandomValues(n)[0] / t;
  };
}(ate);
const ste = /* @__PURE__ */ Ke(ote);
function lte() {
  return ste().toString(26).substr(2, 5).replace(/[0-9]/g, function(e) {
    return String.fromCharCode(e.charCodeAt(0) + 65);
  });
}
var cte = KE;
const u0 = /* @__PURE__ */ Ke(cte);
function dt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "white", n = "background-color: ".concat(e, "; border-radius: 4px; padding: 2px 4px;");
  return t && (n += " color: ".concat(t, ";")), [n, ""];
}
function f0(e, t) {
  for (var n, r, i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), o = 2; o < i; o++)
    a[o - 2] = arguments[o];
  return St(n = [St(r = "%c".concat(e, "%c ")).call(r, t)]).call(n, Xe(dt("green", "white")), a);
}
function ute(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.force, r = n === void 0 ? !1 : n;
  return r ? function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    if (a.length) {
      var s = a, c = yr(s, 1), l = c[0];
      typeof l == "function" && (a = l());
      var u = u0(a[0]) ? a : [a], f = u.length === 1;
      tu(u).call(u, function(d, p) {
        if (f) {
          var m, h;
          (m = console).log.apply(m, Xe(f0.apply(void 0, St(h = [e]).call(h, Xe(d)))));
        } else if (p) {
          var y;
          (y = console).log.apply(y, Xe(u0(d) ? d : [d]));
        } else {
          var v, g;
          (v = console).groupCollapsed.apply(v, Xe(f0.apply(void 0, St(g = [e]).call(g, Xe(d)))));
        }
      }), f || console.groupEnd();
    }
  } : function() {
    return 0;
  };
}
var fte = ta, dte = Wv.EXISTS, pte = al.f, pO = Function.prototype, hte = pO.toString, mte = /^\s*function ([^ (]*)/, vte = "name";
fte && !dte && pte(pO, vte, {
  configurable: !0,
  get: function() {
    try {
      return hte.call(this).match(mte)[1];
    } catch {
      return "";
    }
  }
});
var yte = tn, gte = yte.setTimeout, bte = gte;
const xte = /* @__PURE__ */ Ke(bte);
function wte(e, t) {
  if (!t)
    return e;
  var n = 0, r = null;
  return function() {
    for (var i = arguments.length, a = new Array(i), o = 0; o < i; o++)
      a[o] = arguments[o];
    var s = hi();
    s - n > t ? (e.apply(void 0, a), n = s) : (clearTimeout(r), r = xte(function() {
      e.apply(void 0, a), n = hi();
    }, Math.max(0, t - s + n)));
  };
}
var hO = function(t) {
  var n = t.debounce, r = t.name, i = t.onEvent, a = t.target, o = Dt();
  o.current = i;
  var s = kn(function() {
    return wte(function(l) {
      var u = o.current;
      u && u(l);
    }, n);
  }, [n, o]), c = kt(function(l) {
    l.timeStampLow = hi(), s(l);
  }, [s]);
  return Qa(function() {
    return a.addEventListener(r, c, {
      passive: !0
    }), c({
      target: a,
      type: r
    }), function() {
      return a.removeEventListener(r, c);
    };
  }, [r, c, a]), !1;
};
hO.defaultProps = {
  debounce: 200
};
var Ste = Math.sign || function(t) {
  var n = +t;
  return n === 0 || n !== n ? n : n < 0 ? -1 : 1;
}, _te = ht, Ete = Ste;
_te({ target: "Math", stat: !0 }, {
  sign: Ete
});
var Tte = tn, kte = Tte.Math.sign, Ote = kte, Cte = Ote, Rte = Cte;
const $te = /* @__PURE__ */ Ke(Rte);
function Ite(e, t) {
  var n = $te(t - e), r = Math.sqrt(Math.abs(t - e)), i = e + r * n;
  return n > 0 ? Math.min(t, i) : Math.max(t, i);
}
function Ate(e, t, n, r) {
  for (var i = e, a = 0; a < r; a++)
    i = n(i, t);
  return i;
}
var mO = function(t) {
  var n = t.name, r = t.onEnd, i = t.target, a = t.value, o = Dt(), s = kt(function(l, u, f, d) {
    var p = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : hi();
    (f === "100%" || typeof f == "number") && (cancelAnimationFrame(o.current), o.current = requestAnimationFrame(function() {
      if (i) {
        var m = f === "100%" ? i.scrollHeight - i.offsetHeight : f, h = Ate(u, m, Ite, (hi() - p) / 5);
        Math.abs(m - h) < 1.5 && (h = m), i[l] = h, m === h ? r && r(!0) : s(l, u, f, d + 1, p);
      }
    }));
  }, [o, r, i]), c = kt(function() {
    cancelAnimationFrame(o.current), r && r(!1);
  }, [r]);
  return Qa(function() {
    return s(n, i[n], a, 1), i ? (i.addEventListener("pointerdown", c, {
      passive: !0
    }), i.addEventListener("wheel", c, {
      passive: !0
    }), function() {
      i.removeEventListener("pointerdown", c), i.removeEventListener("wheel", c), cancelAnimationFrame(o.current);
    }) : function() {
      return cancelAnimationFrame(o.current);
    };
  }, [s, o, c, n, i, a]), !1;
};
mO.propTypes = {
  name: tt.string.isRequired,
  onEnd: tt.func,
  target: tt.any.isRequired,
  value: tt.oneOfType([tt.number, tt.oneOf(["100%"])]).isRequired
};
function Xd(e) {
  var t = rt(e), n = yr(t, 2), r = n[0], i = n[1], a = Dt(), o = kt(function(s) {
    typeof s == "function" ? o(function(c) {
      return s = s(c), a.current = s, s;
    }) : (a.current = s, o(s));
  }, [a]);
  return a.current = r, [r, i, a];
}
function d0(e, t) {
  var n = JX(e);
  if (Yw) {
    var r = Yw(e);
    t && (r = mQ(r).call(r, function(i) {
      return Xk(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function p0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    if (t % 2) {
      var r;
      tu(r = d0(Object(n), !0)).call(r, function(a) {
        HW(e, a, n[a]);
      });
    } else if (Jw)
      XQ(e, Jw(n));
    else {
      var i;
      tu(i = d0(Object(n))).call(i, function(a) {
        eee(e, a, Xk(n, a));
      });
    }
  }
  return e;
}
var Pte = function() {
  return 1 / 0;
}, h0 = 17, Nte = "bottom", Gn = "top", m0 = 1, Dte = 34, v0 = {};
function Mte(e, t) {
  return e(), EJ(e, t);
}
function y0(e) {
  var t = e.mode, n = e.target, r = n.offsetHeight, i = n.scrollHeight, a = n.scrollTop, o = i - a - r < m0, s = a < m0, c = t === Gn ? s : o, l = t !== Gn ? s : o;
  return {
    atBottom: o,
    atEnd: c,
    atStart: l,
    atTop: s
  };
}
function Ro(e, t) {
  return e === (t === Gn ? 0 : "100%");
}
var ny = function(t) {
  var n = t.checkInterval, r = t.children, i = t.debounce, a = t.debug, o = t.initialScrollBehavior, s = t.mode, c = t.nonce, l = t.scroller, u = kn(function() {
    return ute("<ScrollToBottom>", {
      force: a
    });
  }, [a]);
  s = s === Gn ? Gn : Nte;
  var f = Dt(0), d = Dt(o), p = Xd(s === Gn ? 0 : "100%"), m = yr(p, 3), h = m[0], y = m[1], v = m[2], g = Xd(null), b = yr(g, 3), T = b[0], S = b[1], E = b[2], O = Dt(0), j = Dt(0), D = Dt(0), k = rt(!0), A = yr(k, 2), V = A[0], $ = A[1], L = rt(!0), M = yr(L, 2), F = M[0], q = M[1], B = rt(!0), N = yr(B, 2), x = N[0], z = N[1], Z = rt(!1), _ = yr(Z, 2), G = _[0], ae = _[1], te = Xd(!0), se = yr(te, 3), de = se[0], pe = se[1], le = se[2], X = Dt([]), W = kt(function(P) {
    var J = E.current;
    return X.current.push(P), J && P({
      scrollTop: J.scrollTop
    }), function() {
      var ce = X.current, _e = FJ(ce).call(ce, P);
      ~_e && cX(ce).call(ce, _e, 1);
    };
  }, [X, E]), fe = kt(function() {
    var P = v.current;
    u(function() {
      var J;
      return St(J = ["%cSpineTo%c: %conEnd%c is fired."]).call(J, Xe(dt("magenta")), Xe(dt("orange")), [{
        animateTo: P
      }]);
    }), f.current = hi(), Ro(P, s) || pe(!1), y(null);
  }, [v, u, f, s, y, pe]), me = kt(function(P) {
    var J = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ce = J.behavior, _e = E.current;
    if (typeof P != "number" && P !== "100%")
      return console.warn('react-scroll-to-bottom: Arguments passed to scrollTo() must be either number or "100%".');
    u(function() {
      var ke;
      return [St(ke = ["%cscrollTo%c: Will scroll to %c".concat(typeof P == "number" ? P + "px" : P.replace(/%/g, "%%"), "%c")]).call(ke, Xe(dt("lime", "")), Xe(dt("purple"))), {
        behavior: ce,
        nextAnimateTo: P,
        target: _e
      }];
    }), ce === "auto" ? (fe(), _e && (_e.scrollTop = P === "100%" ? _e.scrollHeight - _e.offsetHeight : P)) : (ce !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollTo". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), y(P)), Ro(P, s) && (u(function() {
      var ke;
      return [St(ke = ["%cscrollTo%c: Scrolling to end, will set sticky to %ctrue%c."]).call(ke, Xe(dt("lime", "")), Xe(dt("purple"))), [{
        mode: s,
        nextAnimateTo: P
      }]];
    }), pe(!0));
  }, [u, fe, s, y, pe, E]), Oe = kt(function() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = P.behavior;
    u(function() {
      var ce;
      return St(ce = ["%cscrollToBottom%c: Called"]).call(ce, Xe(dt("yellow", "")));
    }), J !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToBottom". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), me("100%", {
      behavior: J || "smooth"
    });
  }, [u, me]), I = kt(function() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = P.behavior;
    u(function() {
      var ce;
      return St(ce = ["%cscrollToTop%c: Called"]).call(ce, Xe(dt("yellow", "")));
    }), J !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToTop". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.'), me(0, {
      behavior: J || "smooth"
    });
  }, [u, me]), Y = kt(function() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = P.behavior;
    u(function() {
      var _e;
      return St(_e = ["%cscrollToEnd%c: Called"]).call(_e, Xe(dt("yellow", "")));
    }), J !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToEnd". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
    var ce = {
      behavior: J || "smooth"
    };
    s === Gn ? I(ce) : Oe(ce);
  }, [u, s, Oe, I]), re = kt(function() {
    var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, J = P.behavior;
    u(function() {
      var _e;
      return St(_e = ["%cscrollToStart%c: Called"]).call(_e, Xe(dt("yellow", "")));
    }), J !== "smooth" && console.warn('react-scroll-to-bottom: Please set "behavior" when calling "scrollToStart". In future versions, the default behavior will be changed from smooth scrolling to discrete scrolling to align with HTML Standard.');
    var ce = {
      behavior: J || "smooth"
    };
    s === Gn ? Oe(ce) : I(ce);
  }, [u, s, Oe, I]), Q = kt(function() {
    var P = E.current;
    if (P) {
      if (d.current === "auto") {
        u(function() {
          var Rt;
          return St(Rt = ["%ctarget changed%c: Initial scroll"]).call(Rt, Xe(dt("blue")));
        }), P.scrollTop = s === Gn ? 0 : P.scrollHeight - P.offsetHeight, d.current = !1;
        return;
      }
      var J = O.current, ce = P.offsetHeight, _e = P.scrollHeight, ke = P.scrollTop, Ge = s === Gn ? 0 : Math.max(0, _e - ce - ke), at = Math.max(0, J - ke), Lt = l({
        maxValue: Ge,
        minValue: at,
        offsetHeight: ce,
        scrollHeight: _e,
        scrollTop: ke
      }), Ct = Math.max(0, Math.min(Ge, Lt)), He;
      s === Gn || Ct !== Ge ? He = ke + Ct : He = "100%", u(function() {
        var Rt, Ye, mn;
        return [St(Rt = [St(Ye = St(mn = "%cscrollToSticky%c: Will animate from %c".concat(J, "px%c to %c")).call(mn, typeof He == "number" ? He + "px" : He.replace(/%/g, "%%"), "%c (%c")).call(Ye, (He === "100%" ? Ge : He) + J, "px%c)")]).call(Rt, Xe(dt("orange")), Xe(dt("purple")), Xe(dt("purple")), Xe(dt("purple"))), {
          animateFrom: J,
          maxValue: Ge,
          minValue: at,
          nextAnimateTo: He,
          nextValue: Ct,
          offsetHeight: ce,
          rawNextValue: Lt,
          scrollHeight: _e,
          scrollTop: ke
        }];
      }), me(He, {
        behavior: "smooth"
      });
    }
  }, [O, u, s, l, me, E]), Ee = kt(function(P) {
    var J, ce = P.timeStampLow, _e = v.current, ke = E.current, Ge = _e !== null;
    if (!(ce <= f.current || !ke)) {
      var at = y0({
        mode: s,
        target: ke
      }), Lt = at.atBottom, Ct = at.atEnd, He = at.atStart, Rt = at.atTop;
      $(Lt), q(Ct), ae(He), z(Rt);
      var Ye = ke.offsetHeight, mn = ke.scrollHeight, En = j.current, Wn = D.current, Nr = Ye !== En, ur = mn !== Wn;
      if (Nr && (j.current = Ye), ur && (D.current = mn), !Nr && !ur) {
        var Zn = Ge && Ro(_e, s) || Ct;
        le.current !== Zn && (u(function() {
          var ft, wt, Ft, Bt;
          return [St(ft = ["%conScroll%c: %csetSticky%c(%c".concat(Zn, "%c)")]).call(ft, Xe(dt("red")), Xe(dt("red")), Xe(dt("purple"))), St(wt = [St(Ft = St(Bt = "(animating = %c".concat(Ge, "%c && isEnd = %c")).call(Bt, Ro(_e, s), "%c) || atEnd = %c")).call(Ft, Ct, "%c")]).call(wt, Xe(dt("purple")), Xe(dt("purple")), Xe(dt("purple")), [{
            animating: Ge,
            animateTo: _e,
            atEnd: Ct,
            mode: s,
            offsetHeight: ke.offsetHeight,
            scrollHeight: ke.scrollHeight,
            sticky: le.current,
            nextSticky: Zn
          }])];
        }), pe(Zn));
      } else le.current && (u(function() {
        var ft;
        return [St(ft = ["%conScroll%c: Size changed while sticky, calling %cscrollToSticky()%c"]).call(ft, Xe(dt("red")), Xe(dt("orange")), [{
          offsetHeightChanged: Nr,
          scrollHeightChanged: ur
        }]), {
          nextOffsetHeight: Ye,
          prevOffsetHeight: En,
          nextScrollHeight: mn,
          prevScrollHeight: Wn
        }];
      }), Q());
      var Dr = ke.scrollTop;
      tu(J = X.current).call(J, function(ft) {
        return ft({
          scrollTop: Dr
        });
      });
    }
  }, [v, u, f, s, j, D, X, Q, $, q, ae, z, pe, le, E]);
  Ht(function() {
    if (T) {
      var P = !1, J = Mte(function() {
        var ce = E.current, _e = v.current !== null;
        le.current ? y0({
          mode: s,
          target: ce
        }).atEnd ? P = !1 : P ? hi() - P > Dte && (_e || (O.current = ce.scrollTop, u(function() {
          var ke;
          return St(ke = ["%cInterval check%c: Should sticky but not at end, calling %cscrollToSticky()%c to scroll"]).call(ke, Xe(dt("navy")), Xe(dt("orange")));
        }), Q()), P = !1) : P = hi() : ce.scrollHeight <= ce.offsetHeight && !le.current && (u(function() {
          var ke;
          return [St(ke = ["%cInterval check%c: Container is emptied, setting sticky back to %ctrue%c"]).call(ke, Xe(dt("navy")), Xe(dt("purple"))), [{
            offsetHeight: ce.offsetHeight,
            scrollHeight: ce.scrollHeight,
            sticky: le.current
          }]];
        }), pe(!0));
      }, Math.max(h0, n) || h0);
      return function() {
        return clearInterval(J);
      };
    }
  }, [v, n, u, s, Q, pe, le, T, E]);
  var xe = kn(function() {
    var P = v0[c] || (v0[c] = Uee({
      key: "react-scroll-to-bottom--css-" + lte(),
      nonce: c
    }));
    return function(J) {
      return P.css(J) + "";
    };
  }, [c]), Re = kn(function() {
    return {
      observeScrollPosition: W,
      setTarget: S,
      styleToClassName: xe
    };
  }, [W, S, xe]), Ve = kn(function() {
    return {
      atBottom: V,
      atEnd: F,
      atStart: G,
      atTop: x,
      mode: s
    };
  }, [V, F, G, x, s]), Ie = kn(function() {
    var P = h !== null;
    return {
      animating: P,
      animatingToEnd: P && Ro(h, s),
      sticky: de
    };
  }, [h, s, de]), Me = kn(function() {
    return p0(p0({}, Ve), Ie);
  }, [Ve, Ie]), U = kn(function() {
    return {
      scrollTo: me,
      scrollToBottom: Oe,
      scrollToEnd: Y,
      scrollToStart: re,
      scrollToTop: I
    };
  }, [me, Oe, Y, re, I]);
  return Ht(function() {
    if (T) {
      var P = function() {
        D.current = T.scrollHeight;
      };
      return T.addEventListener("focus", P, {
        capture: !0,
        passive: !0
      }), function() {
        return T.removeEventListener("focus", P);
      };
    }
  }, [T]), u(function() {
    var P;
    return [St(P = ["%cRender%c: Render"]).call(P, Xe(dt("cyan", ""))), {
      animateTo: h,
      animating: h !== null,
      sticky: de,
      target: T
    }];
  }), /* @__PURE__ */ vt.createElement(ef.Provider, {
    value: Re
  }, /* @__PURE__ */ vt.createElement(Av.Provider, {
    value: U
  }, /* @__PURE__ */ vt.createElement(Dv.Provider, {
    value: Me
  }, /* @__PURE__ */ vt.createElement(Pv.Provider, {
    value: Ve
  }, /* @__PURE__ */ vt.createElement(Nv.Provider, {
    value: Ie
  }, r, T && /* @__PURE__ */ vt.createElement(hO, {
    debounce: i,
    name: "scroll",
    onEvent: Ee,
    target: T
  }), T && h !== null && /* @__PURE__ */ vt.createElement(mO, {
    name: "scrollTop",
    onEnd: fe,
    target: T,
    value: h
  }))))));
};
ny.defaultProps = {
  checkInterval: 100,
  children: void 0,
  debounce: 17,
  debug: void 0,
  initialScrollBehavior: "smooth",
  mode: void 0,
  nonce: void 0,
  scroller: Pte
};
ny.propTypes = {
  checkInterval: tt.number,
  children: tt.any,
  debounce: tt.number,
  debug: tt.bool,
  initialScrollBehavior: tt.oneOf(["auto", "smooth"]),
  mode: tt.oneOf(["bottom", "top"]),
  nonce: tt.string,
  scroller: tt.func
};
var jte = {
  height: "100%",
  overflowY: "auto",
  width: "100%"
}, ry = function(t) {
  var n = t.children, r = t.className, i = Xa(ef), a = i.setTarget, o = Mv()(jte);
  return /* @__PURE__ */ vt.createElement("div", {
    className: $v(o, (r || "") + ""),
    ref: a
  }, n);
};
ry.defaultProps = {
  children: void 0,
  className: void 0
};
ry.propTypes = {
  children: tt.any,
  className: tt.string
};
var Lte = {
  position: "relative"
}, iy = function(t) {
  var n = t.children, r = t.className, i = t.followButtonClassName, a = t.scrollViewClassName, o = Mv()(Lte);
  return /* @__PURE__ */ vt.createElement("div", {
    className: $v(o, (r || "") + "")
  }, /* @__PURE__ */ vt.createElement(ry, {
    className: (a || "") + ""
  }, n), /* @__PURE__ */ vt.createElement(jv, {
    className: (i || "") + ""
  }));
};
iy.defaultProps = {
  children: void 0,
  className: void 0,
  followButtonClassName: void 0,
  scrollViewClassName: void 0
};
iy.propTypes = {
  children: tt.any,
  className: tt.string,
  followButtonClassName: tt.string,
  scrollViewClassName: tt.string
};
var ay = function(t) {
  var n = t.checkInterval, r = t.children, i = t.className, a = t.debounce, o = t.debug, s = t.followButtonClassName, c = t.initialScrollBehavior, l = t.mode, u = t.nonce, f = t.scroller, d = t.scrollViewClassName;
  return /* @__PURE__ */ vt.createElement(ny, {
    checkInterval: n,
    debounce: a,
    debug: o,
    initialScrollBehavior: c,
    mode: l,
    nonce: u,
    scroller: f
  }, /* @__PURE__ */ vt.createElement(iy, {
    className: i,
    followButtonClassName: s,
    scrollViewClassName: d
  }, r));
};
ay.defaultProps = {
  checkInterval: void 0,
  children: void 0,
  className: void 0,
  debounce: void 0,
  debug: void 0,
  followButtonClassName: void 0,
  initialScrollBehavior: "smooth",
  mode: void 0,
  nonce: void 0,
  scroller: void 0,
  scrollViewClassName: void 0
};
ay.propTypes = {
  checkInterval: tt.number,
  children: tt.any,
  className: tt.string,
  debounce: tt.number,
  debug: tt.bool,
  followButtonClassName: tt.string,
  initialScrollBehavior: tt.oneOf(["auto", "smooth"]),
  mode: tt.oneOf(["bottom", "top"]),
  nonce: tt.string,
  scroller: tt.func,
  scrollViewClassName: tt.string
};
t4();
let vO = (e = 21) => crypto.getRandomValues(new Uint8Array(e)).reduce((t, n) => (n &= 63, n < 36 ? t += n.toString(36) : n < 62 ? t += (n - 26).toString(36).toUpperCase() : n > 62 ? t += "-" : t += "_", t), "");
const yO = yu(
  ({
    className: e,
    messages: t = [],
    isTyping: n,
    headerMessage: r,
    renderers: i,
    botAvatar: a,
    botDescription: o,
    botName: s,
    sendMessage: c,
    showMarquee: l = !0,
    ...u
  }) => {
    const { messageList: f } = bt, d = kn(() => RR(t), [t]);
    return /* @__PURE__ */ R.jsxs(
      ay,
      {
        ...u,
        className: ku(f.container.className, e),
        followButtonClassName: f.scrollDownButton.button.className,
        scrollViewClassName: f.viewPort.className,
        children: [
          r && /* @__PURE__ */ R.jsx("span", { ...f.headerMessage, children: r }),
          l && /* @__PURE__ */ R.jsx(QB, { botAvatar: a, botDescription: o, botName: s }),
          d.map((p) => /* @__PURE__ */ R.jsx(Nb, { renderers: i, sendMessage: c, ...p }, p.id)),
          n && /* @__PURE__ */ R.jsx(
            Nb,
            {
              id: vO(),
              renderers: i,
              sendMessage: c,
              direction: "incoming",
              timestamp: /* @__PURE__ */ new Date(),
              block: void 0,
              sender: { name: s ?? "", avatar: a },
              children: /* @__PURE__ */ R.jsx(XB, {})
            }
          )
        ]
      }
    );
  }
);
yO.displayName = "MessageList";
const Fte = ({ className: e, ...t }) => {
  const { className: n } = bt.loader;
  return /* @__PURE__ */ R.jsx("div", { ...t, className: ku(e, n) });
}, Bte = ({
  connected: e,
  configuration: t,
  closeWindow: n,
  isTyping: r,
  messages: i,
  user: a,
  sendMessage: o,
  uploadFile: s,
  isLoading: c,
  renderers: l,
  isReadOnly: u,
  disableComposer: f,
  restartConversation: d,
  allowFileUpload: p,
  ...m
}) => {
  const {
    color: h,
    fontFamily: y,
    radius: v,
    themeMode: g,
    variant: b,
    botAvatar: T,
    botDescription: S,
    botName: E,
    composerPlaceholder: O,
    showPoweredBy: j
  } = t, D = { color: h, fontFamily: y, radius: v, themeMode: g, variant: b }, k = kn(
    () => i.map((A) => {
      const { authorId: V } = A, $ = V === a.id ? "outgoing" : "incoming";
      return {
        ...A,
        direction: $,
        sender: $ === "outgoing" ? { name: a.name ?? "You", avatar: a.pictureUrl } : { name: t.botName ?? "Bot", avatar: t.botAvatar }
      };
    }),
    [t.botAvatar, t.botName, i, a.id, a.name, a.pictureUrl]
  );
  return /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    /* @__PURE__ */ R.jsx(u3, { ...D }),
    /* @__PURE__ */ R.jsxs($E, { connected: e, ...m, children: [
      /* @__PURE__ */ R.jsx(JB, { closeWindow: n, configuration: t, restartConversation: d }),
      c ? /* @__PURE__ */ R.jsx(Fte, {}) : /* @__PURE__ */ R.jsx(R.Fragment, { children: /* @__PURE__ */ R.jsx(
        yO,
        {
          botAvatar: T,
          botDescription: S,
          botName: E,
          renderers: l,
          isTyping: r,
          sendMessage: o,
          messages: k
        }
      ) }),
      /* @__PURE__ */ R.jsx(
        l3,
        {
          sendMessage: o,
          uploadFile: s,
          connected: e,
          isReadOnly: u,
          disableComposer: f,
          showPoweredBy: j,
          composerPlaceholder: O,
          allowFileUpload: p
        }
      )
    ] })
  ] });
};
function gO(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: bO } = Object.prototype, { getPrototypeOf: oy } = Object, sy = /* @__PURE__ */ ((e) => (t) => {
  const n = bO.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Jr = (e) => (e = e.toLowerCase(), (t) => sy(t) === e), uf = (e) => (t) => typeof t === e, { isArray: co } = Array, vs = uf("undefined");
function Ute(e) {
  return e !== null && !vs(e) && e.constructor !== null && !vs(e.constructor) && Zi(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const xO = Jr("ArrayBuffer");
function zte(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && xO(e.buffer), t;
}
const Vte = uf("string"), Zi = uf("function"), wO = uf("number"), ly = (e) => e !== null && typeof e == "object", Hte = (e) => e === !0 || e === !1, vc = (e) => {
  if (sy(e) !== "object")
    return !1;
  const t = oy(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, qte = Jr("Date"), Wte = Jr("File"), Zte = Jr("Blob"), Kte = Jr("FileList"), Gte = (e) => ly(e) && Zi(e.pipe), Yte = (e) => {
  const t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || bO.call(e) === t || Zi(e.toString) && e.toString() === t);
}, Jte = Jr("URLSearchParams"), Xte = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function cl(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), co(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const a = n ? Object.getOwnPropertyNames(e) : Object.keys(e), o = a.length;
    let s;
    for (r = 0; r < o; r++)
      s = a[r], t.call(null, e[s], s, e);
  }
}
function SO(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const _O = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, EO = (e) => !vs(e) && e !== _O;
function Mh() {
  const { caseless: e } = EO(this) && this || {}, t = {}, n = (r, i) => {
    const a = e && SO(t, i) || i;
    vc(t[a]) && vc(r) ? t[a] = Mh(t[a], r) : vc(r) ? t[a] = Mh({}, r) : co(r) ? t[a] = r.slice() : t[a] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && cl(arguments[r], n);
  return t;
}
const Qte = (e, t, n, { allOwnKeys: r } = {}) => (cl(t, (i, a) => {
  n && Zi(i) ? e[a] = gO(i, n) : e[a] = i;
}, { allOwnKeys: r }), e), ene = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), tne = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, nne = (e, t, n, r) => {
  let i, a, o;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0; )
      o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
    e = n !== !1 && oy(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, rne = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, ine = (e) => {
  if (!e) return null;
  if (co(e)) return e;
  let t = e.length;
  if (!wO(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, ane = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && oy(Uint8Array)), one = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const a = i.value;
    t.call(e, a[0], a[1]);
  }
}, sne = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, lne = Jr("HTMLFormElement"), cne = (e) => e.toLowerCase().replace(
  /[_-\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), g0 = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), une = Jr("RegExp"), TO = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  cl(n, (i, a) => {
    t(i, a, e) !== !1 && (r[a] = i);
  }), Object.defineProperties(e, r);
}, fne = (e) => {
  TO(e, (t, n) => {
    if (Zi(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (Zi(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, dne = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((a) => {
      n[a] = !0;
    });
  };
  return co(e) ? r(e) : r(String(e).split(t)), n;
}, pne = () => {
}, hne = (e, t) => (e = +e, Number.isFinite(e) ? e : t), mne = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (ly(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const a = co(r) ? [] : {};
        return cl(r, (o, s) => {
          const c = n(o, i + 1);
          !vs(c) && (a[s] = c);
        }), t[i] = void 0, a;
      }
    }
    return r;
  };
  return n(e, 0);
}, K = {
  isArray: co,
  isArrayBuffer: xO,
  isBuffer: Ute,
  isFormData: Yte,
  isArrayBufferView: zte,
  isString: Vte,
  isNumber: wO,
  isBoolean: Hte,
  isObject: ly,
  isPlainObject: vc,
  isUndefined: vs,
  isDate: qte,
  isFile: Wte,
  isBlob: Zte,
  isRegExp: une,
  isFunction: Zi,
  isStream: Gte,
  isURLSearchParams: Jte,
  isTypedArray: ane,
  isFileList: Kte,
  forEach: cl,
  merge: Mh,
  extend: Qte,
  trim: Xte,
  stripBOM: ene,
  inherits: tne,
  toFlatObject: nne,
  kindOf: sy,
  kindOfTest: Jr,
  endsWith: rne,
  toArray: ine,
  forEachEntry: one,
  matchAll: sne,
  isHTMLForm: lne,
  hasOwnProperty: g0,
  hasOwnProp: g0,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: TO,
  freezeMethods: fne,
  toObjectSet: dne,
  toCamelCase: cne,
  noop: pne,
  toFiniteNumber: hne,
  findKey: SO,
  global: _O,
  isContextDefined: EO,
  toJSONObject: mne
};
function nt(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
K.inherits(nt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: K.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const kO = nt.prototype, OO = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  OO[e] = { value: e };
});
Object.defineProperties(nt, OO);
Object.defineProperty(kO, "isAxiosError", { value: !0 });
nt.from = (e, t, n, r, i, a) => {
  const o = Object.create(kO);
  return K.toFlatObject(e, o, function(c) {
    return c !== Error.prototype;
  }, (s) => s !== "isAxiosError"), nt.call(o, e.message, t, n, r, i), o.cause = e, o.name = e.name, a && Object.assign(o, a), o;
};
var vne = typeof self == "object" ? self.FormData : window.FormData;
const yne = /* @__PURE__ */ Ke(vne);
function jh(e) {
  return K.isPlainObject(e) || K.isArray(e);
}
function CO(e) {
  return K.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function b0(e, t, n) {
  return e ? e.concat(t).map(function(i, a) {
    return i = CO(i), !n && a ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function gne(e) {
  return K.isArray(e) && !e.some(jh);
}
const bne = K.toFlatObject(K, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function xne(e) {
  return e && K.isFunction(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator];
}
function ff(e, t, n) {
  if (!K.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new (yne || FormData)(), n = K.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(h, y) {
    return !K.isUndefined(y[h]);
  });
  const r = n.metaTokens, i = n.visitor || u, a = n.dots, o = n.indexes, c = (n.Blob || typeof Blob < "u" && Blob) && xne(t);
  if (!K.isFunction(i))
    throw new TypeError("visitor must be a function");
  function l(m) {
    if (m === null) return "";
    if (K.isDate(m))
      return m.toISOString();
    if (!c && K.isBlob(m))
      throw new nt("Blob is not supported. Use a Buffer instead.");
    return K.isArrayBuffer(m) || K.isTypedArray(m) ? c && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function u(m, h, y) {
    let v = m;
    if (m && !y && typeof m == "object") {
      if (K.endsWith(h, "{}"))
        h = r ? h : h.slice(0, -2), m = JSON.stringify(m);
      else if (K.isArray(m) && gne(m) || K.isFileList(m) || K.endsWith(h, "[]") && (v = K.toArray(m)))
        return h = CO(h), v.forEach(function(b, T) {
          !(K.isUndefined(b) || b === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            o === !0 ? b0([h], T, a) : o === null ? h : h + "[]",
            l(b)
          );
        }), !1;
    }
    return jh(m) ? !0 : (t.append(b0(y, h, a), l(m)), !1);
  }
  const f = [], d = Object.assign(bne, {
    defaultVisitor: u,
    convertValue: l,
    isVisitable: jh
  });
  function p(m, h) {
    if (!K.isUndefined(m)) {
      if (f.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + h.join("."));
      f.push(m), K.forEach(m, function(v, g) {
        (!(K.isUndefined(v) || v === null) && i.call(
          t,
          v,
          K.isString(g) ? g.trim() : g,
          h,
          d
        )) === !0 && p(v, h ? h.concat(g) : [g]);
      }), f.pop();
    }
  }
  if (!K.isObject(e))
    throw new TypeError("data must be an object");
  return p(e), t;
}
function x0(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function cy(e, t) {
  this._pairs = [], e && ff(e, this, t);
}
const RO = cy.prototype;
RO.append = function(t, n) {
  this._pairs.push([t, n]);
};
RO.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, x0);
  } : x0;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function wne(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $O(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || wne, i = n && n.serialize;
  let a;
  if (i ? a = i(t, n) : a = K.isURLSearchParams(t) ? t.toString() : new cy(t, n).toString(r), a) {
    const o = e.indexOf("#");
    o !== -1 && (e = e.slice(0, o)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class w0 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    K.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const IO = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Sne = typeof URLSearchParams < "u" ? URLSearchParams : cy, _ne = FormData, Ene = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), Tne = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", wr = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Sne,
    FormData: _ne,
    Blob
  },
  isStandardBrowserEnv: Ene,
  isStandardBrowserWebWorkerEnv: Tne,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function kne(e, t) {
  return ff(e, new wr.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, a) {
      return wr.isNode && K.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function One(e) {
  return K.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Cne(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let a;
  for (r = 0; r < i; r++)
    a = n[r], t[a] = e[a];
  return t;
}
function AO(e) {
  function t(n, r, i, a) {
    let o = n[a++];
    const s = Number.isFinite(+o), c = a >= n.length;
    return o = !o && K.isArray(i) ? i.length : o, c ? (K.hasOwnProp(i, o) ? i[o] = [i[o], r] : i[o] = r, !s) : ((!i[o] || !K.isObject(i[o])) && (i[o] = []), t(n, r, i[o], a) && K.isArray(i[o]) && (i[o] = Cne(i[o])), !s);
  }
  if (K.isFormData(e) && K.isFunction(e.entries)) {
    const n = {};
    return K.forEachEntry(e, (r, i) => {
      t(One(r), i, n, 0);
    }), n;
  }
  return null;
}
const Rne = {
  "Content-Type": void 0
};
function $ne(e, t, n) {
  if (K.isString(e))
    try {
      return (t || JSON.parse)(e), K.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const uo = {
  transitional: IO,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, a = K.isObject(t);
    if (a && K.isHTMLForm(t) && (t = new FormData(t)), K.isFormData(t))
      return i && i ? JSON.stringify(AO(t)) : t;
    if (K.isArrayBuffer(t) || K.isBuffer(t) || K.isStream(t) || K.isFile(t) || K.isBlob(t))
      return t;
    if (K.isArrayBufferView(t))
      return t.buffer;
    if (K.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return kne(t, this.formSerializer).toString();
      if ((s = K.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return ff(
          s ? { "files[]": t } : t,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return a || i ? (n.setContentType("application/json", !1), $ne(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || uo.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (t && K.isString(t) && (r && !this.responseType || i)) {
      const o = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (o)
          throw s.name === "SyntaxError" ? nt.from(s, nt.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: wr.classes.FormData,
    Blob: wr.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
K.forEach(["delete", "get", "head"], function(t) {
  uo.headers[t] = {};
});
K.forEach(["post", "put", "patch"], function(t) {
  uo.headers[t] = K.merge(Rne);
});
const Ine = K.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ane = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(o) {
    i = o.indexOf(":"), n = o.substring(0, i).trim().toLowerCase(), r = o.substring(i + 1).trim(), !(!n || t[n] && Ine[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, S0 = Symbol("internals");
function $o(e) {
  return e && String(e).trim().toLowerCase();
}
function yc(e) {
  return e === !1 || e == null ? e : K.isArray(e) ? e.map(yc) : String(e);
}
function Pne(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
function Nne(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function _0(e, t, n, r) {
  if (K.isFunction(r))
    return r.call(this, t, n);
  if (K.isString(t)) {
    if (K.isString(r))
      return t.indexOf(r) !== -1;
    if (K.isRegExp(r))
      return r.test(t);
  }
}
function Dne(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Mne(e, t) {
  const n = K.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, a, o) {
        return this[r].call(this, t, i, a, o);
      },
      configurable: !0
    });
  });
}
class zn {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function a(s, c, l) {
      const u = $o(c);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = K.findKey(i, u);
      (!f || i[f] === void 0 || l === !0 || l === void 0 && i[f] !== !1) && (i[f || c] = yc(s));
    }
    const o = (s, c) => K.forEach(s, (l, u) => a(l, u, c));
    return K.isPlainObject(t) || t instanceof this.constructor ? o(t, n) : K.isString(t) && (t = t.trim()) && !Nne(t) ? o(Ane(t), n) : t != null && a(n, t, r), this;
  }
  get(t, n) {
    if (t = $o(t), t) {
      const r = K.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return Pne(i);
        if (K.isFunction(n))
          return n.call(this, i, r);
        if (K.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = $o(t), t) {
      const r = K.findKey(this, t);
      return !!(r && (!n || _0(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function a(o) {
      if (o = $o(o), o) {
        const s = K.findKey(r, o);
        s && (!n || _0(r, r[s], s, n)) && (delete r[s], i = !0);
      }
    }
    return K.isArray(t) ? t.forEach(a) : a(t), i;
  }
  clear() {
    return Object.keys(this).forEach(this.delete.bind(this));
  }
  normalize(t) {
    const n = this, r = {};
    return K.forEach(this, (i, a) => {
      const o = K.findKey(r, a);
      if (o) {
        n[o] = yc(i), delete n[a];
        return;
      }
      const s = t ? Dne(a) : String(a).trim();
      s !== a && delete n[a], n[s] = yc(i), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return K.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && K.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[S0] = this[S0] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function a(o) {
      const s = $o(o);
      r[s] || (Mne(i, o), r[s] = !0);
    }
    return K.isArray(t) ? t.forEach(a) : a(t), this;
  }
}
zn.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent"]);
K.freezeMethods(zn.prototype);
K.freezeMethods(zn);
function Qd(e, t) {
  const n = this || uo, r = t || n, i = zn.from(r.headers);
  let a = r.data;
  return K.forEach(e, function(s) {
    a = s.call(n, a, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), a;
}
function PO(e) {
  return !!(e && e.__CANCEL__);
}
function ul(e, t, n) {
  nt.call(this, e ?? "canceled", nt.ERR_CANCELED, t, n), this.name = "CanceledError";
}
K.inherits(ul, nt, {
  __CANCEL__: !0
});
const jne = null;
function Lne(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new nt(
    "Request failed with status code " + n.status,
    [nt.ERR_BAD_REQUEST, nt.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const Fne = wr.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  /* @__PURE__ */ function() {
    return {
      write: function(n, r, i, a, o, s) {
        const c = [];
        c.push(n + "=" + encodeURIComponent(r)), K.isNumber(i) && c.push("expires=" + new Date(i).toGMTString()), K.isString(a) && c.push("path=" + a), K.isString(o) && c.push("domain=" + o), s === !0 && c.push("secure"), document.cookie = c.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Bne(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Une(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function NO(e, t) {
  return e && !Bne(t) ? Une(e, t) : t;
}
const zne = wr.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(a) {
      let o = a;
      return t && (n.setAttribute("href", o), o = n.href), n.setAttribute("href", o), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(o) {
      const s = K.isString(o) ? i(o) : o;
      return s.protocol === r.protocol && s.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
);
function Vne(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Hne(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, a = 0, o;
  return t = t !== void 0 ? t : 1e3, function(c) {
    const l = Date.now(), u = r[a];
    o || (o = l), n[i] = c, r[i] = l;
    let f = a, d = 0;
    for (; f !== i; )
      d += n[f++], f = f % e;
    if (i = (i + 1) % e, i === a && (a = (a + 1) % e), l - o < t)
      return;
    const p = u && l - u;
    return p ? Math.round(d * 1e3 / p) : void 0;
  };
}
function E0(e, t) {
  let n = 0;
  const r = Hne(50, 250);
  return (i) => {
    const a = i.loaded, o = i.lengthComputable ? i.total : void 0, s = a - n, c = r(s), l = a <= o;
    n = a;
    const u = {
      loaded: a,
      total: o,
      progress: o ? a / o : void 0,
      bytes: s,
      rate: c || void 0,
      estimated: c && o && l ? (o - a) / c : void 0,
      event: i
    };
    u[t ? "download" : "upload"] = !0, e(u);
  };
}
const qne = typeof XMLHttpRequest < "u", Wne = qne && function(e) {
  return new Promise(function(n, r) {
    let i = e.data;
    const a = zn.from(e.headers).normalize(), o = e.responseType;
    let s;
    function c() {
      e.cancelToken && e.cancelToken.unsubscribe(s), e.signal && e.signal.removeEventListener("abort", s);
    }
    K.isFormData(i) && (wr.isStandardBrowserEnv || wr.isStandardBrowserWebWorkerEnv) && a.setContentType(!1);
    let l = new XMLHttpRequest();
    if (e.auth) {
      const p = e.auth.username || "", m = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      a.set("Authorization", "Basic " + btoa(p + ":" + m));
    }
    const u = NO(e.baseURL, e.url);
    l.open(e.method.toUpperCase(), $O(u, e.params, e.paramsSerializer), !0), l.timeout = e.timeout;
    function f() {
      if (!l)
        return;
      const p = zn.from(
        "getAllResponseHeaders" in l && l.getAllResponseHeaders()
      ), h = {
        data: !o || o === "text" || o === "json" ? l.responseText : l.response,
        status: l.status,
        statusText: l.statusText,
        headers: p,
        config: e,
        request: l
      };
      Lne(function(v) {
        n(v), c();
      }, function(v) {
        r(v), c();
      }, h), l = null;
    }
    if ("onloadend" in l ? l.onloadend = f : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, l.onabort = function() {
      l && (r(new nt("Request aborted", nt.ECONNABORTED, e, l)), l = null);
    }, l.onerror = function() {
      r(new nt("Network Error", nt.ERR_NETWORK, e, l)), l = null;
    }, l.ontimeout = function() {
      let m = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const h = e.transitional || IO;
      e.timeoutErrorMessage && (m = e.timeoutErrorMessage), r(new nt(
        m,
        h.clarifyTimeoutError ? nt.ETIMEDOUT : nt.ECONNABORTED,
        e,
        l
      )), l = null;
    }, wr.isStandardBrowserEnv) {
      const p = (e.withCredentials || zne(u)) && e.xsrfCookieName && Fne.read(e.xsrfCookieName);
      p && a.set(e.xsrfHeaderName, p);
    }
    i === void 0 && a.setContentType(null), "setRequestHeader" in l && K.forEach(a.toJSON(), function(m, h) {
      l.setRequestHeader(h, m);
    }), K.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), o && o !== "json" && (l.responseType = e.responseType), typeof e.onDownloadProgress == "function" && l.addEventListener("progress", E0(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", E0(e.onUploadProgress)), (e.cancelToken || e.signal) && (s = (p) => {
      l && (r(!p || p.type ? new ul(null, e, l) : p), l.abort(), l = null);
    }, e.cancelToken && e.cancelToken.subscribe(s), e.signal && (e.signal.aborted ? s() : e.signal.addEventListener("abort", s)));
    const d = Vne(u);
    if (d && wr.protocols.indexOf(d) === -1) {
      r(new nt("Unsupported protocol " + d + ":", nt.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(i || null);
  });
}, gc = {
  http: jne,
  xhr: Wne
};
K.forEach(gc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Zne = {
  getAdapter: (e) => {
    e = K.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let i = 0; i < t && (n = e[i], !(r = K.isString(n) ? gc[n.toLowerCase()] : n)); i++)
      ;
    if (!r)
      throw r === !1 ? new nt(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        K.hasOwnProp(gc, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!K.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: gc
};
function ep(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ul(null, e);
}
function T0(e) {
  return ep(e), e.headers = zn.from(e.headers), e.data = Qd.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Zne.getAdapter(e.adapter || uo.adapter)(e).then(function(r) {
    return ep(e), r.data = Qd.call(
      e,
      e.transformResponse,
      r
    ), r.headers = zn.from(r.headers), r;
  }, function(r) {
    return PO(r) || (ep(e), r && r.response && (r.response.data = Qd.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = zn.from(r.response.headers))), Promise.reject(r);
  });
}
const k0 = (e) => e instanceof zn ? e.toJSON() : e;
function qa(e, t) {
  t = t || {};
  const n = {};
  function r(l, u, f) {
    return K.isPlainObject(l) && K.isPlainObject(u) ? K.merge.call({ caseless: f }, l, u) : K.isPlainObject(u) ? K.merge({}, u) : K.isArray(u) ? u.slice() : u;
  }
  function i(l, u, f) {
    if (K.isUndefined(u)) {
      if (!K.isUndefined(l))
        return r(void 0, l, f);
    } else return r(l, u, f);
  }
  function a(l, u) {
    if (!K.isUndefined(u))
      return r(void 0, u);
  }
  function o(l, u) {
    if (K.isUndefined(u)) {
      if (!K.isUndefined(l))
        return r(void 0, l);
    } else return r(void 0, u);
  }
  function s(l, u, f) {
    if (f in t)
      return r(l, u);
    if (f in e)
      return r(void 0, l);
  }
  const c = {
    url: a,
    method: a,
    data: a,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: s,
    headers: (l, u) => i(k0(l), k0(u), !0)
  };
  return K.forEach(Object.keys(e).concat(Object.keys(t)), function(u) {
    const f = c[u] || i, d = f(e[u], t[u], u);
    K.isUndefined(d) && f !== s || (n[u] = d);
  }), n;
}
const DO = "1.2.5", uy = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  uy[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const O0 = {};
uy.transitional = function(t, n, r) {
  function i(a, o) {
    return "[Axios v" + DO + "] Transitional option '" + a + "'" + o + (r ? ". " + r : "");
  }
  return (a, o, s) => {
    if (t === !1)
      throw new nt(
        i(o, " has been removed" + (n ? " in " + n : "")),
        nt.ERR_DEPRECATED
      );
    return n && !O0[o] && (O0[o] = !0, console.warn(
      i(
        o,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(a, o, s) : !0;
  };
};
function Kne(e, t, n) {
  if (typeof e != "object")
    throw new nt("options must be an object", nt.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const a = r[i], o = t[a];
    if (o) {
      const s = e[a], c = s === void 0 || o(s, a, e);
      if (c !== !0)
        throw new nt("option " + a + " must be " + c, nt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new nt("Unknown option " + a, nt.ERR_BAD_OPTION);
  }
}
const Lh = {
  assertOptions: Kne,
  validators: uy
}, ti = Lh.validators;
class Li {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new w0(),
      response: new w0()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = qa(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: a } = n;
    r !== void 0 && Lh.assertOptions(r, {
      silentJSONParsing: ti.transitional(ti.boolean),
      forcedJSONParsing: ti.transitional(ti.boolean),
      clarifyTimeoutError: ti.transitional(ti.boolean)
    }, !1), i !== void 0 && Lh.assertOptions(i, {
      encode: ti.function,
      serialize: ti.function
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o;
    o = a && K.merge(
      a.common,
      a[n.method]
    ), o && K.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete a[m];
      }
    ), n.headers = zn.concat(o, a);
    const s = [];
    let c = !0;
    this.interceptors.request.forEach(function(h) {
      typeof h.runWhen == "function" && h.runWhen(n) === !1 || (c = c && h.synchronous, s.unshift(h.fulfilled, h.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(h) {
      l.push(h.fulfilled, h.rejected);
    });
    let u, f = 0, d;
    if (!c) {
      const m = [T0.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, l), d = m.length, u = Promise.resolve(n); f < d; )
        u = u.then(m[f++], m[f++]);
      return u;
    }
    d = s.length;
    let p = n;
    for (f = 0; f < d; ) {
      const m = s[f++], h = s[f++];
      try {
        p = m(p);
      } catch (y) {
        h.call(this, y);
        break;
      }
    }
    try {
      u = T0.call(this, p);
    } catch (m) {
      return Promise.reject(m);
    }
    for (f = 0, d = l.length; f < d; )
      u = u.then(l[f++], l[f++]);
    return u;
  }
  getUri(t) {
    t = qa(this.defaults, t);
    const n = NO(t.baseURL, t.url);
    return $O(n, t.params, t.paramsSerializer);
  }
}
K.forEach(["delete", "get", "head", "options"], function(t) {
  Li.prototype[t] = function(n, r) {
    return this.request(qa(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
K.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(a, o, s) {
      return this.request(qa(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Li.prototype[t] = n(), Li.prototype[t + "Form"] = n(!0);
});
class fy {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners) return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let a;
      const o = new Promise((s) => {
        r.subscribe(s), a = s;
      }).then(i);
      return o.cancel = function() {
        r.unsubscribe(a);
      }, o;
    }, t(function(a, o, s) {
      r.reason || (r.reason = new ul(a, o, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new fy(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
function Gne(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Yne(e) {
  return K.isObject(e) && e.isAxiosError === !0;
}
const Fh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Fh).forEach(([e, t]) => {
  Fh[t] = e;
});
function MO(e) {
  const t = new Li(e), n = gO(Li.prototype.request, t);
  return K.extend(n, Li.prototype, t, { allOwnKeys: !0 }), K.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return MO(qa(e, i));
  }, n;
}
const jt = MO(uo);
jt.Axios = Li;
jt.CanceledError = ul;
jt.CancelToken = fy;
jt.isCancel = PO;
jt.VERSION = DO;
jt.toFormData = ff;
jt.AxiosError = nt;
jt.Cancel = jt.CanceledError;
jt.all = function(t) {
  return Promise.all(t);
};
jt.spread = Gne;
jt.isAxiosError = Yne;
jt.mergeConfig = qa;
jt.AxiosHeaders = zn;
jt.formToJSON = (e) => AO(K.isHTMLForm(e) ? new FormData(e) : e);
jt.HttpStatusCode = Fh;
jt.default = jt;
const jO = {}, Jne = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jO
}, Symbol.toStringTag, { value: "Module" }));
var LO = Object, Xne = Error, Qne = EvalError, ere = RangeError, tre = ReferenceError, FO = SyntaxError, fo = TypeError, nre = URIError, rre = Math.abs, ire = Math.floor, are = Math.max, ore = Math.min, sre = Math.pow, lre = Math.round, cre = Number.isNaN || function(t) {
  return t !== t;
}, ure = cre, fre = function(t) {
  return ure(t) || t === 0 ? t : t < 0 ? -1 : 1;
}, dre = Object.getOwnPropertyDescriptor, bc = dre;
if (bc)
  try {
    bc([], "length");
  } catch {
    bc = null;
  }
var df = bc, xc = Object.defineProperty || !1;
if (xc)
  try {
    xc({}, "a", { value: 1 });
  } catch {
    xc = !1;
  }
var pf = xc, tp, C0;
function pre() {
  return C0 || (C0 = 1, tp = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, n = Symbol("test"), r = Object(n);
    if (typeof n == "string" || Object.prototype.toString.call(n) !== "[object Symbol]" || Object.prototype.toString.call(r) !== "[object Symbol]")
      return !1;
    var i = 42;
    t[n] = i;
    for (var a in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var o = Object.getOwnPropertySymbols(t);
    if (o.length !== 1 || o[0] !== n || !Object.prototype.propertyIsEnumerable.call(t, n))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, n)
      );
      if (s.value !== i || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), tp;
}
var np, R0;
function hre() {
  if (R0) return np;
  R0 = 1;
  var e = typeof Symbol < "u" && Symbol, t = pre();
  return np = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, np;
}
var rp, $0;
function BO() {
  return $0 || ($0 = 1, rp = typeof Reflect < "u" && Reflect.getPrototypeOf || null), rp;
}
var ip, I0;
function UO() {
  if (I0) return ip;
  I0 = 1;
  var e = LO;
  return ip = e.getPrototypeOf || null, ip;
}
var ap, A0;
function mre() {
  if (A0) return ap;
  A0 = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, n = Math.max, r = "[object Function]", i = function(c, l) {
    for (var u = [], f = 0; f < c.length; f += 1)
      u[f] = c[f];
    for (var d = 0; d < l.length; d += 1)
      u[d + c.length] = l[d];
    return u;
  }, a = function(c, l) {
    for (var u = [], f = l, d = 0; f < c.length; f += 1, d += 1)
      u[d] = c[f];
    return u;
  }, o = function(s, c) {
    for (var l = "", u = 0; u < s.length; u += 1)
      l += s[u], u + 1 < s.length && (l += c);
    return l;
  };
  return ap = function(c) {
    var l = this;
    if (typeof l != "function" || t.apply(l) !== r)
      throw new TypeError(e + l);
    for (var u = a(arguments, 1), f, d = function() {
      if (this instanceof f) {
        var v = l.apply(
          this,
          i(u, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return l.apply(
        c,
        i(u, arguments)
      );
    }, p = n(0, l.length - u.length), m = [], h = 0; h < p; h++)
      m[h] = "$" + h;
    if (f = Function("binder", "return function (" + o(m, ",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
      var y = function() {
      };
      y.prototype = l.prototype, f.prototype = new y(), y.prototype = null;
    }
    return f;
  }, ap;
}
var op, P0;
function fl() {
  if (P0) return op;
  P0 = 1;
  var e = mre();
  return op = Function.prototype.bind || e, op;
}
var sp, N0;
function dy() {
  return N0 || (N0 = 1, sp = Function.prototype.call), sp;
}
var lp, D0;
function zO() {
  return D0 || (D0 = 1, lp = Function.prototype.apply), lp;
}
var cp, M0;
function vre() {
  return M0 || (M0 = 1, cp = typeof Reflect < "u" && Reflect && Reflect.apply), cp;
}
var up, j0;
function yre() {
  if (j0) return up;
  j0 = 1;
  var e = fl(), t = zO(), n = dy(), r = vre();
  return up = r || e.call(n, t), up;
}
var fp, L0;
function gre() {
  if (L0) return fp;
  L0 = 1;
  var e = fl(), t = fo, n = dy(), r = yre();
  return fp = function(a) {
    if (a.length < 1 || typeof a[0] != "function")
      throw new t("a function is required");
    return r(e, n, a);
  }, fp;
}
var dp, F0;
function bre() {
  if (F0) return dp;
  F0 = 1;
  var e = gre(), t = df, n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (o) {
    if (!o || typeof o != "object" || !("code" in o) || o.code !== "ERR_PROTO_ACCESS")
      throw o;
  }
  var r = !!n && t && t(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), i = Object, a = i.getPrototypeOf;
  return dp = r && typeof r.get == "function" ? e([r.get]) : typeof a == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return a(s == null ? s : i(s));
    }
  ) : !1, dp;
}
var pp, B0;
function xre() {
  if (B0) return pp;
  B0 = 1;
  var e = BO(), t = UO(), n = bre();
  return pp = e ? function(i) {
    return e(i);
  } : t ? function(i) {
    if (!i || typeof i != "object" && typeof i != "function")
      throw new TypeError("getProto: not an object");
    return t(i);
  } : n ? function(i) {
    return n(i);
  } : null, pp;
}
var hp, U0;
function wre() {
  if (U0) return hp;
  U0 = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, n = fl();
  return hp = n.call(e, t), hp;
}
var Ze, Sre = LO, _re = Xne, Ere = Qne, Tre = ere, kre = tre, Wa = FO, $a = fo, Ore = nre, Cre = rre, Rre = ire, $re = are, Ire = ore, Are = sre, Pre = lre, Nre = fre, VO = Function, mp = function(e) {
  try {
    return VO('"use strict"; return (' + e + ").constructor;")();
  } catch {
  }
}, ys = df, Dre = pf, vp = function() {
  throw new $a();
}, Mre = ys ? function() {
  try {
    return arguments.callee, vp;
  } catch {
    try {
      return ys(arguments, "callee").get;
    } catch {
      return vp;
    }
  }
}() : vp, ha = hre()(), Kt = xre(), jre = UO(), Lre = BO(), HO = zO(), dl = dy(), ga = {}, Fre = typeof Uint8Array > "u" || !Kt ? Ze : Kt(Uint8Array), Fi = {
  __proto__: null,
  "%AggregateError%": typeof AggregateError > "u" ? Ze : AggregateError,
  "%Array%": Array,
  "%ArrayBuffer%": typeof ArrayBuffer > "u" ? Ze : ArrayBuffer,
  "%ArrayIteratorPrototype%": ha && Kt ? Kt([][Symbol.iterator]()) : Ze,
  "%AsyncFromSyncIteratorPrototype%": Ze,
  "%AsyncFunction%": ga,
  "%AsyncGenerator%": ga,
  "%AsyncGeneratorFunction%": ga,
  "%AsyncIteratorPrototype%": ga,
  "%Atomics%": typeof Atomics > "u" ? Ze : Atomics,
  "%BigInt%": typeof BigInt > "u" ? Ze : BigInt,
  "%BigInt64Array%": typeof BigInt64Array > "u" ? Ze : BigInt64Array,
  "%BigUint64Array%": typeof BigUint64Array > "u" ? Ze : BigUint64Array,
  "%Boolean%": Boolean,
  "%DataView%": typeof DataView > "u" ? Ze : DataView,
  "%Date%": Date,
  "%decodeURI%": decodeURI,
  "%decodeURIComponent%": decodeURIComponent,
  "%encodeURI%": encodeURI,
  "%encodeURIComponent%": encodeURIComponent,
  "%Error%": _re,
  "%eval%": eval,
  // eslint-disable-line no-eval
  "%EvalError%": Ere,
  "%Float32Array%": typeof Float32Array > "u" ? Ze : Float32Array,
  "%Float64Array%": typeof Float64Array > "u" ? Ze : Float64Array,
  "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? Ze : FinalizationRegistry,
  "%Function%": VO,
  "%GeneratorFunction%": ga,
  "%Int8Array%": typeof Int8Array > "u" ? Ze : Int8Array,
  "%Int16Array%": typeof Int16Array > "u" ? Ze : Int16Array,
  "%Int32Array%": typeof Int32Array > "u" ? Ze : Int32Array,
  "%isFinite%": isFinite,
  "%isNaN%": isNaN,
  "%IteratorPrototype%": ha && Kt ? Kt(Kt([][Symbol.iterator]())) : Ze,
  "%JSON%": typeof JSON == "object" ? JSON : Ze,
  "%Map%": typeof Map > "u" ? Ze : Map,
  "%MapIteratorPrototype%": typeof Map > "u" || !ha || !Kt ? Ze : Kt((/* @__PURE__ */ new Map())[Symbol.iterator]()),
  "%Math%": Math,
  "%Number%": Number,
  "%Object%": Sre,
  "%Object.getOwnPropertyDescriptor%": ys,
  "%parseFloat%": parseFloat,
  "%parseInt%": parseInt,
  "%Promise%": typeof Promise > "u" ? Ze : Promise,
  "%Proxy%": typeof Proxy > "u" ? Ze : Proxy,
  "%RangeError%": Tre,
  "%ReferenceError%": kre,
  "%Reflect%": typeof Reflect > "u" ? Ze : Reflect,
  "%RegExp%": RegExp,
  "%Set%": typeof Set > "u" ? Ze : Set,
  "%SetIteratorPrototype%": typeof Set > "u" || !ha || !Kt ? Ze : Kt((/* @__PURE__ */ new Set())[Symbol.iterator]()),
  "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? Ze : SharedArrayBuffer,
  "%String%": String,
  "%StringIteratorPrototype%": ha && Kt ? Kt(""[Symbol.iterator]()) : Ze,
  "%Symbol%": ha ? Symbol : Ze,
  "%SyntaxError%": Wa,
  "%ThrowTypeError%": Mre,
  "%TypedArray%": Fre,
  "%TypeError%": $a,
  "%Uint8Array%": typeof Uint8Array > "u" ? Ze : Uint8Array,
  "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? Ze : Uint8ClampedArray,
  "%Uint16Array%": typeof Uint16Array > "u" ? Ze : Uint16Array,
  "%Uint32Array%": typeof Uint32Array > "u" ? Ze : Uint32Array,
  "%URIError%": Ore,
  "%WeakMap%": typeof WeakMap > "u" ? Ze : WeakMap,
  "%WeakRef%": typeof WeakRef > "u" ? Ze : WeakRef,
  "%WeakSet%": typeof WeakSet > "u" ? Ze : WeakSet,
  "%Function.prototype.call%": dl,
  "%Function.prototype.apply%": HO,
  "%Object.defineProperty%": Dre,
  "%Object.getPrototypeOf%": jre,
  "%Math.abs%": Cre,
  "%Math.floor%": Rre,
  "%Math.max%": $re,
  "%Math.min%": Ire,
  "%Math.pow%": Are,
  "%Math.round%": Pre,
  "%Math.sign%": Nre,
  "%Reflect.getPrototypeOf%": Lre
};
if (Kt)
  try {
    null.error;
  } catch (e) {
    var Bre = Kt(Kt(e));
    Fi["%Error.prototype%"] = Bre;
  }
var Ure = function e(t) {
  var n;
  if (t === "%AsyncFunction%")
    n = mp("async function () {}");
  else if (t === "%GeneratorFunction%")
    n = mp("function* () {}");
  else if (t === "%AsyncGeneratorFunction%")
    n = mp("async function* () {}");
  else if (t === "%AsyncGenerator%") {
    var r = e("%AsyncGeneratorFunction%");
    r && (n = r.prototype);
  } else if (t === "%AsyncIteratorPrototype%") {
    var i = e("%AsyncGenerator%");
    i && Kt && (n = Kt(i.prototype));
  }
  return Fi[t] = n, n;
}, z0 = {
  __proto__: null,
  "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
  "%ArrayPrototype%": ["Array", "prototype"],
  "%ArrayProto_entries%": ["Array", "prototype", "entries"],
  "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
  "%ArrayProto_keys%": ["Array", "prototype", "keys"],
  "%ArrayProto_values%": ["Array", "prototype", "values"],
  "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
  "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
  "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
  "%BooleanPrototype%": ["Boolean", "prototype"],
  "%DataViewPrototype%": ["DataView", "prototype"],
  "%DatePrototype%": ["Date", "prototype"],
  "%ErrorPrototype%": ["Error", "prototype"],
  "%EvalErrorPrototype%": ["EvalError", "prototype"],
  "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
  "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
  "%FunctionPrototype%": ["Function", "prototype"],
  "%Generator%": ["GeneratorFunction", "prototype"],
  "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
  "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
  "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
  "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
  "%JSONParse%": ["JSON", "parse"],
  "%JSONStringify%": ["JSON", "stringify"],
  "%MapPrototype%": ["Map", "prototype"],
  "%NumberPrototype%": ["Number", "prototype"],
  "%ObjectPrototype%": ["Object", "prototype"],
  "%ObjProto_toString%": ["Object", "prototype", "toString"],
  "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
  "%PromisePrototype%": ["Promise", "prototype"],
  "%PromiseProto_then%": ["Promise", "prototype", "then"],
  "%Promise_all%": ["Promise", "all"],
  "%Promise_reject%": ["Promise", "reject"],
  "%Promise_resolve%": ["Promise", "resolve"],
  "%RangeErrorPrototype%": ["RangeError", "prototype"],
  "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
  "%RegExpPrototype%": ["RegExp", "prototype"],
  "%SetPrototype%": ["Set", "prototype"],
  "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
  "%StringPrototype%": ["String", "prototype"],
  "%SymbolPrototype%": ["Symbol", "prototype"],
  "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
  "%TypedArrayPrototype%": ["TypedArray", "prototype"],
  "%TypeErrorPrototype%": ["TypeError", "prototype"],
  "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
  "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
  "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
  "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
  "%URIErrorPrototype%": ["URIError", "prototype"],
  "%WeakMapPrototype%": ["WeakMap", "prototype"],
  "%WeakSetPrototype%": ["WeakSet", "prototype"]
}, pl = fl(), iu = wre(), zre = pl.call(dl, Array.prototype.concat), Vre = pl.call(HO, Array.prototype.splice), V0 = pl.call(dl, String.prototype.replace), au = pl.call(dl, String.prototype.slice), Hre = pl.call(dl, RegExp.prototype.exec), qre = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Wre = /\\(\\)?/g, Zre = function(t) {
  var n = au(t, 0, 1), r = au(t, -1);
  if (n === "%" && r !== "%")
    throw new Wa("invalid intrinsic syntax, expected closing `%`");
  if (r === "%" && n !== "%")
    throw new Wa("invalid intrinsic syntax, expected opening `%`");
  var i = [];
  return V0(t, qre, function(a, o, s, c) {
    i[i.length] = s ? V0(c, Wre, "$1") : o || a;
  }), i;
}, Kre = function(t, n) {
  var r = t, i;
  if (iu(z0, r) && (i = z0[r], r = "%" + i[0] + "%"), iu(Fi, r)) {
    var a = Fi[r];
    if (a === ga && (a = Ure(r)), typeof a > "u" && !n)
      throw new $a("intrinsic " + t + " exists, but is not available. Please file an issue!");
    return {
      alias: i,
      name: r,
      value: a
    };
  }
  throw new Wa("intrinsic " + t + " does not exist!");
}, hf = function(t, n) {
  if (typeof t != "string" || t.length === 0)
    throw new $a("intrinsic name must be a non-empty string");
  if (arguments.length > 1 && typeof n != "boolean")
    throw new $a('"allowMissing" argument must be a boolean');
  if (Hre(/^%?[^%]*%?$/, t) === null)
    throw new Wa("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
  var r = Zre(t), i = r.length > 0 ? r[0] : "", a = Kre("%" + i + "%", n), o = a.name, s = a.value, c = !1, l = a.alias;
  l && (i = l[0], Vre(r, zre([0, 1], l)));
  for (var u = 1, f = !0; u < r.length; u += 1) {
    var d = r[u], p = au(d, 0, 1), m = au(d, -1);
    if ((p === '"' || p === "'" || p === "`" || m === '"' || m === "'" || m === "`") && p !== m)
      throw new Wa("property names with quotes must have matching quotes");
    if ((d === "constructor" || !f) && (c = !0), i += "." + d, o = "%" + i + "%", iu(Fi, o))
      s = Fi[o];
    else if (s != null) {
      if (!(d in s)) {
        if (!n)
          throw new $a("base intrinsic for " + t + " exists, but the property is not available.");
        return;
      }
      if (ys && u + 1 >= r.length) {
        var h = ys(s, d);
        f = !!h, f && "get" in h && !("originalValue" in h.get) ? s = h.get : s = s[d];
      } else
        f = iu(s, d), s = s[d];
      f && !c && (Fi[o] = s);
    }
  }
  return s;
}, qO = { exports: {} }, H0 = pf, Gre = FO, ma = fo, q0 = df, Yre = function(t, n, r) {
  if (!t || typeof t != "object" && typeof t != "function")
    throw new ma("`obj` must be an object or a function`");
  if (typeof n != "string" && typeof n != "symbol")
    throw new ma("`property` must be a string or a symbol`");
  if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
    throw new ma("`nonEnumerable`, if provided, must be a boolean or null");
  if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
    throw new ma("`nonWritable`, if provided, must be a boolean or null");
  if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
    throw new ma("`nonConfigurable`, if provided, must be a boolean or null");
  if (arguments.length > 6 && typeof arguments[6] != "boolean")
    throw new ma("`loose`, if provided, must be a boolean");
  var i = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, c = !!q0 && q0(t, n);
  if (H0)
    H0(t, n, {
      configurable: o === null && c ? c.configurable : !o,
      enumerable: i === null && c ? c.enumerable : !i,
      value: r,
      writable: a === null && c ? c.writable : !a
    });
  else if (s || !i && !a && !o)
    t[n] = r;
  else
    throw new Gre("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
}, Bh = pf, WO = function() {
  return !!Bh;
};
WO.hasArrayLengthDefineBug = function() {
  if (!Bh)
    return null;
  try {
    return Bh([], "length", { value: 1 }).length !== 1;
  } catch {
    return !0;
  }
};
var Jre = WO, Xre = hf, W0 = Yre, Qre = Jre(), Z0 = df, K0 = fo, eie = Xre("%Math.floor%"), tie = function(t, n) {
  if (typeof t != "function")
    throw new K0("`fn` is not a function");
  if (typeof n != "number" || n < 0 || n > 4294967295 || eie(n) !== n)
    throw new K0("`length` must be a positive 32-bit integer");
  var r = arguments.length > 2 && !!arguments[2], i = !0, a = !0;
  if ("length" in t && Z0) {
    var o = Z0(t, "length");
    o && !o.configurable && (i = !1), o && !o.writable && (a = !1);
  }
  return (i || a || !r) && (Qre ? W0(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    n,
    !0,
    !0
  ) : W0(
    /** @type {Parameters<define>[0]} */
    t,
    "length",
    n
  )), t;
};
(function(e) {
  var t = fl(), n = hf, r = tie, i = fo, a = n("%Function.prototype.apply%"), o = n("%Function.prototype.call%"), s = n("%Reflect.apply%", !0) || t.call(o, a), c = pf, l = n("%Math.max%");
  e.exports = function(d) {
    if (typeof d != "function")
      throw new i("a function is required");
    var p = s(t, o, arguments);
    return r(
      p,
      1 + l(0, d.length - (arguments.length - 1)),
      !0
    );
  };
  var u = function() {
    return s(t, a, arguments);
  };
  c ? c(e.exports, "apply", { value: u }) : e.exports.apply = u;
})(qO);
var nie = qO.exports, ZO = hf, KO = nie, rie = KO(ZO("String.prototype.indexOf")), iie = function(t, n) {
  var r = ZO(t, !!n);
  return typeof r == "function" && rie(t, ".prototype.") > -1 ? KO(r) : r;
};
const aie = /* @__PURE__ */ qC(Jne);
var py = typeof Map == "function" && Map.prototype, yp = Object.getOwnPropertyDescriptor && py ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, ou = py && yp && typeof yp.get == "function" ? yp.get : null, G0 = py && Map.prototype.forEach, hy = typeof Set == "function" && Set.prototype, gp = Object.getOwnPropertyDescriptor && hy ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, su = hy && gp && typeof gp.get == "function" ? gp.get : null, Y0 = hy && Set.prototype.forEach, oie = typeof WeakMap == "function" && WeakMap.prototype, Uo = oie ? WeakMap.prototype.has : null, sie = typeof WeakSet == "function" && WeakSet.prototype, zo = sie ? WeakSet.prototype.has : null, lie = typeof WeakRef == "function" && WeakRef.prototype, J0 = lie ? WeakRef.prototype.deref : null, cie = Boolean.prototype.valueOf, uie = Object.prototype.toString, fie = Function.prototype.toString, die = String.prototype.match, my = String.prototype.slice, ci = String.prototype.replace, pie = String.prototype.toUpperCase, X0 = String.prototype.toLowerCase, GO = RegExp.prototype.test, Q0 = Array.prototype.concat, xr = Array.prototype.join, hie = Array.prototype.slice, e1 = Math.floor, Uh = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, bp = Object.getOwnPropertySymbols, zh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, Za = typeof Symbol == "function" && typeof Symbol.iterator == "object", on = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === Za || !0) ? Symbol.toStringTag : null, YO = Object.prototype.propertyIsEnumerable, t1 = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e) {
  return e.__proto__;
} : null);
function n1(e, t) {
  if (e === 1 / 0 || e === -1 / 0 || e !== e || e && e > -1e3 && e < 1e3 || GO.call(/e/, t))
    return t;
  var n = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof e == "number") {
    var r = e < 0 ? -e1(-e) : e1(e);
    if (r !== e) {
      var i = String(r), a = my.call(t, i.length + 1);
      return ci.call(i, n, "$&_") + "." + ci.call(ci.call(a, /([0-9]{3})/g, "$&_"), /_$/, "");
    }
  }
  return ci.call(t, n, "$&_");
}
var Vh = aie, r1 = Vh.custom, i1 = XO(r1) ? r1 : null, mie = function e(t, n, r, i) {
  var a = n || {};
  if (ri(a, "quoteStyle") && a.quoteStyle !== "single" && a.quoteStyle !== "double")
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  if (ri(a, "maxStringLength") && (typeof a.maxStringLength == "number" ? a.maxStringLength < 0 && a.maxStringLength !== 1 / 0 : a.maxStringLength !== null))
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  var o = ri(a, "customInspect") ? a.customInspect : !0;
  if (typeof o != "boolean" && o !== "symbol")
    throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
  if (ri(a, "indent") && a.indent !== null && a.indent !== "	" && !(parseInt(a.indent, 10) === a.indent && a.indent > 0))
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  if (ri(a, "numericSeparator") && typeof a.numericSeparator != "boolean")
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  var s = a.numericSeparator;
  if (typeof t > "u")
    return "undefined";
  if (t === null)
    return "null";
  if (typeof t == "boolean")
    return t ? "true" : "false";
  if (typeof t == "string")
    return eC(t, a);
  if (typeof t == "number") {
    if (t === 0)
      return 1 / 0 / t > 0 ? "0" : "-0";
    var c = String(t);
    return s ? n1(t, c) : c;
  }
  if (typeof t == "bigint") {
    var l = String(t) + "n";
    return s ? n1(t, l) : l;
  }
  var u = typeof a.depth > "u" ? 5 : a.depth;
  if (typeof r > "u" && (r = 0), r >= u && u > 0 && typeof t == "object")
    return Hh(t) ? "[Array]" : "[Object]";
  var f = Pie(a, r);
  if (typeof i > "u")
    i = [];
  else if (QO(i, t) >= 0)
    return "[Circular]";
  function d($, L, M) {
    if (L && (i = hie.call(i), i.push(L)), M) {
      var F = {
        depth: a.depth
      };
      return ri(a, "quoteStyle") && (F.quoteStyle = a.quoteStyle), e($, F, r + 1, i);
    }
    return e($, a, r + 1, i);
  }
  if (typeof t == "function" && !a1(t)) {
    var p = Eie(t), m = ql(t, d);
    return "[Function" + (p ? ": " + p : " (anonymous)") + "]" + (m.length > 0 ? " { " + xr.call(m, ", ") + " }" : "");
  }
  if (XO(t)) {
    var h = Za ? ci.call(String(t), /^(Symbol\(.*\))_[^)]*$/, "$1") : zh.call(t);
    return typeof t == "object" && !Za ? Io(h) : h;
  }
  if ($ie(t)) {
    for (var y = "<" + X0.call(String(t.nodeName)), v = t.attributes || [], g = 0; g < v.length; g++)
      y += " " + v[g].name + "=" + JO(vie(v[g].value), "double", a);
    return y += ">", t.childNodes && t.childNodes.length && (y += "..."), y += "</" + X0.call(String(t.nodeName)) + ">", y;
  }
  if (Hh(t)) {
    if (t.length === 0)
      return "[]";
    var b = ql(t, d);
    return f && !Aie(b) ? "[" + qh(b, f) + "]" : "[ " + xr.call(b, ", ") + " ]";
  }
  if (gie(t)) {
    var T = ql(t, d);
    return !("cause" in Error.prototype) && "cause" in t && !YO.call(t, "cause") ? "{ [" + String(t) + "] " + xr.call(Q0.call("[cause]: " + d(t.cause), T), ", ") + " }" : T.length === 0 ? "[" + String(t) + "]" : "{ [" + String(t) + "] " + xr.call(T, ", ") + " }";
  }
  if (typeof t == "object" && o) {
    if (i1 && typeof t[i1] == "function" && Vh)
      return Vh(t, { depth: u - r });
    if (o !== "symbol" && typeof t.inspect == "function")
      return t.inspect();
  }
  if (Tie(t)) {
    var S = [];
    return G0 && G0.call(t, function($, L) {
      S.push(d(L, t, !0) + " => " + d($, t));
    }), o1("Map", ou.call(t), S, f);
  }
  if (Cie(t)) {
    var E = [];
    return Y0 && Y0.call(t, function($) {
      E.push(d($, t));
    }), o1("Set", su.call(t), E, f);
  }
  if (kie(t))
    return xp("WeakMap");
  if (Rie(t))
    return xp("WeakSet");
  if (Oie(t))
    return xp("WeakRef");
  if (xie(t))
    return Io(d(Number(t)));
  if (Sie(t))
    return Io(d(Uh.call(t)));
  if (wie(t))
    return Io(cie.call(t));
  if (bie(t))
    return Io(d(String(t)));
  if (typeof window < "u" && t === window)
    return "{ [object Window] }";
  if (typeof globalThis < "u" && t === globalThis || typeof pt < "u" && t === pt)
    return "{ [object globalThis] }";
  if (!yie(t) && !a1(t)) {
    var O = ql(t, d), j = t1 ? t1(t) === Object.prototype : t instanceof Object || t.constructor === Object, D = t instanceof Object ? "" : "null prototype", k = !j && on && Object(t) === t && on in t ? my.call(Ri(t), 8, -1) : D ? "Object" : "", A = j || typeof t.constructor != "function" ? "" : t.constructor.name ? t.constructor.name + " " : "", V = A + (k || D ? "[" + xr.call(Q0.call([], k || [], D || []), ": ") + "] " : "");
    return O.length === 0 ? V + "{}" : f ? V + "{" + qh(O, f) + "}" : V + "{ " + xr.call(O, ", ") + " }";
  }
  return String(t);
};
function JO(e, t, n) {
  var r = (n.quoteStyle || t) === "double" ? '"' : "'";
  return r + e + r;
}
function vie(e) {
  return ci.call(String(e), /"/g, "&quot;");
}
function Hh(e) {
  return Ri(e) === "[object Array]" && (!on || !(typeof e == "object" && on in e));
}
function yie(e) {
  return Ri(e) === "[object Date]" && (!on || !(typeof e == "object" && on in e));
}
function a1(e) {
  return Ri(e) === "[object RegExp]" && (!on || !(typeof e == "object" && on in e));
}
function gie(e) {
  return Ri(e) === "[object Error]" && (!on || !(typeof e == "object" && on in e));
}
function bie(e) {
  return Ri(e) === "[object String]" && (!on || !(typeof e == "object" && on in e));
}
function xie(e) {
  return Ri(e) === "[object Number]" && (!on || !(typeof e == "object" && on in e));
}
function wie(e) {
  return Ri(e) === "[object Boolean]" && (!on || !(typeof e == "object" && on in e));
}
function XO(e) {
  if (Za)
    return e && typeof e == "object" && e instanceof Symbol;
  if (typeof e == "symbol")
    return !0;
  if (!e || typeof e != "object" || !zh)
    return !1;
  try {
    return zh.call(e), !0;
  } catch {
  }
  return !1;
}
function Sie(e) {
  if (!e || typeof e != "object" || !Uh)
    return !1;
  try {
    return Uh.call(e), !0;
  } catch {
  }
  return !1;
}
var _ie = Object.prototype.hasOwnProperty || function(e) {
  return e in this;
};
function ri(e, t) {
  return _ie.call(e, t);
}
function Ri(e) {
  return uie.call(e);
}
function Eie(e) {
  if (e.name)
    return e.name;
  var t = die.call(fie.call(e), /^function\s*([\w$]+)/);
  return t ? t[1] : null;
}
function QO(e, t) {
  if (e.indexOf)
    return e.indexOf(t);
  for (var n = 0, r = e.length; n < r; n++)
    if (e[n] === t)
      return n;
  return -1;
}
function Tie(e) {
  if (!ou || !e || typeof e != "object")
    return !1;
  try {
    ou.call(e);
    try {
      su.call(e);
    } catch {
      return !0;
    }
    return e instanceof Map;
  } catch {
  }
  return !1;
}
function kie(e) {
  if (!Uo || !e || typeof e != "object")
    return !1;
  try {
    Uo.call(e, Uo);
    try {
      zo.call(e, zo);
    } catch {
      return !0;
    }
    return e instanceof WeakMap;
  } catch {
  }
  return !1;
}
function Oie(e) {
  if (!J0 || !e || typeof e != "object")
    return !1;
  try {
    return J0.call(e), !0;
  } catch {
  }
  return !1;
}
function Cie(e) {
  if (!su || !e || typeof e != "object")
    return !1;
  try {
    su.call(e);
    try {
      ou.call(e);
    } catch {
      return !0;
    }
    return e instanceof Set;
  } catch {
  }
  return !1;
}
function Rie(e) {
  if (!zo || !e || typeof e != "object")
    return !1;
  try {
    zo.call(e, zo);
    try {
      Uo.call(e, Uo);
    } catch {
      return !0;
    }
    return e instanceof WeakSet;
  } catch {
  }
  return !1;
}
function $ie(e) {
  return !e || typeof e != "object" ? !1 : typeof HTMLElement < "u" && e instanceof HTMLElement ? !0 : typeof e.nodeName == "string" && typeof e.getAttribute == "function";
}
function eC(e, t) {
  if (e.length > t.maxStringLength) {
    var n = e.length - t.maxStringLength, r = "... " + n + " more character" + (n > 1 ? "s" : "");
    return eC(my.call(e, 0, t.maxStringLength), t) + r;
  }
  var i = ci.call(ci.call(e, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Iie);
  return JO(i, "single", t);
}
function Iie(e) {
  var t = e.charCodeAt(0), n = {
    8: "b",
    9: "t",
    10: "n",
    12: "f",
    13: "r"
  }[t];
  return n ? "\\" + n : "\\x" + (t < 16 ? "0" : "") + pie.call(t.toString(16));
}
function Io(e) {
  return "Object(" + e + ")";
}
function xp(e) {
  return e + " { ? }";
}
function o1(e, t, n, r) {
  var i = r ? qh(n, r) : xr.call(n, ", ");
  return e + " (" + t + ") {" + i + "}";
}
function Aie(e) {
  for (var t = 0; t < e.length; t++)
    if (QO(e[t], `
`) >= 0)
      return !1;
  return !0;
}
function Pie(e, t) {
  var n;
  if (e.indent === "	")
    n = "	";
  else if (typeof e.indent == "number" && e.indent > 0)
    n = xr.call(Array(e.indent + 1), " ");
  else
    return null;
  return {
    base: n,
    prev: xr.call(Array(t + 1), n)
  };
}
function qh(e, t) {
  if (e.length === 0)
    return "";
  var n = `
` + t.prev + t.base;
  return n + xr.call(e, "," + n) + `
` + t.prev;
}
function ql(e, t) {
  var n = Hh(e), r = [];
  if (n) {
    r.length = e.length;
    for (var i = 0; i < e.length; i++)
      r[i] = ri(e, i) ? t(e[i], e) : "";
  }
  var a = typeof bp == "function" ? bp(e) : [], o;
  if (Za) {
    o = {};
    for (var s = 0; s < a.length; s++)
      o["$" + a[s]] = a[s];
  }
  for (var c in e)
    ri(e, c) && (n && String(Number(c)) === c && c < e.length || Za && o["$" + c] instanceof Symbol || (GO.call(/[^\w$]/, c) ? r.push(t(c, e) + ": " + t(e[c], e)) : r.push(c + ": " + t(e[c], e))));
  if (typeof bp == "function")
    for (var l = 0; l < a.length; l++)
      YO.call(e, a[l]) && r.push("[" + t(a[l]) + "]: " + t(e[a[l]], e));
  return r;
}
var tC = hf, po = iie, Nie = mie, Die = fo, Wl = tC("%WeakMap%", !0), Zl = tC("%Map%", !0), Mie = po("WeakMap.prototype.get", !0), jie = po("WeakMap.prototype.set", !0), Lie = po("WeakMap.prototype.has", !0), Fie = po("Map.prototype.get", !0), Bie = po("Map.prototype.set", !0), Uie = po("Map.prototype.has", !0), vy = function(e, t) {
  for (var n = e, r; (r = n.next) !== null; n = r)
    if (r.key === t)
      return n.next = r.next, r.next = /** @type {NonNullable<typeof list.next>} */
      e.next, e.next = r, r;
}, zie = function(e, t) {
  var n = vy(e, t);
  return n && n.value;
}, Vie = function(e, t, n) {
  var r = vy(e, t);
  r ? r.value = n : e.next = /** @type {import('.').ListNode<typeof value>} */
  {
    // eslint-disable-line no-param-reassign, no-extra-parens
    key: t,
    next: e.next,
    value: n
  };
}, Hie = function(e, t) {
  return !!vy(e, t);
}, qie = function() {
  var t, n, r, i = {
    assert: function(a) {
      if (!i.has(a))
        throw new Die("Side channel does not contain " + Nie(a));
    },
    get: function(a) {
      if (Wl && a && (typeof a == "object" || typeof a == "function")) {
        if (t)
          return Mie(t, a);
      } else if (Zl) {
        if (n)
          return Fie(n, a);
      } else if (r)
        return zie(r, a);
    },
    has: function(a) {
      if (Wl && a && (typeof a == "object" || typeof a == "function")) {
        if (t)
          return Lie(t, a);
      } else if (Zl) {
        if (n)
          return Uie(n, a);
      } else if (r)
        return Hie(r, a);
      return !1;
    },
    set: function(a, o) {
      Wl && a && (typeof a == "object" || typeof a == "function") ? (t || (t = new Wl()), jie(t, a, o)) : Zl ? (n || (n = new Zl()), Bie(n, a, o)) : (r || (r = { key: {}, next: null }), Vie(r, a, o));
    }
  };
  return i;
}, Wie = String.prototype.replace, Zie = /%20/g, wp = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, yy = {
  default: wp.RFC3986,
  formatters: {
    RFC1738: function(e) {
      return Wie.call(e, Zie, "+");
    },
    RFC3986: function(e) {
      return String(e);
    }
  },
  RFC1738: wp.RFC1738,
  RFC3986: wp.RFC3986
}, Kie = yy, Sp = Object.prototype.hasOwnProperty, Ni = Array.isArray, pr = function() {
  for (var e = [], t = 0; t < 256; ++t)
    e.push("%" + ((t < 16 ? "0" : "") + t.toString(16)).toUpperCase());
  return e;
}(), Gie = function(t) {
  for (; t.length > 1; ) {
    var n = t.pop(), r = n.obj[n.prop];
    if (Ni(r)) {
      for (var i = [], a = 0; a < r.length; ++a)
        typeof r[a] < "u" && i.push(r[a]);
      n.obj[n.prop] = i;
    }
  }
}, nC = function(t, n) {
  for (var r = n && n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, i = 0; i < t.length; ++i)
    typeof t[i] < "u" && (r[i] = t[i]);
  return r;
}, Yie = function e(t, n, r) {
  if (!n)
    return t;
  if (typeof n != "object") {
    if (Ni(t))
      t.push(n);
    else if (t && typeof t == "object")
      (r && (r.plainObjects || r.allowPrototypes) || !Sp.call(Object.prototype, n)) && (t[n] = !0);
    else
      return [t, n];
    return t;
  }
  if (!t || typeof t != "object")
    return [t].concat(n);
  var i = t;
  return Ni(t) && !Ni(n) && (i = nC(t, r)), Ni(t) && Ni(n) ? (n.forEach(function(a, o) {
    if (Sp.call(t, o)) {
      var s = t[o];
      s && typeof s == "object" && a && typeof a == "object" ? t[o] = e(s, a, r) : t.push(a);
    } else
      t[o] = a;
  }), t) : Object.keys(n).reduce(function(a, o) {
    var s = n[o];
    return Sp.call(a, o) ? a[o] = e(a[o], s, r) : a[o] = s, a;
  }, i);
}, Jie = function(t, n) {
  return Object.keys(n).reduce(function(r, i) {
    return r[i] = n[i], r;
  }, t);
}, Xie = function(e, t, n) {
  var r = e.replace(/\+/g, " ");
  if (n === "iso-8859-1")
    return r.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(r);
  } catch {
    return r;
  }
}, _p = 1024, Qie = function(t, n, r, i, a) {
  if (t.length === 0)
    return t;
  var o = t;
  if (typeof t == "symbol" ? o = Symbol.prototype.toString.call(t) : typeof t != "string" && (o = String(t)), r === "iso-8859-1")
    return escape(o).replace(/%u[0-9a-f]{4}/gi, function(p) {
      return "%26%23" + parseInt(p.slice(2), 16) + "%3B";
    });
  for (var s = "", c = 0; c < o.length; c += _p) {
    for (var l = o.length >= _p ? o.slice(c, c + _p) : o, u = [], f = 0; f < l.length; ++f) {
      var d = l.charCodeAt(f);
      if (d === 45 || d === 46 || d === 95 || d === 126 || d >= 48 && d <= 57 || d >= 65 && d <= 90 || d >= 97 && d <= 122 || a === Kie.RFC1738 && (d === 40 || d === 41)) {
        u[u.length] = l.charAt(f);
        continue;
      }
      if (d < 128) {
        u[u.length] = pr[d];
        continue;
      }
      if (d < 2048) {
        u[u.length] = pr[192 | d >> 6] + pr[128 | d & 63];
        continue;
      }
      if (d < 55296 || d >= 57344) {
        u[u.length] = pr[224 | d >> 12] + pr[128 | d >> 6 & 63] + pr[128 | d & 63];
        continue;
      }
      f += 1, d = 65536 + ((d & 1023) << 10 | l.charCodeAt(f) & 1023), u[u.length] = pr[240 | d >> 18] + pr[128 | d >> 12 & 63] + pr[128 | d >> 6 & 63] + pr[128 | d & 63];
    }
    s += u.join("");
  }
  return s;
}, eae = function(t) {
  for (var n = [{ obj: { o: t }, prop: "o" }], r = [], i = 0; i < n.length; ++i)
    for (var a = n[i], o = a.obj[a.prop], s = Object.keys(o), c = 0; c < s.length; ++c) {
      var l = s[c], u = o[l];
      typeof u == "object" && u !== null && r.indexOf(u) === -1 && (n.push({ obj: o, prop: l }), r.push(u));
    }
  return Gie(n), t;
}, tae = function(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}, nae = function(t) {
  return !t || typeof t != "object" ? !1 : !!(t.constructor && t.constructor.isBuffer && t.constructor.isBuffer(t));
}, rae = function(t, n) {
  return [].concat(t, n);
}, iae = function(t, n) {
  if (Ni(t)) {
    for (var r = [], i = 0; i < t.length; i += 1)
      r.push(n(t[i]));
    return r;
  }
  return n(t);
}, rC = {
  arrayToObject: nC,
  assign: Jie,
  combine: rae,
  compact: eae,
  decode: Xie,
  encode: Qie,
  isBuffer: nae,
  isRegExp: tae,
  maybeMap: iae,
  merge: Yie
}, iC = qie, wc = rC, Vo = yy, aae = Object.prototype.hasOwnProperty, aC = {
  brackets: function(t) {
    return t + "[]";
  },
  comma: "comma",
  indices: function(t, n) {
    return t + "[" + n + "]";
  },
  repeat: function(t) {
    return t;
  }
}, gr = Array.isArray, oae = Array.prototype.push, oC = function(e, t) {
  oae.apply(e, gr(t) ? t : [t]);
}, sae = Date.prototype.toISOString, s1 = Vo.default, zt = {
  addQueryPrefix: !1,
  allowDots: !1,
  allowEmptyArrays: !1,
  arrayFormat: "indices",
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encodeDotInKeys: !1,
  encoder: wc.encode,
  encodeValuesOnly: !1,
  format: s1,
  formatter: Vo.formatters[s1],
  // deprecated
  indices: !1,
  serializeDate: function(t) {
    return sae.call(t);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, lae = function(t) {
  return typeof t == "string" || typeof t == "number" || typeof t == "boolean" || typeof t == "symbol" || typeof t == "bigint";
}, Ep = {}, cae = function e(t, n, r, i, a, o, s, c, l, u, f, d, p, m, h, y, v, g) {
  for (var b = t, T = g, S = 0, E = !1; (T = T.get(Ep)) !== void 0 && !E; ) {
    var O = T.get(t);
    if (S += 1, typeof O < "u") {
      if (O === S)
        throw new RangeError("Cyclic object value");
      E = !0;
    }
    typeof T.get(Ep) > "u" && (S = 0);
  }
  if (typeof u == "function" ? b = u(n, b) : b instanceof Date ? b = p(b) : r === "comma" && gr(b) && (b = wc.maybeMap(b, function(x) {
    return x instanceof Date ? p(x) : x;
  })), b === null) {
    if (o)
      return l && !y ? l(n, zt.encoder, v, "key", m) : n;
    b = "";
  }
  if (lae(b) || wc.isBuffer(b)) {
    if (l) {
      var j = y ? n : l(n, zt.encoder, v, "key", m);
      return [h(j) + "=" + h(l(b, zt.encoder, v, "value", m))];
    }
    return [h(n) + "=" + h(String(b))];
  }
  var D = [];
  if (typeof b > "u")
    return D;
  var k;
  if (r === "comma" && gr(b))
    y && l && (b = wc.maybeMap(b, l)), k = [{ value: b.length > 0 ? b.join(",") || null : void 0 }];
  else if (gr(u))
    k = u;
  else {
    var A = Object.keys(b);
    k = f ? A.sort(f) : A;
  }
  var V = c ? n.replace(/\./g, "%2E") : n, $ = i && gr(b) && b.length === 1 ? V + "[]" : V;
  if (a && gr(b) && b.length === 0)
    return $ + "[]";
  for (var L = 0; L < k.length; ++L) {
    var M = k[L], F = typeof M == "object" && typeof M.value < "u" ? M.value : b[M];
    if (!(s && F === null)) {
      var q = d && c ? M.replace(/\./g, "%2E") : M, B = gr(b) ? typeof r == "function" ? r($, q) : $ : $ + (d ? "." + q : "[" + q + "]");
      g.set(t, S);
      var N = iC();
      N.set(Ep, g), oC(D, e(
        F,
        B,
        r,
        i,
        a,
        o,
        s,
        c,
        r === "comma" && y && gr(b) ? null : l,
        u,
        f,
        d,
        p,
        m,
        h,
        y,
        v,
        N
      ));
    }
  }
  return D;
}, uae = function(t) {
  if (!t)
    return zt;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.encodeDotInKeys < "u" && typeof t.encodeDotInKeys != "boolean")
    throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.encoder !== null && typeof t.encoder < "u" && typeof t.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var n = t.charset || zt.charset;
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var r = Vo.default;
  if (typeof t.format < "u") {
    if (!aae.call(Vo.formatters, t.format))
      throw new TypeError("Unknown format option provided.");
    r = t.format;
  }
  var i = Vo.formatters[r], a = zt.filter;
  (typeof t.filter == "function" || gr(t.filter)) && (a = t.filter);
  var o;
  if (t.arrayFormat in aC ? o = t.arrayFormat : "indices" in t ? o = t.indices ? "indices" : "repeat" : o = zt.arrayFormat, "commaRoundTrip" in t && typeof t.commaRoundTrip != "boolean")
    throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
  var s = typeof t.allowDots > "u" ? t.encodeDotInKeys === !0 ? !0 : zt.allowDots : !!t.allowDots;
  return {
    addQueryPrefix: typeof t.addQueryPrefix == "boolean" ? t.addQueryPrefix : zt.addQueryPrefix,
    allowDots: s,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : zt.allowEmptyArrays,
    arrayFormat: o,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : zt.charsetSentinel,
    commaRoundTrip: t.commaRoundTrip,
    delimiter: typeof t.delimiter > "u" ? zt.delimiter : t.delimiter,
    encode: typeof t.encode == "boolean" ? t.encode : zt.encode,
    encodeDotInKeys: typeof t.encodeDotInKeys == "boolean" ? t.encodeDotInKeys : zt.encodeDotInKeys,
    encoder: typeof t.encoder == "function" ? t.encoder : zt.encoder,
    encodeValuesOnly: typeof t.encodeValuesOnly == "boolean" ? t.encodeValuesOnly : zt.encodeValuesOnly,
    filter: a,
    format: r,
    formatter: i,
    serializeDate: typeof t.serializeDate == "function" ? t.serializeDate : zt.serializeDate,
    skipNulls: typeof t.skipNulls == "boolean" ? t.skipNulls : zt.skipNulls,
    sort: typeof t.sort == "function" ? t.sort : null,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : zt.strictNullHandling
  };
}, fae = function(e, t) {
  var n = e, r = uae(t), i, a;
  typeof r.filter == "function" ? (a = r.filter, n = a("", n)) : gr(r.filter) && (a = r.filter, i = a);
  var o = [];
  if (typeof n != "object" || n === null)
    return "";
  var s = aC[r.arrayFormat], c = s === "comma" && r.commaRoundTrip;
  i || (i = Object.keys(n)), r.sort && i.sort(r.sort);
  for (var l = iC(), u = 0; u < i.length; ++u) {
    var f = i[u];
    r.skipNulls && n[f] === null || oC(o, cae(
      n[f],
      f,
      s,
      c,
      r.allowEmptyArrays,
      r.strictNullHandling,
      r.skipNulls,
      r.encodeDotInKeys,
      r.encode ? r.encoder : null,
      r.filter,
      r.sort,
      r.allowDots,
      r.serializeDate,
      r.format,
      r.formatter,
      r.encodeValuesOnly,
      r.charset,
      l
    ));
  }
  var d = o.join(r.delimiter), p = r.addQueryPrefix === !0 ? "?" : "";
  return r.charsetSentinel && (r.charset === "iso-8859-1" ? p += "utf8=%26%2310003%3B&" : p += "utf8=%E2%9C%93&"), d.length > 0 ? p + d : "";
}, Ka = rC, Wh = Object.prototype.hasOwnProperty, dae = Array.isArray, Tt = {
  allowDots: !1,
  allowEmptyArrays: !1,
  allowPrototypes: !1,
  allowSparse: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decodeDotInKeys: !1,
  decoder: Ka.decode,
  delimiter: "&",
  depth: 5,
  duplicates: "combine",
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictDepth: !1,
  strictNullHandling: !1
}, pae = function(e) {
  return e.replace(/&#(\d+);/g, function(t, n) {
    return String.fromCharCode(parseInt(n, 10));
  });
}, sC = function(e, t) {
  return e && typeof e == "string" && t.comma && e.indexOf(",") > -1 ? e.split(",") : e;
}, hae = "utf8=%26%2310003%3B", mae = "utf8=%E2%9C%93", vae = function(t, n) {
  var r = { __proto__: null }, i = n.ignoreQueryPrefix ? t.replace(/^\?/, "") : t;
  i = i.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
  var a = n.parameterLimit === 1 / 0 ? void 0 : n.parameterLimit, o = i.split(n.delimiter, a), s = -1, c, l = n.charset;
  if (n.charsetSentinel)
    for (c = 0; c < o.length; ++c)
      o[c].indexOf("utf8=") === 0 && (o[c] === mae ? l = "utf-8" : o[c] === hae && (l = "iso-8859-1"), s = c, c = o.length);
  for (c = 0; c < o.length; ++c)
    if (c !== s) {
      var u = o[c], f = u.indexOf("]="), d = f === -1 ? u.indexOf("=") : f + 1, p, m;
      d === -1 ? (p = n.decoder(u, Tt.decoder, l, "key"), m = n.strictNullHandling ? null : "") : (p = n.decoder(u.slice(0, d), Tt.decoder, l, "key"), m = Ka.maybeMap(
        sC(u.slice(d + 1), n),
        function(y) {
          return n.decoder(y, Tt.decoder, l, "value");
        }
      )), m && n.interpretNumericEntities && l === "iso-8859-1" && (m = pae(m)), u.indexOf("[]=") > -1 && (m = dae(m) ? [m] : m);
      var h = Wh.call(r, p);
      h && n.duplicates === "combine" ? r[p] = Ka.combine(r[p], m) : (!h || n.duplicates === "last") && (r[p] = m);
    }
  return r;
}, yae = function(e, t, n, r) {
  for (var i = r ? t : sC(t, n), a = e.length - 1; a >= 0; --a) {
    var o, s = e[a];
    if (s === "[]" && n.parseArrays)
      o = n.allowEmptyArrays && (i === "" || n.strictNullHandling && i === null) ? [] : [].concat(i);
    else {
      o = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var c = s.charAt(0) === "[" && s.charAt(s.length - 1) === "]" ? s.slice(1, -1) : s, l = n.decodeDotInKeys ? c.replace(/%2E/g, ".") : c, u = parseInt(l, 10);
      !n.parseArrays && l === "" ? o = { 0: i } : !isNaN(u) && s !== l && String(u) === l && u >= 0 && n.parseArrays && u <= n.arrayLimit ? (o = [], o[u] = i) : l !== "__proto__" && (o[l] = i);
    }
    i = o;
  }
  return i;
}, gae = function(t, n, r, i) {
  if (t) {
    var a = r.allowDots ? t.replace(/\.([^.[]+)/g, "[$1]") : t, o = /(\[[^[\]]*])/, s = /(\[[^[\]]*])/g, c = r.depth > 0 && o.exec(a), l = c ? a.slice(0, c.index) : a, u = [];
    if (l) {
      if (!r.plainObjects && Wh.call(Object.prototype, l) && !r.allowPrototypes)
        return;
      u.push(l);
    }
    for (var f = 0; r.depth > 0 && (c = s.exec(a)) !== null && f < r.depth; ) {
      if (f += 1, !r.plainObjects && Wh.call(Object.prototype, c[1].slice(1, -1)) && !r.allowPrototypes)
        return;
      u.push(c[1]);
    }
    if (c) {
      if (r.strictDepth === !0)
        throw new RangeError("Input depth exceeded depth option of " + r.depth + " and strictDepth is true");
      u.push("[" + a.slice(c.index) + "]");
    }
    return yae(u, n, r, i);
  }
}, bae = function(t) {
  if (!t)
    return Tt;
  if (typeof t.allowEmptyArrays < "u" && typeof t.allowEmptyArrays != "boolean")
    throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
  if (typeof t.decodeDotInKeys < "u" && typeof t.decodeDotInKeys != "boolean")
    throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
  if (t.decoder !== null && typeof t.decoder < "u" && typeof t.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof t.charset < "u" && t.charset !== "utf-8" && t.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var n = typeof t.charset > "u" ? Tt.charset : t.charset, r = typeof t.duplicates > "u" ? Tt.duplicates : t.duplicates;
  if (r !== "combine" && r !== "first" && r !== "last")
    throw new TypeError("The duplicates option must be either combine, first, or last");
  var i = typeof t.allowDots > "u" ? t.decodeDotInKeys === !0 ? !0 : Tt.allowDots : !!t.allowDots;
  return {
    allowDots: i,
    allowEmptyArrays: typeof t.allowEmptyArrays == "boolean" ? !!t.allowEmptyArrays : Tt.allowEmptyArrays,
    allowPrototypes: typeof t.allowPrototypes == "boolean" ? t.allowPrototypes : Tt.allowPrototypes,
    allowSparse: typeof t.allowSparse == "boolean" ? t.allowSparse : Tt.allowSparse,
    arrayLimit: typeof t.arrayLimit == "number" ? t.arrayLimit : Tt.arrayLimit,
    charset: n,
    charsetSentinel: typeof t.charsetSentinel == "boolean" ? t.charsetSentinel : Tt.charsetSentinel,
    comma: typeof t.comma == "boolean" ? t.comma : Tt.comma,
    decodeDotInKeys: typeof t.decodeDotInKeys == "boolean" ? t.decodeDotInKeys : Tt.decodeDotInKeys,
    decoder: typeof t.decoder == "function" ? t.decoder : Tt.decoder,
    delimiter: typeof t.delimiter == "string" || Ka.isRegExp(t.delimiter) ? t.delimiter : Tt.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof t.depth == "number" || t.depth === !1 ? +t.depth : Tt.depth,
    duplicates: r,
    ignoreQueryPrefix: t.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof t.interpretNumericEntities == "boolean" ? t.interpretNumericEntities : Tt.interpretNumericEntities,
    parameterLimit: typeof t.parameterLimit == "number" ? t.parameterLimit : Tt.parameterLimit,
    parseArrays: t.parseArrays !== !1,
    plainObjects: typeof t.plainObjects == "boolean" ? t.plainObjects : Tt.plainObjects,
    strictDepth: typeof t.strictDepth == "boolean" ? !!t.strictDepth : Tt.strictDepth,
    strictNullHandling: typeof t.strictNullHandling == "boolean" ? t.strictNullHandling : Tt.strictNullHandling
  };
}, xae = function(e, t) {
  var n = bae(t);
  if (e === "" || e === null || typeof e > "u")
    return n.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var r = typeof e == "string" ? vae(e, n) : e, i = n.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, a = Object.keys(r), o = 0; o < a.length; ++o) {
    var s = a[o], c = gae(s, r[s], n, typeof e == "string");
    i = Ka.merge(i, c, n);
  }
  return n.allowSparse === !0 ? i : Ka.compact(i);
}, wae = fae, Sae = xae, _ae = yy, Eae = {
  formats: _ae,
  parse: Sae,
  stringify: wae
};
const Tae = /* @__PURE__ */ Ke(Eae);
var Zh = { exports: {} };
/** @license
 * eventsource.js
 * Available under MIT License (MIT)
 * https://github.com/Yaffle/EventSource/
 */
(function(e, t) {
  (function(n) {
    var r = n.setTimeout, i = n.clearTimeout, a = n.XMLHttpRequest, o = n.XDomainRequest, s = n.ActiveXObject, c = n.EventSource, l = n.document, u = n.Promise, f = n.fetch, d = n.Response, p = n.TextDecoder, m = n.TextEncoder, h = n.AbortController;
    if (typeof window < "u" && typeof l < "u" && !("readyState" in l) && l.body == null && (l.readyState = "loading", window.addEventListener("load", function(I) {
      l.readyState = "complete";
    }, !1)), a == null && s != null && (a = function() {
      return new s("Microsoft.XMLHTTP");
    }), Object.create == null && (Object.create = function(I) {
      function Y() {
      }
      return Y.prototype = I, new Y();
    }), Date.now || (Date.now = function() {
      return (/* @__PURE__ */ new Date()).getTime();
    }), h == null) {
      var y = f;
      f = function(I, Y) {
        var re = Y.signal;
        return y(I, { headers: Y.headers, credentials: Y.credentials, cache: Y.cache }).then(function(Q) {
          var Ee = Q.body.getReader();
          return re._reader = Ee, re._aborted && re._reader.cancel(), {
            status: Q.status,
            statusText: Q.statusText,
            headers: Q.headers,
            body: {
              getReader: function() {
                return Ee;
              }
            }
          };
        });
      }, h = function() {
        this.signal = {
          _reader: null,
          _aborted: !1
        }, this.abort = function() {
          this.signal._reader != null && this.signal._reader.cancel(), this.signal._aborted = !0;
        };
      };
    }
    function v() {
      this.bitsNeeded = 0, this.codePoint = 0;
    }
    v.prototype.decode = function(I) {
      function Y(Me, U, P) {
        if (P === 1)
          return Me >= 128 >> U && Me << U <= 2047;
        if (P === 2)
          return Me >= 2048 >> U && Me << U <= 55295 || Me >= 57344 >> U && Me << U <= 65535;
        if (P === 3)
          return Me >= 65536 >> U && Me << U <= 1114111;
        throw new Error();
      }
      function re(Me, U) {
        if (Me === 6 * 1)
          return U >> 6 > 15 ? 3 : U > 31 ? 2 : 1;
        if (Me === 6 * 2)
          return U > 15 ? 3 : 2;
        if (Me === 6 * 3)
          return 3;
        throw new Error();
      }
      for (var Q = 65533, Ee = "", xe = this.bitsNeeded, Re = this.codePoint, Ve = 0; Ve < I.length; Ve += 1) {
        var Ie = I[Ve];
        xe !== 0 && (Ie < 128 || Ie > 191 || !Y(Re << 6 | Ie & 63, xe - 6, re(xe, Re))) && (xe = 0, Re = Q, Ee += String.fromCharCode(Re)), xe === 0 ? (Ie >= 0 && Ie <= 127 ? (xe = 0, Re = Ie) : Ie >= 192 && Ie <= 223 ? (xe = 6 * 1, Re = Ie & 31) : Ie >= 224 && Ie <= 239 ? (xe = 6 * 2, Re = Ie & 15) : Ie >= 240 && Ie <= 247 ? (xe = 6 * 3, Re = Ie & 7) : (xe = 0, Re = Q), xe !== 0 && !Y(Re, xe, re(xe, Re)) && (xe = 0, Re = Q)) : (xe -= 6, Re = Re << 6 | Ie & 63), xe === 0 && (Re <= 65535 ? Ee += String.fromCharCode(Re) : (Ee += String.fromCharCode(55296 + (Re - 65535 - 1 >> 10)), Ee += String.fromCharCode(56320 + (Re - 65535 - 1 & 1023))));
      }
      return this.bitsNeeded = xe, this.codePoint = Re, Ee;
    };
    var g = function() {
      try {
        return new p().decode(new m().encode("test"), { stream: !0 }) === "test";
      } catch (I) {
        console.debug("TextDecoder does not support streaming option. Using polyfill instead: " + I);
      }
      return !1;
    };
    (p == null || m == null || !g()) && (p = v);
    var b = function() {
    };
    function T(I) {
      this.withCredentials = !1, this.readyState = 0, this.status = 0, this.statusText = "", this.responseText = "", this.onprogress = b, this.onload = b, this.onerror = b, this.onreadystatechange = b, this._contentType = "", this._xhr = I, this._sendTimeout = 0, this._abort = b;
    }
    T.prototype.open = function(I, Y) {
      this._abort(!0);
      var re = this, Q = this._xhr, Ee = 1, xe = 0;
      this._abort = function(P) {
        re._sendTimeout !== 0 && (i(re._sendTimeout), re._sendTimeout = 0), (Ee === 1 || Ee === 2 || Ee === 3) && (Ee = 4, Q.onload = b, Q.onerror = b, Q.onabort = b, Q.onprogress = b, Q.onreadystatechange = b, Q.abort(), xe !== 0 && (i(xe), xe = 0), P || (re.readyState = 4, re.onabort(null), re.onreadystatechange())), Ee = 0;
      };
      var Re = function() {
        if (Ee === 1) {
          var P = 0, J = "", ce = void 0;
          if ("contentType" in Q)
            P = 200, J = "OK", ce = Q.contentType;
          else
            try {
              P = Q.status, J = Q.statusText, ce = Q.getResponseHeader("Content-Type");
            } catch {
              P = 0, J = "", ce = void 0;
            }
          P !== 0 && (Ee = 2, re.readyState = 2, re.status = P, re.statusText = J, re._contentType = ce, re.onreadystatechange());
        }
      }, Ve = function() {
        if (Re(), Ee === 2 || Ee === 3) {
          Ee = 3;
          var P = "";
          try {
            P = Q.responseText;
          } catch {
          }
          re.readyState = 3, re.responseText = P, re.onprogress();
        }
      }, Ie = function(P, J) {
        if ((J == null || J.preventDefault == null) && (J = {
          preventDefault: b
        }), Ve(), Ee === 1 || Ee === 2 || Ee === 3) {
          if (Ee = 4, xe !== 0 && (i(xe), xe = 0), re.readyState = 4, P === "load")
            re.onload(J);
          else if (P === "error")
            re.onerror(J);
          else if (P === "abort")
            re.onabort(J);
          else
            throw new TypeError();
          re.onreadystatechange();
        }
      }, Me = function(P) {
        Q != null && (Q.readyState === 4 ? (!("onload" in Q) || !("onerror" in Q) || !("onabort" in Q)) && Ie(Q.responseText === "" ? "error" : "load", P) : Q.readyState === 3 ? "onprogress" in Q || Ve() : Q.readyState === 2 && Re());
      }, U = function() {
        xe = r(function() {
          U();
        }, 500), Q.readyState === 3 && Ve();
      };
      "onload" in Q && (Q.onload = function(P) {
        Ie("load", P);
      }), "onerror" in Q && (Q.onerror = function(P) {
        Ie("error", P);
      }), "onabort" in Q && (Q.onabort = function(P) {
        Ie("abort", P);
      }), "onprogress" in Q && (Q.onprogress = Ve), "onreadystatechange" in Q && (Q.onreadystatechange = function(P) {
        Me(P);
      }), ("contentType" in Q || !("ontimeout" in a.prototype)) && (Y += (Y.indexOf("?") === -1 ? "?" : "&") + "padding=true"), Q.open(I, Y, !0), "readyState" in Q && (xe = r(function() {
        U();
      }, 0));
    }, T.prototype.abort = function() {
      this._abort(!1);
    }, T.prototype.getResponseHeader = function(I) {
      return this._contentType;
    }, T.prototype.setRequestHeader = function(I, Y) {
      var re = this._xhr;
      "setRequestHeader" in re && re.setRequestHeader(I, Y);
    }, T.prototype.getAllResponseHeaders = function() {
      return this._xhr.getAllResponseHeaders != null && this._xhr.getAllResponseHeaders() || "";
    }, T.prototype.send = function() {
      if ((!("ontimeout" in a.prototype) || !("sendAsBinary" in a.prototype) && !("mozAnon" in a.prototype)) && l != null && l.readyState != null && l.readyState !== "complete") {
        var I = this;
        I._sendTimeout = r(function() {
          I._sendTimeout = 0, I.send();
        }, 4);
        return;
      }
      var Y = this._xhr;
      "withCredentials" in Y && (Y.withCredentials = this.withCredentials);
      try {
        Y.send(void 0);
      } catch (re) {
        throw re;
      }
    };
    function S(I) {
      return I.replace(/[A-Z]/g, function(Y) {
        return String.fromCharCode(Y.charCodeAt(0) + 32);
      });
    }
    function E(I) {
      for (var Y = /* @__PURE__ */ Object.create(null), re = I.split(`\r
`), Q = 0; Q < re.length; Q += 1) {
        var Ee = re[Q], xe = Ee.split(": "), Re = xe.shift(), Ve = xe.join(": ");
        Y[S(Re)] = Ve;
      }
      this._map = Y;
    }
    E.prototype.get = function(I) {
      return this._map[S(I)];
    }, a != null && a.HEADERS_RECEIVED == null && (a.HEADERS_RECEIVED = 2);
    function O() {
    }
    O.prototype.open = function(I, Y, re, Q, Ee, xe, Re) {
      I.open("GET", Ee);
      var Ve = 0;
      I.onprogress = function() {
        var Me = I.responseText, U = Me.slice(Ve);
        Ve += U.length, re(U);
      }, I.onerror = function(Me) {
        Me.preventDefault(), Q(new Error("NetworkError"));
      }, I.onload = function() {
        Q(null);
      }, I.onabort = function() {
        Q(null);
      }, I.onreadystatechange = function() {
        if (I.readyState === a.HEADERS_RECEIVED) {
          var Me = I.status, U = I.statusText, P = I.getResponseHeader("Content-Type"), J = I.getAllResponseHeaders();
          Y(Me, U, P, new E(J));
        }
      }, I.withCredentials = xe;
      for (var Ie in Re)
        Object.prototype.hasOwnProperty.call(Re, Ie) && I.setRequestHeader(Ie, Re[Ie]);
      return I.send(), I;
    };
    function j(I) {
      this._headers = I;
    }
    j.prototype.get = function(I) {
      return this._headers.get(I);
    };
    function D() {
    }
    D.prototype.open = function(I, Y, re, Q, Ee, xe, Re) {
      var Ve = null, Ie = new h(), Me = Ie.signal, U = new p();
      return f(Ee, {
        headers: Re,
        credentials: xe ? "include" : "same-origin",
        signal: Me,
        cache: "no-store"
      }).then(function(P) {
        return Ve = P.body.getReader(), Y(P.status, P.statusText, P.headers.get("Content-Type"), new j(P.headers)), new u(function(J, ce) {
          var _e = function() {
            Ve.read().then(function(ke) {
              if (ke.done)
                J(void 0);
              else {
                var Ge = U.decode(ke.value, { stream: !0 });
                re(Ge), _e();
              }
            }).catch(function(ke) {
              ce(ke);
            });
          };
          _e();
        });
      }).catch(function(P) {
        if (P.name !== "AbortError")
          return P;
      }).then(function(P) {
        Q(P);
      }), {
        abort: function() {
          Ve != null && Ve.cancel(), Ie.abort();
        }
      };
    };
    function k() {
      this._listeners = /* @__PURE__ */ Object.create(null);
    }
    function A(I) {
      r(function() {
        throw I;
      }, 0);
    }
    k.prototype.dispatchEvent = function(I) {
      I.target = this;
      var Y = this._listeners[I.type];
      if (Y != null)
        for (var re = Y.length, Q = 0; Q < re; Q += 1) {
          var Ee = Y[Q];
          try {
            typeof Ee.handleEvent == "function" ? Ee.handleEvent(I) : Ee.call(this, I);
          } catch (xe) {
            A(xe);
          }
        }
    }, k.prototype.addEventListener = function(I, Y) {
      I = String(I);
      var re = this._listeners, Q = re[I];
      Q == null && (Q = [], re[I] = Q);
      for (var Ee = !1, xe = 0; xe < Q.length; xe += 1)
        Q[xe] === Y && (Ee = !0);
      Ee || Q.push(Y);
    }, k.prototype.removeEventListener = function(I, Y) {
      I = String(I);
      var re = this._listeners, Q = re[I];
      if (Q != null) {
        for (var Ee = [], xe = 0; xe < Q.length; xe += 1)
          Q[xe] !== Y && Ee.push(Q[xe]);
        Ee.length === 0 ? delete re[I] : re[I] = Ee;
      }
    };
    function V(I) {
      this.type = I, this.target = void 0;
    }
    function $(I, Y) {
      V.call(this, I), this.data = Y.data, this.lastEventId = Y.lastEventId;
    }
    $.prototype = Object.create(V.prototype);
    function L(I, Y) {
      V.call(this, I), this.status = Y.status, this.statusText = Y.statusText, this.headers = Y.headers;
    }
    L.prototype = Object.create(V.prototype);
    function M(I, Y) {
      V.call(this, I), this.error = Y.error;
    }
    M.prototype = Object.create(V.prototype);
    var F = -1, q = 0, B = 1, N = 2, x = -1, z = 0, Z = 1, _ = 2, G = 3, ae = /^text\/event\-stream(;.*)?$/i, te = 1e3, se = 18e6, de = function(I, Y) {
      var re = I == null ? Y : parseInt(I, 10);
      return re !== re && (re = Y), pe(re);
    }, pe = function(I) {
      return Math.min(Math.max(I, te), se);
    }, le = function(I, Y, re) {
      try {
        typeof Y == "function" && Y.call(I, re);
      } catch (Q) {
        A(Q);
      }
    };
    function X(I, Y) {
      k.call(this), Y = Y || {}, this.onopen = void 0, this.onmessage = void 0, this.onerror = void 0, this.url = void 0, this.readyState = void 0, this.withCredentials = void 0, this.headers = void 0, this._close = void 0, me(this, I, Y);
    }
    function W() {
      return a != null && "withCredentials" in a.prototype || o == null ? new a() : new o();
    }
    var fe = f != null && d != null && "body" in d.prototype;
    function me(I, Y, re) {
      Y = String(Y);
      var Q = !!re.withCredentials, Ee = re.lastEventIdQueryParameterName || "lastEventId", xe = pe(1e3), Re = de(re.heartbeatTimeout, 45e3), Ve = "", Ie = xe, Me = !1, U = 0, P = re.headers || {}, J = re.Transport, ce = fe && J == null ? void 0 : new T(J != null ? new J() : W()), _e = J != null && typeof J != "string" ? new J() : ce == null ? new D() : new O(), ke = void 0, Ge = 0, at = F, Lt = "", Ct = "", He = "", Rt = "", Ye = z, mn = 0, En = 0, Wn = function(ft, wt, Ft, Bt) {
        if (at === q)
          if (ft === 200 && Ft != null && ae.test(Ft)) {
            at = B, Me = Date.now(), Ie = xe, I.readyState = B;
            var Jt = new L("open", {
              status: ft,
              statusText: wt,
              headers: Bt
            });
            I.dispatchEvent(Jt), le(I, I.onopen, Jt);
          } else {
            var Ut = "";
            ft !== 200 ? (wt && (wt = wt.replace(/\s+/g, " ")), Ut = "EventSource's response has a status " + ft + " " + wt + " that is not 200. Aborting the connection.") : Ut = "EventSource's response has a Content-Type specifying an unsupported type: " + (Ft == null ? "-" : Ft.replace(/\s+/g, " ")) + ". Aborting the connection.", Zn();
            var Jt = new L("error", {
              status: ft,
              statusText: wt,
              headers: Bt
            });
            I.dispatchEvent(Jt), le(I, I.onerror, Jt), console.error(Ut);
          }
      }, Nr = function(ft) {
        if (at === B) {
          for (var wt = -1, Ft = 0; Ft < ft.length; Ft += 1) {
            var Bt = ft.charCodeAt(Ft);
            (Bt === 10 || Bt === 13) && (wt = Ft);
          }
          var Jt = (wt !== -1 ? Rt : "") + ft.slice(0, wt + 1);
          Rt = (wt === -1 ? Rt : "") + ft.slice(wt + 1), ft !== "" && (Me = Date.now(), U += ft.length);
          for (var Ut = 0; Ut < Jt.length; Ut += 1) {
            var Bt = Jt.charCodeAt(Ut);
            if (Ye === x && Bt === 10)
              Ye = z;
            else if (Ye === x && (Ye = z), Bt === 13 || Bt === 10) {
              if (Ye !== z) {
                Ye === Z && (En = Ut + 1);
                var Nn = Jt.slice(mn, En - 1), Dn = Jt.slice(En + (En < Ut && Jt.charCodeAt(En) === 32 ? 1 : 0), Ut);
                Nn === "data" ? (Lt += `
`, Lt += Dn) : Nn === "id" ? Ct = Dn : Nn === "event" ? He = Dn : Nn === "retry" ? (xe = de(Dn, xe), Ie = xe) : Nn === "heartbeatTimeout" && (Re = de(Dn, Re), Ge !== 0 && (i(Ge), Ge = r(function() {
                  Dr();
                }, Re)));
              }
              if (Ye === z) {
                if (Lt !== "") {
                  Ve = Ct, He === "" && (He = "message");
                  var Xr = new $(He, {
                    data: Lt.slice(1),
                    lastEventId: Ct
                  });
                  if (I.dispatchEvent(Xr), He === "open" ? le(I, I.onopen, Xr) : He === "message" ? le(I, I.onmessage, Xr) : He === "error" && le(I, I.onerror, Xr), at === N)
                    return;
                }
                Lt = "", He = "";
              }
              Ye = Bt === 13 ? x : z;
            } else
              Ye === z && (mn = Ut, Ye = Z), Ye === Z ? Bt === 58 && (En = Ut + 1, Ye = _) : Ye === _ && (Ye = G);
          }
        }
      }, ur = function(ft) {
        if (at === B || at === q) {
          at = F, Ge !== 0 && (i(Ge), Ge = 0), Ge = r(function() {
            Dr();
          }, Ie), Ie = pe(Math.min(xe * 16, Ie * 2)), I.readyState = q;
          var wt = new M("error", { error: ft });
          I.dispatchEvent(wt), le(I, I.onerror, wt), ft != null && console.error(ft);
        }
      }, Zn = function() {
        at = N, ke != null && (ke.abort(), ke = void 0), Ge !== 0 && (i(Ge), Ge = 0), I.readyState = N;
      }, Dr = function() {
        if (Ge = 0, at !== F) {
          if (!Me && ke != null)
            ur(new Error("No activity within " + Re + " milliseconds. " + (at === q ? "No response received." : U + " chars received.") + " Reconnecting.")), ke != null && (ke.abort(), ke = void 0);
          else {
            var ft = Math.max((Me || Date.now()) + Re - Date.now(), 1);
            Me = !1, Ge = r(function() {
              Dr();
            }, ft);
          }
          return;
        }
        Me = !1, U = 0, Ge = r(function() {
          Dr();
        }, Re), at = q, Lt = "", He = "", Ct = Ve, Rt = "", mn = 0, En = 0, Ye = z;
        var wt = Y;
        if (Y.slice(0, 5) !== "data:" && Y.slice(0, 5) !== "blob:" && Ve !== "") {
          var Ft = Y.indexOf("?");
          wt = Ft === -1 ? Y : Y.slice(0, Ft + 1) + Y.slice(Ft + 1).replace(/(?:^|&)([^=&]*)(?:=[^&]*)?/g, function(Dn, Xr) {
            return Xr === Ee ? "" : Dn;
          }), wt += (Y.indexOf("?") === -1 ? "?" : "&") + Ee + "=" + encodeURIComponent(Ve);
        }
        var Bt = I.withCredentials, Jt = {};
        Jt.Accept = "text/event-stream";
        var Ut = I.headers;
        if (Ut != null)
          for (var Nn in Ut)
            Object.prototype.hasOwnProperty.call(Ut, Nn) && (Jt[Nn] = Ut[Nn]);
        try {
          ke = _e.open(ce, Wn, Nr, ur, wt, Bt, Jt);
        } catch (Dn) {
          throw Zn(), Dn;
        }
      };
      I.url = Y, I.readyState = q, I.withCredentials = Q, I.headers = P, I._close = Zn, Dr();
    }
    X.prototype = Object.create(k.prototype), X.prototype.CONNECTING = q, X.prototype.OPEN = B, X.prototype.CLOSED = N, X.prototype.close = function() {
      this._close();
    }, X.CONNECTING = q, X.OPEN = B, X.CLOSED = N, X.prototype.withCredentials = void 0;
    var Oe = c;
    a != null && (c == null || !("withCredentials" in c.prototype)) && (Oe = X), function(I) {
      {
        var Y = I(t);
        Y !== void 0 && (e.exports = Y);
      }
    }(function(I) {
      I.EventSourcePolyfill = X, I.NativeEventSource = c, I.EventSource = Oe;
    });
  })(typeof globalThis > "u" ? typeof window < "u" ? window : typeof self < "u" ? self : pt : globalThis);
})(Zh, Zh.exports);
var kae = Zh.exports;
const Oae = /* @__PURE__ */ Ke(kae);
var Qe;
(function(e) {
  e.assertEqual = (i) => i;
  function t(i) {
  }
  e.assertIs = t;
  function n(i) {
    throw new Error();
  }
  e.assertNever = n, e.arrayToEnum = (i) => {
    const a = {};
    for (const o of i)
      a[o] = o;
    return a;
  }, e.getValidEnumValues = (i) => {
    const a = e.objectKeys(i).filter((s) => typeof i[i[s]] != "number"), o = {};
    for (const s of a)
      o[s] = i[s];
    return e.objectValues(o);
  }, e.objectValues = (i) => e.objectKeys(i).map(function(a) {
    return i[a];
  }), e.objectKeys = typeof Object.keys == "function" ? (i) => Object.keys(i) : (i) => {
    const a = [];
    for (const o in i)
      Object.prototype.hasOwnProperty.call(i, o) && a.push(o);
    return a;
  }, e.find = (i, a) => {
    for (const o of i)
      if (a(o))
        return o;
  }, e.isInteger = typeof Number.isInteger == "function" ? (i) => Number.isInteger(i) : (i) => typeof i == "number" && isFinite(i) && Math.floor(i) === i;
  function r(i, a = " | ") {
    return i.map((o) => typeof o == "string" ? `'${o}'` : o).join(a);
  }
  e.joinValues = r, e.jsonStringifyReplacer = (i, a) => typeof a == "bigint" ? a.toString() : a;
})(Qe || (Qe = {}));
var Kh;
(function(e) {
  e.mergeShapes = (t, n) => ({
    ...t,
    ...n
    // second overwrites first
  });
})(Kh || (Kh = {}));
const ge = Qe.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), si = (e) => {
  switch (typeof e) {
    case "undefined":
      return ge.undefined;
    case "string":
      return ge.string;
    case "number":
      return isNaN(e) ? ge.nan : ge.number;
    case "boolean":
      return ge.boolean;
    case "function":
      return ge.function;
    case "bigint":
      return ge.bigint;
    case "symbol":
      return ge.symbol;
    case "object":
      return Array.isArray(e) ? ge.array : e === null ? ge.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? ge.promise : typeof Map < "u" && e instanceof Map ? ge.map : typeof Set < "u" && e instanceof Set ? ge.set : typeof Date < "u" && e instanceof Date ? ge.date : ge.object;
    default:
      return ge.unknown;
  }
}, ne = Qe.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), Cae = (e) => JSON.stringify(e, null, 2).replace(/"([^"]+)":/g, "$1:");
class $n extends Error {
  constructor(t) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = t;
  }
  get errors() {
    return this.issues;
  }
  format(t) {
    const n = t || function(a) {
      return a.message;
    }, r = { _errors: [] }, i = (a) => {
      for (const o of a.issues)
        if (o.code === "invalid_union")
          o.unionErrors.map(i);
        else if (o.code === "invalid_return_type")
          i(o.returnTypeError);
        else if (o.code === "invalid_arguments")
          i(o.argumentsError);
        else if (o.path.length === 0)
          r._errors.push(n(o));
        else {
          let s = r, c = 0;
          for (; c < o.path.length; ) {
            const l = o.path[c];
            c === o.path.length - 1 ? (s[l] = s[l] || { _errors: [] }, s[l]._errors.push(n(o))) : s[l] = s[l] || { _errors: [] }, s = s[l], c++;
          }
        }
    };
    return i(this), r;
  }
  static assert(t) {
    if (!(t instanceof $n))
      throw new Error(`Not a ZodError: ${t}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, Qe.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(t = (n) => n.message) {
    const n = {}, r = [];
    for (const i of this.issues)
      i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
$n.create = (e) => new $n(e);
const Ga = (e, t) => {
  let n;
  switch (e.code) {
    case ne.invalid_type:
      e.received === ge.undefined ? n = "Required" : n = `Expected ${e.expected}, received ${e.received}`;
      break;
    case ne.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(e.expected, Qe.jsonStringifyReplacer)}`;
      break;
    case ne.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${Qe.joinValues(e.keys, ", ")}`;
      break;
    case ne.invalid_union:
      n = "Invalid input";
      break;
    case ne.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${Qe.joinValues(e.options)}`;
      break;
    case ne.invalid_enum_value:
      n = `Invalid enum value. Expected ${Qe.joinValues(e.options)}, received '${e.received}'`;
      break;
    case ne.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case ne.invalid_return_type:
      n = "Invalid function return type";
      break;
    case ne.invalid_date:
      n = "Invalid date";
      break;
    case ne.invalid_string:
      typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : Qe.assertNever(e.validation) : e.validation !== "regex" ? n = `Invalid ${e.validation}` : n = "Invalid";
      break;
    case ne.too_small:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : n = "Invalid input";
      break;
    case ne.too_big:
      e.type === "array" ? n = `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? n = `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? n = `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? n = `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? n = `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : n = "Invalid input";
      break;
    case ne.custom:
      n = "Invalid input";
      break;
    case ne.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case ne.not_multiple_of:
      n = `Number must be a multiple of ${e.multipleOf}`;
      break;
    case ne.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = t.defaultError, Qe.assertNever(e);
  }
  return { message: n };
};
let lC = Ga;
function Rae(e) {
  lC = e;
}
function lu() {
  return lC;
}
const cu = (e) => {
  const { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
    ...i,
    path: a
  };
  if (i.message !== void 0)
    return {
      ...i,
      path: a,
      message: i.message
    };
  let s = "";
  const c = r.filter((l) => !!l).slice().reverse();
  for (const l of c)
    s = l(o, { data: t, defaultError: s }).message;
  return {
    ...i,
    path: a,
    message: s
  };
}, $ae = [];
function he(e, t) {
  const n = lu(), r = cu({
    issueData: t,
    data: e.data,
    path: e.path,
    errorMaps: [
      e.common.contextualErrorMap,
      e.schemaErrorMap,
      n,
      n === Ga ? void 0 : Ga
      // then global default map
    ].filter((i) => !!i)
  });
  e.common.issues.push(r);
}
class sn {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(t, n) {
    const r = [];
    for (const i of n) {
      if (i.status === "aborted")
        return Ne;
      i.status === "dirty" && t.dirty(), r.push(i.value);
    }
    return { status: t.value, value: r };
  }
  static async mergeObjectAsync(t, n) {
    const r = [];
    for (const i of n) {
      const a = await i.key, o = await i.value;
      r.push({
        key: a,
        value: o
      });
    }
    return sn.mergeObjectSync(t, r);
  }
  static mergeObjectSync(t, n) {
    const r = {};
    for (const i of n) {
      const { key: a, value: o } = i;
      if (a.status === "aborted" || o.status === "aborted")
        return Ne;
      a.status === "dirty" && t.dirty(), o.status === "dirty" && t.dirty(), a.value !== "__proto__" && (typeof o.value < "u" || i.alwaysSet) && (r[a.value] = o.value);
    }
    return { status: t.value, value: r };
  }
}
const Ne = Object.freeze({
  status: "aborted"
}), Sa = (e) => ({ status: "dirty", value: e }), hn = (e) => ({ status: "valid", value: e }), Gh = (e) => e.status === "aborted", Yh = (e) => e.status === "dirty", gs = (e) => e.status === "valid", bs = (e) => typeof Promise < "u" && e instanceof Promise;
function uu(e, t, n, r) {
  if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return t.get(e);
}
function cC(e, t, n, r, i) {
  if (typeof t == "function" ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return t.set(e, n), n;
}
var Te;
(function(e) {
  e.errToObj = (t) => typeof t == "string" ? { message: t } : t || {}, e.toString = (t) => typeof t == "string" ? t : t == null ? void 0 : t.message;
})(Te || (Te = {}));
var No, Do;
class kr {
  constructor(t, n, r, i) {
    this._cachedPath = [], this.parent = t, this.data = n, this._path = r, this._key = i;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const l1 = (e, t) => {
  if (gs(t))
    return { success: !0, data: t.value };
  if (!e.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const n = new $n(e.common.issues);
      return this._error = n, this._error;
    }
  };
};
function Be(e) {
  if (!e)
    return {};
  const { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
  if (t && (n || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return t ? { errorMap: t, description: i } : { errorMap: (o, s) => {
    var c, l;
    const { message: u } = e;
    return o.code === "invalid_enum_value" ? { message: u ?? s.defaultError } : typeof s.data > "u" ? { message: (c = u ?? r) !== null && c !== void 0 ? c : s.defaultError } : o.code !== "invalid_type" ? { message: s.defaultError } : { message: (l = u ?? n) !== null && l !== void 0 ? l : s.defaultError };
  }, description: i };
}
class ze {
  constructor(t) {
    this.spa = this.safeParseAsync, this._def = t, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(t) {
    return si(t.data);
  }
  _getOrReturnCtx(t, n) {
    return n || {
      common: t.parent.common,
      data: t.data,
      parsedType: si(t.data),
      schemaErrorMap: this._def.errorMap,
      path: t.path,
      parent: t.parent
    };
  }
  _processInputParams(t) {
    return {
      status: new sn(),
      ctx: {
        common: t.parent.common,
        data: t.data,
        parsedType: si(t.data),
        schemaErrorMap: this._def.errorMap,
        path: t.path,
        parent: t.parent
      }
    };
  }
  _parseSync(t) {
    const n = this._parse(t);
    if (bs(n))
      throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(t) {
    const n = this._parse(t);
    return Promise.resolve(n);
  }
  parse(t, n) {
    const r = this.safeParse(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(t, n) {
    var r;
    const i = {
      common: {
        issues: [],
        async: (r = n == null ? void 0 : n.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: n == null ? void 0 : n.errorMap
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: si(t)
    }, a = this._parseSync({ data: t, path: i.path, parent: i });
    return l1(i, a);
  }
  async parseAsync(t, n) {
    const r = await this.safeParseAsync(t, n);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(t, n) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: n == null ? void 0 : n.errorMap,
        async: !0
      },
      path: (n == null ? void 0 : n.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: t,
      parsedType: si(t)
    }, i = this._parse({ data: t, path: r.path, parent: r }), a = await (bs(i) ? i : Promise.resolve(i));
    return l1(r, a);
  }
  refine(t, n) {
    const r = (i) => typeof n == "string" || typeof n > "u" ? { message: n } : typeof n == "function" ? n(i) : n;
    return this._refinement((i, a) => {
      const o = t(i), s = () => a.addIssue({
        code: ne.custom,
        ...r(i)
      });
      return typeof Promise < "u" && o instanceof Promise ? o.then((c) => c ? !0 : (s(), !1)) : o ? !0 : (s(), !1);
    });
  }
  refinement(t, n) {
    return this._refinement((r, i) => t(r) ? !0 : (i.addIssue(typeof n == "function" ? n(r, i) : n), !1));
  }
  _refinement(t) {
    return new or({
      schema: this,
      typeName: Pe.ZodEffects,
      effect: { type: "refinement", refinement: t }
    });
  }
  superRefine(t) {
    return this._refinement(t);
  }
  optional() {
    return _r.create(this, this._def);
  }
  nullable() {
    return _i.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return nr.create(this, this._def);
  }
  promise() {
    return Ja.create(this, this._def);
  }
  or(t) {
    return _s.create([this, t], this._def);
  }
  and(t) {
    return Es.create(this, t, this._def);
  }
  transform(t) {
    return new or({
      ...Be(this._def),
      schema: this,
      typeName: Pe.ZodEffects,
      effect: { type: "transform", transform: t }
    });
  }
  default(t) {
    const n = typeof t == "function" ? t : () => t;
    return new Rs({
      ...Be(this._def),
      innerType: this,
      defaultValue: n,
      typeName: Pe.ZodDefault
    });
  }
  brand() {
    return new gy({
      typeName: Pe.ZodBranded,
      type: this,
      ...Be(this._def)
    });
  }
  catch(t) {
    const n = typeof t == "function" ? t : () => t;
    return new $s({
      ...Be(this._def),
      innerType: this,
      catchValue: n,
      typeName: Pe.ZodCatch
    });
  }
  describe(t) {
    const n = this.constructor;
    return new n({
      ...this._def,
      description: t
    });
  }
  pipe(t) {
    return hl.create(this, t);
  }
  readonly() {
    return Is.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const Iae = /^c[^\s-]{8,}$/i, Aae = /^[0-9a-z]+$/, Pae = /^[0-9A-HJKMNP-TV-Z]{26}$/, Nae = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Dae = /^[a-z0-9_-]{21}$/i, Mae = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, jae = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Lae = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let Tp;
const Fae = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Bae = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, Uae = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, uC = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", zae = new RegExp(`^${uC}$`);
function fC(e) {
  let t = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
  return e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision == null && (t = `${t}(\\.\\d+)?`), t;
}
function Vae(e) {
  return new RegExp(`^${fC(e)}$`);
}
function dC(e) {
  let t = `${uC}T${fC(e)}`;
  const n = [];
  return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, new RegExp(`^${t}$`);
}
function Hae(e, t) {
  return !!((t === "v4" || !t) && Fae.test(e) || (t === "v6" || !t) && Bae.test(e));
}
class Qn extends ze {
  _parse(t) {
    if (this._def.coerce && (t.data = String(t.data)), this._getType(t) !== ge.string) {
      const a = this._getOrReturnCtx(t);
      return he(a, {
        code: ne.invalid_type,
        expected: ge.string,
        received: a.parsedType
      }), Ne;
    }
    const r = new sn();
    let i;
    for (const a of this._def.checks)
      if (a.kind === "min")
        t.data.length < a.value && (i = this._getOrReturnCtx(t, i), he(i, {
          code: ne.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        t.data.length > a.value && (i = this._getOrReturnCtx(t, i), he(i, {
          code: ne.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const o = t.data.length > a.value, s = t.data.length < a.value;
        (o || s) && (i = this._getOrReturnCtx(t, i), o ? he(i, {
          code: ne.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : s && he(i, {
          code: ne.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        jae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "email",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        Tp || (Tp = new RegExp(Lae, "u")), Tp.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "emoji",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        Nae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "uuid",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "nanoid")
        Dae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "nanoid",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        Iae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "cuid",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        Aae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "cuid2",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        Pae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
          validation: "ulid",
          code: ne.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(t.data);
        } catch {
          i = this._getOrReturnCtx(t, i), he(i, {
            validation: "url",
            code: ne.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        validation: "regex",
        code: ne.invalid_string,
        message: a.message
      }), r.dirty())) : a.kind === "trim" ? t.data = t.data.trim() : a.kind === "includes" ? t.data.includes(a.value, a.position) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: { includes: a.value, position: a.position },
        message: a.message
      }), r.dirty()) : a.kind === "toLowerCase" ? t.data = t.data.toLowerCase() : a.kind === "toUpperCase" ? t.data = t.data.toUpperCase() : a.kind === "startsWith" ? t.data.startsWith(a.value) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: { startsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "endsWith" ? t.data.endsWith(a.value) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: { endsWith: a.value },
        message: a.message
      }), r.dirty()) : a.kind === "datetime" ? dC(a).test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: "datetime",
        message: a.message
      }), r.dirty()) : a.kind === "date" ? zae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: "date",
        message: a.message
      }), r.dirty()) : a.kind === "time" ? Vae(a).test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.invalid_string,
        validation: "time",
        message: a.message
      }), r.dirty()) : a.kind === "duration" ? Mae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        validation: "duration",
        code: ne.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "ip" ? Hae(t.data, a.version) || (i = this._getOrReturnCtx(t, i), he(i, {
        validation: "ip",
        code: ne.invalid_string,
        message: a.message
      }), r.dirty()) : a.kind === "base64" ? Uae.test(t.data) || (i = this._getOrReturnCtx(t, i), he(i, {
        validation: "base64",
        code: ne.invalid_string,
        message: a.message
      }), r.dirty()) : Qe.assertNever(a);
    return { status: r.value, value: t.data };
  }
  _regex(t, n, r) {
    return this.refinement((i) => t.test(i), {
      validation: n,
      code: ne.invalid_string,
      ...Te.errToObj(r)
    });
  }
  _addCheck(t) {
    return new Qn({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  email(t) {
    return this._addCheck({ kind: "email", ...Te.errToObj(t) });
  }
  url(t) {
    return this._addCheck({ kind: "url", ...Te.errToObj(t) });
  }
  emoji(t) {
    return this._addCheck({ kind: "emoji", ...Te.errToObj(t) });
  }
  uuid(t) {
    return this._addCheck({ kind: "uuid", ...Te.errToObj(t) });
  }
  nanoid(t) {
    return this._addCheck({ kind: "nanoid", ...Te.errToObj(t) });
  }
  cuid(t) {
    return this._addCheck({ kind: "cuid", ...Te.errToObj(t) });
  }
  cuid2(t) {
    return this._addCheck({ kind: "cuid2", ...Te.errToObj(t) });
  }
  ulid(t) {
    return this._addCheck({ kind: "ulid", ...Te.errToObj(t) });
  }
  base64(t) {
    return this._addCheck({ kind: "base64", ...Te.errToObj(t) });
  }
  ip(t) {
    return this._addCheck({ kind: "ip", ...Te.errToObj(t) });
  }
  datetime(t) {
    var n, r;
    return typeof t == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      local: !1,
      message: t
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      offset: (n = t == null ? void 0 : t.offset) !== null && n !== void 0 ? n : !1,
      local: (r = t == null ? void 0 : t.local) !== null && r !== void 0 ? r : !1,
      ...Te.errToObj(t == null ? void 0 : t.message)
    });
  }
  date(t) {
    return this._addCheck({ kind: "date", message: t });
  }
  time(t) {
    return typeof t == "string" ? this._addCheck({
      kind: "time",
      precision: null,
      message: t
    }) : this._addCheck({
      kind: "time",
      precision: typeof (t == null ? void 0 : t.precision) > "u" ? null : t == null ? void 0 : t.precision,
      ...Te.errToObj(t == null ? void 0 : t.message)
    });
  }
  duration(t) {
    return this._addCheck({ kind: "duration", ...Te.errToObj(t) });
  }
  regex(t, n) {
    return this._addCheck({
      kind: "regex",
      regex: t,
      ...Te.errToObj(n)
    });
  }
  includes(t, n) {
    return this._addCheck({
      kind: "includes",
      value: t,
      position: n == null ? void 0 : n.position,
      ...Te.errToObj(n == null ? void 0 : n.message)
    });
  }
  startsWith(t, n) {
    return this._addCheck({
      kind: "startsWith",
      value: t,
      ...Te.errToObj(n)
    });
  }
  endsWith(t, n) {
    return this._addCheck({
      kind: "endsWith",
      value: t,
      ...Te.errToObj(n)
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t,
      ...Te.errToObj(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t,
      ...Te.errToObj(n)
    });
  }
  length(t, n) {
    return this._addCheck({
      kind: "length",
      value: t,
      ...Te.errToObj(n)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(t) {
    return this.min(1, Te.errToObj(t));
  }
  trim() {
    return new Qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new Qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new Qn({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((t) => t.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((t) => t.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((t) => t.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((t) => t.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((t) => t.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((t) => t.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((t) => t.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((t) => t.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((t) => t.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((t) => t.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((t) => t.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((t) => t.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((t) => t.kind === "ip");
  }
  get isBase64() {
    return !!this._def.checks.find((t) => t.kind === "base64");
  }
  get minLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxLength() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
Qn.create = (e) => {
  var t;
  return new Qn({
    checks: [],
    typeName: Pe.ZodString,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Be(e)
  });
};
function qae(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r, a = parseInt(e.toFixed(i).replace(".", "")), o = parseInt(t.toFixed(i).replace(".", ""));
  return a % o / Math.pow(10, i);
}
class xi extends ze {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = Number(t.data)), this._getType(t) !== ge.number) {
      const a = this._getOrReturnCtx(t);
      return he(a, {
        code: ne.invalid_type,
        expected: ge.number,
        received: a.parsedType
      }), Ne;
    }
    let r;
    const i = new sn();
    for (const a of this._def.checks)
      a.kind === "int" ? Qe.isInteger(t.data) || (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), i.dirty()) : a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? qae(t.data, a.value) !== 0 && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : a.kind === "finite" ? Number.isFinite(t.data) || (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.not_finite,
        message: a.message
      }), i.dirty()) : Qe.assertNever(a);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Te.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Te.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Te.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Te.toString(n));
  }
  setLimit(t, n, r, i) {
    return new xi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Te.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new xi({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  int(t) {
    return this._addCheck({
      kind: "int",
      message: Te.toString(t)
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: Te.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: Te.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: Te.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: Te.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Te.toString(n)
    });
  }
  finite(t) {
    return this._addCheck({
      kind: "finite",
      message: Te.toString(t)
    });
  }
  safe(t) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: Te.toString(t)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: Te.toString(t)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
  get isInt() {
    return !!this._def.checks.find((t) => t.kind === "int" || t.kind === "multipleOf" && Qe.isInteger(t.value));
  }
  get isFinite() {
    let t = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (t === null || r.value < t) && (t = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(t);
  }
}
xi.create = (e) => new xi({
  checks: [],
  typeName: Pe.ZodNumber,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Be(e)
});
class wi extends ze {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(t) {
    if (this._def.coerce && (t.data = BigInt(t.data)), this._getType(t) !== ge.bigint) {
      const a = this._getOrReturnCtx(t);
      return he(a, {
        code: ne.invalid_type,
        expected: ge.bigint,
        received: a.parsedType
      }), Ne;
    }
    let r;
    const i = new sn();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? t.data < a.value : t.data <= a.value) && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "max" ? (a.inclusive ? t.data > a.value : t.data >= a.value) && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), i.dirty()) : a.kind === "multipleOf" ? t.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(t, r), he(r, {
        code: ne.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), i.dirty()) : Qe.assertNever(a);
    return { status: i.value, value: t.data };
  }
  gte(t, n) {
    return this.setLimit("min", t, !0, Te.toString(n));
  }
  gt(t, n) {
    return this.setLimit("min", t, !1, Te.toString(n));
  }
  lte(t, n) {
    return this.setLimit("max", t, !0, Te.toString(n));
  }
  lt(t, n) {
    return this.setLimit("max", t, !1, Te.toString(n));
  }
  setLimit(t, n, r, i) {
    return new wi({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: t,
          value: n,
          inclusive: r,
          message: Te.toString(i)
        }
      ]
    });
  }
  _addCheck(t) {
    return new wi({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  positive(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: Te.toString(t)
    });
  }
  negative(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: Te.toString(t)
    });
  }
  nonpositive(t) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: Te.toString(t)
    });
  }
  nonnegative(t) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: Te.toString(t)
    });
  }
  multipleOf(t, n) {
    return this._addCheck({
      kind: "multipleOf",
      value: t,
      message: Te.toString(n)
    });
  }
  get minValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t;
  }
  get maxValue() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t;
  }
}
wi.create = (e) => {
  var t;
  return new wi({
    checks: [],
    typeName: Pe.ZodBigInt,
    coerce: (t = e == null ? void 0 : e.coerce) !== null && t !== void 0 ? t : !1,
    ...Be(e)
  });
};
class xs extends ze {
  _parse(t) {
    if (this._def.coerce && (t.data = !!t.data), this._getType(t) !== ge.boolean) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.boolean,
        received: r.parsedType
      }), Ne;
    }
    return hn(t.data);
  }
}
xs.create = (e) => new xs({
  typeName: Pe.ZodBoolean,
  coerce: (e == null ? void 0 : e.coerce) || !1,
  ...Be(e)
});
class Ki extends ze {
  _parse(t) {
    if (this._def.coerce && (t.data = new Date(t.data)), this._getType(t) !== ge.date) {
      const a = this._getOrReturnCtx(t);
      return he(a, {
        code: ne.invalid_type,
        expected: ge.date,
        received: a.parsedType
      }), Ne;
    }
    if (isNaN(t.data.getTime())) {
      const a = this._getOrReturnCtx(t);
      return he(a, {
        code: ne.invalid_date
      }), Ne;
    }
    const r = new sn();
    let i;
    for (const a of this._def.checks)
      a.kind === "min" ? t.data.getTime() < a.value && (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? t.data.getTime() > a.value && (i = this._getOrReturnCtx(t, i), he(i, {
        code: ne.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : Qe.assertNever(a);
    return {
      status: r.value,
      value: new Date(t.data.getTime())
    };
  }
  _addCheck(t) {
    return new Ki({
      ...this._def,
      checks: [...this._def.checks, t]
    });
  }
  min(t, n) {
    return this._addCheck({
      kind: "min",
      value: t.getTime(),
      message: Te.toString(n)
    });
  }
  max(t, n) {
    return this._addCheck({
      kind: "max",
      value: t.getTime(),
      message: Te.toString(n)
    });
  }
  get minDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "min" && (t === null || n.value > t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
  get maxDate() {
    let t = null;
    for (const n of this._def.checks)
      n.kind === "max" && (t === null || n.value < t) && (t = n.value);
    return t != null ? new Date(t) : null;
  }
}
Ki.create = (e) => new Ki({
  checks: [],
  coerce: (e == null ? void 0 : e.coerce) || !1,
  typeName: Pe.ZodDate,
  ...Be(e)
});
class fu extends ze {
  _parse(t) {
    if (this._getType(t) !== ge.symbol) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.symbol,
        received: r.parsedType
      }), Ne;
    }
    return hn(t.data);
  }
}
fu.create = (e) => new fu({
  typeName: Pe.ZodSymbol,
  ...Be(e)
});
class ws extends ze {
  _parse(t) {
    if (this._getType(t) !== ge.undefined) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.undefined,
        received: r.parsedType
      }), Ne;
    }
    return hn(t.data);
  }
}
ws.create = (e) => new ws({
  typeName: Pe.ZodUndefined,
  ...Be(e)
});
class Ss extends ze {
  _parse(t) {
    if (this._getType(t) !== ge.null) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.null,
        received: r.parsedType
      }), Ne;
    }
    return hn(t.data);
  }
}
Ss.create = (e) => new Ss({
  typeName: Pe.ZodNull,
  ...Be(e)
});
class Ya extends ze {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(t) {
    return hn(t.data);
  }
}
Ya.create = (e) => new Ya({
  typeName: Pe.ZodAny,
  ...Be(e)
});
class Bi extends ze {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(t) {
    return hn(t.data);
  }
}
Bi.create = (e) => new Bi({
  typeName: Pe.ZodUnknown,
  ...Be(e)
});
class Wr extends ze {
  _parse(t) {
    const n = this._getOrReturnCtx(t);
    return he(n, {
      code: ne.invalid_type,
      expected: ge.never,
      received: n.parsedType
    }), Ne;
  }
}
Wr.create = (e) => new Wr({
  typeName: Pe.ZodNever,
  ...Be(e)
});
class du extends ze {
  _parse(t) {
    if (this._getType(t) !== ge.undefined) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.void,
        received: r.parsedType
      }), Ne;
    }
    return hn(t.data);
  }
}
du.create = (e) => new du({
  typeName: Pe.ZodVoid,
  ...Be(e)
});
class nr extends ze {
  _parse(t) {
    const { ctx: n, status: r } = this._processInputParams(t), i = this._def;
    if (n.parsedType !== ge.array)
      return he(n, {
        code: ne.invalid_type,
        expected: ge.array,
        received: n.parsedType
      }), Ne;
    if (i.exactLength !== null) {
      const o = n.data.length > i.exactLength.value, s = n.data.length < i.exactLength.value;
      (o || s) && (he(n, {
        code: o ? ne.too_big : ne.too_small,
        minimum: s ? i.exactLength.value : void 0,
        maximum: o ? i.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: i.exactLength.message
      }), r.dirty());
    }
    if (i.minLength !== null && n.data.length < i.minLength.value && (he(n, {
      code: ne.too_small,
      minimum: i.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.minLength.message
    }), r.dirty()), i.maxLength !== null && n.data.length > i.maxLength.value && (he(n, {
      code: ne.too_big,
      maximum: i.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: i.maxLength.message
    }), r.dirty()), n.common.async)
      return Promise.all([...n.data].map((o, s) => i.type._parseAsync(new kr(n, o, n.path, s)))).then((o) => sn.mergeArray(r, o));
    const a = [...n.data].map((o, s) => i.type._parseSync(new kr(n, o, n.path, s)));
    return sn.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(t, n) {
    return new nr({
      ...this._def,
      minLength: { value: t, message: Te.toString(n) }
    });
  }
  max(t, n) {
    return new nr({
      ...this._def,
      maxLength: { value: t, message: Te.toString(n) }
    });
  }
  length(t, n) {
    return new nr({
      ...this._def,
      exactLength: { value: t, message: Te.toString(n) }
    });
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
nr.create = (e, t) => new nr({
  type: e,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: Pe.ZodArray,
  ...Be(t)
});
function ba(e) {
  if (e instanceof _t) {
    const t = {};
    for (const n in e.shape) {
      const r = e.shape[n];
      t[n] = _r.create(ba(r));
    }
    return new _t({
      ...e._def,
      shape: () => t
    });
  } else return e instanceof nr ? new nr({
    ...e._def,
    type: ba(e.element)
  }) : e instanceof _r ? _r.create(ba(e.unwrap())) : e instanceof _i ? _i.create(ba(e.unwrap())) : e instanceof Or ? Or.create(e.items.map((t) => ba(t))) : e;
}
class _t extends ze {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const t = this._def.shape(), n = Qe.objectKeys(t);
    return this._cached = { shape: t, keys: n };
  }
  _parse(t) {
    if (this._getType(t) !== ge.object) {
      const l = this._getOrReturnCtx(t);
      return he(l, {
        code: ne.invalid_type,
        expected: ge.object,
        received: l.parsedType
      }), Ne;
    }
    const { status: r, ctx: i } = this._processInputParams(t), { shape: a, keys: o } = this._getCached(), s = [];
    if (!(this._def.catchall instanceof Wr && this._def.unknownKeys === "strip"))
      for (const l in i.data)
        o.includes(l) || s.push(l);
    const c = [];
    for (const l of o) {
      const u = a[l], f = i.data[l];
      c.push({
        key: { status: "valid", value: l },
        value: u._parse(new kr(i, f, i.path, l)),
        alwaysSet: l in i.data
      });
    }
    if (this._def.catchall instanceof Wr) {
      const l = this._def.unknownKeys;
      if (l === "passthrough")
        for (const u of s)
          c.push({
            key: { status: "valid", value: u },
            value: { status: "valid", value: i.data[u] }
          });
      else if (l === "strict")
        s.length > 0 && (he(i, {
          code: ne.unrecognized_keys,
          keys: s
        }), r.dirty());
      else if (l !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const l = this._def.catchall;
      for (const u of s) {
        const f = i.data[u];
        c.push({
          key: { status: "valid", value: u },
          value: l._parse(
            new kr(i, f, i.path, u)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: u in i.data
        });
      }
    }
    return i.common.async ? Promise.resolve().then(async () => {
      const l = [];
      for (const u of c) {
        const f = await u.key, d = await u.value;
        l.push({
          key: f,
          value: d,
          alwaysSet: u.alwaysSet
        });
      }
      return l;
    }).then((l) => sn.mergeObjectSync(r, l)) : sn.mergeObjectSync(r, c);
  }
  get shape() {
    return this._def.shape();
  }
  strict(t) {
    return Te.errToObj, new _t({
      ...this._def,
      unknownKeys: "strict",
      ...t !== void 0 ? {
        errorMap: (n, r) => {
          var i, a, o, s;
          const c = (o = (a = (i = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(i, n, r).message) !== null && o !== void 0 ? o : r.defaultError;
          return n.code === "unrecognized_keys" ? {
            message: (s = Te.errToObj(t).message) !== null && s !== void 0 ? s : c
          } : {
            message: c
          };
        }
      } : {}
    });
  }
  strip() {
    return new _t({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new _t({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(t) {
    return new _t({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...t
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(t) {
    return new _t({
      unknownKeys: t._def.unknownKeys,
      catchall: t._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...t._def.shape()
      }),
      typeName: Pe.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(t, n) {
    return this.augment({ [t]: n });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(t) {
    return new _t({
      ...this._def,
      catchall: t
    });
  }
  pick(t) {
    const n = {};
    return Qe.objectKeys(t).forEach((r) => {
      t[r] && this.shape[r] && (n[r] = this.shape[r]);
    }), new _t({
      ...this._def,
      shape: () => n
    });
  }
  omit(t) {
    const n = {};
    return Qe.objectKeys(this.shape).forEach((r) => {
      t[r] || (n[r] = this.shape[r]);
    }), new _t({
      ...this._def,
      shape: () => n
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return ba(this);
  }
  partial(t) {
    const n = {};
    return Qe.objectKeys(this.shape).forEach((r) => {
      const i = this.shape[r];
      t && !t[r] ? n[r] = i : n[r] = i.optional();
    }), new _t({
      ...this._def,
      shape: () => n
    });
  }
  required(t) {
    const n = {};
    return Qe.objectKeys(this.shape).forEach((r) => {
      if (t && !t[r])
        n[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof _r; )
          a = a._def.innerType;
        n[r] = a;
      }
    }), new _t({
      ...this._def,
      shape: () => n
    });
  }
  keyof() {
    return pC(Qe.objectKeys(this.shape));
  }
}
_t.create = (e, t) => new _t({
  shape: () => e,
  unknownKeys: "strip",
  catchall: Wr.create(),
  typeName: Pe.ZodObject,
  ...Be(t)
});
_t.strictCreate = (e, t) => new _t({
  shape: () => e,
  unknownKeys: "strict",
  catchall: Wr.create(),
  typeName: Pe.ZodObject,
  ...Be(t)
});
_t.lazycreate = (e, t) => new _t({
  shape: e,
  unknownKeys: "strip",
  catchall: Wr.create(),
  typeName: Pe.ZodObject,
  ...Be(t)
});
class _s extends ze {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = this._def.options;
    function i(a) {
      for (const s of a)
        if (s.result.status === "valid")
          return s.result;
      for (const s of a)
        if (s.result.status === "dirty")
          return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = a.map((s) => new $n(s.ctx.common.issues));
      return he(n, {
        code: ne.invalid_union,
        unionErrors: o
      }), Ne;
    }
    if (n.common.async)
      return Promise.all(r.map(async (a) => {
        const o = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: n.data,
            path: n.path,
            parent: o
          }),
          ctx: o
        };
      })).then(i);
    {
      let a;
      const o = [];
      for (const c of r) {
        const l = {
          ...n,
          common: {
            ...n.common,
            issues: []
          },
          parent: null
        }, u = c._parseSync({
          data: n.data,
          path: n.path,
          parent: l
        });
        if (u.status === "valid")
          return u;
        u.status === "dirty" && !a && (a = { result: u, ctx: l }), l.common.issues.length && o.push(l.common.issues);
      }
      if (a)
        return n.common.issues.push(...a.ctx.common.issues), a.result;
      const s = o.map((c) => new $n(c));
      return he(n, {
        code: ne.invalid_union,
        unionErrors: s
      }), Ne;
    }
  }
  get options() {
    return this._def.options;
  }
}
_s.create = (e, t) => new _s({
  options: e,
  typeName: Pe.ZodUnion,
  ...Be(t)
});
const jr = (e) => e instanceof ks ? jr(e.schema) : e instanceof or ? jr(e.innerType()) : e instanceof Os ? [e.value] : e instanceof Si ? e.options : e instanceof Cs ? Qe.objectValues(e.enum) : e instanceof Rs ? jr(e._def.innerType) : e instanceof ws ? [void 0] : e instanceof Ss ? [null] : e instanceof _r ? [void 0, ...jr(e.unwrap())] : e instanceof _i ? [null, ...jr(e.unwrap())] : e instanceof gy || e instanceof Is ? jr(e.unwrap()) : e instanceof $s ? jr(e._def.innerType) : [];
class mf extends ze {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ge.object)
      return he(n, {
        code: ne.invalid_type,
        expected: ge.object,
        received: n.parsedType
      }), Ne;
    const r = this.discriminator, i = n.data[r], a = this.optionsMap.get(i);
    return a ? n.common.async ? a._parseAsync({
      data: n.data,
      path: n.path,
      parent: n
    }) : a._parseSync({
      data: n.data,
      path: n.path,
      parent: n
    }) : (he(n, {
      code: ne.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), Ne);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(t, n, r) {
    const i = /* @__PURE__ */ new Map();
    for (const a of n) {
      const o = jr(a.shape[t]);
      if (!o.length)
        throw new Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
      for (const s of o) {
        if (i.has(s))
          throw new Error(`Discriminator property ${String(t)} has duplicate value ${String(s)}`);
        i.set(s, a);
      }
    }
    return new mf({
      typeName: Pe.ZodDiscriminatedUnion,
      discriminator: t,
      options: n,
      optionsMap: i,
      ...Be(r)
    });
  }
}
function Jh(e, t) {
  const n = si(e), r = si(t);
  if (e === t)
    return { valid: !0, data: e };
  if (n === ge.object && r === ge.object) {
    const i = Qe.objectKeys(t), a = Qe.objectKeys(e).filter((s) => i.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of a) {
      const c = Jh(e[s], t[s]);
      if (!c.valid)
        return { valid: !1 };
      o[s] = c.data;
    }
    return { valid: !0, data: o };
  } else if (n === ge.array && r === ge.array) {
    if (e.length !== t.length)
      return { valid: !1 };
    const i = [];
    for (let a = 0; a < e.length; a++) {
      const o = e[a], s = t[a], c = Jh(o, s);
      if (!c.valid)
        return { valid: !1 };
      i.push(c.data);
    }
    return { valid: !0, data: i };
  } else return n === ge.date && r === ge.date && +e == +t ? { valid: !0, data: e } : { valid: !1 };
}
class Es extends ze {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = (a, o) => {
      if (Gh(a) || Gh(o))
        return Ne;
      const s = Jh(a.value, o.value);
      return s.valid ? ((Yh(a) || Yh(o)) && n.dirty(), { status: n.value, value: s.data }) : (he(r, {
        code: ne.invalid_intersection_types
      }), Ne);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, o]) => i(a, o)) : i(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
Es.create = (e, t, n) => new Es({
  left: e,
  right: t,
  typeName: Pe.ZodIntersection,
  ...Be(n)
});
class Or extends ze {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ge.array)
      return he(r, {
        code: ne.invalid_type,
        expected: ge.array,
        received: r.parsedType
      }), Ne;
    if (r.data.length < this._def.items.length)
      return he(r, {
        code: ne.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), Ne;
    !this._def.rest && r.data.length > this._def.items.length && (he(r, {
      code: ne.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), n.dirty());
    const a = [...r.data].map((o, s) => {
      const c = this._def.items[s] || this._def.rest;
      return c ? c._parse(new kr(r, o, r.path, s)) : null;
    }).filter((o) => !!o);
    return r.common.async ? Promise.all(a).then((o) => sn.mergeArray(n, o)) : sn.mergeArray(n, a);
  }
  get items() {
    return this._def.items;
  }
  rest(t) {
    return new Or({
      ...this._def,
      rest: t
    });
  }
}
Or.create = (e, t) => {
  if (!Array.isArray(e))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Or({
    items: e,
    typeName: Pe.ZodTuple,
    rest: null,
    ...Be(t)
  });
};
class Ts extends ze {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ge.object)
      return he(r, {
        code: ne.invalid_type,
        expected: ge.object,
        received: r.parsedType
      }), Ne;
    const i = [], a = this._def.keyType, o = this._def.valueType;
    for (const s in r.data)
      i.push({
        key: a._parse(new kr(r, s, r.path, s)),
        value: o._parse(new kr(r, r.data[s], r.path, s)),
        alwaysSet: s in r.data
      });
    return r.common.async ? sn.mergeObjectAsync(n, i) : sn.mergeObjectSync(n, i);
  }
  get element() {
    return this._def.valueType;
  }
  static create(t, n, r) {
    return n instanceof ze ? new Ts({
      keyType: t,
      valueType: n,
      typeName: Pe.ZodRecord,
      ...Be(r)
    }) : new Ts({
      keyType: Qn.create(),
      valueType: t,
      typeName: Pe.ZodRecord,
      ...Be(n)
    });
  }
}
class pu extends ze {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ge.map)
      return he(r, {
        code: ne.invalid_type,
        expected: ge.map,
        received: r.parsedType
      }), Ne;
    const i = this._def.keyType, a = this._def.valueType, o = [...r.data.entries()].map(([s, c], l) => ({
      key: i._parse(new kr(r, s, r.path, [l, "key"])),
      value: a._parse(new kr(r, c, r.path, [l, "value"]))
    }));
    if (r.common.async) {
      const s = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const c of o) {
          const l = await c.key, u = await c.value;
          if (l.status === "aborted" || u.status === "aborted")
            return Ne;
          (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
        }
        return { status: n.value, value: s };
      });
    } else {
      const s = /* @__PURE__ */ new Map();
      for (const c of o) {
        const l = c.key, u = c.value;
        if (l.status === "aborted" || u.status === "aborted")
          return Ne;
        (l.status === "dirty" || u.status === "dirty") && n.dirty(), s.set(l.value, u.value);
      }
      return { status: n.value, value: s };
    }
  }
}
pu.create = (e, t, n) => new pu({
  valueType: t,
  keyType: e,
  typeName: Pe.ZodMap,
  ...Be(n)
});
class Gi extends ze {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.parsedType !== ge.set)
      return he(r, {
        code: ne.invalid_type,
        expected: ge.set,
        received: r.parsedType
      }), Ne;
    const i = this._def;
    i.minSize !== null && r.data.size < i.minSize.value && (he(r, {
      code: ne.too_small,
      minimum: i.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.minSize.message
    }), n.dirty()), i.maxSize !== null && r.data.size > i.maxSize.value && (he(r, {
      code: ne.too_big,
      maximum: i.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: i.maxSize.message
    }), n.dirty());
    const a = this._def.valueType;
    function o(c) {
      const l = /* @__PURE__ */ new Set();
      for (const u of c) {
        if (u.status === "aborted")
          return Ne;
        u.status === "dirty" && n.dirty(), l.add(u.value);
      }
      return { status: n.value, value: l };
    }
    const s = [...r.data.values()].map((c, l) => a._parse(new kr(r, c, r.path, l)));
    return r.common.async ? Promise.all(s).then((c) => o(c)) : o(s);
  }
  min(t, n) {
    return new Gi({
      ...this._def,
      minSize: { value: t, message: Te.toString(n) }
    });
  }
  max(t, n) {
    return new Gi({
      ...this._def,
      maxSize: { value: t, message: Te.toString(n) }
    });
  }
  size(t, n) {
    return this.min(t, n).max(t, n);
  }
  nonempty(t) {
    return this.min(1, t);
  }
}
Gi.create = (e, t) => new Gi({
  valueType: e,
  minSize: null,
  maxSize: null,
  typeName: Pe.ZodSet,
  ...Be(t)
});
class Ia extends ze {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ge.function)
      return he(n, {
        code: ne.invalid_type,
        expected: ge.function,
        received: n.parsedType
      }), Ne;
    function r(s, c) {
      return cu({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          lu(),
          Ga
        ].filter((l) => !!l),
        issueData: {
          code: ne.invalid_arguments,
          argumentsError: c
        }
      });
    }
    function i(s, c) {
      return cu({
        data: s,
        path: n.path,
        errorMaps: [
          n.common.contextualErrorMap,
          n.schemaErrorMap,
          lu(),
          Ga
        ].filter((l) => !!l),
        issueData: {
          code: ne.invalid_return_type,
          returnTypeError: c
        }
      });
    }
    const a = { errorMap: n.common.contextualErrorMap }, o = n.data;
    if (this._def.returns instanceof Ja) {
      const s = this;
      return hn(async function(...c) {
        const l = new $n([]), u = await s._def.args.parseAsync(c, a).catch((p) => {
          throw l.addIssue(r(c, p)), l;
        }), f = await Reflect.apply(o, this, u);
        return await s._def.returns._def.type.parseAsync(f, a).catch((p) => {
          throw l.addIssue(i(f, p)), l;
        });
      });
    } else {
      const s = this;
      return hn(function(...c) {
        const l = s._def.args.safeParse(c, a);
        if (!l.success)
          throw new $n([r(c, l.error)]);
        const u = Reflect.apply(o, this, l.data), f = s._def.returns.safeParse(u, a);
        if (!f.success)
          throw new $n([i(u, f.error)]);
        return f.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...t) {
    return new Ia({
      ...this._def,
      args: Or.create(t).rest(Bi.create())
    });
  }
  returns(t) {
    return new Ia({
      ...this._def,
      returns: t
    });
  }
  implement(t) {
    return this.parse(t);
  }
  strictImplement(t) {
    return this.parse(t);
  }
  static create(t, n, r) {
    return new Ia({
      args: t || Or.create([]).rest(Bi.create()),
      returns: n || Bi.create(),
      typeName: Pe.ZodFunction,
      ...Be(r)
    });
  }
}
class ks extends ze {
  get schema() {
    return this._def.getter();
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
ks.create = (e, t) => new ks({
  getter: e,
  typeName: Pe.ZodLazy,
  ...Be(t)
});
class Os extends ze {
  _parse(t) {
    if (t.data !== this._def.value) {
      const n = this._getOrReturnCtx(t);
      return he(n, {
        received: n.data,
        code: ne.invalid_literal,
        expected: this._def.value
      }), Ne;
    }
    return { status: "valid", value: t.data };
  }
  get value() {
    return this._def.value;
  }
}
Os.create = (e, t) => new Os({
  value: e,
  typeName: Pe.ZodLiteral,
  ...Be(t)
});
function pC(e, t) {
  return new Si({
    values: e,
    typeName: Pe.ZodEnum,
    ...Be(t)
  });
}
class Si extends ze {
  constructor() {
    super(...arguments), No.set(this, void 0);
  }
  _parse(t) {
    if (typeof t.data != "string") {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return he(n, {
        expected: Qe.joinValues(r),
        received: n.parsedType,
        code: ne.invalid_type
      }), Ne;
    }
    if (uu(this, No) || cC(this, No, new Set(this._def.values)), !uu(this, No).has(t.data)) {
      const n = this._getOrReturnCtx(t), r = this._def.values;
      return he(n, {
        received: n.data,
        code: ne.invalid_enum_value,
        options: r
      }), Ne;
    }
    return hn(t.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Values() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  get Enum() {
    const t = {};
    for (const n of this._def.values)
      t[n] = n;
    return t;
  }
  extract(t, n = this._def) {
    return Si.create(t, {
      ...this._def,
      ...n
    });
  }
  exclude(t, n = this._def) {
    return Si.create(this.options.filter((r) => !t.includes(r)), {
      ...this._def,
      ...n
    });
  }
}
No = /* @__PURE__ */ new WeakMap();
Si.create = pC;
class Cs extends ze {
  constructor() {
    super(...arguments), Do.set(this, void 0);
  }
  _parse(t) {
    const n = Qe.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(t);
    if (r.parsedType !== ge.string && r.parsedType !== ge.number) {
      const i = Qe.objectValues(n);
      return he(r, {
        expected: Qe.joinValues(i),
        received: r.parsedType,
        code: ne.invalid_type
      }), Ne;
    }
    if (uu(this, Do) || cC(this, Do, new Set(Qe.getValidEnumValues(this._def.values))), !uu(this, Do).has(t.data)) {
      const i = Qe.objectValues(n);
      return he(r, {
        received: r.data,
        code: ne.invalid_enum_value,
        options: i
      }), Ne;
    }
    return hn(t.data);
  }
  get enum() {
    return this._def.values;
  }
}
Do = /* @__PURE__ */ new WeakMap();
Cs.create = (e, t) => new Cs({
  values: e,
  typeName: Pe.ZodNativeEnum,
  ...Be(t)
});
class Ja extends ze {
  unwrap() {
    return this._def.type;
  }
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    if (n.parsedType !== ge.promise && n.common.async === !1)
      return he(n, {
        code: ne.invalid_type,
        expected: ge.promise,
        received: n.parsedType
      }), Ne;
    const r = n.parsedType === ge.promise ? n.data : Promise.resolve(n.data);
    return hn(r.then((i) => this._def.type.parseAsync(i, {
      path: n.path,
      errorMap: n.common.contextualErrorMap
    })));
  }
}
Ja.create = (e, t) => new Ja({
  type: e,
  typeName: Pe.ZodPromise,
  ...Be(t)
});
class or extends ze {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === Pe.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t), i = this._def.effect || null, a = {
      addIssue: (o) => {
        he(r, o), o.fatal ? n.abort() : n.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), i.type === "preprocess") {
      const o = i.transform(r.data, a);
      if (r.common.async)
        return Promise.resolve(o).then(async (s) => {
          if (n.value === "aborted")
            return Ne;
          const c = await this._def.schema._parseAsync({
            data: s,
            path: r.path,
            parent: r
          });
          return c.status === "aborted" ? Ne : c.status === "dirty" || n.value === "dirty" ? Sa(c.value) : c;
        });
      {
        if (n.value === "aborted")
          return Ne;
        const s = this._def.schema._parseSync({
          data: o,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? Ne : s.status === "dirty" || n.value === "dirty" ? Sa(s.value) : s;
      }
    }
    if (i.type === "refinement") {
      const o = (s) => {
        const c = i.refinement(s, a);
        if (r.common.async)
          return Promise.resolve(c);
        if (c instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return s;
      };
      if (r.common.async === !1) {
        const s = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return s.status === "aborted" ? Ne : (s.status === "dirty" && n.dirty(), o(s.value), { status: n.value, value: s.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((s) => s.status === "aborted" ? Ne : (s.status === "dirty" && n.dirty(), o(s.value).then(() => ({ status: n.value, value: s.value }))));
    }
    if (i.type === "transform")
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!gs(o))
          return o;
        const s = i.transform(o.value, a);
        if (s instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: s };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => gs(o) ? Promise.resolve(i.transform(o.value, a)).then((s) => ({ status: n.value, value: s })) : o);
    Qe.assertNever(i);
  }
}
or.create = (e, t, n) => new or({
  schema: e,
  typeName: Pe.ZodEffects,
  effect: t,
  ...Be(n)
});
or.createWithPreprocess = (e, t, n) => new or({
  schema: t,
  effect: { type: "preprocess", transform: e },
  typeName: Pe.ZodEffects,
  ...Be(n)
});
class _r extends ze {
  _parse(t) {
    return this._getType(t) === ge.undefined ? hn(void 0) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
_r.create = (e, t) => new _r({
  innerType: e,
  typeName: Pe.ZodOptional,
  ...Be(t)
});
class _i extends ze {
  _parse(t) {
    return this._getType(t) === ge.null ? hn(null) : this._def.innerType._parse(t);
  }
  unwrap() {
    return this._def.innerType;
  }
}
_i.create = (e, t) => new _i({
  innerType: e,
  typeName: Pe.ZodNullable,
  ...Be(t)
});
class Rs extends ze {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t);
    let r = n.data;
    return n.parsedType === ge.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
Rs.create = (e, t) => new Rs({
  innerType: e,
  typeName: Pe.ZodDefault,
  defaultValue: typeof t.default == "function" ? t.default : () => t.default,
  ...Be(t)
});
class $s extends ze {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = {
      ...n,
      common: {
        ...n.common,
        issues: []
      }
    }, i = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return bs(i) ? i.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new $n(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: i.status === "valid" ? i.value : this._def.catchValue({
        get error() {
          return new $n(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
$s.create = (e, t) => new $s({
  innerType: e,
  typeName: Pe.ZodCatch,
  catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
  ...Be(t)
});
class hu extends ze {
  _parse(t) {
    if (this._getType(t) !== ge.nan) {
      const r = this._getOrReturnCtx(t);
      return he(r, {
        code: ne.invalid_type,
        expected: ge.nan,
        received: r.parsedType
      }), Ne;
    }
    return { status: "valid", value: t.data };
  }
}
hu.create = (e) => new hu({
  typeName: Pe.ZodNaN,
  ...Be(e)
});
const Wae = Symbol("zod_brand");
class gy extends ze {
  _parse(t) {
    const { ctx: n } = this._processInputParams(t), r = n.data;
    return this._def.type._parse({
      data: r,
      path: n.path,
      parent: n
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class hl extends ze {
  _parse(t) {
    const { status: n, ctx: r } = this._processInputParams(t);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? Ne : a.status === "dirty" ? (n.dirty(), Sa(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const i = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return i.status === "aborted" ? Ne : i.status === "dirty" ? (n.dirty(), {
        status: "dirty",
        value: i.value
      }) : this._def.out._parseSync({
        data: i.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(t, n) {
    return new hl({
      in: t,
      out: n,
      typeName: Pe.ZodPipeline
    });
  }
}
class Is extends ze {
  _parse(t) {
    const n = this._def.innerType._parse(t), r = (i) => (gs(i) && (i.value = Object.freeze(i.value)), i);
    return bs(n) ? n.then((i) => r(i)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Is.create = (e, t) => new Is({
  innerType: e,
  typeName: Pe.ZodReadonly,
  ...Be(t)
});
function hC(e, t = {}, n) {
  return e ? Ya.create().superRefine((r, i) => {
    var a, o;
    if (!e(r)) {
      const s = typeof t == "function" ? t(r) : typeof t == "string" ? { message: t } : t, c = (o = (a = s.fatal) !== null && a !== void 0 ? a : n) !== null && o !== void 0 ? o : !0, l = typeof s == "string" ? { message: s } : s;
      i.addIssue({ code: "custom", ...l, fatal: c });
    }
  }) : Ya.create();
}
const Zae = {
  object: _t.lazycreate
};
var Pe;
(function(e) {
  e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(Pe || (Pe = {}));
const Kae = (e, t = {
  message: `Input not instance of ${e.name}`
}) => hC((n) => n instanceof e, t), mC = Qn.create, vC = xi.create, Gae = hu.create, Yae = wi.create, yC = xs.create, Jae = Ki.create, Xae = fu.create, Qae = ws.create, eoe = Ss.create, toe = Ya.create, noe = Bi.create, roe = Wr.create, ioe = du.create, aoe = nr.create, ooe = _t.create, soe = _t.strictCreate, loe = _s.create, coe = mf.create, uoe = Es.create, foe = Or.create, doe = Ts.create, poe = pu.create, hoe = Gi.create, moe = Ia.create, voe = ks.create, yoe = Os.create, goe = Si.create, boe = Cs.create, xoe = Ja.create, c1 = or.create, woe = _r.create, Soe = _i.create, _oe = or.createWithPreprocess, Eoe = hl.create, Toe = () => mC().optional(), koe = () => vC().optional(), Ooe = () => yC().optional(), Coe = {
  string: (e) => Qn.create({ ...e, coerce: !0 }),
  number: (e) => xi.create({ ...e, coerce: !0 }),
  boolean: (e) => xs.create({
    ...e,
    coerce: !0
  }),
  bigint: (e) => wi.create({ ...e, coerce: !0 }),
  date: (e) => Ki.create({ ...e, coerce: !0 })
}, Roe = Ne;
var H = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: Ga,
  setErrorMap: Rae,
  getErrorMap: lu,
  makeIssue: cu,
  EMPTY_PATH: $ae,
  addIssueToContext: he,
  ParseStatus: sn,
  INVALID: Ne,
  DIRTY: Sa,
  OK: hn,
  isAborted: Gh,
  isDirty: Yh,
  isValid: gs,
  isAsync: bs,
  get util() {
    return Qe;
  },
  get objectUtil() {
    return Kh;
  },
  ZodParsedType: ge,
  getParsedType: si,
  ZodType: ze,
  datetimeRegex: dC,
  ZodString: Qn,
  ZodNumber: xi,
  ZodBigInt: wi,
  ZodBoolean: xs,
  ZodDate: Ki,
  ZodSymbol: fu,
  ZodUndefined: ws,
  ZodNull: Ss,
  ZodAny: Ya,
  ZodUnknown: Bi,
  ZodNever: Wr,
  ZodVoid: du,
  ZodArray: nr,
  ZodObject: _t,
  ZodUnion: _s,
  ZodDiscriminatedUnion: mf,
  ZodIntersection: Es,
  ZodTuple: Or,
  ZodRecord: Ts,
  ZodMap: pu,
  ZodSet: Gi,
  ZodFunction: Ia,
  ZodLazy: ks,
  ZodLiteral: Os,
  ZodEnum: Si,
  ZodNativeEnum: Cs,
  ZodPromise: Ja,
  ZodEffects: or,
  ZodTransformer: or,
  ZodOptional: _r,
  ZodNullable: _i,
  ZodDefault: Rs,
  ZodCatch: $s,
  ZodNaN: hu,
  BRAND: Wae,
  ZodBranded: gy,
  ZodPipeline: hl,
  ZodReadonly: Is,
  custom: hC,
  Schema: ze,
  ZodSchema: ze,
  late: Zae,
  get ZodFirstPartyTypeKind() {
    return Pe;
  },
  coerce: Coe,
  any: toe,
  array: aoe,
  bigint: Yae,
  boolean: yC,
  date: Jae,
  discriminatedUnion: coe,
  effect: c1,
  enum: goe,
  function: moe,
  instanceof: Kae,
  intersection: uoe,
  lazy: voe,
  literal: yoe,
  map: poe,
  nan: Gae,
  nativeEnum: boe,
  never: roe,
  null: eoe,
  nullable: Soe,
  number: vC,
  object: ooe,
  oboolean: Ooe,
  onumber: koe,
  optional: woe,
  ostring: Toe,
  pipeline: Eoe,
  preprocess: _oe,
  promise: xoe,
  record: doe,
  set: hoe,
  strictObject: soe,
  string: mC,
  symbol: Xae,
  transformer: c1,
  tuple: foe,
  undefined: Qae,
  union: loe,
  unknown: noe,
  void: ioe,
  NEVER: Roe,
  ZodIssueCode: ne,
  quotelessJson: Cae,
  ZodError: $n
}), $oe = Object.defineProperty, Ioe = (e, t, n) => t in e ? $oe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Aoe = (e, t, n) => (Ioe(e, t + "", n), n), Poe = {
  getRandomValues: (e) => new Uint8Array(e.map(() => Math.floor(Math.random() * 256)))
}, Xh = typeof window < "u" && typeof window.document < "u" ? window.crypto : jO;
Xh.getRandomValues || (Xh = Poe);
var xt = class extends Error {
  constructor(t, n, r, i, a, o) {
    super(i);
    Se(this, "isApiError", !0);
    this.code = t, this.description = n, this.type = r, this.message = i, this.error = a, this.id = o, this.id || (this.id = xt.generateId());
  }
  format() {
    return `[${this.type}] ${this.message} (Error ID: ${this.id})`;
  }
  toJSON() {
    return {
      id: this.id,
      code: this.code,
      type: this.type,
      message: this.message
    };
  }
  static generateId() {
    const t = this.getPrefix(), n = (/* @__PURE__ */ new Date()).toISOString().replace(/[\-:TZ]/g, "").split(".")[0], r = 4, i = Array.from(Xh.getRandomValues(new Uint8Array(r))).map((a) => a.toString(16).padStart(2, "0")).join("").toUpperCase();
    return `${t}_${n}x${i}`;
  }
  static getPrefix() {
    return typeof window < "u" && typeof window.document < "u" ? "err_bwsr" : "err";
  }
}, Noe = (e) => typeof e == "object" && !Array.isArray(e) && e !== null, Qh = (e) => e instanceof xt || Noe(e) && e.isApiError === !0, As = class extends xt {
  constructor(e, t, n) {
    super(500, "An unknown error occurred", "Unknown", e, t, n);
  }
}, Doe = class extends xt {
  constructor(e, t, n) {
    super(500, "An internal error occurred", "Internal", e, t, n);
  }
}, Moe = class extends xt {
  constructor(e, t, n) {
    super(401, "The request requires to be authenticated.", "Unauthorized", e, t, n);
  }
}, joe = class extends xt {
  constructor(e, t, n) {
    super(403, "The requested action can't be peform by this resource.", "Forbidden", e, t, n);
  }
}, Loe = class extends xt {
  constructor(e, t, n) {
    super(413, "The request payload is too large.", "PayloadTooLarge", e, t, n);
  }
}, Foe = class extends xt {
  constructor(e, t, n) {
    super(400, "The request payload is invalid.", "InvalidPayload", e, t, n);
  }
}, Boe = class extends xt {
  constructor(e, t, n) {
    super(415, "The request is invalid because the content-type is not supported.", "UnsupportedMediaType", e, t, n);
  }
}, Uoe = class extends xt {
  constructor(e, t, n) {
    super(405, "The requested method does not exist.", "MethodNotFound", e, t, n);
  }
}, zoe = class extends xt {
  constructor(e, t, n) {
    super(404, "The requested resource does not exist.", "ResourceNotFound", e, t, n);
  }
}, Voe = class extends xt {
  constructor(e, t, n) {
    super(400, "The provided JSON schema is invalid.", "InvalidJsonSchema", e, t, n);
  }
}, Hoe = class extends xt {
  constructor(e, t, n) {
    super(400, "The provided data doesn't respect the provided JSON schema.", "InvalidDataFormat", e, t, n);
  }
}, qoe = class extends xt {
  constructor(e, t, n) {
    super(400, "The provided identifier is not valid. An identifier must start with a lowercase letter, be between 2 and 100 characters long and use only alphanumeric characters.", "InvalidIdentifier", e, t, n);
  }
}, Woe = class extends xt {
  constructor(e, t, n) {
    super(409, "The resource is related with a different resource that the one referenced in the request. This is usually caused when providing two resource identifiers that aren't linked together.", "RelationConflict", e, t, n);
  }
}, Zoe = class extends xt {
  constructor(e, t, n) {
    super(409, "The resource cannot be deleted because it's referenced by another resource", "ReferenceConstraint", e, t, n);
  }
}, Koe = class extends xt {
  constructor(e, t, n) {
    super(409, "The resource is current locked and cannot be operated on until the lock is released.", "ResourceLockedConflict", e, t, n);
  }
}, Goe = class extends xt {
  constructor(e, t, n) {
    super(400, "The provided resource reference is missing. This is usually caused when providing an invalid id inside the payload of a request.", "ReferenceNotFound", e, t, n);
  }
}, Yoe = class extends xt {
  constructor(e, t, n) {
    super(400, "The provided query is invalid. This is usually caused when providing an invalid parameter for querying a resource.", "InvalidQuery", e, t, n);
  }
}, Joe = class extends xt {
  constructor(e, t, n) {
    super(400, "An error happened during the execution of a runtime (bot or integration).", "Runtime", e, t, n);
  }
}, Xoe = class extends xt {
  constructor(e, t, n) {
    super(409, "The record attempted to be created already exists.", "AlreadyExists", e, t, n);
  }
}, Qoe = class extends xt {
  constructor(e, t, n) {
    super(429, "The request has been rate limited.", "RateLimited", e, t, n);
  }
}, ese = class extends xt {
  constructor(e, t, n) {
    super(402, "A payment is required to perform this request.", "PaymentRequired", e, t, n);
  }
}, tse = class extends xt {
  constructor(e, t, n) {
    super(403, "The request exceeds the allowed quota. Quotas are a soft limit that can be increased.", "QuotaExceeded", e, t, n);
  }
}, nse = class extends xt {
  constructor(e, t, n) {
    super(413, "The request exceeds the allowed limit. Limits are a hard limit that cannot be increased.", "LimitExceeded", e, t, n);
  }
}, rse = class extends xt {
  constructor(e, t, n) {
    super(400, "Request payload contains breaking changes which is not allowed for this resource without a version increment.", "BreakingChanges", e, t, n);
  }
}, ise = {
  Unknown: As,
  Internal: Doe,
  Unauthorized: Moe,
  Forbidden: joe,
  PayloadTooLarge: Loe,
  InvalidPayload: Foe,
  UnsupportedMediaType: Boe,
  MethodNotFound: Uoe,
  ResourceNotFound: zoe,
  InvalidJsonSchema: Voe,
  InvalidDataFormat: Hoe,
  InvalidIdentifier: qoe,
  RelationConflict: Woe,
  ReferenceConstraint: Zoe,
  ResourceLockedConflict: Koe,
  ReferenceNotFound: Goe,
  InvalidQuery: Yoe,
  Runtime: Joe,
  AlreadyExists: Xoe,
  RateLimited: Qoe,
  PaymentRequired: ese,
  QuotaExceeded: tse,
  LimitExceeded: nse,
  BreakingChanges: rse
}, u1 = (e) => Qh(e) ? e : e instanceof Error ? new As(e.message, e) : typeof e == "string" ? new As(e) : ase(e);
function ase(e) {
  if (typeof e == "object" && "code" in e && "type" in e && "id" in e && "message" in e && typeof e.type == "string" && typeof e.message == "string") {
    const t = ise[e.type];
    return t ? new t(e.message, void 0, e.id || "UNKNOWN") : new As(`An unclassified API error occurred: ${e.message} (Type: ${e.type}, Code: ${e.code})`);
  }
  return new As("An invalid error occurred: " + JSON.stringify(e));
}
var ose = (e) => e[1] !== void 0, At = (e) => {
  const { method: t, path: n, query: r, headers: i, body: a } = e, o = Object.entries(i).filter(ose), s = Object.fromEntries(o), c = Tae.stringify(r, { encode: !0, arrayFormat: "repeat", allowDots: !0 }), l = c ? [n, c].join("?") : n;
  return {
    method: t,
    url: l,
    headers: s,
    data: a
  };
}, sse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), lse = (e) => ({
  path: "/conversations",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: { _: e._ }
}), cse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), use = (e) => ({
  path: "/conversations",
  headers: { "x-user-key": e["x-user-key"] },
  query: { nextToken: e.nextToken },
  params: {},
  body: {}
}), fse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/listen`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), dse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/messages`,
  headers: { "x-user-key": e["x-user-key"] },
  query: { nextToken: e.nextToken },
  params: { id: e.id },
  body: {}
}), pse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/participants`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: { userId: e.userId }
}), hse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/participants/${encodeURIComponent(e.userId)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id, userId: e.userId },
  body: {}
}), mse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/participants/${encodeURIComponent(e.userId)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id, userId: e.userId },
  body: {}
}), vse = (e) => ({
  path: `/conversations/${encodeURIComponent(e.id)}/participants`,
  headers: { "x-user-key": e["x-user-key"] },
  query: { nextToken: e.nextToken },
  params: { id: e.id },
  body: {}
}), yse = (e) => ({
  path: `/messages/${encodeURIComponent(e.id)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), gse = (e) => ({
  path: "/messages",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: { payload: e.payload, conversationId: e.conversationId, metadata: e.metadata }
}), bse = (e) => ({
  path: `/messages/${encodeURIComponent(e.id)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), xse = (e) => ({
  path: "/users/me",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: {}
}), wse = (e) => ({
  path: "/users",
  headers: {},
  query: {},
  params: {},
  body: { name: e.name, pictureUrl: e.pictureUrl, userData: e.userData }
}), Sse = (e) => ({
  path: "/users/me",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: { name: e.name, pictureUrl: e.pictureUrl, userData: e.userData }
}), _se = (e) => ({
  path: "/users/me",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: {}
}), Ese = (e) => ({
  path: `/events/${encodeURIComponent(e.id)}`,
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: { id: e.id },
  body: {}
}), Tse = (e) => ({
  path: "/events",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: { payload: e.payload, conversationId: e.conversationId, bindConversation: e.bindConversation, bindUser: e.bindUser }
}), kse = (e) => ({
  path: "/files",
  headers: { "x-user-key": e["x-user-key"] },
  query: {},
  params: {},
  body: { key: e.key, size: e.size, accessPolicies: e.accessPolicies, index: e.index, contentType: e.contentType, tags: e.tags }
}), Ose = class {
  constructor(e, t = {}) {
    Se(this, "getConversation", async (e) => {
      const { path: t, headers: n, query: r, body: i } = sse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "createConversation", async (e) => {
      const { path: t, headers: n, query: r, body: i } = lse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "deleteConversation", async (e) => {
      const { path: t, headers: n, query: r, body: i } = cse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "delete",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "listConversations", async (e) => {
      const { path: t, headers: n, query: r, body: i } = use(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "listenConversation", async (e) => {
      const { path: t, headers: n, query: r, body: i } = fse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "listConversationMessages", async (e) => {
      const { path: t, headers: n, query: r, body: i } = dse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "addParticipant", async (e) => {
      const { path: t, headers: n, query: r, body: i } = pse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "removeParticipant", async (e) => {
      const { path: t, headers: n, query: r, body: i } = hse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "delete",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "getParticipant", async (e) => {
      const { path: t, headers: n, query: r, body: i } = mse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "listParticipants", async (e) => {
      const { path: t, headers: n, query: r, body: i } = vse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "getMessage", async (e) => {
      const { path: t, headers: n, query: r, body: i } = yse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "createMessage", async (e) => {
      const { path: t, headers: n, query: r, body: i } = gse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "deleteMessage", async (e) => {
      const { path: t, headers: n, query: r, body: i } = bse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "delete",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "getUser", async (e) => {
      const { path: t, headers: n, query: r, body: i } = xse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "createUser", async (e) => {
      const { path: t, headers: n, query: r, body: i } = wse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "updateUser", async (e) => {
      const { path: t, headers: n, query: r, body: i } = Sse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "put",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "deleteUser", async (e) => {
      const { path: t, headers: n, query: r, body: i } = _se(e), o = (this.props.toAxiosRequest ?? At)({
        method: "delete",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "getEvent", async (e) => {
      const { path: t, headers: n, query: r, body: i } = Ese(e), o = (this.props.toAxiosRequest ?? At)({
        method: "get",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "createEvent", async (e) => {
      const { path: t, headers: n, query: r, body: i } = Tse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    Se(this, "createFile", async (e) => {
      const { path: t, headers: n, query: r, body: i } = kse(e), o = (this.props.toAxiosRequest ?? At)({
        method: "post",
        path: t,
        headers: { ...n },
        query: { ...r },
        body: i
      });
      return this.axiosInstance.request(o).then((s) => s.data).catch((s) => {
        throw Pt(s);
      });
    });
    this.axiosInstance = e, this.props = t;
  }
};
function Pt(e) {
  var t;
  return jt.isAxiosError(e) && ((t = e.response) != null && t.data) ? u1(e.response.data) : u1(e);
}
var gC = class {
  constructor() {
    Se(this, "listeners", {});
  }
  emit(e, t) {
    const n = this.listeners[e];
    if (n)
      for (const r of [...n])
        r(t);
  }
  onceOrMore(e, t) {
    const n = (r) => {
      t(r) === "stop-listening" && this.off(e, n);
    };
    this.on(e, n);
  }
  once(e, t) {
    const n = (r) => {
      this.off(e, n), t(r);
    };
    this.on(e, n);
  }
  on(e, t) {
    this.listeners[e] || (this.listeners[e] = []), this.listeners[e].push(t);
  }
  off(e, t) {
    const n = this.listeners[e];
    if (!n)
      return;
    const r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  }
  cleanup() {
    this.listeners = {};
  }
}, Cse = (e, t) => {
  const n = new Oae.EventSourcePolyfill(e, {
    headers: t.headers,
    heartbeatTimeout: t.timeout
  }), r = new gC();
  return n.onopen = (i) => r.emit("open", i), n.onmessage = (i) => r.emit("message", i), n.onerror = (i) => r.emit("error", i), {
    emitter: r,
    source: n
  };
}, Rse = async (e, t = {}) => {
  const { emitter: n, source: r } = Cse(e, t);
  return await new Promise((i, a) => {
    n.on("open", () => {
      i();
    }), n.on("error", (o) => {
      a(o);
    });
  }).finally(() => n.cleanup()), {
    on: n.on.bind(n),
    close: () => {
      n.cleanup(), r.close();
    }
  };
}, $se = H.object({
  type: H.literal("message_created"),
  data: H.object({
    id: H.string().describe("Id of the [Message](#schema_message)"),
    createdAt: H.string().datetime().describe(
      "Creation date of the [Message](#schema_message) in ISO 8601 format"
    ),
    payload: H.union([
      H.object({ audioUrl: H.string().min(1), type: H.literal("audio") }),
      H.object({
        title: H.string().min(1),
        subtitle: H.string().min(1).optional(),
        imageUrl: H.string().min(1).optional(),
        actions: H.array(
          H.object({
            action: H.enum(["postback", "url", "say"]),
            label: H.string().min(1),
            value: H.string().min(1)
          })
        ),
        type: H.literal("card")
      }),
      H.object({
        items: H.array(
          H.object({
            title: H.string().min(1),
            subtitle: H.string().min(1).optional(),
            imageUrl: H.string().min(1).optional(),
            actions: H.array(
              H.object({
                action: H.enum(["postback", "url", "say"]),
                label: H.string().min(1),
                value: H.string().min(1)
              })
            )
          })
        ),
        type: H.literal("carousel")
      }),
      H.object({
        text: H.string().min(1),
        options: H.array(
          H.object({ label: H.string().min(1), value: H.string().min(1) })
        ),
        type: H.literal("choice"),
        disableFreeText: H.boolean().optional()
      }),
      H.object({
        text: H.string().min(1),
        options: H.array(
          H.object({ label: H.string().min(1), value: H.string().min(1) })
        ),
        type: H.literal("dropdown")
      }),
      H.object({
        fileUrl: H.string().min(1),
        title: H.string().min(1).optional(),
        type: H.literal("file")
      }),
      H.object({ imageUrl: H.string().min(1), type: H.literal("image") }),
      H.object({
        latitude: H.number(),
        longitude: H.number(),
        address: H.string().optional(),
        title: H.string().optional(),
        type: H.literal("location")
      }),
      H.object({
        text: H.string().min(1),
        type: H.literal("text"),
        value: H.string().optional()
      }),
      H.object({ videoUrl: H.string().min(1), type: H.literal("video") }),
      H.object({
        items: H.array(
          H.union([
            H.object({
              type: H.literal("text"),
              payload: H.object({ text: H.string().min(1) })
            }),
            H.object({
              type: H.literal("markdown"),
              payload: H.object({ markdown: H.string().min(1) })
            }),
            H.object({
              type: H.literal("image"),
              payload: H.object({ imageUrl: H.string().min(1) })
            }),
            H.object({
              type: H.literal("audio"),
              payload: H.object({ audioUrl: H.string().min(1) })
            }),
            H.object({
              type: H.literal("video"),
              payload: H.object({ videoUrl: H.string().min(1) })
            }),
            H.object({
              type: H.literal("file"),
              payload: H.object({
                fileUrl: H.string().min(1),
                title: H.string().min(1).optional()
              })
            }),
            H.object({
              type: H.literal("location"),
              payload: H.object({
                latitude: H.number(),
                longitude: H.number(),
                address: H.string().optional(),
                title: H.string().optional()
              })
            })
          ])
        ),
        type: H.literal("bloc")
      }),
      H.object({
        markdown: H.string().min(1),
        type: H.literal("markdown")
      }),
      H.object({
        type: H.literal("custom"),
        url: H.string(),
        name: H.string(),
        data: H.union([H.any(), H.null()]).optional()
      })
    ]).describe("Payload is the content type of the message."),
    userId: H.string().describe("ID of the [User](#schema_user)"),
    conversationId: H.string().describe("ID of the [Conversation](#schema_conversation)"),
    metadata: H.record(H.union([H.any(), H.null()])).describe("Metadata of the message").optional()
  }).describe(
    "The Message object represents a message in a [Conversation](#schema_conversation) for a specific [User](#schema_user)."
  )
}), Ise = H.object({
  type: H.literal("webchat_visibility"),
  data: H.object({
    visibility: H.union([
      H.literal("show"),
      H.literal("hide"),
      H.literal("toggle")
    ])
  })
}), Ase = H.object({
  type: H.literal("webchat_config"),
  data: H.object({ config: H.record(H.union([H.any(), H.null()])) })
}), Pse = H.object({
  type: H.literal("custom"),
  data: H.object({ event: H.record(H.union([H.any(), H.null()])) })
}), Nse = H.object({
  type: H.literal("typing_started"),
  data: H.object({ timeout: H.number().optional() })
}), Dse = H.object({ type: H.literal("typing_stopped"), data: H.record(H.never()) }), Mse = {
  messageCreated: $se,
  webchatVisibility: Ise,
  webchatConfig: Ase,
  custom: Pse,
  typingStarted: Nse,
  typingStopped: Dse
}, f1 = "unknown error", bC = class extends gC {
  constructor(t) {
    super();
    Se(this, "_state", { status: "disconnected" });
    Se(this, "connect", async () => {
      if (this._state.status === "connected")
        return;
      if (this._state.status === "connecting") {
        await this._state.connectionPromise;
        return;
      }
      const t = this._connect();
      this._state = { status: "connecting", connectionPromise: t }, await t;
    });
    Se(this, "disconnect", async () => {
      if (this._state.status === "disconnected")
        return;
      let t;
      this._state.status === "connecting" ? t = await this._state.connectionPromise : t = this._state.source, this._disconnectSync(t);
    });
    Se(this, "_connect", async () => {
      const t = await Rse(`${this._props.url}/conversations/${this._props.conversationId}/listen`, {
        headers: { "x-user-key": this._props.userKey },
        timeout: this._props.timeout
      });
      return t.on("message", this._handleMessage), t.on("error", this._handleError(t)), this._state = { status: "connected", source: t }, t;
    });
    Se(this, "_disconnectSync", (t) => {
      t.close(), this._state = { status: "disconnected" };
    });
    Se(this, "_handleMessage", (t) => {
      const n = this._parseSignal(t.data);
      this.emit(n.type, n.data);
    });
    Se(this, "_handleError", (t) => (n) => {
      this._disconnectSync(t);
      const r = this._toError(n);
      this.emit("error", r);
    });
    Se(this, "_parseSignal", (t) => {
      for (const n of Object.values(Mse)) {
        const r = this._safeJsonParse(t), i = n.safeParse(r);
        if (i.success)
          return i.data;
      }
      return {
        type: "unknown",
        data: t
      };
    });
    Se(this, "_safeJsonParse", (t) => {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    });
    Se(this, "_toError", (t) => {
      if (t instanceof Error)
        return t;
      if (typeof t == "string")
        return new Error(t);
      if (t === null)
        return new Error(f1);
      if (typeof t == "object" && "message" in t)
        return this._toError(t.message);
      try {
        const n = JSON.stringify(t);
        return new Error(n);
      } catch {
        return new Error(f1);
      }
    });
    this._props = t;
  }
  get status() {
    return this._state.status;
  }
}, xC = bC;
Aoe(xC, "listen", async (e) => {
  const t = new bC(e);
  return await t.connect(), t;
});
var wC = 100 * 1024 * 1024, jse = wC, Lse = wC, Fse = 6e4, SC = class {
  constructor(e) {
    Se(this, "_auto");
    Se(this, "createConversation", (e) => this._auto.createConversation(e));
    Se(this, "getConversation", (e) => this._auto.getConversation(e));
    Se(this, "deleteConversation", (e) => this._auto.deleteConversation(e));
    Se(this, "listConversations", (e) => this._auto.listConversations(e));
    Se(this, "listConversationMessages", (e) => this._auto.listConversationMessages(e));
    Se(this, "addParticipant", (e) => this._auto.addParticipant(e));
    Se(this, "removeParticipant", (e) => this._auto.removeParticipant(e));
    Se(this, "getParticipant", (e) => this._auto.getParticipant(e));
    Se(this, "listParticipants", (e) => this._auto.listParticipants(e));
    Se(this, "createMessage", (e) => this._auto.createMessage(e));
    Se(this, "getMessage", (e) => this._auto.getMessage(e));
    Se(this, "deleteMessage", (e) => this._auto.deleteMessage(e));
    Se(this, "createFile", (e) => this._auto.createFile(e));
    Se(this, "createUser", (e) => this._auto.createUser(e));
    Se(this, "getUser", (e) => this._auto.getUser(e));
    Se(this, "updateUser", (e) => this._auto.updateUser(e));
    Se(this, "deleteUser", (e) => this._auto.deleteUser(e));
    Se(this, "createEvent", (e) => this._auto.createEvent(e));
    Se(this, "getEvent", (e) => this._auto.getEvent(e));
    Se(this, "listenConversation", async ({
      id: e,
      "x-user-key": t
    }) => await xC.listen({
      url: this.props.apiUrl,
      conversationId: e,
      userKey: t,
      timeout: this.props.sseTimeout
    }));
    this.props = e;
    const { apiUrl: t } = e, n = {
      ...e.headers
    }, r = this.props.timeout ?? Fse, i = jt.create({
      baseURL: t,
      headers: n,
      withCredentials: !0,
      timeout: r,
      maxBodyLength: jse,
      maxContentLength: Lse
    });
    this._auto = new Ose(i);
  }
};
const Bse = 6e4;
function Use({ apiUrl: e, clientId: t, sseTimeout: n = Bse }) {
  const r = new SC({
    apiUrl: `${e}/${t}`,
    sseTimeout: n
  });
  return {
    sendMessage: async (i) => {
      const { message: a } = await r.createMessage(i);
      return _a(a);
    },
    getMessage: async (i) => {
      const { message: a } = await r.getMessage(i);
      return _a(a);
    },
    listConversationMessages: async (i) => {
      const { messages: a, meta: o } = await r.listConversationMessages(i);
      return {
        messages: a.map(_a),
        meta: o
      };
    },
    createMessage: async (i) => {
      const { message: a } = await r.createMessage(i);
      return _a(a);
    },
    addParticipant: r.addParticipant.bind(r),
    createConversation: r.createConversation.bind(r),
    createEvent: r.createEvent.bind(r),
    createFile: r.createFile.bind(r),
    createUser: r.createUser.bind(r),
    deleteConversation: r.deleteConversation.bind(r),
    deleteMessage: r.deleteMessage.bind(r),
    deleteUser: r.deleteUser.bind(r),
    getConversation: r.getConversation.bind(r),
    getEvent: r.getEvent.bind(r),
    getParticipant: r.getParticipant.bind(r),
    getUser: r.getUser.bind(r),
    listConversations: r.listConversations.bind(r),
    removeParticipant: r.removeParticipant.bind(r),
    updateUser: r.updateUser.bind(r),
    listenConversation: r.listenConversation.bind(r)
  };
}
function _a(e) {
  const { metadata: t, conversationId: n, userId: r } = e, { payload: i, disableInput: a } = nm(e.payload);
  return {
    id: e.id,
    conversationId: n,
    authorId: r,
    timestamp: new Date(e.createdAt),
    block: i,
    disableInput: a,
    metadata: t
  };
}
const mu = {
  disconnected: 0,
  user_creating: 1,
  user_created: 2,
  conversation_creating: 3,
  conversation_created: 4
}, yn = (e, t) => e.status === t, hr = (e, t) => mu[e.status] < mu[t], d1 = (e, t) => mu[e.status] >= mu[t];
class mr extends Error {
  constructor(t) {
    super(`Unexpected state: ${t.status}`), this.state = t;
  }
}
const zse = ["audio", "file", "image", "video"], _C = (e) => zse.includes(e), Vse = 6e4;
class Hse extends lm {
  constructor(n) {
    super();
    Se(this, "_client");
    Se(this, "_webhookId");
    Se(this, "_apiUrl");
    Se(this, "_state", { status: "disconnected" });
    Se(this, "mode", "pushpin");
    Se(this, "_initialConnect", async ({ data: n, name: r, pictureUrl: i }) => {
      if (d1(this._state, "user_created"))
        throw new Error("Client is already connected. Please disconnect first.");
      if (yn(this._state, "user_creating"))
        return;
      this._state = {
        status: "user_creating"
      };
      const {
        user: { id: a },
        key: o
      } = await this._client.createUser({
        name: r,
        pictureUrl: i,
        userData: n
      });
      return this._state = {
        status: "user_created",
        userId: a,
        userKey: o
      }, {
        userId: a,
        userToken: o
      };
    });
    Se(this, "_reConnect", async (n, { data: r, name: i, pictureUrl: a }) => {
      if (d1(this._state, "user_created")) {
        if (this._state.userId !== n.userId)
          throw new Error("Client is already connected. Please disconnect first.");
        return n;
      }
      return yn(this._state, "user_creating") || (this._state = {
        status: "user_created",
        userId: n.userId,
        userKey: n.userToken
      }, await this._client.updateUser({
        "x-user-key": n.userToken,
        name: i,
        pictureUrl: a,
        userData: r
      })), n;
    });
    Se(this, "_mapMessage", (n) => {
      const { metadata: r } = n, { payload: i, disableInput: a } = nm(n.payload);
      return {
        id: n.id,
        conversationId: n.conversationId,
        authorId: n.userId,
        sentOn: new Date(n.createdAt),
        payload: i,
        disableInput: a,
        metadata: r
      };
    });
    const r = `${n.apiUrl}/${n.clientId}`;
    this._webhookId = n.clientId, this._apiUrl = r, this._client = new SC({
      apiUrl: r,
      sseTimeout: Vse
    });
  }
  get apiUrl() {
    return this._apiUrl;
  }
  get clientId() {
    return this._webhookId;
  }
  get userId() {
    if (!hr(this._state, "user_created"))
      return this._state.userId;
  }
  async getUser() {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    const { user: n } = await this._client.getUser({ "x-user-key": this._state.userKey });
    return { data: n.data };
  }
  async updateUser(n) {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    const { user: r } = await this._client.updateUser({
      "x-user-key": this._state.userKey,
      name: n.name,
      pictureUrl: n.pictureUrl,
      userData: n.data
    });
    return r;
  }
  get conversationId() {
    if (!hr(this._state, "conversation_created"))
      return this._state.conversationId;
  }
  async connect(n, r, i = {}) {
    const a = { data: r, ...i };
    return n ? await this.userExists(n) ? this._reConnect(n, a) : this._initialConnect(a) : this._initialConnect(a);
  }
  async disconnect() {
    yn(this._state, "conversation_created") ? this._state.signalEmitter.cleanup() : yn(this._state, "conversation_creating") && console.warn("zombie conversation..."), this._state = { status: "disconnected" };
  }
  async sendFile(n) {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    if (yn(this._state, "conversation_creating"))
      throw new mr(this._state);
    let r;
    yn(this._state, "conversation_created") ? r = this._state : (this._state = { status: "conversation_creating", userId: this._state.userId, userKey: this._state.userKey }, r = await this._createNewConversation(this._state));
    const { size: i, name: a } = n, s = await ((m) => new Promise((h, y) => {
      const v = new FileReader();
      v.onload = (g) => {
        var b;
        return h((b = g.target) == null ? void 0 : b.result);
      }, v.onerror = (g) => {
        var b;
        return y((b = g.target) == null ? void 0 : b.error);
      }, v.readAsArrayBuffer(m);
    }))(n), {
      file: { uploadUrl: c, contentType: l, url: u }
    } = await this._client.createFile({
      "x-user-key": r.userKey,
      size: i,
      key: a,
      accessPolicies: ["public_content"],
      index: !1,
      tags: { source: "integration", integrationName: "webchat" }
    });
    await fetch(c, {
      method: "PUT",
      headers: {
        "x-amz-tagging": "public=true"
      },
      body: s
    });
    const f = l.split("/").shift() ?? "", d = _C(f) ? f : "file", p = d === "image" ? { type: d, imageUrl: u } : d === "audio" ? { type: d, audioUrl: u } : d === "video" ? { type: d, videoUrl: u } : { type: d, fileUrl: u };
    return await this._client.createMessage({
      "x-user-key": r.userKey,
      conversationId: r.conversationId,
      payload: p
    }), this.emit("messageSent", p), { fileUrl: u, name: a, type: d };
  }
  async sendMessage(n) {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    if (yn(this._state, "conversation_creating"))
      throw new mr(this._state);
    let r;
    yn(this._state, "conversation_created") ? r = this._state : (this._state = { status: "conversation_creating", userId: this._state.userId, userKey: this._state.userKey }, r = await this._createNewConversation(this._state)), await this._client.createMessage({
      "x-user-key": r.userKey,
      conversationId: r.conversationId,
      payload: n
    }), this.emit("messageSent", n);
  }
  async sendEvent(n) {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    if (yn(this._state, "conversation_creating"))
      throw new mr(this._state);
    let r;
    yn(this._state, "conversation_created") ? r = this._state : (this._state = { status: "conversation_creating", userId: this._state.userId, userKey: this._state.userKey }, r = await this._createNewConversation(this._state)), await this._client.createEvent({
      "x-user-key": r.userKey,
      conversationId: r.conversationId,
      payload: {
        type: "custom",
        data: n
      }
    });
  }
  async switchConversation(n) {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    yn(this._state, "conversation_created") && this._state.conversationId === n || yn(this._state, "conversation_creating") || (this._state = {
      status: "conversation_creating",
      userId: this._state.userId,
      userKey: this._state.userKey
    }, await this._connectConversation(this._state, n));
  }
  async conversationExists(n) {
    if (hr(this._state, "user_created"))
      return !1;
    try {
      return await this._client.getConversation({
        "x-user-key": this._state.userKey,
        id: n
      }), !0;
    } catch (r) {
      if (Qh(r) && r.code === 404)
        return !1;
      throw r;
    }
  }
  async userExists({ userToken: n }) {
    try {
      return await this._client.getUser({
        "x-user-key": n
      }), !0;
    } catch (r) {
      const i = (a) => a.code === 404 || a.code === 401;
      if (Qh(r) && i(r))
        return !1;
      throw r;
    }
  }
  async newConversation() {
    if (hr(this._state, "user_created"))
      throw new mr(this._state);
    yn(this._state, "conversation_creating") || (this._state = { status: "conversation_creating", userId: this._state.userId, userKey: this._state.userKey }, await this._createNewConversation(this._state));
  }
  async _createNewConversation(n) {
    const {
      conversation: { id: r }
    } = await this._client.createConversation({ "x-user-key": n.userKey }), i = await this._connectConversation(n, r);
    return await this._client.createEvent({
      "x-user-key": n.userKey,
      conversationId: r,
      payload: { type: "conversation_started", data: {} }
    }), i;
  }
  async listMessages() {
    if (!yn(this._state, "conversation_created"))
      return [];
    const { conversationId: n, userKey: r } = this._state, i = [];
    let a;
    do {
      const o = await this._client.listConversationMessages({ id: n, "x-user-key": r, nextToken: a });
      i.push(...o.messages), a = o.meta.nextToken;
    } while (a);
    return i.map(this._mapMessage);
  }
  async _connectConversation(n, r) {
    const i = await this._client.listenConversation({ id: r, "x-user-key": n.userKey });
    return i.on("unknown", (a) => {
      typeof a == "string" && a === "ping" || console.debug("unknown event", a);
    }), i.on("message_created", (a) => {
      a.userId, n.userId;
    }), i.on("error", (a) => {
      this._state = { status: "user_created", userId: n.userId, userKey: n.userKey }, this.emit("error", new Error(`Connection to conversation lost: ${a.message}`));
    }), i.on("webchat_visibility", (a) => {
      this.emit("webchatVisibility", a.visibility);
    }), i.on("webchat_config", (a) => {
      this.emit("webchatConfig", a.config);
    }), i.on("typing_started", (a) => {
      this.emit("isTyping", { isTyping: !0, timeout: a.timeout ?? 5e3 });
    }), i.on("typing_stopped", () => {
      this.emit("isTyping", { isTyping: !1, timeout: 0 });
    }), i.on("custom", (a) => {
      this.emit("customEvent", a.event);
    }), this.emit("conversation", r), this._state = {
      status: "conversation_created",
      userId: n.userId,
      userKey: n.userKey,
      conversationId: r,
      signalEmitter: i
    }, this._state;
  }
}
const qse = ({ clientId: e, apiUrl: t = "https://webchat.botpress.cloud" }) => new Hse({
  apiUrl: t,
  clientId: e
}), rce = ({ clientId: e, apiUrl: t = "https://webchat.botpress.cloud" }) => {
  const [n] = rt(qse({ clientId: e, apiUrl: t }));
  return n;
};
function Wse() {
  const [e, t] = rt(!1), n = Dt(null);
  return {
    isTyping: e,
    setIsTyping: (r, i) => {
      if (t(r), !r)
        return () => {
        };
      if (n.current = /* @__PURE__ */ new Date(), !i)
        return () => {
        };
      const a = setTimeout(() => {
        const o = n.current;
        o && (/* @__PURE__ */ new Date()).getTime() - o.getTime() > i && t(!1);
      }, i + 100);
      return () => clearTimeout(a);
    }
  };
}
var EC = {}, by = {}, vu = pt && pt.__assign || function() {
  return vu = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vu.apply(this, arguments);
};
Object.defineProperty(by, "__esModule", { value: !0 });
var Zse = {
  delayFirstAttempt: !1,
  jitter: "none",
  maxDelay: 1 / 0,
  numOfAttempts: 10,
  retry: function() {
    return !0;
  },
  startingDelay: 100,
  timeMultiple: 2
};
function Kse(e) {
  var t = vu(vu({}, Zse), e);
  return t.numOfAttempts < 1 && (t.numOfAttempts = 1), t;
}
by.getSanitizedOptions = Kse;
var xy = {}, wy = {}, vf = {}, Sy = {}, _y = {};
Object.defineProperty(_y, "__esModule", { value: !0 });
function Gse(e) {
  var t = Math.random() * e;
  return Math.round(t);
}
_y.fullJitter = Gse;
var Ey = {};
Object.defineProperty(Ey, "__esModule", { value: !0 });
function Yse(e) {
  return e;
}
Ey.noJitter = Yse;
Object.defineProperty(Sy, "__esModule", { value: !0 });
var Jse = _y, Xse = Ey;
function Qse(e) {
  switch (e.jitter) {
    case "full":
      return Jse.fullJitter;
    case "none":
    default:
      return Xse.noJitter;
  }
}
Sy.JitterFactory = Qse;
Object.defineProperty(vf, "__esModule", { value: !0 });
var ele = Sy, tle = (
  /** @class */
  function() {
    function e(t) {
      this.options = t, this.attempt = 0;
    }
    return e.prototype.apply = function() {
      var t = this;
      return new Promise(function(n) {
        return setTimeout(n, t.jitteredDelay);
      });
    }, e.prototype.setAttemptNumber = function(t) {
      this.attempt = t;
    }, Object.defineProperty(e.prototype, "jitteredDelay", {
      get: function() {
        var t = ele.JitterFactory(this.options);
        return t(this.delay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "delay", {
      get: function() {
        var t = this.options.startingDelay, n = this.options.timeMultiple, r = this.numOfDelayedAttempts, i = t * Math.pow(n, r);
        return Math.min(i, this.options.maxDelay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt;
      },
      enumerable: !0,
      configurable: !0
    }), e;
  }()
);
vf.Delay = tle;
var nle = pt && pt.__extends || /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) i.hasOwnProperty(a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), rle = pt && pt.__awaiter || function(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        o(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        o(f);
      }
    }
    function l(u) {
      u.done ? a(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
}, ile = pt && pt.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (a = l[0] & 2 ? i.return : l[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, l[1])).done) return a;
      switch (i = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
        case 0:
        case 1:
          a = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, i = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = l;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(l);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (u) {
      l = [6, u], i = 0;
    } finally {
      r = a = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
};
Object.defineProperty(wy, "__esModule", { value: !0 });
var ale = vf, ole = (
  /** @class */
  function(e) {
    nle(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.apply = function() {
      return rle(this, void 0, void 0, function() {
        return ile(this, function(n) {
          return [2, this.isFirstAttempt ? !0 : e.prototype.apply.call(this)];
        });
      });
    }, Object.defineProperty(t.prototype, "isFirstAttempt", {
      get: function() {
        return this.attempt === 0;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt - 1;
      },
      enumerable: !0,
      configurable: !0
    }), t;
  }(ale.Delay)
);
wy.SkipFirstDelay = ole;
var Ty = {}, sle = pt && pt.__extends || /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var a in i) i.hasOwnProperty(a) && (r[a] = i[a]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}();
Object.defineProperty(Ty, "__esModule", { value: !0 });
var lle = vf, cle = (
  /** @class */
  function(e) {
    sle(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t;
  }(lle.Delay)
);
Ty.AlwaysDelay = cle;
Object.defineProperty(xy, "__esModule", { value: !0 });
var ule = wy, fle = Ty;
function dle(e, t) {
  var n = ple(e);
  return n.setAttemptNumber(t), n;
}
xy.DelayFactory = dle;
function ple(e) {
  return e.delayFirstAttempt ? new fle.AlwaysDelay(e) : new ule.SkipFirstDelay(e);
}
var em = pt && pt.__awaiter || function(e, t, n, r) {
  function i(a) {
    return a instanceof n ? a : new n(function(o) {
      o(a);
    });
  }
  return new (n || (n = Promise))(function(a, o) {
    function s(u) {
      try {
        l(r.next(u));
      } catch (f) {
        o(f);
      }
    }
    function c(u) {
      try {
        l(r.throw(u));
      } catch (f) {
        o(f);
      }
    }
    function l(u) {
      u.done ? a(u.value) : i(u.value).then(s, c);
    }
    l((r = r.apply(e, t || [])).next());
  });
}, tm = pt && pt.__generator || function(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, i, a, o;
  return o = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (a = l[0] & 2 ? i.return : l[0] ? i.throw || ((a = i.return) && a.call(i), 0) : i.next) && !(a = a.call(i, l[1])).done) return a;
      switch (i = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
        case 0:
        case 1:
          a = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, i = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = l;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(l);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (u) {
      l = [6, u], i = 0;
    } finally {
      r = a = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
};
Object.defineProperty(EC, "__esModule", { value: !0 });
var hle = by, mle = xy;
function vle(e, t) {
  return t === void 0 && (t = {}), em(this, void 0, void 0, function() {
    var n, r;
    return tm(this, function(i) {
      switch (i.label) {
        case 0:
          return n = hle.getSanitizedOptions(t), r = new gle(e, n), [4, r.execute()];
        case 1:
          return [2, i.sent()];
      }
    });
  });
}
var yle = EC.backOff = vle, gle = (
  /** @class */
  function() {
    function e(t, n) {
      this.request = t, this.options = n, this.attemptNumber = 0;
    }
    return e.prototype.execute = function() {
      return em(this, void 0, void 0, function() {
        var t, n;
        return tm(this, function(r) {
          switch (r.label) {
            case 0:
              if (this.attemptLimitReached) return [3, 7];
              r.label = 1;
            case 1:
              return r.trys.push([1, 4, , 6]), [4, this.applyDelay()];
            case 2:
              return r.sent(), [4, this.request()];
            case 3:
              return [2, r.sent()];
            case 4:
              return t = r.sent(), this.attemptNumber++, [4, this.options.retry(t, this.attemptNumber)];
            case 5:
              if (n = r.sent(), !n || this.attemptLimitReached)
                throw t;
              return [3, 6];
            case 6:
              return [3, 0];
            case 7:
              throw new Error("Something went wrong.");
          }
        });
      });
    }, Object.defineProperty(e.prototype, "attemptLimitReached", {
      get: function() {
        return this.attemptNumber >= this.options.numOfAttempts;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.applyDelay = function() {
      return em(this, void 0, void 0, function() {
        var t;
        return tm(this, function(n) {
          switch (n.label) {
            case 0:
              return t = mle.DelayFactory(this.options, this.attemptNumber), [4, t.apply()];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e;
  }()
);
function ble({
  apiUrl: e = "https://webchat.botpress.cloud",
  clientId: t,
  storageKey: n,
  ...r
}) {
  const [i, a] = rt(), o = wo((D) => D.messages), s = wo((D) => D.addMessage), c = wo((D) => D.fetchMessages), l = wo((D) => D.setMessages), u = wo((D) => D.isFetching), [f, d] = rt("connecting"), { isTyping: p, setIsTyping: m } = Wse(), h = kn(() => new lm(), []), y = qj(n), v = kn(() => Use({ apiUrl: e, clientId: t }), [e, t]), g = Dt(null), [b, T] = rt(r.userKey), [S, E] = rt(r.conversationId);
  async function O(D) {
    const { conversation: k } = await v.createConversation({ "x-user-key": D });
    return y.setState({ conversationId: k.id }), await v.createEvent({
      "x-user-key": D,
      conversationId: k.id,
      payload: {
        type: "conversation_started",
        data: {}
      }
    }), k.id;
  }
  if (Ht(() => {
    let D = !0;
    async function k({ userKey: A, conversationId: V }) {
      let $, L = r.userKey ?? A, M = r.conversationId ?? V;
      if (d("connecting"), !L) {
        const B = y.getState().user;
        L = B == null ? void 0 : B.userToken;
      }
      if (!L) {
        const { key: B, user: N } = await v.createUser({});
        $ = N, L = B, y.setState({ user: { userId: N.id, userToken: L } });
      }
      if (!$) {
        const { user: B } = await v.getUser({ "x-user-key": L });
        $ = B;
      }
      M || (M = y.getState().conversationId), M || (M = await O(L));
      const [F, q] = [
        await v.listenConversation({
          "x-user-key": L,
          id: M
        }),
        await c({
          client: v,
          conversationId: M,
          userKey: L
        })
      ];
      h.emit("conversation", M), p1({ emitter: h, signalEmitter: F }), D && (g.current = F, T(L), E(M), a($), l(q), d("connected"));
    }
    return k({ userKey: b, conversationId: S }).catch((A) => {
      console.error(A);
    }), () => {
      g.current && (g.current.cleanup(), g.current = null), D = !1;
    };
  }, [b, S, v, h, r.conversationId, r.userKey]), Ht(() => {
    var k;
    if (!b || !S)
      return;
    async function D({ userKey: A, conversationId: V }) {
      const $ = await v.listenConversation({ "x-user-key": A, id: V });
      g.current = $, p1({ emitter: h, signalEmitter: $ });
    }
    f === "error" && ((k = g.current) == null || k.cleanup(), yle(() => D({ conversationId: S, userKey: b }), {
      startingDelay: 2e3,
      maxDelay: 1e4,
      numOfAttempts: 1 / 0
    }), d("connected"));
  }, [f, b, S]), Ht(() => {
    const D = [
      h.on("message", (k) => ((i == null ? void 0 : i.id) !== k.authorId && h.emit("isTyping", { isTyping: !1, timeout: 0 }), s(k))),
      h.on("isTyping", ({ isTyping: k, timeout: A }) => {
        m(k, A);
      }),
      h.on("error", () => {
        d("error");
      })
    ];
    return () => {
      D.forEach((k) => k());
    };
  }, []), f === "connecting" || !b || !S)
    return {
      clientState: "connecting",
      on: h.on.bind(h),
      client: void 0,
      messages: [],
      conversationId: void 0,
      newConversation: () => {
      },
      user: void 0,
      isTyping: void 0,
      isFetchingMessages: u
    };
  const j = {
    sendMessage: async (D) => {
      const k = vO();
      s(
        _a({
          id: k,
          createdAt: (/* @__PURE__ */ new Date()).toISOString(),
          userId: (i == null ? void 0 : i.id) ?? "",
          conversationId: S,
          payload: D,
          metadata: {
            clientMessageId: k,
            delivered: !1
          }
        })
      ), await v.createMessage({
        "x-user-key": b,
        conversationId: S,
        payload: D,
        metadata: {
          clientMessageId: k
        }
      }).catch((A) => h.emit("error", A));
    },
    updateUser: async (D) => {
      const { user: k } = await v.updateUser({
        "x-user-key": b,
        name: D.name,
        pictureUrl: D.pictureUrl,
        userData: D.data
      });
      return k;
    },
    sendEvent: async (D) => {
      await v.createEvent({
        "x-user-key": b,
        conversationId: S,
        payload: {
          type: "custom",
          data: D
        }
      });
    },
    uploadFile: async (D) => {
      const { size: k, name: A } = D, $ = await ((N) => new Promise((x, z) => {
        const Z = new FileReader();
        Z.onload = (_) => {
          var G;
          return x((G = _.target) == null ? void 0 : G.result);
        }, Z.onerror = (_) => {
          var G;
          return z((G = _.target) == null ? void 0 : G.error);
        }, Z.readAsArrayBuffer(N);
      }))(D), {
        file: { uploadUrl: L, contentType: M, url: F }
      } = await v.createFile({
        "x-user-key": b,
        size: k,
        key: A,
        accessPolicies: ["public_content"],
        index: !1,
        tags: { source: "integration", integrationName: "webchat" }
      });
      await fetch(L, {
        method: "PUT",
        headers: {
          "x-amz-tagging": "public=true"
        },
        body: $
      });
      const q = M.split("/").shift() ?? "", B = _C(q) ? q : "file";
      return { fileUrl: F, name: A, type: B };
    },
    getUser: async () => {
      const { user: D } = await v.getUser({ "x-user-key": b });
      return D;
    }
  };
  return {
    clientState: f,
    on: h.on.bind(h),
    client: j,
    messages: o,
    conversationId: S,
    newConversation: () => {
      l([]), O(b).then(E);
    },
    user: i,
    isTyping: p,
    isFetchingMessages: u
  };
}
function p1({
  emitter: e,
  signalEmitter: t
}) {
  t.on("unknown", (n) => {
  }), t.on("message_created", (n) => {
    e.emit("message", _a(n));
  }), t.on("error", (n) => {
    e.emit("error", new Error(`Connection to conversation lost: ${n.message}`));
  }), t.on("webchat_visibility", (n) => {
    e.emit("webchatVisibility", n.visibility);
  }), t.on("webchat_config", (n) => {
    e.emit("webchatConfig", n.config);
  }), t.on("typing_started", (n) => {
    e.emit("isTyping", { isTyping: !0, timeout: n.timeout ?? 5e3 });
  }), t.on("typing_stopped", () => {
    e.emit("isTyping", { isTyping: !1, timeout: 0 });
  }), t.on("custom", (n) => {
    e.emit("customEvent", n.event);
  });
}
const ice = ({
  clientId: e,
  storageKey: t,
  configuration: n,
  allowFileUpload: r,
  apiUrl: i,
  userKey: a,
  conversationId: o,
  ...s
}) => {
  const c = t || `bp-webchat-${e}`, {
    clientState: l,
    client: u,
    isFetchingMessages: f,
    isTyping: d,
    newConversation: p,
    messages: m,
    user: h
  } = ble({
    clientId: e,
    apiUrl: i,
    conversationId: o,
    userKey: a,
    storageKey: c
  }), { sendMessage: y, uploadFile: v } = u ?? {};
  return /* @__PURE__ */ R.jsx(
    Bte,
    {
      configuration: n ?? {},
      user: h ?? { id: "" },
      isLoading: f || l === "connecting",
      isTyping: d,
      connected: l === "connected" ? !0 : l === "disconnected" ? !1 : void 0,
      messages: m,
      sendMessage: y,
      uploadFile: v,
      allowFileUpload: r,
      restartConversation: p,
      ...s
    }
  );
};
export {
  um as Avatar,
  qs as Block,
  Bte as Chat,
  l3 as Composer,
  $E as Container,
  VB as Fab,
  JB as Header,
  Nb as Message,
  yO as MessageList,
  Wi as Modal,
  c3 as ModalProvider,
  GB as RestartConversationButton,
  u3 as StylesheetProvider,
  XB as TypingIndicator,
  ice as Webchat,
  G1 as WebchatThemeSchema,
  _le as __adapters,
  bf as avatarThemeSchema,
  j$ as blockThemeSchema,
  U$ as configPropsSchema,
  N$ as configurationSchema,
  M$ as cssStyleSchema,
  go as descriptionItemSchema,
  zse as fileTypes,
  z$ as generateThemeStylesheet,
  Use as getClient,
  qj as getUseUserStore,
  Xle as initPropsSchema,
  _C as isFileType,
  D$ as markdownTypeSchema,
  F5 as renderers,
  F$ as statePropsSchema,
  ue as styleOptionSchema,
  L$ as themeSchema,
  rce as useClient,
  ble as useWebchatClient,
  Rm as useWebchatStore,
  B$ as userPropsSchema,
  bt as webchatClasses
};
